//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IAccountService {
    login(loginModel: LoginRequest): Observable<ResponseModelOfLoginResponse>;
    portalLogin(loginModel: LoginRequest): Observable<ResponseModelOfLoginResponse>;
    licenceCheck(licenceCode: string | null | undefined): Observable<LicenceCheckDbResponse>;
    registrationAllowed(): Observable<FileResponse>;
    register(registerRequest: RegisterDbRequest): Observable<ResponseModelOfLoginResponse>;
    selfRegister(selfRegisterRequest: SelfRegisterDbRequest): Observable<ResponseModelOfLoginResponse>;
    confirmEmail(token: string | null | undefined): Observable<ResponseModelOfConfirmEmailResponse>;
    resendEmailConfirmation(): Observable<ResponseModelOfConfirmEmailResponse>;
    changeUnconfirmedEmail(request: ChangeUnconfirmedEmailRequest): Observable<ResponseModelOfConfirmEmailResponse>;
    emailConfirmationStatus(): Observable<ResponseModelOfEmailConfirmationStatusResponse>;
    changePassword(resetPasswordDbRequest: ChangePasswordDbRequest): Observable<ChangePasswordResponse>;
    resetPassword(emailAddress: string | null | undefined): Observable<ResetPasswordResponse>;
    resetPasswordConfirm(request: ResetPasswordConfirmRequest): Observable<ResponseModelOfConfirmEmailResponse>;
    checkAccountSubscription(emailAddress: string | null | undefined): Observable<ResponseModelOfCheckAccountSubscriptionResponse>;
    logout(): Observable<boolean>;
    nodeBBSession(): Observable<boolean>;
    updatePreferredName(request: UpdatePreferredNameRequest): Observable<ResponseModelOfBoolean>;
    getCommunityUsername(): Observable<ResponseModelOfGetCommunityUsernameResponse>;
    updateCommunityUsername(request: UpdateCommunityUsernameRequest): Observable<ResponseModelOfBoolean>;
    previewCommunityUsername(request: PreviewCommunityUsernameRequest): Observable<ResponseModelOfPreviewCommunityUsernameResponse>;
    completeOnboarding(): Observable<ResponseModelOfBoolean>;
}

@Injectable()
export class AccountService implements IAccountService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    login(loginModel: LoginRequest): Observable<ResponseModelOfLoginResponse> {
        let url_ = this.baseUrl + "/api/Account/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfLoginResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfLoginResponse>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<ResponseModelOfLoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfLoginResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfLoginResponse>(null as any);
    }

    portalLogin(loginModel: LoginRequest): Observable<ResponseModelOfLoginResponse> {
        let url_ = this.baseUrl + "/api/Account/PortalLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPortalLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPortalLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfLoginResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfLoginResponse>;
        }));
    }

    protected processPortalLogin(response: HttpResponseBase): Observable<ResponseModelOfLoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfLoginResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfLoginResponse>(null as any);
    }

    licenceCheck(licenceCode: string | null | undefined): Observable<LicenceCheckDbResponse> {
        let url_ = this.baseUrl + "/api/Account/LicenceCheck?";
        if (licenceCode !== undefined && licenceCode !== null)
            url_ += "LicenceCode=" + encodeURIComponent("" + licenceCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLicenceCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLicenceCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenceCheckDbResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenceCheckDbResponse>;
        }));
    }

    protected processLicenceCheck(response: HttpResponseBase): Observable<LicenceCheckDbResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenceCheckDbResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenceCheckDbResponse>(null as any);
    }

    registrationAllowed(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/RegistrationAllowed";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegistrationAllowed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegistrationAllowed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRegistrationAllowed(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    register(registerRequest: RegisterDbRequest): Observable<ResponseModelOfLoginResponse> {
        let url_ = this.baseUrl + "/api/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registerRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfLoginResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfLoginResponse>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<ResponseModelOfLoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfLoginResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfLoginResponse>(null as any);
    }

    selfRegister(selfRegisterRequest: SelfRegisterDbRequest): Observable<ResponseModelOfLoginResponse> {
        let url_ = this.baseUrl + "/api/Account/SelfRegister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selfRegisterRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelfRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelfRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfLoginResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfLoginResponse>;
        }));
    }

    protected processSelfRegister(response: HttpResponseBase): Observable<ResponseModelOfLoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfLoginResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfLoginResponse>(null as any);
    }

    confirmEmail(token: string | null | undefined): Observable<ResponseModelOfConfirmEmailResponse> {
        let url_ = this.baseUrl + "/api/Account/ConfirmEmail?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfConfirmEmailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfConfirmEmailResponse>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<ResponseModelOfConfirmEmailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfConfirmEmailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfConfirmEmailResponse>(null as any);
    }

    resendEmailConfirmation(): Observable<ResponseModelOfConfirmEmailResponse> {
        let url_ = this.baseUrl + "/api/Account/ResendEmailConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendEmailConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendEmailConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfConfirmEmailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfConfirmEmailResponse>;
        }));
    }

    protected processResendEmailConfirmation(response: HttpResponseBase): Observable<ResponseModelOfConfirmEmailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfConfirmEmailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfConfirmEmailResponse>(null as any);
    }

    changeUnconfirmedEmail(request: ChangeUnconfirmedEmailRequest): Observable<ResponseModelOfConfirmEmailResponse> {
        let url_ = this.baseUrl + "/api/Account/ChangeUnconfirmedEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUnconfirmedEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUnconfirmedEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfConfirmEmailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfConfirmEmailResponse>;
        }));
    }

    protected processChangeUnconfirmedEmail(response: HttpResponseBase): Observable<ResponseModelOfConfirmEmailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfConfirmEmailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfConfirmEmailResponse>(null as any);
    }

    emailConfirmationStatus(): Observable<ResponseModelOfEmailConfirmationStatusResponse> {
        let url_ = this.baseUrl + "/api/Account/EmailConfirmationStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailConfirmationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailConfirmationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfEmailConfirmationStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfEmailConfirmationStatusResponse>;
        }));
    }

    protected processEmailConfirmationStatus(response: HttpResponseBase): Observable<ResponseModelOfEmailConfirmationStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfEmailConfirmationStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfEmailConfirmationStatusResponse>(null as any);
    }

    changePassword(resetPasswordDbRequest: ChangePasswordDbRequest): Observable<ChangePasswordResponse> {
        let url_ = this.baseUrl + "/api/Account/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resetPasswordDbRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangePasswordResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangePasswordResponse>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<ChangePasswordResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangePasswordResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChangePasswordResponse>(null as any);
    }

    resetPassword(emailAddress: string | null | undefined): Observable<ResetPasswordResponse> {
        let url_ = this.baseUrl + "/api/Account/ResetPassword?";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordResponse>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordResponse>(null as any);
    }

    resetPasswordConfirm(request: ResetPasswordConfirmRequest): Observable<ResponseModelOfConfirmEmailResponse> {
        let url_ = this.baseUrl + "/api/Account/ResetPasswordConfirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfConfirmEmailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfConfirmEmailResponse>;
        }));
    }

    protected processResetPasswordConfirm(response: HttpResponseBase): Observable<ResponseModelOfConfirmEmailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfConfirmEmailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfConfirmEmailResponse>(null as any);
    }

    checkAccountSubscription(emailAddress: string | null | undefined): Observable<ResponseModelOfCheckAccountSubscriptionResponse> {
        let url_ = this.baseUrl + "/api/Account/CheckAccountSubscription?";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAccountSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAccountSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfCheckAccountSubscriptionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfCheckAccountSubscriptionResponse>;
        }));
    }

    protected processCheckAccountSubscription(response: HttpResponseBase): Observable<ResponseModelOfCheckAccountSubscriptionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfCheckAccountSubscriptionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfCheckAccountSubscriptionResponse>(null as any);
    }

    logout(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Account/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    nodeBBSession(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Account/NodeBBSession";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNodeBBSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNodeBBSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processNodeBBSession(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    updatePreferredName(request: UpdatePreferredNameRequest): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/Account/UpdatePreferredName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePreferredName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePreferredName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processUpdatePreferredName(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }

    getCommunityUsername(): Observable<ResponseModelOfGetCommunityUsernameResponse> {
        let url_ = this.baseUrl + "/api/Account/GetCommunityUsername";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommunityUsername(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunityUsername(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfGetCommunityUsernameResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfGetCommunityUsernameResponse>;
        }));
    }

    protected processGetCommunityUsername(response: HttpResponseBase): Observable<ResponseModelOfGetCommunityUsernameResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfGetCommunityUsernameResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfGetCommunityUsernameResponse>(null as any);
    }

    updateCommunityUsername(request: UpdateCommunityUsernameRequest): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/Account/UpdateCommunityUsername";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCommunityUsername(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCommunityUsername(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processUpdateCommunityUsername(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }

    previewCommunityUsername(request: PreviewCommunityUsernameRequest): Observable<ResponseModelOfPreviewCommunityUsernameResponse> {
        let url_ = this.baseUrl + "/api/Account/PreviewCommunityUsername";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewCommunityUsername(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewCommunityUsername(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfPreviewCommunityUsernameResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfPreviewCommunityUsernameResponse>;
        }));
    }

    protected processPreviewCommunityUsername(response: HttpResponseBase): Observable<ResponseModelOfPreviewCommunityUsernameResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfPreviewCommunityUsernameResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfPreviewCommunityUsernameResponse>(null as any);
    }

    completeOnboarding(): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/Account/CompleteOnboarding";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteOnboarding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteOnboarding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processCompleteOnboarding(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }
}

export interface IAppleNotificationService {
    registerDevice(deviceLibraryIdentifier: string | null, passTypeIdentifier: string | null, serialNumber: string | null, protocolVersion: string, jsonBody: string): Observable<number>;
    unregisteredDevice(deviceLibraryIdentifier: string | null, passTypeIdentifier: string | null, serialNumber: string | null, protocolVersion: string): Observable<number>;
    sendSerials(passTypeIdentifier: string | null, deviceLibraryIdentifier: string | null, passesUpdatedSince: string | null | undefined, protocolVersion: string): Observable<ListUpdatedPasses>;
    latestPass(passTypeIdentifier: string | null, serialNumber: string | null, protocolVersion: string): Observable<FileResponse>;
    readFiles(filePath: string | null | undefined): Observable<string>;
    errorLog(protocolVersion: string, errorlog: string): Observable<number>;
    tokenNTimes(minTime: string | null, maxTime: string | null): Observable<TriggerData[]>;
    getNotificationTriggers(minTime: string | null, maxTime: string | null): Observable<NotificationTriggers[]>;
}

@Injectable()
export class AppleNotificationService implements IAppleNotificationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    registerDevice(deviceLibraryIdentifier: string | null, passTypeIdentifier: string | null, serialNumber: string | null, protocolVersion: string, jsonBody: string): Observable<number> {
        let url_ = this.baseUrl + "/{protocolVersion}/devices/{deviceLibraryIdentifier}/registrations/{passTypeIdentifier}/{serialNumber}";
        if (deviceLibraryIdentifier === undefined || deviceLibraryIdentifier === null)
            throw new Error("The parameter 'deviceLibraryIdentifier' must be defined.");
        url_ = url_.replace("{deviceLibraryIdentifier}", encodeURIComponent("" + deviceLibraryIdentifier));
        if (passTypeIdentifier === undefined || passTypeIdentifier === null)
            throw new Error("The parameter 'passTypeIdentifier' must be defined.");
        url_ = url_.replace("{passTypeIdentifier}", encodeURIComponent("" + passTypeIdentifier));
        if (serialNumber === undefined || serialNumber === null)
            throw new Error("The parameter 'serialNumber' must be defined.");
        url_ = url_.replace("{serialNumber}", encodeURIComponent("" + serialNumber));
        if (protocolVersion === undefined || protocolVersion === null)
            throw new Error("The parameter 'protocolVersion' must be defined.");
        url_ = url_.replace("{protocolVersion}", encodeURIComponent("" + protocolVersion));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jsonBody);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processRegisterDevice(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    unregisteredDevice(deviceLibraryIdentifier: string | null, passTypeIdentifier: string | null, serialNumber: string | null, protocolVersion: string): Observable<number> {
        let url_ = this.baseUrl + "/{protocolVersion}/devices/{deviceLibraryIdentifier}/registrations/{passTypeIdentifier}/{serialNumber}";
        if (deviceLibraryIdentifier === undefined || deviceLibraryIdentifier === null)
            throw new Error("The parameter 'deviceLibraryIdentifier' must be defined.");
        url_ = url_.replace("{deviceLibraryIdentifier}", encodeURIComponent("" + deviceLibraryIdentifier));
        if (passTypeIdentifier === undefined || passTypeIdentifier === null)
            throw new Error("The parameter 'passTypeIdentifier' must be defined.");
        url_ = url_.replace("{passTypeIdentifier}", encodeURIComponent("" + passTypeIdentifier));
        if (serialNumber === undefined || serialNumber === null)
            throw new Error("The parameter 'serialNumber' must be defined.");
        url_ = url_.replace("{serialNumber}", encodeURIComponent("" + serialNumber));
        if (protocolVersion === undefined || protocolVersion === null)
            throw new Error("The parameter 'protocolVersion' must be defined.");
        url_ = url_.replace("{protocolVersion}", encodeURIComponent("" + protocolVersion));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnregisteredDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnregisteredDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUnregisteredDevice(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    sendSerials(passTypeIdentifier: string | null, deviceLibraryIdentifier: string | null, passesUpdatedSince: string | null | undefined, protocolVersion: string): Observable<ListUpdatedPasses> {
        let url_ = this.baseUrl + "/{protocolVersion}/devices/{deviceLibraryIdentifier}/registrations/{passTypeIdentifier}?";
        if (passTypeIdentifier === undefined || passTypeIdentifier === null)
            throw new Error("The parameter 'passTypeIdentifier' must be defined.");
        url_ = url_.replace("{passTypeIdentifier}", encodeURIComponent("" + passTypeIdentifier));
        if (deviceLibraryIdentifier === undefined || deviceLibraryIdentifier === null)
            throw new Error("The parameter 'deviceLibraryIdentifier' must be defined.");
        url_ = url_.replace("{deviceLibraryIdentifier}", encodeURIComponent("" + deviceLibraryIdentifier));
        if (protocolVersion === undefined || protocolVersion === null)
            throw new Error("The parameter 'protocolVersion' must be defined.");
        url_ = url_.replace("{protocolVersion}", encodeURIComponent("" + protocolVersion));
        if (passesUpdatedSince !== undefined && passesUpdatedSince !== null)
            url_ += "passesUpdatedSince=" + encodeURIComponent("" + passesUpdatedSince) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSerials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSerials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListUpdatedPasses>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListUpdatedPasses>;
        }));
    }

    protected processSendSerials(response: HttpResponseBase): Observable<ListUpdatedPasses> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListUpdatedPasses.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListUpdatedPasses>(null as any);
    }

    latestPass(passTypeIdentifier: string | null, serialNumber: string | null, protocolVersion: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/{protocolVersion}/passes/{passTypeIdentifier}/{serialNumber}";
        if (passTypeIdentifier === undefined || passTypeIdentifier === null)
            throw new Error("The parameter 'passTypeIdentifier' must be defined.");
        url_ = url_.replace("{passTypeIdentifier}", encodeURIComponent("" + passTypeIdentifier));
        if (serialNumber === undefined || serialNumber === null)
            throw new Error("The parameter 'serialNumber' must be defined.");
        url_ = url_.replace("{serialNumber}", encodeURIComponent("" + serialNumber));
        if (protocolVersion === undefined || protocolVersion === null)
            throw new Error("The parameter 'protocolVersion' must be defined.");
        url_ = url_.replace("{protocolVersion}", encodeURIComponent("" + protocolVersion));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLatestPass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLatestPass(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processLatestPass(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    readFiles(filePath: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/AppleNotification?";
        if (filePath !== undefined && filePath !== null)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processReadFiles(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    errorLog(protocolVersion: string, errorlog: string): Observable<number> {
        let url_ = this.baseUrl + "/{protocolVersion}/log";
        if (protocolVersion === undefined || protocolVersion === null)
            throw new Error("The parameter 'protocolVersion' must be defined.");
        url_ = url_.replace("{protocolVersion}", encodeURIComponent("" + protocolVersion));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(errorlog);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processErrorLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processErrorLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processErrorLog(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    tokenNTimes(minTime: string | null, maxTime: string | null): Observable<TriggerData[]> {
        let url_ = this.baseUrl + "/triggerdata/{minTime}/{maxTime}";
        if (minTime === undefined || minTime === null)
            throw new Error("The parameter 'minTime' must be defined.");
        url_ = url_.replace("{minTime}", encodeURIComponent("" + minTime));
        if (maxTime === undefined || maxTime === null)
            throw new Error("The parameter 'maxTime' must be defined.");
        url_ = url_.replace("{maxTime}", encodeURIComponent("" + maxTime));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTokenNTimes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTokenNTimes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TriggerData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TriggerData[]>;
        }));
    }

    protected processTokenNTimes(response: HttpResponseBase): Observable<TriggerData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TriggerData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TriggerData[]>(null as any);
    }

    getNotificationTriggers(minTime: string | null, maxTime: string | null): Observable<NotificationTriggers[]> {
        let url_ = this.baseUrl + "/androidnotifications/{minTime}/{maxTime}";
        if (minTime === undefined || minTime === null)
            throw new Error("The parameter 'minTime' must be defined.");
        url_ = url_.replace("{minTime}", encodeURIComponent("" + minTime));
        if (maxTime === undefined || maxTime === null)
            throw new Error("The parameter 'maxTime' must be defined.");
        url_ = url_.replace("{maxTime}", encodeURIComponent("" + maxTime));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationTriggers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationTriggers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationTriggers[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationTriggers[]>;
        }));
    }

    protected processGetNotificationTriggers(response: HttpResponseBase): Observable<NotificationTriggers[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationTriggers.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationTriggers[]>(null as any);
    }
}

export interface IAppUpdatesService {
    getLatest(deviceId: string | null | undefined): Observable<ResponseModelOfListOfAppUpdateAnnouncementResponse>;
    markSeen(request: MarkAppUpdateSeenRequest): Observable<ResponseModelOfBoolean>;
    updatePrompt(version: string | null | undefined): Observable<ResponseModelOfAppUpdatePromptResponse>;
    isRequired(version: string | null | undefined): Observable<ResponseModelOfBoolean>;
}

@Injectable()
export class AppUpdatesService implements IAppUpdatesService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getLatest(deviceId: string | null | undefined): Observable<ResponseModelOfListOfAppUpdateAnnouncementResponse> {
        let url_ = this.baseUrl + "/api/app-updates/latest?";
        if (deviceId !== undefined && deviceId !== null)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfListOfAppUpdateAnnouncementResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfListOfAppUpdateAnnouncementResponse>;
        }));
    }

    protected processGetLatest(response: HttpResponseBase): Observable<ResponseModelOfListOfAppUpdateAnnouncementResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfListOfAppUpdateAnnouncementResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfListOfAppUpdateAnnouncementResponse>(null as any);
    }

    markSeen(request: MarkAppUpdateSeenRequest): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/app-updates/mark-seen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkSeen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkSeen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processMarkSeen(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }

    updatePrompt(version: string | null | undefined): Observable<ResponseModelOfAppUpdatePromptResponse> {
        let url_ = this.baseUrl + "/api/app-updates/update-prompt?";
        if (version !== undefined && version !== null)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrompt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrompt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfAppUpdatePromptResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfAppUpdatePromptResponse>;
        }));
    }

    protected processUpdatePrompt(response: HttpResponseBase): Observable<ResponseModelOfAppUpdatePromptResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfAppUpdatePromptResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfAppUpdatePromptResponse>(null as any);
    }

    isRequired(version: string | null | undefined): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/app-updates/is-required?";
        if (version !== undefined && version !== null)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsRequired(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsRequired(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processIsRequired(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }
}

export interface IAttachmentService {
    get(): Observable<FileResponse>;
    upload(file: FileParameter | null | undefined, attachmentType: string | null | undefined): Observable<ResponseTransportOfUploadAttachmentOutput>;
    view(attachmentId: number | undefined): Observable<ResponseTransportOfString>;
    download(filename: string | null | undefined): Observable<FileResponse>;
    delete(attachmentId: number | undefined): Observable<ResponseTransportOfBoolean>;
}

@Injectable()
export class AttachmentService implements IAttachmentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    get(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Attachment/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    upload(file: FileParameter | null | undefined, attachmentType: string | null | undefined): Observable<ResponseTransportOfUploadAttachmentOutput> {
        let url_ = this.baseUrl + "/api/Attachment/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (attachmentType !== null && attachmentType !== undefined)
            content_.append("AttachmentType", attachmentType.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfUploadAttachmentOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfUploadAttachmentOutput>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<ResponseTransportOfUploadAttachmentOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfUploadAttachmentOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfUploadAttachmentOutput>(null as any);
    }

    view(attachmentId: number | undefined): Observable<ResponseTransportOfString> {
        let url_ = this.baseUrl + "/api/Attachment/View?";
        if (attachmentId === null)
            throw new Error("The parameter 'attachmentId' cannot be null.");
        else if (attachmentId !== undefined)
            url_ += "attachmentId=" + encodeURIComponent("" + attachmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfString>;
        }));
    }

    protected processView(response: HttpResponseBase): Observable<ResponseTransportOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfString>(null as any);
    }

    download(filename: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Attachment/Download?";
        if (filename !== undefined && filename !== null)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    delete(attachmentId: number | undefined): Observable<ResponseTransportOfBoolean> {
        let url_ = this.baseUrl + "/api/Attachment/Delete?";
        if (attachmentId === null)
            throw new Error("The parameter 'attachmentId' cannot be null.");
        else if (attachmentId !== undefined)
            url_ += "attachmentId=" + encodeURIComponent("" + attachmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfBoolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ResponseTransportOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfBoolean>(null as any);
    }
}

export interface IAttributeService {
    getCountry(countryDbRequest: CountryDbRequest): Observable<CountryResponse[]>;
    getProfession(professionDbRequest: ProfessionDbRequest): Observable<ProfessionResponse[]>;
    getGender(): Observable<GenderResponse[]>;
}

@Injectable()
export class AttributeService implements IAttributeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getCountry(countryDbRequest: CountryDbRequest): Observable<CountryResponse[]> {
        let url_ = this.baseUrl + "/api/Attribute/GetCountry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(countryDbRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryResponse[]>;
        }));
    }

    protected processGetCountry(response: HttpResponseBase): Observable<CountryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryResponse[]>(null as any);
    }

    getProfession(professionDbRequest: ProfessionDbRequest): Observable<ProfessionResponse[]> {
        let url_ = this.baseUrl + "/api/Attribute/GetProfession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(professionDbRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionResponse[]>;
        }));
    }

    protected processGetProfession(response: HttpResponseBase): Observable<ProfessionResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfessionResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfessionResponse[]>(null as any);
    }

    getGender(): Observable<GenderResponse[]> {
        let url_ = this.baseUrl + "/api/Attribute/GetGender";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGender(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGender(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenderResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenderResponse[]>;
        }));
    }

    protected processGetGender(response: HttpResponseBase): Observable<GenderResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GenderResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenderResponse[]>(null as any);
    }
}

export interface ICardsService {
    getOriginalDeck(getAllDecks: number | undefined, cardId: number | null | undefined, cardDeckId: number | null | undefined): Observable<CardDecks[]>;
    getPatientDeck(getAllDecks: number | undefined, cardId: number | null | undefined, cardDeckId: number | null | undefined): Observable<CardDecks[]>;
    getCardDeckTypes(): Observable<CardDeckType[]>;
    getCardCategories(): Observable<CardCategories[]>;
    getAllCards(): Observable<CardModelResponse>;
    getCollectionStats(): Observable<CardCollectionStatsResponse>;
    completeCard(cardSessionCompleteRequest: CardSessionCompleteRequest): Observable<number>;
    savePatientCards(myDeckModel: MyDeckModel): Observable<number>;
    createCustomCard(request: CreateUserCardRequest): Observable<number>;
    editCard(request: EditCardRequest): Observable<EditCardResponse>;
}

@Injectable()
export class CardsService implements ICardsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getOriginalDeck(getAllDecks: number | undefined, cardId: number | null | undefined, cardDeckId: number | null | undefined): Observable<CardDecks[]> {
        let url_ = this.baseUrl + "/api/Cards/GetOriginalDeck?";
        if (getAllDecks === null)
            throw new Error("The parameter 'getAllDecks' cannot be null.");
        else if (getAllDecks !== undefined)
            url_ += "GetAllDecks=" + encodeURIComponent("" + getAllDecks) + "&";
        if (cardId !== undefined && cardId !== null)
            url_ += "CardId=" + encodeURIComponent("" + cardId) + "&";
        if (cardDeckId !== undefined && cardDeckId !== null)
            url_ += "CardDeckId=" + encodeURIComponent("" + cardDeckId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOriginalDeck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOriginalDeck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardDecks[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardDecks[]>;
        }));
    }

    protected processGetOriginalDeck(response: HttpResponseBase): Observable<CardDecks[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardDecks.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CardDecks[]>(null as any);
    }

    getPatientDeck(getAllDecks: number | undefined, cardId: number | null | undefined, cardDeckId: number | null | undefined): Observable<CardDecks[]> {
        let url_ = this.baseUrl + "/api/Cards/GetPatientDeck?";
        if (getAllDecks === null)
            throw new Error("The parameter 'getAllDecks' cannot be null.");
        else if (getAllDecks !== undefined)
            url_ += "GetAllDecks=" + encodeURIComponent("" + getAllDecks) + "&";
        if (cardId !== undefined && cardId !== null)
            url_ += "CardId=" + encodeURIComponent("" + cardId) + "&";
        if (cardDeckId !== undefined && cardDeckId !== null)
            url_ += "CardDeckId=" + encodeURIComponent("" + cardDeckId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientDeck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientDeck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardDecks[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardDecks[]>;
        }));
    }

    protected processGetPatientDeck(response: HttpResponseBase): Observable<CardDecks[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardDecks.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CardDecks[]>(null as any);
    }

    getCardDeckTypes(): Observable<CardDeckType[]> {
        let url_ = this.baseUrl + "/api/Cards/GetCardDeckTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardDeckTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardDeckTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardDeckType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardDeckType[]>;
        }));
    }

    protected processGetCardDeckTypes(response: HttpResponseBase): Observable<CardDeckType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardDeckType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CardDeckType[]>(null as any);
    }

    getCardCategories(): Observable<CardCategories[]> {
        let url_ = this.baseUrl + "/api/Cards/GetCardCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardCategories[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardCategories[]>;
        }));
    }

    protected processGetCardCategories(response: HttpResponseBase): Observable<CardCategories[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardCategories.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CardCategories[]>(null as any);
    }

    getAllCards(): Observable<CardModelResponse> {
        let url_ = this.baseUrl + "/api/Cards/GetAllCards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardModelResponse>;
        }));
    }

    protected processGetAllCards(response: HttpResponseBase): Observable<CardModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardModelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CardModelResponse>(null as any);
    }

    getCollectionStats(): Observable<CardCollectionStatsResponse> {
        let url_ = this.baseUrl + "/api/Cards/GetCollectionStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCollectionStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCollectionStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardCollectionStatsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardCollectionStatsResponse>;
        }));
    }

    protected processGetCollectionStats(response: HttpResponseBase): Observable<CardCollectionStatsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardCollectionStatsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CardCollectionStatsResponse>(null as any);
    }

    completeCard(cardSessionCompleteRequest: CardSessionCompleteRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/Cards/CompleteCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cardSessionCompleteRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCompleteCard(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    savePatientCards(myDeckModel: MyDeckModel): Observable<number> {
        let url_ = this.baseUrl + "/api/Cards/SavePatientCards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(myDeckModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePatientCards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePatientCards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSavePatientCards(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    createCustomCard(request: CreateUserCardRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/Cards/CreateCustomCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateCustomCard(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    editCard(request: EditCardRequest): Observable<EditCardResponse> {
        let url_ = this.baseUrl + "/api/Cards/EditCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditCardResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditCardResponse>;
        }));
    }

    protected processEditCard(response: HttpResponseBase): Observable<EditCardResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditCardResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditCardResponse>(null as any);
    }
}

export interface IConsoleService {
    getClinician(clinicianId: number | null | undefined, clinicId: number | null | undefined): Observable<ClinicianSelectResponse>;
    saveClinician(clinicianSaveRequest: ClinicianSaveRequest): Observable<SaveResponse>;
    getClinic(organisationId: number | null | undefined, clinicId: number | null | undefined): Observable<ClinicSelectResponse>;
    saveClinic(clinicSaveRequest: ClinicSaveRequest): Observable<SaveResponse>;
    getOrganisations(organisationId: number | null | undefined): Observable<ConsoleOrganisationResponse>;
    saveLicence(isClinician: boolean | undefined, isFirstLicence: boolean | undefined, newLicenceCount: number | undefined, licenceSaveRequest: LicenceSaveRequest): Observable<LicenceSaveResponse>;
    updateLicence(licenceUpdateRequest: LicenceUpdateRequest): Observable<boolean>;
    assignLicence(licenceAssignRequest: LicenceAssignRequest): Observable<LicenceAssignResponse>;
    saveOrganisation(organisationSaveRequest: OrganisationSaveRequest): Observable<SaveResponse>;
    getLicence(masterLicenceId: number | null | undefined, licenceTypeId: number | null | undefined, clinicianId: number | null | undefined): Observable<LicenceSelectResponse>;
    getProfession(professionId: number | null | undefined, professionName: string | null | undefined, professionTypeId: number | null | undefined, professionTypeName: string | null | undefined): Observable<ProfessionSelectResponse[]>;
    getCountries(): Observable<Country[]>;
    getLocations(countryId: number | undefined, searchTerm: string | null | undefined): Observable<Locations[]>;
    getClinicTypes(): Observable<ClinicTypeSelectResponse>;
}

@Injectable()
export class ConsoleService implements IConsoleService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getClinician(clinicianId: number | null | undefined, clinicId: number | null | undefined): Observable<ClinicianSelectResponse> {
        let url_ = this.baseUrl + "/api/Console/GetClinician?";
        if (clinicianId !== undefined && clinicianId !== null)
            url_ += "ClinicianId=" + encodeURIComponent("" + clinicianId) + "&";
        if (clinicId !== undefined && clinicId !== null)
            url_ += "ClinicId=" + encodeURIComponent("" + clinicId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClinician(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClinician(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClinicianSelectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClinicianSelectResponse>;
        }));
    }

    protected processGetClinician(response: HttpResponseBase): Observable<ClinicianSelectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicianSelectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClinicianSelectResponse>(null as any);
    }

    saveClinician(clinicianSaveRequest: ClinicianSaveRequest): Observable<SaveResponse> {
        let url_ = this.baseUrl + "/api/Console/SaveClinician";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clinicianSaveRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveClinician(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveClinician(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveResponse>;
        }));
    }

    protected processSaveClinician(response: HttpResponseBase): Observable<SaveResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SaveResponse>(null as any);
    }

    getClinic(organisationId: number | null | undefined, clinicId: number | null | undefined): Observable<ClinicSelectResponse> {
        let url_ = this.baseUrl + "/api/Console/GetClinic?";
        if (organisationId !== undefined && organisationId !== null)
            url_ += "OrganisationId=" + encodeURIComponent("" + organisationId) + "&";
        if (clinicId !== undefined && clinicId !== null)
            url_ += "ClinicId=" + encodeURIComponent("" + clinicId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClinic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClinic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClinicSelectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClinicSelectResponse>;
        }));
    }

    protected processGetClinic(response: HttpResponseBase): Observable<ClinicSelectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicSelectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClinicSelectResponse>(null as any);
    }

    saveClinic(clinicSaveRequest: ClinicSaveRequest): Observable<SaveResponse> {
        let url_ = this.baseUrl + "/api/Console/SaveClinic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clinicSaveRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveClinic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveClinic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveResponse>;
        }));
    }

    protected processSaveClinic(response: HttpResponseBase): Observable<SaveResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SaveResponse>(null as any);
    }

    getOrganisations(organisationId: number | null | undefined): Observable<ConsoleOrganisationResponse> {
        let url_ = this.baseUrl + "/api/Console/GetOrganisations?";
        if (organisationId !== undefined && organisationId !== null)
            url_ += "OrganisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganisations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganisations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsoleOrganisationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsoleOrganisationResponse>;
        }));
    }

    protected processGetOrganisations(response: HttpResponseBase): Observable<ConsoleOrganisationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsoleOrganisationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsoleOrganisationResponse>(null as any);
    }

    saveLicence(isClinician: boolean | undefined, isFirstLicence: boolean | undefined, newLicenceCount: number | undefined, licenceSaveRequest: LicenceSaveRequest): Observable<LicenceSaveResponse> {
        let url_ = this.baseUrl + "/api/Console/SaveLicence?";
        if (isClinician === null)
            throw new Error("The parameter 'isClinician' cannot be null.");
        else if (isClinician !== undefined)
            url_ += "isClinician=" + encodeURIComponent("" + isClinician) + "&";
        if (isFirstLicence === null)
            throw new Error("The parameter 'isFirstLicence' cannot be null.");
        else if (isFirstLicence !== undefined)
            url_ += "isFirstLicence=" + encodeURIComponent("" + isFirstLicence) + "&";
        if (newLicenceCount === null)
            throw new Error("The parameter 'newLicenceCount' cannot be null.");
        else if (newLicenceCount !== undefined)
            url_ += "newLicenceCount=" + encodeURIComponent("" + newLicenceCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(licenceSaveRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenceSaveResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenceSaveResponse>;
        }));
    }

    protected processSaveLicence(response: HttpResponseBase): Observable<LicenceSaveResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenceSaveResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenceSaveResponse>(null as any);
    }

    updateLicence(licenceUpdateRequest: LicenceUpdateRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Console/UpdateLicence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(licenceUpdateRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateLicence(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    assignLicence(licenceAssignRequest: LicenceAssignRequest): Observable<LicenceAssignResponse> {
        let url_ = this.baseUrl + "/api/Console/AssignLicence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(licenceAssignRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenceAssignResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenceAssignResponse>;
        }));
    }

    protected processAssignLicence(response: HttpResponseBase): Observable<LicenceAssignResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenceAssignResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenceAssignResponse>(null as any);
    }

    saveOrganisation(organisationSaveRequest: OrganisationSaveRequest): Observable<SaveResponse> {
        let url_ = this.baseUrl + "/api/Console/SaveOrganisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organisationSaveRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveOrganisation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveOrganisation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveResponse>;
        }));
    }

    protected processSaveOrganisation(response: HttpResponseBase): Observable<SaveResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SaveResponse>(null as any);
    }

    getLicence(masterLicenceId: number | null | undefined, licenceTypeId: number | null | undefined, clinicianId: number | null | undefined): Observable<LicenceSelectResponse> {
        let url_ = this.baseUrl + "/api/Console/GetLicence?";
        if (masterLicenceId !== undefined && masterLicenceId !== null)
            url_ += "masterLicenceId=" + encodeURIComponent("" + masterLicenceId) + "&";
        if (licenceTypeId !== undefined && licenceTypeId !== null)
            url_ += "licenceTypeId=" + encodeURIComponent("" + licenceTypeId) + "&";
        if (clinicianId !== undefined && clinicianId !== null)
            url_ += "clinicianId=" + encodeURIComponent("" + clinicianId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenceSelectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenceSelectResponse>;
        }));
    }

    protected processGetLicence(response: HttpResponseBase): Observable<LicenceSelectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenceSelectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenceSelectResponse>(null as any);
    }

    getProfession(professionId: number | null | undefined, professionName: string | null | undefined, professionTypeId: number | null | undefined, professionTypeName: string | null | undefined): Observable<ProfessionSelectResponse[]> {
        let url_ = this.baseUrl + "/api/Console/GetProfession?";
        if (professionId !== undefined && professionId !== null)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (professionName !== undefined && professionName !== null)
            url_ += "professionName=" + encodeURIComponent("" + professionName) + "&";
        if (professionTypeId !== undefined && professionTypeId !== null)
            url_ += "professionTypeId=" + encodeURIComponent("" + professionTypeId) + "&";
        if (professionTypeName !== undefined && professionTypeName !== null)
            url_ += "professionTypeName=" + encodeURIComponent("" + professionTypeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionSelectResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionSelectResponse[]>;
        }));
    }

    protected processGetProfession(response: HttpResponseBase): Observable<ProfessionSelectResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfessionSelectResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfessionSelectResponse[]>(null as any);
    }

    getCountries(): Observable<Country[]> {
        let url_ = this.baseUrl + "/api/Console/GetCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Country[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Country[]>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<Country[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Country.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Country[]>(null as any);
    }

    getLocations(countryId: number | undefined, searchTerm: string | null | undefined): Observable<Locations[]> {
        let url_ = this.baseUrl + "/api/Console/GetLocations?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Locations[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Locations[]>;
        }));
    }

    protected processGetLocations(response: HttpResponseBase): Observable<Locations[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Locations.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Locations[]>(null as any);
    }

    getClinicTypes(): Observable<ClinicTypeSelectResponse> {
        let url_ = this.baseUrl + "/api/Console/GetClinicTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClinicTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClinicTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClinicTypeSelectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClinicTypeSelectResponse>;
        }));
    }

    protected processGetClinicTypes(response: HttpResponseBase): Observable<ClinicTypeSelectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicTypeSelectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClinicTypeSelectResponse>(null as any);
    }
}

export interface IContactService {
    sendAppFeatureSuggestion(request: AppFeatureSuggestionRequest): Observable<ResponseModelOfBoolean>;
    sendBugReport(request: BugReportRequest): Observable<ResponseModelOfBoolean>;
}

@Injectable()
export class ContactService implements IContactService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    sendAppFeatureSuggestion(request: AppFeatureSuggestionRequest): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/Contact/SendAppFeatureSuggestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAppFeatureSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAppFeatureSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processSendAppFeatureSuggestion(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }

    sendBugReport(request: BugReportRequest): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/Contact/SendBugReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendBugReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendBugReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processSendBugReport(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }
}

export interface ICourseService {
    getCourses(): Observable<ResponseTransportOfListOfCourseEditDto>;
    getCourseForEdit(id: number | null | undefined): Observable<ResponseTransportOfCourseEditDto>;
    createOrUpdateCourse(courseEditDto: CourseEditDto): Observable<ResponseTransportOfCourseEditDto>;
    duplicateCourse(id: number | undefined): Observable<ResponseTransportOfCourseEditDto>;
    deleteCourse(id: number | undefined): Observable<ResponseTransportOfBoolean>;
    publishCourse(id: number | undefined): Observable<ResponseTransportOfBoolean>;
}

@Injectable()
export class CourseService implements ICourseService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getCourses(): Observable<ResponseTransportOfListOfCourseEditDto> {
        let url_ = this.baseUrl + "/api/Course/GetCourses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfListOfCourseEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfListOfCourseEditDto>;
        }));
    }

    protected processGetCourses(response: HttpResponseBase): Observable<ResponseTransportOfListOfCourseEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfListOfCourseEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfListOfCourseEditDto>(null as any);
    }

    getCourseForEdit(id: number | null | undefined): Observable<ResponseTransportOfCourseEditDto> {
        let url_ = this.baseUrl + "/api/Course/GetCourseForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourseForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourseForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfCourseEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfCourseEditDto>;
        }));
    }

    protected processGetCourseForEdit(response: HttpResponseBase): Observable<ResponseTransportOfCourseEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfCourseEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfCourseEditDto>(null as any);
    }

    createOrUpdateCourse(courseEditDto: CourseEditDto): Observable<ResponseTransportOfCourseEditDto> {
        let url_ = this.baseUrl + "/api/Course/CreateOrUpdateCourse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(courseEditDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateCourse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateCourse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfCourseEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfCourseEditDto>;
        }));
    }

    protected processCreateOrUpdateCourse(response: HttpResponseBase): Observable<ResponseTransportOfCourseEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfCourseEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfCourseEditDto>(null as any);
    }

    duplicateCourse(id: number | undefined): Observable<ResponseTransportOfCourseEditDto> {
        let url_ = this.baseUrl + "/api/Course/DuplicateCourse?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateCourse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateCourse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfCourseEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfCourseEditDto>;
        }));
    }

    protected processDuplicateCourse(response: HttpResponseBase): Observable<ResponseTransportOfCourseEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfCourseEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfCourseEditDto>(null as any);
    }

    deleteCourse(id: number | undefined): Observable<ResponseTransportOfBoolean> {
        let url_ = this.baseUrl + "/api/Course/DeleteCourse?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCourse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCourse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfBoolean>;
        }));
    }

    protected processDeleteCourse(response: HttpResponseBase): Observable<ResponseTransportOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfBoolean>(null as any);
    }

    publishCourse(id: number | undefined): Observable<ResponseTransportOfBoolean> {
        let url_ = this.baseUrl + "/api/Course/PublishCourse?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishCourse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishCourse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfBoolean>;
        }));
    }

    protected processPublishCourse(response: HttpResponseBase): Observable<ResponseTransportOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfBoolean>(null as any);
    }
}

export interface IFavouriteHandService {
    getFavouriteHands(): Observable<ResponseModelOfFavouriteHandOperationResponse>;
    createFavouriteHand(request: CreateFavouriteHandRequest): Observable<ResponseModelOfFavouriteHandOperationResponse>;
    renameFavouriteHand(request: RenameFavouriteHandRequest): Observable<ResponseModelOfFavouriteHandOperationResponse>;
    deleteFavouriteHand(request: DeleteFavouriteHandRequest): Observable<ResponseModelOfFavouriteHandOperationResponse>;
}

@Injectable()
export class FavouriteHandService implements IFavouriteHandService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getFavouriteHands(): Observable<ResponseModelOfFavouriteHandOperationResponse> {
        let url_ = this.baseUrl + "/api/FavouriteHand/GetFavouriteHands";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFavouriteHands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFavouriteHands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfFavouriteHandOperationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfFavouriteHandOperationResponse>;
        }));
    }

    protected processGetFavouriteHands(response: HttpResponseBase): Observable<ResponseModelOfFavouriteHandOperationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfFavouriteHandOperationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfFavouriteHandOperationResponse>(null as any);
    }

    createFavouriteHand(request: CreateFavouriteHandRequest): Observable<ResponseModelOfFavouriteHandOperationResponse> {
        let url_ = this.baseUrl + "/api/FavouriteHand/CreateFavouriteHand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFavouriteHand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFavouriteHand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfFavouriteHandOperationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfFavouriteHandOperationResponse>;
        }));
    }

    protected processCreateFavouriteHand(response: HttpResponseBase): Observable<ResponseModelOfFavouriteHandOperationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfFavouriteHandOperationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfFavouriteHandOperationResponse>(null as any);
    }

    renameFavouriteHand(request: RenameFavouriteHandRequest): Observable<ResponseModelOfFavouriteHandOperationResponse> {
        let url_ = this.baseUrl + "/api/FavouriteHand/RenameFavouriteHand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenameFavouriteHand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenameFavouriteHand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfFavouriteHandOperationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfFavouriteHandOperationResponse>;
        }));
    }

    protected processRenameFavouriteHand(response: HttpResponseBase): Observable<ResponseModelOfFavouriteHandOperationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfFavouriteHandOperationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfFavouriteHandOperationResponse>(null as any);
    }

    deleteFavouriteHand(request: DeleteFavouriteHandRequest): Observable<ResponseModelOfFavouriteHandOperationResponse> {
        let url_ = this.baseUrl + "/api/FavouriteHand/DeleteFavouriteHand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFavouriteHand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFavouriteHand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfFavouriteHandOperationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfFavouriteHandOperationResponse>;
        }));
    }

    protected processDeleteFavouriteHand(response: HttpResponseBase): Observable<ResponseModelOfFavouriteHandOperationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfFavouriteHandOperationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfFavouriteHandOperationResponse>(null as any);
    }
}

export interface IFeatureFlagsService {
    getResolvedFlags(): Observable<ResponseModelOfDictionaryOfStringAndBoolean>;
    getPublicSignupFlags(): Observable<ResponseModelOfDictionaryOfStringAndBoolean>;
    getAllForAdmin(): Observable<ResponseModelOfListOfFeatureFlagAdminDto>;
    upsertFlag(request: UpsertFeatureFlagRequest): Observable<ResponseModelOfBoolean>;
    addOverride(request: FeatureFlagOverrideRequest): Observable<ResponseModelOfBoolean>;
    removeOverride(request: FeatureFlagOverrideRequest): Observable<ResponseModelOfBoolean>;
}

@Injectable()
export class FeatureFlagsService implements IFeatureFlagsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getResolvedFlags(): Observable<ResponseModelOfDictionaryOfStringAndBoolean> {
        let url_ = this.baseUrl + "/api/FeatureFlags/GetResolvedFlags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResolvedFlags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResolvedFlags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfDictionaryOfStringAndBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfDictionaryOfStringAndBoolean>;
        }));
    }

    protected processGetResolvedFlags(response: HttpResponseBase): Observable<ResponseModelOfDictionaryOfStringAndBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfDictionaryOfStringAndBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfDictionaryOfStringAndBoolean>(null as any);
    }

    getPublicSignupFlags(): Observable<ResponseModelOfDictionaryOfStringAndBoolean> {
        let url_ = this.baseUrl + "/api/FeatureFlags/GetPublicSignupFlags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicSignupFlags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicSignupFlags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfDictionaryOfStringAndBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfDictionaryOfStringAndBoolean>;
        }));
    }

    protected processGetPublicSignupFlags(response: HttpResponseBase): Observable<ResponseModelOfDictionaryOfStringAndBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfDictionaryOfStringAndBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfDictionaryOfStringAndBoolean>(null as any);
    }

    getAllForAdmin(): Observable<ResponseModelOfListOfFeatureFlagAdminDto> {
        let url_ = this.baseUrl + "/api/FeatureFlags/GetAllForAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfListOfFeatureFlagAdminDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfListOfFeatureFlagAdminDto>;
        }));
    }

    protected processGetAllForAdmin(response: HttpResponseBase): Observable<ResponseModelOfListOfFeatureFlagAdminDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfListOfFeatureFlagAdminDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfListOfFeatureFlagAdminDto>(null as any);
    }

    upsertFlag(request: UpsertFeatureFlagRequest): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/FeatureFlags/UpsertFlag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processUpsertFlag(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }

    addOverride(request: FeatureFlagOverrideRequest): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/FeatureFlags/AddOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOverride(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOverride(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processAddOverride(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }

    removeOverride(request: FeatureFlagOverrideRequest): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/FeatureFlags/RemoveOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveOverride(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveOverride(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processRemoveOverride(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }
}

export interface IFlareUpPlanService {
    getUserPlan(): Observable<ResponseTransportOfFlareUpPlanDto>;
    update(id: number, flareUpPlan: FlareUpPlanDto): Observable<ResponseTransportOfFlareUpPlanDto>;
    create(flareUpPlan: FlareUpPlanDto): Observable<ResponseTransportOfFlareUpPlanDto>;
    deleteFlareUpPlan(id: number): Observable<FileResponse>;
}

@Injectable()
export class FlareUpPlanService implements IFlareUpPlanService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getUserPlan(): Observable<ResponseTransportOfFlareUpPlanDto> {
        let url_ = this.baseUrl + "/api/FlareUpPlan/GetUserPlan";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfFlareUpPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfFlareUpPlanDto>;
        }));
    }

    protected processGetUserPlan(response: HttpResponseBase): Observable<ResponseTransportOfFlareUpPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfFlareUpPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfFlareUpPlanDto>(null as any);
    }

    update(id: number, flareUpPlan: FlareUpPlanDto): Observable<ResponseTransportOfFlareUpPlanDto> {
        let url_ = this.baseUrl + "/api/FlareUpPlan/Update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(flareUpPlan);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfFlareUpPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfFlareUpPlanDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResponseTransportOfFlareUpPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfFlareUpPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfFlareUpPlanDto>(null as any);
    }

    create(flareUpPlan: FlareUpPlanDto): Observable<ResponseTransportOfFlareUpPlanDto> {
        let url_ = this.baseUrl + "/api/FlareUpPlan/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(flareUpPlan);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfFlareUpPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfFlareUpPlanDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResponseTransportOfFlareUpPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfFlareUpPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfFlareUpPlanDto>(null as any);
    }

    deleteFlareUpPlan(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/FlareUpPlan/DeleteFlareUpPlan/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFlareUpPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFlareUpPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteFlareUpPlan(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IFormService {
    getSurvey(surveyType: string | null | undefined): Observable<ResponseTransportOfSurveyDto>;
    getSurveyForEdit(surveyType: string | null | undefined): Observable<ResponseTransportOfSurveyEditDto>;
    getSurveyEntityForEdit(surveyType: string | null | undefined, licenceStreamId: number | undefined): Observable<ResponseTransportOfSurveyEntityEditDto>;
    saveSurveyEntity(withDependency: boolean | undefined, licenceStreamId: number | undefined, surveyEntityDto: SurveyEntityEditDto): Observable<ResponseTransportOfInteger>;
    getDependencyQuestionList(surveyType: string | null | undefined): Observable<ResponseTransportOfDependencyQuestionsDto>;
    deleteSurveyEntity(surveyId: number | undefined): Observable<ResponseTransportOfBoolean>;
    saveDependencyQuestions(inputDto: DependencyQuestionsDto): Observable<ResponseTransportOfBoolean>;
    saveLiftResponse(liftResponseSaveRequest: LiftResponseSaveRequest): Observable<ResponseTransportOfInteger>;
    saveResponse(surveyResponseSaveRequest: SurveyResponseSaveRequest): Observable<ResponseTransportOfInteger>;
    savePatientResponse(surveyResponseSaveRequest: PatientSurveyResponseSaveRequest): Observable<ResponseTransportOfInteger>;
    getLastSurveyResponse(surveyType: string | null | undefined): Observable<ResponseTransportOfSurveyResponseDto>;
    getSurveyCompletion(): Observable<ResponseTransportOfSurveyCompletionResponse>;
    getPatientSurveyCompletion(patientId: number | undefined): Observable<ResponseTransportOfSurveyCompletionResponse>;
    getSurveyWithUserResponse(surveyType: string | null | undefined): Observable<ResponseTransportOfSurveyDto>;
    getPatientSurveyWithUserResponse(patientId: number | undefined, surveyType: string | null | undefined): Observable<ResponseTransportOfPatientSurveyResponse>;
    activateSurvey(patientId: number | undefined, surveyType: string | null | undefined): Observable<ResponseTransportOfInteger>;
}

@Injectable()
export class FormService implements IFormService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getSurvey(surveyType: string | null | undefined): Observable<ResponseTransportOfSurveyDto> {
        let url_ = this.baseUrl + "/api/Form/GetSurvey?";
        if (surveyType !== undefined && surveyType !== null)
            url_ += "surveyType=" + encodeURIComponent("" + surveyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfSurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfSurveyDto>;
        }));
    }

    protected processGetSurvey(response: HttpResponseBase): Observable<ResponseTransportOfSurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfSurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfSurveyDto>(null as any);
    }

    getSurveyForEdit(surveyType: string | null | undefined): Observable<ResponseTransportOfSurveyEditDto> {
        let url_ = this.baseUrl + "/api/Form/GetSurveyForEdit?";
        if (surveyType !== undefined && surveyType !== null)
            url_ += "surveyType=" + encodeURIComponent("" + surveyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfSurveyEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfSurveyEditDto>;
        }));
    }

    protected processGetSurveyForEdit(response: HttpResponseBase): Observable<ResponseTransportOfSurveyEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfSurveyEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfSurveyEditDto>(null as any);
    }

    getSurveyEntityForEdit(surveyType: string | null | undefined, licenceStreamId: number | undefined): Observable<ResponseTransportOfSurveyEntityEditDto> {
        let url_ = this.baseUrl + "/api/Form/GetSurveyEntityForEdit?";
        if (surveyType !== undefined && surveyType !== null)
            url_ += "surveyType=" + encodeURIComponent("" + surveyType) + "&";
        if (licenceStreamId === null)
            throw new Error("The parameter 'licenceStreamId' cannot be null.");
        else if (licenceStreamId !== undefined)
            url_ += "licenceStreamId=" + encodeURIComponent("" + licenceStreamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyEntityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyEntityForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfSurveyEntityEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfSurveyEntityEditDto>;
        }));
    }

    protected processGetSurveyEntityForEdit(response: HttpResponseBase): Observable<ResponseTransportOfSurveyEntityEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfSurveyEntityEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfSurveyEntityEditDto>(null as any);
    }

    saveSurveyEntity(withDependency: boolean | undefined, licenceStreamId: number | undefined, surveyEntityDto: SurveyEntityEditDto): Observable<ResponseTransportOfInteger> {
        let url_ = this.baseUrl + "/api/Form/SaveSurveyEntity?";
        if (withDependency === null)
            throw new Error("The parameter 'withDependency' cannot be null.");
        else if (withDependency !== undefined)
            url_ += "withDependency=" + encodeURIComponent("" + withDependency) + "&";
        if (licenceStreamId === null)
            throw new Error("The parameter 'licenceStreamId' cannot be null.");
        else if (licenceStreamId !== undefined)
            url_ += "licenceStreamId=" + encodeURIComponent("" + licenceStreamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyEntityDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSurveyEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSurveyEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfInteger>;
        }));
    }

    protected processSaveSurveyEntity(response: HttpResponseBase): Observable<ResponseTransportOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfInteger>(null as any);
    }

    getDependencyQuestionList(surveyType: string | null | undefined): Observable<ResponseTransportOfDependencyQuestionsDto> {
        let url_ = this.baseUrl + "/api/Form/GetDependencyQuestionList?";
        if (surveyType !== undefined && surveyType !== null)
            url_ += "surveyType=" + encodeURIComponent("" + surveyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDependencyQuestionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDependencyQuestionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfDependencyQuestionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfDependencyQuestionsDto>;
        }));
    }

    protected processGetDependencyQuestionList(response: HttpResponseBase): Observable<ResponseTransportOfDependencyQuestionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfDependencyQuestionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfDependencyQuestionsDto>(null as any);
    }

    deleteSurveyEntity(surveyId: number | undefined): Observable<ResponseTransportOfBoolean> {
        let url_ = this.baseUrl + "/api/Form/DeleteSurveyEntity?";
        if (surveyId === null)
            throw new Error("The parameter 'surveyId' cannot be null.");
        else if (surveyId !== undefined)
            url_ += "surveyId=" + encodeURIComponent("" + surveyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSurveyEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSurveyEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfBoolean>;
        }));
    }

    protected processDeleteSurveyEntity(response: HttpResponseBase): Observable<ResponseTransportOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfBoolean>(null as any);
    }

    saveDependencyQuestions(inputDto: DependencyQuestionsDto): Observable<ResponseTransportOfBoolean> {
        let url_ = this.baseUrl + "/api/Form/SaveDependencyQuestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveDependencyQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveDependencyQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfBoolean>;
        }));
    }

    protected processSaveDependencyQuestions(response: HttpResponseBase): Observable<ResponseTransportOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfBoolean>(null as any);
    }

    saveLiftResponse(liftResponseSaveRequest: LiftResponseSaveRequest): Observable<ResponseTransportOfInteger> {
        let url_ = this.baseUrl + "/api/Form/SaveLiftResponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(liftResponseSaveRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveLiftResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveLiftResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfInteger>;
        }));
    }

    protected processSaveLiftResponse(response: HttpResponseBase): Observable<ResponseTransportOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfInteger>(null as any);
    }

    saveResponse(surveyResponseSaveRequest: SurveyResponseSaveRequest): Observable<ResponseTransportOfInteger> {
        let url_ = this.baseUrl + "/api/Form/SaveResponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyResponseSaveRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfInteger>;
        }));
    }

    protected processSaveResponse(response: HttpResponseBase): Observable<ResponseTransportOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfInteger>(null as any);
    }

    savePatientResponse(surveyResponseSaveRequest: PatientSurveyResponseSaveRequest): Observable<ResponseTransportOfInteger> {
        let url_ = this.baseUrl + "/api/Form/SavePatientResponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyResponseSaveRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePatientResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePatientResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfInteger>;
        }));
    }

    protected processSavePatientResponse(response: HttpResponseBase): Observable<ResponseTransportOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfInteger>(null as any);
    }

    getLastSurveyResponse(surveyType: string | null | undefined): Observable<ResponseTransportOfSurveyResponseDto> {
        let url_ = this.baseUrl + "/api/Form/GetLastSurveyResponse?";
        if (surveyType !== undefined && surveyType !== null)
            url_ += "surveyType=" + encodeURIComponent("" + surveyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastSurveyResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastSurveyResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfSurveyResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfSurveyResponseDto>;
        }));
    }

    protected processGetLastSurveyResponse(response: HttpResponseBase): Observable<ResponseTransportOfSurveyResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfSurveyResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfSurveyResponseDto>(null as any);
    }

    getSurveyCompletion(): Observable<ResponseTransportOfSurveyCompletionResponse> {
        let url_ = this.baseUrl + "/api/Form/GetSurveyCompletion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyCompletion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyCompletion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfSurveyCompletionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfSurveyCompletionResponse>;
        }));
    }

    protected processGetSurveyCompletion(response: HttpResponseBase): Observable<ResponseTransportOfSurveyCompletionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfSurveyCompletionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfSurveyCompletionResponse>(null as any);
    }

    getPatientSurveyCompletion(patientId: number | undefined): Observable<ResponseTransportOfSurveyCompletionResponse> {
        let url_ = this.baseUrl + "/api/Form/GetPatientSurveyCompletion?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientSurveyCompletion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientSurveyCompletion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfSurveyCompletionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfSurveyCompletionResponse>;
        }));
    }

    protected processGetPatientSurveyCompletion(response: HttpResponseBase): Observable<ResponseTransportOfSurveyCompletionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfSurveyCompletionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfSurveyCompletionResponse>(null as any);
    }

    getSurveyWithUserResponse(surveyType: string | null | undefined): Observable<ResponseTransportOfSurveyDto> {
        let url_ = this.baseUrl + "/api/Form/GetSurveyWithUserResponse?";
        if (surveyType !== undefined && surveyType !== null)
            url_ += "surveyType=" + encodeURIComponent("" + surveyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyWithUserResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyWithUserResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfSurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfSurveyDto>;
        }));
    }

    protected processGetSurveyWithUserResponse(response: HttpResponseBase): Observable<ResponseTransportOfSurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfSurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfSurveyDto>(null as any);
    }

    getPatientSurveyWithUserResponse(patientId: number | undefined, surveyType: string | null | undefined): Observable<ResponseTransportOfPatientSurveyResponse> {
        let url_ = this.baseUrl + "/api/Form/GetPatientSurveyWithUserResponse?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (surveyType !== undefined && surveyType !== null)
            url_ += "surveyType=" + encodeURIComponent("" + surveyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientSurveyWithUserResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientSurveyWithUserResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfPatientSurveyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfPatientSurveyResponse>;
        }));
    }

    protected processGetPatientSurveyWithUserResponse(response: HttpResponseBase): Observable<ResponseTransportOfPatientSurveyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfPatientSurveyResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfPatientSurveyResponse>(null as any);
    }

    activateSurvey(patientId: number | undefined, surveyType: string | null | undefined): Observable<ResponseTransportOfInteger> {
        let url_ = this.baseUrl + "/api/Form/ActivateSurvey?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (surveyType !== undefined && surveyType !== null)
            url_ += "surveyType=" + encodeURIComponent("" + surveyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateSurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfInteger>;
        }));
    }

    protected processActivateSurvey(response: HttpResponseBase): Observable<ResponseTransportOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfInteger>(null as any);
    }
}

export interface IHandService {
    saveHand(request: SaveHandRequest): Observable<ResponseModelOfHandOperationResponse>;
    getHand(date: string | null | undefined): Observable<ResponseModelOfHandOperationResponse>;
    copyHand(request: CopyHandRequest): Observable<ResponseModelOfHandOperationResponse>;
    setCardPlayed(request: SetHandCardPlayedRequest): Observable<ResponseModelOfHandOperationResponse>;
    deleteHand(request: DeleteHandRequest): Observable<ResponseModelOfHandOperationResponse>;
    useFavouriteHand(request: UseFavouriteHandRequest): Observable<ResponseModelOfHandOperationResponse>;
}

@Injectable()
export class HandService implements IHandService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    saveHand(request: SaveHandRequest): Observable<ResponseModelOfHandOperationResponse> {
        let url_ = this.baseUrl + "/api/Hand/SaveHand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveHand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveHand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfHandOperationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfHandOperationResponse>;
        }));
    }

    protected processSaveHand(response: HttpResponseBase): Observable<ResponseModelOfHandOperationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfHandOperationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfHandOperationResponse>(null as any);
    }

    getHand(date: string | null | undefined): Observable<ResponseModelOfHandOperationResponse> {
        let url_ = this.baseUrl + "/api/Hand/GetHand?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfHandOperationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfHandOperationResponse>;
        }));
    }

    protected processGetHand(response: HttpResponseBase): Observable<ResponseModelOfHandOperationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfHandOperationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfHandOperationResponse>(null as any);
    }

    copyHand(request: CopyHandRequest): Observable<ResponseModelOfHandOperationResponse> {
        let url_ = this.baseUrl + "/api/Hand/CopyHand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyHand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyHand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfHandOperationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfHandOperationResponse>;
        }));
    }

    protected processCopyHand(response: HttpResponseBase): Observable<ResponseModelOfHandOperationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfHandOperationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfHandOperationResponse>(null as any);
    }

    setCardPlayed(request: SetHandCardPlayedRequest): Observable<ResponseModelOfHandOperationResponse> {
        let url_ = this.baseUrl + "/api/Hand/SetCardPlayed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCardPlayed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCardPlayed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfHandOperationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfHandOperationResponse>;
        }));
    }

    protected processSetCardPlayed(response: HttpResponseBase): Observable<ResponseModelOfHandOperationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfHandOperationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfHandOperationResponse>(null as any);
    }

    deleteHand(request: DeleteHandRequest): Observable<ResponseModelOfHandOperationResponse> {
        let url_ = this.baseUrl + "/api/Hand/DeleteHand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteHand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteHand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfHandOperationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfHandOperationResponse>;
        }));
    }

    protected processDeleteHand(response: HttpResponseBase): Observable<ResponseModelOfHandOperationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfHandOperationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfHandOperationResponse>(null as any);
    }

    useFavouriteHand(request: UseFavouriteHandRequest): Observable<ResponseModelOfHandOperationResponse> {
        let url_ = this.baseUrl + "/api/Hand/UseFavouriteHand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUseFavouriteHand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUseFavouriteHand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfHandOperationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfHandOperationResponse>;
        }));
    }

    protected processUseFavouriteHand(response: HttpResponseBase): Observable<ResponseModelOfHandOperationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfHandOperationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfHandOperationResponse>(null as any);
    }
}

export interface IHelpService {
    getCategories(): Observable<ResponseTransportOfListOfHelpCategoryViewDto>;
    getArticlesByCategory(categorySlug: string | null | undefined): Observable<ResponseTransportOfListOfHelpArticleSummaryViewDto>;
    getArticleBySlug(slug: string | null | undefined): Observable<ResponseTransportOfHelpArticleViewDto>;
    search(query: string | null | undefined): Observable<ResponseTransportOfListOfHelpArticleSummaryViewDto>;
    submitFeedback(articleId: number | undefined, response: string | null | undefined): Observable<ResponseTransportOfBoolean>;
}

@Injectable()
export class HelpService implements IHelpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getCategories(): Observable<ResponseTransportOfListOfHelpCategoryViewDto> {
        let url_ = this.baseUrl + "/api/Help/GetCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfListOfHelpCategoryViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfListOfHelpCategoryViewDto>;
        }));
    }

    protected processGetCategories(response: HttpResponseBase): Observable<ResponseTransportOfListOfHelpCategoryViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfListOfHelpCategoryViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfListOfHelpCategoryViewDto>(null as any);
    }

    getArticlesByCategory(categorySlug: string | null | undefined): Observable<ResponseTransportOfListOfHelpArticleSummaryViewDto> {
        let url_ = this.baseUrl + "/api/Help/GetArticlesByCategory?";
        if (categorySlug !== undefined && categorySlug !== null)
            url_ += "categorySlug=" + encodeURIComponent("" + categorySlug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticlesByCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticlesByCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfListOfHelpArticleSummaryViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfListOfHelpArticleSummaryViewDto>;
        }));
    }

    protected processGetArticlesByCategory(response: HttpResponseBase): Observable<ResponseTransportOfListOfHelpArticleSummaryViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfListOfHelpArticleSummaryViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfListOfHelpArticleSummaryViewDto>(null as any);
    }

    getArticleBySlug(slug: string | null | undefined): Observable<ResponseTransportOfHelpArticleViewDto> {
        let url_ = this.baseUrl + "/api/Help/GetArticleBySlug?";
        if (slug !== undefined && slug !== null)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticleBySlug(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleBySlug(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfHelpArticleViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfHelpArticleViewDto>;
        }));
    }

    protected processGetArticleBySlug(response: HttpResponseBase): Observable<ResponseTransportOfHelpArticleViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfHelpArticleViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfHelpArticleViewDto>(null as any);
    }

    search(query: string | null | undefined): Observable<ResponseTransportOfListOfHelpArticleSummaryViewDto> {
        let url_ = this.baseUrl + "/api/Help/Search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfListOfHelpArticleSummaryViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfListOfHelpArticleSummaryViewDto>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ResponseTransportOfListOfHelpArticleSummaryViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfListOfHelpArticleSummaryViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfListOfHelpArticleSummaryViewDto>(null as any);
    }

    submitFeedback(articleId: number | undefined, response: string | null | undefined): Observable<ResponseTransportOfBoolean> {
        let url_ = this.baseUrl + "/api/Help/SubmitFeedback?";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&";
        if (response !== undefined && response !== null)
            url_ += "response=" + encodeURIComponent("" + response) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfBoolean>;
        }));
    }

    protected processSubmitFeedback(response: HttpResponseBase): Observable<ResponseTransportOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfBoolean>(null as any);
    }
}

export interface IHistoryService {
    getScoreHistory(scoreHistoryDbRequest: ScoreHistoryDbRequest): Observable<ScoreChartDbResponse>;
    getTopHalosZombies(topHaloZombiRequest: TopHaloZombiRequest): Observable<TopHaloZombiResponse[]>;
    getHalosZombiesById(marginOfSafetySetId: number | undefined): Observable<HaloZombiResponse[]>;
    getScoreComponents(itemId: number | undefined): Observable<ScoreCompoDbResponse[]>;
}

@Injectable()
export class HistoryService implements IHistoryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getScoreHistory(scoreHistoryDbRequest: ScoreHistoryDbRequest): Observable<ScoreChartDbResponse> {
        let url_ = this.baseUrl + "/api/History/GetScoreHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scoreHistoryDbRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScoreHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScoreHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreChartDbResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreChartDbResponse>;
        }));
    }

    protected processGetScoreHistory(response: HttpResponseBase): Observable<ScoreChartDbResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreChartDbResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScoreChartDbResponse>(null as any);
    }

    getTopHalosZombies(topHaloZombiRequest: TopHaloZombiRequest): Observable<TopHaloZombiResponse[]> {
        let url_ = this.baseUrl + "/api/History/GetTopHalosZombies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topHaloZombiRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopHalosZombies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopHalosZombies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopHaloZombiResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopHaloZombiResponse[]>;
        }));
    }

    protected processGetTopHalosZombies(response: HttpResponseBase): Observable<TopHaloZombiResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopHaloZombiResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopHaloZombiResponse[]>(null as any);
    }

    getHalosZombiesById(marginOfSafetySetId: number | undefined): Observable<HaloZombiResponse[]> {
        let url_ = this.baseUrl + "/api/History/GetHalosZombiesById?";
        if (marginOfSafetySetId === null)
            throw new Error("The parameter 'marginOfSafetySetId' cannot be null.");
        else if (marginOfSafetySetId !== undefined)
            url_ += "marginOfSafetySetId=" + encodeURIComponent("" + marginOfSafetySetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHalosZombiesById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHalosZombiesById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HaloZombiResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HaloZombiResponse[]>;
        }));
    }

    protected processGetHalosZombiesById(response: HttpResponseBase): Observable<HaloZombiResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HaloZombiResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HaloZombiResponse[]>(null as any);
    }

    getScoreComponents(itemId: number | undefined): Observable<ScoreCompoDbResponse[]> {
        let url_ = this.baseUrl + "/api/History/GetScoreComponents?";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScoreComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScoreComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreCompoDbResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreCompoDbResponse[]>;
        }));
    }

    protected processGetScoreComponents(response: HttpResponseBase): Observable<ScoreCompoDbResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScoreCompoDbResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScoreCompoDbResponse[]>(null as any);
    }
}

export interface IInteractionService {
    track(request: InteractionEventRequest): Observable<FileResponse>;
}

@Injectable()
export class InteractionService implements IInteractionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    track(request: InteractionEventRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Interaction/Track";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrack(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processTrack(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface ILearnModuleService {
    viewCourse(): Observable<ResponseTransportOfCourseViewDto>;
    updateLessonStatus(lessonId: number | undefined, isCompleted: boolean | undefined): Observable<ResponseTransportOfBoolean>;
    updateLessonProgress(lessonId: number | undefined, slideIndex: number | undefined): Observable<ResponseTransportOfBoolean>;
    getAttachmentViewLink(attachmentId: number | undefined): Observable<ResponseTransportOfString>;
}

@Injectable()
export class LearnModuleService implements ILearnModuleService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    viewCourse(): Observable<ResponseTransportOfCourseViewDto> {
        let url_ = this.baseUrl + "/api/LearnModule/ViewCourse";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processViewCourse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processViewCourse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfCourseViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfCourseViewDto>;
        }));
    }

    protected processViewCourse(response: HttpResponseBase): Observable<ResponseTransportOfCourseViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfCourseViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfCourseViewDto>(null as any);
    }

    updateLessonStatus(lessonId: number | undefined, isCompleted: boolean | undefined): Observable<ResponseTransportOfBoolean> {
        let url_ = this.baseUrl + "/api/LearnModule/UpdateLessonStatus?";
        if (lessonId === null)
            throw new Error("The parameter 'lessonId' cannot be null.");
        else if (lessonId !== undefined)
            url_ += "lessonId=" + encodeURIComponent("" + lessonId) + "&";
        if (isCompleted === null)
            throw new Error("The parameter 'isCompleted' cannot be null.");
        else if (isCompleted !== undefined)
            url_ += "isCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLessonStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLessonStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfBoolean>;
        }));
    }

    protected processUpdateLessonStatus(response: HttpResponseBase): Observable<ResponseTransportOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfBoolean>(null as any);
    }

    updateLessonProgress(lessonId: number | undefined, slideIndex: number | undefined): Observable<ResponseTransportOfBoolean> {
        let url_ = this.baseUrl + "/api/LearnModule/UpdateLessonProgress?";
        if (lessonId === null)
            throw new Error("The parameter 'lessonId' cannot be null.");
        else if (lessonId !== undefined)
            url_ += "lessonId=" + encodeURIComponent("" + lessonId) + "&";
        if (slideIndex === null)
            throw new Error("The parameter 'slideIndex' cannot be null.");
        else if (slideIndex !== undefined)
            url_ += "slideIndex=" + encodeURIComponent("" + slideIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLessonProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLessonProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfBoolean>;
        }));
    }

    protected processUpdateLessonProgress(response: HttpResponseBase): Observable<ResponseTransportOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfBoolean>(null as any);
    }

    getAttachmentViewLink(attachmentId: number | undefined): Observable<ResponseTransportOfString> {
        let url_ = this.baseUrl + "/api/LearnModule/GetAttachmentViewLink?";
        if (attachmentId === null)
            throw new Error("The parameter 'attachmentId' cannot be null.");
        else if (attachmentId !== undefined)
            url_ += "attachmentId=" + encodeURIComponent("" + attachmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentViewLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentViewLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfString>;
        }));
    }

    protected processGetAttachmentViewLink(response: HttpResponseBase): Observable<ResponseTransportOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfString>(null as any);
    }
}

export interface ILicenceService {
    getLicenceStreams(): Observable<LicenceStreamDto[]>;
    getLicences(masterLicenceId: number | null | undefined, licenceTypeId: number | null | undefined, clinicianId: number | null | undefined): Observable<LicenceDto[]>;
    getUserLicenceStream(): Observable<LicenceStreamDto>;
}

@Injectable()
export class LicenceService implements ILicenceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getLicenceStreams(): Observable<LicenceStreamDto[]> {
        let url_ = this.baseUrl + "/api/Licence/GetLicenceStreams";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicenceStreams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenceStreams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenceStreamDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenceStreamDto[]>;
        }));
    }

    protected processGetLicenceStreams(response: HttpResponseBase): Observable<LicenceStreamDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenceStreamDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenceStreamDto[]>(null as any);
    }

    getLicences(masterLicenceId: number | null | undefined, licenceTypeId: number | null | undefined, clinicianId: number | null | undefined): Observable<LicenceDto[]> {
        let url_ = this.baseUrl + "/api/Licence/GetLicences?";
        if (masterLicenceId !== undefined && masterLicenceId !== null)
            url_ += "masterLicenceId=" + encodeURIComponent("" + masterLicenceId) + "&";
        if (licenceTypeId !== undefined && licenceTypeId !== null)
            url_ += "licenceTypeId=" + encodeURIComponent("" + licenceTypeId) + "&";
        if (clinicianId !== undefined && clinicianId !== null)
            url_ += "clinicianId=" + encodeURIComponent("" + clinicianId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenceDto[]>;
        }));
    }

    protected processGetLicences(response: HttpResponseBase): Observable<LicenceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenceDto[]>(null as any);
    }

    getUserLicenceStream(): Observable<LicenceStreamDto> {
        let url_ = this.baseUrl + "/api/Licence/GetUserLicenceStream";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLicenceStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLicenceStream(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenceStreamDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenceStreamDto>;
        }));
    }

    protected processGetUserLicenceStream(response: HttpResponseBase): Observable<LicenceStreamDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenceStreamDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenceStreamDto>(null as any);
    }
}

export interface IMedicationService {
    getMedicationData(): Observable<ResponseTransportOfListOfMedicationDto>;
    getMedicationList(): Observable<ResponseTransportOfListOfMedicationListDto>;
    get(id: number | undefined): Observable<ResponseTransportOfMedication>;
    create(medicationDto: MedicationDto): Observable<ResponseTransportOfMedicationDto>;
    update(id: number | undefined, medicationDto: MedicationDto): Observable<ResponseTransportOfMedicationDto>;
    delete(id: number | undefined): Observable<void>;
    getAllChemicals(): Observable<ResponseTransportOfListOfChemical>;
    getChemical(id: number | undefined): Observable<ResponseTransportOfChemical>;
    createChemical(chemical: Chemical): Observable<void>;
    updateChemical(id: number | undefined, chemical: Chemical): Observable<void>;
    deleteChemical(id: number | undefined): Observable<void>;
    getAllChemicalCategories(): Observable<ResponseTransportOfListOfChemicalCategory>;
    getChemicalCategory(id: number | undefined): Observable<ResponseTransportOfChemicalCategory>;
    createChemicalCategory(chemicalCategory: ChemicalCategory): Observable<void>;
    updateChemicalCategory(id: number | undefined, chemicalCategory: ChemicalCategory): Observable<void>;
    deleteChemicalCategory(id: number | undefined): Observable<void>;
    getAllMedicationDoses(): Observable<ResponseTransportOfListOfMedicationDose>;
    getMedicationDose(id: number | undefined): Observable<ResponseTransportOfMedicationDose>;
    createMedicationDose(medicationDoseDto: MedicationDoseDto): Observable<ResponseTransportOfMedicationDoseDto>;
    updateMedicationDose(id: number | undefined, medicationDoseDto: MedicationDoseDto): Observable<ResponseTransportOfMedicationDoseDto>;
    deleteMedicationDose(id: number | undefined): Observable<void>;
    getAllMedicationDoseCompositions(): Observable<ResponseTransportOfListOfMedicationDoseComposition>;
    getMedicationDoseComposition(id: number | undefined): Observable<ResponseTransportOfMedicationDoseComposition>;
    createMedicationDoseComposition(medicationDoseCompositionDto: MedicationDoseCompositionDto): Observable<ResponseTransportOfMedicationDoseComposition>;
    updateMedicationDoseComposition(id: number | undefined, medicationDoseCompositionDto: MedicationDoseCompositionDto): Observable<ResponseTransportOfMedicationDoseComposition>;
    deleteMedicationDoseComposition(id: number | undefined): Observable<void>;
}

@Injectable()
export class MedicationService implements IMedicationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getMedicationData(): Observable<ResponseTransportOfListOfMedicationDto> {
        let url_ = this.baseUrl + "/api/Medication/GetMedicationData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfListOfMedicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfListOfMedicationDto>;
        }));
    }

    protected processGetMedicationData(response: HttpResponseBase): Observable<ResponseTransportOfListOfMedicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfListOfMedicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfListOfMedicationDto>(null as any);
    }

    getMedicationList(): Observable<ResponseTransportOfListOfMedicationListDto> {
        let url_ = this.baseUrl + "/api/Medication/GetMedicationList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicationList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfListOfMedicationListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfListOfMedicationListDto>;
        }));
    }

    protected processGetMedicationList(response: HttpResponseBase): Observable<ResponseTransportOfListOfMedicationListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfListOfMedicationListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfListOfMedicationListDto>(null as any);
    }

    get(id: number | undefined): Observable<ResponseTransportOfMedication> {
        let url_ = this.baseUrl + "/api/Medication/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfMedication>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfMedication>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResponseTransportOfMedication> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfMedication.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfMedication>(null as any);
    }

    create(medicationDto: MedicationDto): Observable<ResponseTransportOfMedicationDto> {
        let url_ = this.baseUrl + "/api/Medication/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medicationDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfMedicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfMedicationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResponseTransportOfMedicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfMedicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfMedicationDto>(null as any);
    }

    update(id: number | undefined, medicationDto: MedicationDto): Observable<ResponseTransportOfMedicationDto> {
        let url_ = this.baseUrl + "/api/Medication/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medicationDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfMedicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfMedicationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResponseTransportOfMedicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfMedicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfMedicationDto>(null as any);
    }

    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Medication/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getAllChemicals(): Observable<ResponseTransportOfListOfChemical> {
        let url_ = this.baseUrl + "/api/Medication/GetAllChemicals";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllChemicals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllChemicals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfListOfChemical>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfListOfChemical>;
        }));
    }

    protected processGetAllChemicals(response: HttpResponseBase): Observable<ResponseTransportOfListOfChemical> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfListOfChemical.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfListOfChemical>(null as any);
    }

    getChemical(id: number | undefined): Observable<ResponseTransportOfChemical> {
        let url_ = this.baseUrl + "/api/Medication/GetChemical?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChemical(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChemical(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfChemical>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfChemical>;
        }));
    }

    protected processGetChemical(response: HttpResponseBase): Observable<ResponseTransportOfChemical> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfChemical.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfChemical>(null as any);
    }

    createChemical(chemical: Chemical): Observable<void> {
        let url_ = this.baseUrl + "/api/Medication/CreateChemical";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chemical);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateChemical(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateChemical(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateChemical(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    updateChemical(id: number | undefined, chemical: Chemical): Observable<void> {
        let url_ = this.baseUrl + "/api/Medication/UpdateChemical?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chemical);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateChemical(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateChemical(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateChemical(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deleteChemical(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Medication/DeleteChemical?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteChemical(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteChemical(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteChemical(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getAllChemicalCategories(): Observable<ResponseTransportOfListOfChemicalCategory> {
        let url_ = this.baseUrl + "/api/Medication/GetAllChemicalCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllChemicalCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllChemicalCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfListOfChemicalCategory>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfListOfChemicalCategory>;
        }));
    }

    protected processGetAllChemicalCategories(response: HttpResponseBase): Observable<ResponseTransportOfListOfChemicalCategory> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfListOfChemicalCategory.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfListOfChemicalCategory>(null as any);
    }

    getChemicalCategory(id: number | undefined): Observable<ResponseTransportOfChemicalCategory> {
        let url_ = this.baseUrl + "/api/Medication/GetChemicalCategory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChemicalCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChemicalCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfChemicalCategory>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfChemicalCategory>;
        }));
    }

    protected processGetChemicalCategory(response: HttpResponseBase): Observable<ResponseTransportOfChemicalCategory> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfChemicalCategory.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfChemicalCategory>(null as any);
    }

    createChemicalCategory(chemicalCategory: ChemicalCategory): Observable<void> {
        let url_ = this.baseUrl + "/api/Medication/CreateChemicalCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chemicalCategory);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateChemicalCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateChemicalCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateChemicalCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    updateChemicalCategory(id: number | undefined, chemicalCategory: ChemicalCategory): Observable<void> {
        let url_ = this.baseUrl + "/api/Medication/UpdateChemicalCategory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chemicalCategory);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateChemicalCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateChemicalCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateChemicalCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deleteChemicalCategory(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Medication/DeleteChemicalCategory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteChemicalCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteChemicalCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteChemicalCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getAllMedicationDoses(): Observable<ResponseTransportOfListOfMedicationDose> {
        let url_ = this.baseUrl + "/api/Medication/GetAllMedicationDoses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMedicationDoses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMedicationDoses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfListOfMedicationDose>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfListOfMedicationDose>;
        }));
    }

    protected processGetAllMedicationDoses(response: HttpResponseBase): Observable<ResponseTransportOfListOfMedicationDose> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfListOfMedicationDose.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfListOfMedicationDose>(null as any);
    }

    getMedicationDose(id: number | undefined): Observable<ResponseTransportOfMedicationDose> {
        let url_ = this.baseUrl + "/api/Medication/GetMedicationDose?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicationDose(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicationDose(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfMedicationDose>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfMedicationDose>;
        }));
    }

    protected processGetMedicationDose(response: HttpResponseBase): Observable<ResponseTransportOfMedicationDose> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfMedicationDose.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfMedicationDose>(null as any);
    }

    createMedicationDose(medicationDoseDto: MedicationDoseDto): Observable<ResponseTransportOfMedicationDoseDto> {
        let url_ = this.baseUrl + "/api/Medication/CreateMedicationDose";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medicationDoseDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMedicationDose(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMedicationDose(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfMedicationDoseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfMedicationDoseDto>;
        }));
    }

    protected processCreateMedicationDose(response: HttpResponseBase): Observable<ResponseTransportOfMedicationDoseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfMedicationDoseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfMedicationDoseDto>(null as any);
    }

    updateMedicationDose(id: number | undefined, medicationDoseDto: MedicationDoseDto): Observable<ResponseTransportOfMedicationDoseDto> {
        let url_ = this.baseUrl + "/api/Medication/UpdateMedicationDose?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medicationDoseDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMedicationDose(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMedicationDose(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfMedicationDoseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfMedicationDoseDto>;
        }));
    }

    protected processUpdateMedicationDose(response: HttpResponseBase): Observable<ResponseTransportOfMedicationDoseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfMedicationDoseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfMedicationDoseDto>(null as any);
    }

    deleteMedicationDose(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Medication/DeleteMedicationDose?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMedicationDose(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMedicationDose(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMedicationDose(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getAllMedicationDoseCompositions(): Observable<ResponseTransportOfListOfMedicationDoseComposition> {
        let url_ = this.baseUrl + "/api/Medication/GetAllMedicationDoseCompositions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMedicationDoseCompositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMedicationDoseCompositions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfListOfMedicationDoseComposition>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfListOfMedicationDoseComposition>;
        }));
    }

    protected processGetAllMedicationDoseCompositions(response: HttpResponseBase): Observable<ResponseTransportOfListOfMedicationDoseComposition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfListOfMedicationDoseComposition.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfListOfMedicationDoseComposition>(null as any);
    }

    getMedicationDoseComposition(id: number | undefined): Observable<ResponseTransportOfMedicationDoseComposition> {
        let url_ = this.baseUrl + "/api/Medication/GetMedicationDoseComposition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicationDoseComposition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicationDoseComposition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfMedicationDoseComposition>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfMedicationDoseComposition>;
        }));
    }

    protected processGetMedicationDoseComposition(response: HttpResponseBase): Observable<ResponseTransportOfMedicationDoseComposition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfMedicationDoseComposition.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfMedicationDoseComposition>(null as any);
    }

    createMedicationDoseComposition(medicationDoseCompositionDto: MedicationDoseCompositionDto): Observable<ResponseTransportOfMedicationDoseComposition> {
        let url_ = this.baseUrl + "/api/Medication/CreateMedicationDoseComposition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medicationDoseCompositionDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMedicationDoseComposition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMedicationDoseComposition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfMedicationDoseComposition>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfMedicationDoseComposition>;
        }));
    }

    protected processCreateMedicationDoseComposition(response: HttpResponseBase): Observable<ResponseTransportOfMedicationDoseComposition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfMedicationDoseComposition.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfMedicationDoseComposition>(null as any);
    }

    updateMedicationDoseComposition(id: number | undefined, medicationDoseCompositionDto: MedicationDoseCompositionDto): Observable<ResponseTransportOfMedicationDoseComposition> {
        let url_ = this.baseUrl + "/api/Medication/UpdateMedicationDoseComposition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medicationDoseCompositionDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMedicationDoseComposition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMedicationDoseComposition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfMedicationDoseComposition>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfMedicationDoseComposition>;
        }));
    }

    protected processUpdateMedicationDoseComposition(response: HttpResponseBase): Observable<ResponseTransportOfMedicationDoseComposition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfMedicationDoseComposition.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfMedicationDoseComposition>(null as any);
    }

    deleteMedicationDoseComposition(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Medication/DeleteMedicationDoseComposition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMedicationDoseComposition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMedicationDoseComposition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMedicationDoseComposition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IMessageService {
    getMessage(applicationMessageId: number | undefined): Observable<MessageDbResponse>;
}

@Injectable()
export class MessageService implements IMessageService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getMessage(applicationMessageId: number | undefined): Observable<MessageDbResponse> {
        let url_ = this.baseUrl + "/api/Message/GetMessage?";
        if (applicationMessageId === null)
            throw new Error("The parameter 'applicationMessageId' cannot be null.");
        else if (applicationMessageId !== undefined)
            url_ += "ApplicationMessageId=" + encodeURIComponent("" + applicationMessageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDbResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDbResponse>;
        }));
    }

    protected processGetMessage(response: HttpResponseBase): Observable<MessageDbResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageDbResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageDbResponse>(null as any);
    }
}

export interface INavigationService {
    track(request: NavigationEventRequest): Observable<FileResponse>;
}

@Injectable()
export class NavigationService implements INavigationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    track(request: NavigationEventRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Navigation/Track";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrack(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processTrack(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface INodeBBWebhookService {
    handle(): Observable<FileResponse>;
}

@Injectable()
export class NodeBBWebhookService implements INodeBBWebhookService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    handle(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/webhooks/nodebb";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processHandle(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface INotificationsService {
    getBell(): Observable<ResponseModelOfNotificationBellResponse>;
    markSeen(request: MarkSeenRequest): Observable<ResponseModelOfInteger>;
}

@Injectable()
export class NotificationsService implements INotificationsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getBell(): Observable<ResponseModelOfNotificationBellResponse> {
        let url_ = this.baseUrl + "/api/Notifications/GetBell";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBell(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBell(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfNotificationBellResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfNotificationBellResponse>;
        }));
    }

    protected processGetBell(response: HttpResponseBase): Observable<ResponseModelOfNotificationBellResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfNotificationBellResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfNotificationBellResponse>(null as any);
    }

    markSeen(request: MarkSeenRequest): Observable<ResponseModelOfInteger> {
        let url_ = this.baseUrl + "/api/Notifications/MarkSeen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkSeen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkSeen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfInteger>;
        }));
    }

    protected processMarkSeen(response: HttpResponseBase): Observable<ResponseModelOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfInteger>(null as any);
    }
}

export interface INovaService {
    getCurrentInsight(): Observable<InsightCardDto>;
    recordInsightShown(request: NovaRecordInsightShownRequest): Observable<void>;
    getChatContext(): Observable<NovaChatContextResponse>;
    getChatHistory(): Observable<NovaChatHistoryResponse>;
    getOpeningChips(): Observable<NovaChipsResponse>;
    sendMessage(request: NovaSendMessageRequest): Observable<NovaSendMessageResponse>;
    sendMessageStream(request: NovaSendMessageRequest): Observable<void>;
    warmUp(): Observable<NovaWarmUpResponse>;
    speak(request: NovaSpeakRequest): Observable<void>;
    startRealtimeSession(): Observable<NovaRealtimeSessionResponse>;
    endRealtimeSession(request: NovaRealtimeEndSessionRequest): Observable<NovaRealtimeEndSessionResponse>;
    logEvents(request: NovaLogEventsRequest): Observable<NovaLogEventsResponse>;
    walkthroughSlice(request: NovaWalkthroughSliceRequest): Observable<NovaWalkthroughSliceResponse>;
    realtimeEvent(request: NovaRealtimeEventRequest): Observable<NovaRealtimeEventResponse>;
}

@Injectable()
export class NovaService implements INovaService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getCurrentInsight(): Observable<InsightCardDto> {
        let url_ = this.baseUrl + "/api/Nova/GetCurrentInsight";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentInsight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentInsight(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsightCardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsightCardDto>;
        }));
    }

    protected processGetCurrentInsight(response: HttpResponseBase): Observable<InsightCardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsightCardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InsightCardDto>(null as any);
    }

    recordInsightShown(request: NovaRecordInsightShownRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Nova/RecordInsightShown";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecordInsightShown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecordInsightShown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecordInsightShown(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getChatContext(): Observable<NovaChatContextResponse> {
        let url_ = this.baseUrl + "/api/Nova/GetChatContext";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatContext(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatContext(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NovaChatContextResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NovaChatContextResponse>;
        }));
    }

    protected processGetChatContext(response: HttpResponseBase): Observable<NovaChatContextResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NovaChatContextResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NovaChatContextResponse>(null as any);
    }

    getChatHistory(): Observable<NovaChatHistoryResponse> {
        let url_ = this.baseUrl + "/api/Nova/GetChatHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NovaChatHistoryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NovaChatHistoryResponse>;
        }));
    }

    protected processGetChatHistory(response: HttpResponseBase): Observable<NovaChatHistoryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NovaChatHistoryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NovaChatHistoryResponse>(null as any);
    }

    getOpeningChips(): Observable<NovaChipsResponse> {
        let url_ = this.baseUrl + "/api/Nova/GetOpeningChips";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpeningChips(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpeningChips(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NovaChipsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NovaChipsResponse>;
        }));
    }

    protected processGetOpeningChips(response: HttpResponseBase): Observable<NovaChipsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NovaChipsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NovaChipsResponse>(null as any);
    }

    sendMessage(request: NovaSendMessageRequest): Observable<NovaSendMessageResponse> {
        let url_ = this.baseUrl + "/api/Nova/SendMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NovaSendMessageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NovaSendMessageResponse>;
        }));
    }

    protected processSendMessage(response: HttpResponseBase): Observable<NovaSendMessageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NovaSendMessageResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NovaSendMessageResponse>(null as any);
    }

    sendMessageStream(request: NovaSendMessageRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Nova/SendMessageStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMessageStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMessageStream(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMessageStream(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    warmUp(): Observable<NovaWarmUpResponse> {
        let url_ = this.baseUrl + "/api/Nova/WarmUp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWarmUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWarmUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NovaWarmUpResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NovaWarmUpResponse>;
        }));
    }

    protected processWarmUp(response: HttpResponseBase): Observable<NovaWarmUpResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NovaWarmUpResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NovaWarmUpResponse>(null as any);
    }

    speak(request: NovaSpeakRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Nova/Speak";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSpeak(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSpeak(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSpeak(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    startRealtimeSession(): Observable<NovaRealtimeSessionResponse> {
        let url_ = this.baseUrl + "/api/Nova/StartRealtimeSession";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartRealtimeSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartRealtimeSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NovaRealtimeSessionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NovaRealtimeSessionResponse>;
        }));
    }

    protected processStartRealtimeSession(response: HttpResponseBase): Observable<NovaRealtimeSessionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NovaRealtimeSessionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 429) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = NovaRealtimeRefusalResponse.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NovaRealtimeSessionResponse>(null as any);
    }

    endRealtimeSession(request: NovaRealtimeEndSessionRequest): Observable<NovaRealtimeEndSessionResponse> {
        let url_ = this.baseUrl + "/api/Nova/EndRealtimeSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndRealtimeSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndRealtimeSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NovaRealtimeEndSessionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NovaRealtimeEndSessionResponse>;
        }));
    }

    protected processEndRealtimeSession(response: HttpResponseBase): Observable<NovaRealtimeEndSessionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NovaRealtimeEndSessionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NovaRealtimeEndSessionResponse>(null as any);
    }

    logEvents(request: NovaLogEventsRequest): Observable<NovaLogEventsResponse> {
        let url_ = this.baseUrl + "/api/Nova/LogEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NovaLogEventsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NovaLogEventsResponse>;
        }));
    }

    protected processLogEvents(response: HttpResponseBase): Observable<NovaLogEventsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NovaLogEventsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NovaLogEventsResponse>(null as any);
    }

    walkthroughSlice(request: NovaWalkthroughSliceRequest): Observable<NovaWalkthroughSliceResponse> {
        let url_ = this.baseUrl + "/api/Nova/WalkthroughSlice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWalkthroughSlice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWalkthroughSlice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NovaWalkthroughSliceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NovaWalkthroughSliceResponse>;
        }));
    }

    protected processWalkthroughSlice(response: HttpResponseBase): Observable<NovaWalkthroughSliceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NovaWalkthroughSliceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NovaWalkthroughSliceResponse>(null as any);
    }

    realtimeEvent(request: NovaRealtimeEventRequest): Observable<NovaRealtimeEventResponse> {
        let url_ = this.baseUrl + "/api/Nova/RealtimeEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRealtimeEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRealtimeEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NovaRealtimeEventResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NovaRealtimeEventResponse>;
        }));
    }

    protected processRealtimeEvent(response: HttpResponseBase): Observable<NovaRealtimeEventResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NovaRealtimeEventResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NovaRealtimeEventResponse>(null as any);
    }
}

export interface INovaDiagnosticsService {
    getProviderStatus(): Observable<NovaProviderStatusResponse>;
    runLatencyComparison(iterations: number | undefined, message: string | null | undefined): Observable<NovaLatencyReport>;
    getCompanionContext(): Observable<string>;
    composedPrompt(voice: boolean | undefined, region: string | null | undefined): Observable<string>;
}

@Injectable()
export class NovaDiagnosticsService implements INovaDiagnosticsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getProviderStatus(): Observable<NovaProviderStatusResponse> {
        let url_ = this.baseUrl + "/api/NovaDiagnostics/GetProviderStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NovaProviderStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NovaProviderStatusResponse>;
        }));
    }

    protected processGetProviderStatus(response: HttpResponseBase): Observable<NovaProviderStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NovaProviderStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NovaProviderStatusResponse>(null as any);
    }

    runLatencyComparison(iterations: number | undefined, message: string | null | undefined): Observable<NovaLatencyReport> {
        let url_ = this.baseUrl + "/api/NovaDiagnostics/RunLatencyComparison?";
        if (iterations === null)
            throw new Error("The parameter 'iterations' cannot be null.");
        else if (iterations !== undefined)
            url_ += "iterations=" + encodeURIComponent("" + iterations) + "&";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunLatencyComparison(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunLatencyComparison(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NovaLatencyReport>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NovaLatencyReport>;
        }));
    }

    protected processRunLatencyComparison(response: HttpResponseBase): Observable<NovaLatencyReport> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NovaLatencyReport.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NovaLatencyReport>(null as any);
    }

    getCompanionContext(): Observable<string> {
        let url_ = this.baseUrl + "/api/NovaDiagnostics/GetCompanionContext";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanionContext(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanionContext(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCompanionContext(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    composedPrompt(voice: boolean | undefined, region: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/NovaDiagnostics/ComposedPrompt?";
        if (voice === null)
            throw new Error("The parameter 'voice' cannot be null.");
        else if (voice !== undefined)
            url_ += "voice=" + encodeURIComponent("" + voice) + "&";
        if (region !== undefined && region !== null)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComposedPrompt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComposedPrompt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processComposedPrompt(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

export interface IOnboardingService {
    saveProfile(request: SaveProfileRequest): Observable<ResponseModelOfBoolean>;
    saveCheckIn(request: SaveCheckInRequest): Observable<ResponseModelOfBoolean>;
    getOnboardingSteps(): Observable<ResponseModelOfListOfUserOnboardingStepDto>;
    upsertOnboardingStep(request: UpsertOnboardingStepRequest): Observable<ResponseModelOfBoolean>;
    hasSubmittedScore(): Observable<ResponseModelOfBoolean>;
    getSubmittedScoreCount(): Observable<ResponseModelOfInteger>;
    hasSavedPlan(): Observable<ResponseModelOfBoolean>;
    hasQualifyingSavedPlan(): Observable<ResponseModelOfBoolean>;
    hasSavedHand(): Observable<ResponseModelOfBoolean>;
    hasQualifyingSavedHand(): Observable<ResponseModelOfBoolean>;
    getQualifyingSavedPlanCount(): Observable<ResponseModelOfInteger>;
    resetOnboardingSteps(request: ResetOnboardingStepsRequest): Observable<ResponseModelOfBoolean>;
}

@Injectable()
export class OnboardingService implements IOnboardingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    saveProfile(request: SaveProfileRequest): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/Onboarding/SaveProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processSaveProfile(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }

    saveCheckIn(request: SaveCheckInRequest): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/Onboarding/SaveCheckIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCheckIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCheckIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processSaveCheckIn(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }

    getOnboardingSteps(): Observable<ResponseModelOfListOfUserOnboardingStepDto> {
        let url_ = this.baseUrl + "/api/Onboarding/GetOnboardingSteps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnboardingSteps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnboardingSteps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfListOfUserOnboardingStepDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfListOfUserOnboardingStepDto>;
        }));
    }

    protected processGetOnboardingSteps(response: HttpResponseBase): Observable<ResponseModelOfListOfUserOnboardingStepDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfListOfUserOnboardingStepDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfListOfUserOnboardingStepDto>(null as any);
    }

    upsertOnboardingStep(request: UpsertOnboardingStepRequest): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/Onboarding/UpsertOnboardingStep";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertOnboardingStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertOnboardingStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processUpsertOnboardingStep(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }

    hasSubmittedScore(): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/Onboarding/HasSubmittedScore";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasSubmittedScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasSubmittedScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processHasSubmittedScore(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }

    getSubmittedScoreCount(): Observable<ResponseModelOfInteger> {
        let url_ = this.baseUrl + "/api/Onboarding/GetSubmittedScoreCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubmittedScoreCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubmittedScoreCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfInteger>;
        }));
    }

    protected processGetSubmittedScoreCount(response: HttpResponseBase): Observable<ResponseModelOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfInteger>(null as any);
    }

    hasSavedPlan(): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/Onboarding/HasSavedPlan";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasSavedPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasSavedPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processHasSavedPlan(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }

    hasQualifyingSavedPlan(): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/Onboarding/HasQualifyingSavedPlan";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasQualifyingSavedPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasQualifyingSavedPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processHasQualifyingSavedPlan(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }

    hasSavedHand(): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/Onboarding/HasSavedHand";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasSavedHand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasSavedHand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processHasSavedHand(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }

    hasQualifyingSavedHand(): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/Onboarding/HasQualifyingSavedHand";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasQualifyingSavedHand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasQualifyingSavedHand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processHasQualifyingSavedHand(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }

    getQualifyingSavedPlanCount(): Observable<ResponseModelOfInteger> {
        let url_ = this.baseUrl + "/api/Onboarding/GetQualifyingSavedPlanCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualifyingSavedPlanCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualifyingSavedPlanCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfInteger>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfInteger>;
        }));
    }

    protected processGetQualifyingSavedPlanCount(response: HttpResponseBase): Observable<ResponseModelOfInteger> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfInteger.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfInteger>(null as any);
    }

    resetOnboardingSteps(request: ResetOnboardingStepsRequest): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/Onboarding/ResetOnboardingSteps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetOnboardingSteps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetOnboardingSteps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processResetOnboardingSteps(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }
}

export interface IPatientPlanService {
    getPatientPlans(localDateTime: string | null | undefined): Observable<PatientPlanDto[]>;
    getPatientPlansWithScore(localDateTime: string | null | undefined): Observable<PatientPlanWithScoreResponse[]>;
    getPatientPlanFavourites(): Observable<PatientPlanFavouriteListResponse[]>;
    isCardUsedInFavouritePlan(cardId: number | undefined): Observable<boolean>;
    savePatientPlanFavourite(patientPlanFavourite: PatientPlanFavouriteSaveRequest): Observable<number>;
    getPatientPlanDetails(patientPlanId: number | null | undefined): Observable<PatientPlanDetailResponse>;
    getPatientPlanFavouriteDetails(patientPlanFavouriteId: number | null | undefined): Observable<PatientPlanDetailResponse>;
    savePatientPlan(patientPlanSaveDbRequest: PatientPlanSaveDbRequest): Observable<number>;
    reusePlan(request: ReusePlanRequest): Observable<number>;
    dailyPeriodSelect(): Observable<DailyPeriodDbResponse[]>;
    deletePlan(deletePlanRequest: DeletePlanRequest): Observable<number>;
    deleteDayPlan(deleteDayPlanRequest: DeleteDayPlanRequest): Observable<number>;
    deleteCard(deleteCardRequest: DeleteCardRequest): Observable<number>;
}

@Injectable()
export class PatientPlanService implements IPatientPlanService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getPatientPlans(localDateTime: string | null | undefined): Observable<PatientPlanDto[]> {
        let url_ = this.baseUrl + "/api/PatientPlan/GetPatientPlans?";
        if (localDateTime !== undefined && localDateTime !== null)
            url_ += "localDateTime=" + encodeURIComponent("" + localDateTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientPlans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientPlans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientPlanDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientPlanDto[]>;
        }));
    }

    protected processGetPatientPlans(response: HttpResponseBase): Observable<PatientPlanDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientPlanDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientPlanDto[]>(null as any);
    }

    getPatientPlansWithScore(localDateTime: string | null | undefined): Observable<PatientPlanWithScoreResponse[]> {
        let url_ = this.baseUrl + "/api/PatientPlan/GetPatientPlansWithScore?";
        if (localDateTime !== undefined && localDateTime !== null)
            url_ += "localDateTime=" + encodeURIComponent("" + localDateTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientPlansWithScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientPlansWithScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientPlanWithScoreResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientPlanWithScoreResponse[]>;
        }));
    }

    protected processGetPatientPlansWithScore(response: HttpResponseBase): Observable<PatientPlanWithScoreResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientPlanWithScoreResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientPlanWithScoreResponse[]>(null as any);
    }

    getPatientPlanFavourites(): Observable<PatientPlanFavouriteListResponse[]> {
        let url_ = this.baseUrl + "/api/PatientPlan/GetPatientPlanFavourites";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientPlanFavourites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientPlanFavourites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientPlanFavouriteListResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientPlanFavouriteListResponse[]>;
        }));
    }

    protected processGetPatientPlanFavourites(response: HttpResponseBase): Observable<PatientPlanFavouriteListResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientPlanFavouriteListResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientPlanFavouriteListResponse[]>(null as any);
    }

    isCardUsedInFavouritePlan(cardId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PatientPlan/IsCardUsedInFavouritePlan?";
        if (cardId === null)
            throw new Error("The parameter 'cardId' cannot be null.");
        else if (cardId !== undefined)
            url_ += "cardId=" + encodeURIComponent("" + cardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsCardUsedInFavouritePlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsCardUsedInFavouritePlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsCardUsedInFavouritePlan(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    savePatientPlanFavourite(patientPlanFavourite: PatientPlanFavouriteSaveRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/PatientPlan/SavePatientPlanFavourite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientPlanFavourite);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePatientPlanFavourite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePatientPlanFavourite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSavePatientPlanFavourite(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getPatientPlanDetails(patientPlanId: number | null | undefined): Observable<PatientPlanDetailResponse> {
        let url_ = this.baseUrl + "/api/PatientPlan/GetPatientPlanDetails?";
        if (patientPlanId !== undefined && patientPlanId !== null)
            url_ += "PatientPlanId=" + encodeURIComponent("" + patientPlanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientPlanDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientPlanDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientPlanDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientPlanDetailResponse>;
        }));
    }

    protected processGetPatientPlanDetails(response: HttpResponseBase): Observable<PatientPlanDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientPlanDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientPlanDetailResponse>(null as any);
    }

    getPatientPlanFavouriteDetails(patientPlanFavouriteId: number | null | undefined): Observable<PatientPlanDetailResponse> {
        let url_ = this.baseUrl + "/api/PatientPlan/GetPatientPlanFavouriteDetails?";
        if (patientPlanFavouriteId !== undefined && patientPlanFavouriteId !== null)
            url_ += "PatientPlanFavouriteId=" + encodeURIComponent("" + patientPlanFavouriteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientPlanFavouriteDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientPlanFavouriteDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientPlanDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientPlanDetailResponse>;
        }));
    }

    protected processGetPatientPlanFavouriteDetails(response: HttpResponseBase): Observable<PatientPlanDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientPlanDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatientPlanDetailResponse>(null as any);
    }

    savePatientPlan(patientPlanSaveDbRequest: PatientPlanSaveDbRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/PatientPlan/SavePatientPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientPlanSaveDbRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePatientPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePatientPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSavePatientPlan(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    reusePlan(request: ReusePlanRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/PatientPlan/ReusePlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReusePlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReusePlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processReusePlan(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    dailyPeriodSelect(): Observable<DailyPeriodDbResponse[]> {
        let url_ = this.baseUrl + "/api/PatientPlan/DailyPeriodSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDailyPeriodSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDailyPeriodSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DailyPeriodDbResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DailyPeriodDbResponse[]>;
        }));
    }

    protected processDailyPeriodSelect(response: HttpResponseBase): Observable<DailyPeriodDbResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DailyPeriodDbResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DailyPeriodDbResponse[]>(null as any);
    }

    deletePlan(deletePlanRequest: DeletePlanRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/PatientPlan/DeletePlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deletePlanRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeletePlan(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    deleteDayPlan(deleteDayPlanRequest: DeleteDayPlanRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/PatientPlan/DeleteDayPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteDayPlanRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDayPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDayPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteDayPlan(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    deleteCard(deleteCardRequest: DeleteCardRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/PatientPlan/DeleteCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteCardRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteCard(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

export interface IPaymentsService {
    createCheckoutSession(request: CreateCheckoutSessionRequest): Observable<ResponseModelOfCreateCheckoutSessionResponse>;
    verifySession(sessionId: string | null | undefined): Observable<ResponseModelOfVerifySessionResponse>;
    createBillingPortalSession(): Observable<ResponseModelOfCreateBillingPortalSessionResponse>;
    subscriptionStatus(): Observable<ResponseModelOfSubscriptionStatusResponse>;
    cancelSubscription(): Observable<ResponseModelOfCancelSubscriptionResponse>;
    resumeSubscription(): Observable<ResponseModelOfResumeSubscriptionResponse>;
    billingHistory(): Observable<ResponseModelOfListOfBillingHistoryItem>;
    backfillStripeCustomers(dryRun: boolean | undefined): Observable<ResponseModelOfBackfillStripeCustomersResponse>;
    reconcilePendingSubscriptions(dryRun: boolean | undefined): Observable<ResponseModelOfBackfillStripeCustomersResponse>;
}

@Injectable()
export class PaymentsService implements IPaymentsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    createCheckoutSession(request: CreateCheckoutSessionRequest): Observable<ResponseModelOfCreateCheckoutSessionResponse> {
        let url_ = this.baseUrl + "/api/Payments/CreateCheckoutSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCheckoutSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCheckoutSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfCreateCheckoutSessionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfCreateCheckoutSessionResponse>;
        }));
    }

    protected processCreateCheckoutSession(response: HttpResponseBase): Observable<ResponseModelOfCreateCheckoutSessionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfCreateCheckoutSessionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfCreateCheckoutSessionResponse>(null as any);
    }

    verifySession(sessionId: string | null | undefined): Observable<ResponseModelOfVerifySessionResponse> {
        let url_ = this.baseUrl + "/api/Payments/VerifySession?";
        if (sessionId !== undefined && sessionId !== null)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifySession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifySession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfVerifySessionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfVerifySessionResponse>;
        }));
    }

    protected processVerifySession(response: HttpResponseBase): Observable<ResponseModelOfVerifySessionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfVerifySessionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfVerifySessionResponse>(null as any);
    }

    createBillingPortalSession(): Observable<ResponseModelOfCreateBillingPortalSessionResponse> {
        let url_ = this.baseUrl + "/api/Payments/CreateBillingPortalSession";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBillingPortalSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBillingPortalSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfCreateBillingPortalSessionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfCreateBillingPortalSessionResponse>;
        }));
    }

    protected processCreateBillingPortalSession(response: HttpResponseBase): Observable<ResponseModelOfCreateBillingPortalSessionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfCreateBillingPortalSessionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfCreateBillingPortalSessionResponse>(null as any);
    }

    subscriptionStatus(): Observable<ResponseModelOfSubscriptionStatusResponse> {
        let url_ = this.baseUrl + "/api/Payments/SubscriptionStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscriptionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscriptionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfSubscriptionStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfSubscriptionStatusResponse>;
        }));
    }

    protected processSubscriptionStatus(response: HttpResponseBase): Observable<ResponseModelOfSubscriptionStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfSubscriptionStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfSubscriptionStatusResponse>(null as any);
    }

    cancelSubscription(): Observable<ResponseModelOfCancelSubscriptionResponse> {
        let url_ = this.baseUrl + "/api/Payments/CancelSubscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfCancelSubscriptionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfCancelSubscriptionResponse>;
        }));
    }

    protected processCancelSubscription(response: HttpResponseBase): Observable<ResponseModelOfCancelSubscriptionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfCancelSubscriptionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfCancelSubscriptionResponse>(null as any);
    }

    resumeSubscription(): Observable<ResponseModelOfResumeSubscriptionResponse> {
        let url_ = this.baseUrl + "/api/Payments/ResumeSubscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResumeSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResumeSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfResumeSubscriptionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfResumeSubscriptionResponse>;
        }));
    }

    protected processResumeSubscription(response: HttpResponseBase): Observable<ResponseModelOfResumeSubscriptionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfResumeSubscriptionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfResumeSubscriptionResponse>(null as any);
    }

    billingHistory(): Observable<ResponseModelOfListOfBillingHistoryItem> {
        let url_ = this.baseUrl + "/api/Payments/BillingHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBillingHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBillingHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfListOfBillingHistoryItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfListOfBillingHistoryItem>;
        }));
    }

    protected processBillingHistory(response: HttpResponseBase): Observable<ResponseModelOfListOfBillingHistoryItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfListOfBillingHistoryItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfListOfBillingHistoryItem>(null as any);
    }

    backfillStripeCustomers(dryRun: boolean | undefined): Observable<ResponseModelOfBackfillStripeCustomersResponse> {
        let url_ = this.baseUrl + "/api/Payments/BackfillStripeCustomers?";
        if (dryRun === null)
            throw new Error("The parameter 'dryRun' cannot be null.");
        else if (dryRun !== undefined)
            url_ += "dryRun=" + encodeURIComponent("" + dryRun) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackfillStripeCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackfillStripeCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBackfillStripeCustomersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBackfillStripeCustomersResponse>;
        }));
    }

    protected processBackfillStripeCustomers(response: HttpResponseBase): Observable<ResponseModelOfBackfillStripeCustomersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBackfillStripeCustomersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBackfillStripeCustomersResponse>(null as any);
    }

    reconcilePendingSubscriptions(dryRun: boolean | undefined): Observable<ResponseModelOfBackfillStripeCustomersResponse> {
        let url_ = this.baseUrl + "/api/Payments/ReconcilePendingSubscriptions?";
        if (dryRun === null)
            throw new Error("The parameter 'dryRun' cannot be null.");
        else if (dryRun !== undefined)
            url_ += "dryRun=" + encodeURIComponent("" + dryRun) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReconcilePendingSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReconcilePendingSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBackfillStripeCustomersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBackfillStripeCustomersResponse>;
        }));
    }

    protected processReconcilePendingSubscriptions(response: HttpResponseBase): Observable<ResponseModelOfBackfillStripeCustomersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBackfillStripeCustomersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBackfillStripeCustomersResponse>(null as any);
    }
}

export interface IPerspectiveService {
    get(localDateTime: string | null | undefined): Observable<TodaysPerspectiveResponse>;
}

@Injectable()
export class PerspectiveService implements IPerspectiveService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    get(localDateTime: string | null | undefined): Observable<TodaysPerspectiveResponse> {
        let url_ = this.baseUrl + "/api/Perspective/Get?";
        if (localDateTime !== undefined && localDateTime !== null)
            url_ += "localDateTime=" + encodeURIComponent("" + localDateTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TodaysPerspectiveResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TodaysPerspectiveResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TodaysPerspectiveResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TodaysPerspectiveResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TodaysPerspectiveResponse>(null as any);
    }
}

export interface IPhodaFormsService {
    saveIntakeForm(intakeFormSaveDbRequest: IntakeFormItem): Observable<string>;
    savePainQuestionnaires(painQuestionnairesDbRequest: PainQuestionnairesItem): Observable<string>;
    saveSixWeekAssessment(sixWeekAssessmentDbRequest: SixWeekAssessmentItem): Observable<string>;
    saveTwelveWeekAssessment(twelveWeekAssessmentDbRequest: TwelveWeekAssessmentItem): Observable<string>;
    savePostProgramAssessment(postProgramAssessmentDbRequest: PostProgramAssessmentItem): Observable<string>;
    savePhodaScore(phodaScoreDbRequest: PhodaScoreItem): Observable<string>;
    getFormUserCompletion(userGuid: string | null | undefined): Observable<FormUserCompletionResponse>;
}

@Injectable()
export class PhodaFormsService implements IPhodaFormsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    saveIntakeForm(intakeFormSaveDbRequest: IntakeFormItem): Observable<string> {
        let url_ = this.baseUrl + "/api/PhodaForms/SaveIntakeForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(intakeFormSaveDbRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveIntakeForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveIntakeForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveIntakeForm(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    savePainQuestionnaires(painQuestionnairesDbRequest: PainQuestionnairesItem): Observable<string> {
        let url_ = this.baseUrl + "/api/PhodaForms/SavePainQuestionnaires";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(painQuestionnairesDbRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePainQuestionnaires(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePainQuestionnaires(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSavePainQuestionnaires(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    saveSixWeekAssessment(sixWeekAssessmentDbRequest: SixWeekAssessmentItem): Observable<string> {
        let url_ = this.baseUrl + "/api/PhodaForms/SaveSixWeekAssessment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sixWeekAssessmentDbRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSixWeekAssessment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSixWeekAssessment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveSixWeekAssessment(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    saveTwelveWeekAssessment(twelveWeekAssessmentDbRequest: TwelveWeekAssessmentItem): Observable<string> {
        let url_ = this.baseUrl + "/api/PhodaForms/SaveTwelveWeekAssessment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(twelveWeekAssessmentDbRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveTwelveWeekAssessment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveTwelveWeekAssessment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveTwelveWeekAssessment(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    savePostProgramAssessment(postProgramAssessmentDbRequest: PostProgramAssessmentItem): Observable<string> {
        let url_ = this.baseUrl + "/api/PhodaForms/SavePostProgramAssessment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postProgramAssessmentDbRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePostProgramAssessment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePostProgramAssessment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSavePostProgramAssessment(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    savePhodaScore(phodaScoreDbRequest: PhodaScoreItem): Observable<string> {
        let url_ = this.baseUrl + "/api/PhodaForms/SavePhodaScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(phodaScoreDbRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePhodaScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePhodaScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSavePhodaScore(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getFormUserCompletion(userGuid: string | null | undefined): Observable<FormUserCompletionResponse> {
        let url_ = this.baseUrl + "/api/PhodaForms/GetFormUserCompletion?";
        if (userGuid !== undefined && userGuid !== null)
            url_ += "userGuid=" + encodeURIComponent("" + userGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormUserCompletion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormUserCompletion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormUserCompletionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormUserCompletionResponse>;
        }));
    }

    protected processGetFormUserCompletion(response: HttpResponseBase): Observable<FormUserCompletionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormUserCompletionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormUserCompletionResponse>(null as any);
    }
}

export interface IPortalService {
    getPatientListStats(): Observable<ResponseTransportOfListOfPatientStats>;
    getPatient(patientId: number | undefined): Observable<ResponseTransportOfPatientDto>;
    assignClinician(patientId: number | undefined, clinicianId: number | undefined): Observable<ResponseTransportOfBoolean>;
    changeEnrollStatus(patientId: number | undefined, isEnrolled: boolean | undefined): Observable<ResponseTransportOfBoolean>;
    updatePatientDataField(patientId: number | undefined, fieldName: string | null | undefined, fieldValue: string | null | undefined): Observable<ResponseTransportOfPatientDataDto>;
    getPatientMOSData(patientId: number | undefined, startDate: Date | undefined, endDate: Date | undefined): Observable<ResponseTransportOfListOfPatientMOSItem>;
    getScoreHistory(scoreHistoryDbRequest: PatientScoreHistoryDbRequest): Observable<ResponseTransportOfScoreChartDbResponse>;
    getPatientHaloZombieUsage(patientId: number | undefined, startDate: Date | undefined, endDate: Date | null | undefined): Observable<ResponseTransportOfListOfPatientHaloZombieItem>;
    getPatietMOSByTimeOfDay(): Observable<ResponseTransportOfListOfPatientMOSByTimeOfDay>;
    getAvgDailyUserHitByWeek(): Observable<ResponseTransportOfListOfAverageUserHit>;
    getPatientMedicationChartData(patientId: number | undefined, periodType: string | null | undefined): Observable<ResponseTransportOfGetPatientMedicationChartDataOutput>;
    getPatientWorkHoursChartData(patientId: number | undefined): Observable<ResponseTransportOfGetPatientWorkHoursChartDataOutput>;
    getPatientPercentOfDutiesChartData(patientId: number | undefined): Observable<ResponseTransportOfGetPatientWorkPercentageChartDataOutput>;
    getPatientWorkIntensityChartData(patientId: number | undefined): Observable<ResponseTransportOfGetPatientWorkIntensityChartDataOutput>;
}

@Injectable()
export class PortalService implements IPortalService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getPatientListStats(): Observable<ResponseTransportOfListOfPatientStats> {
        let url_ = this.baseUrl + "/api/Portal/GetPatientListStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientListStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientListStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfListOfPatientStats>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfListOfPatientStats>;
        }));
    }

    protected processGetPatientListStats(response: HttpResponseBase): Observable<ResponseTransportOfListOfPatientStats> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfListOfPatientStats.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfListOfPatientStats>(null as any);
    }

    getPatient(patientId: number | undefined): Observable<ResponseTransportOfPatientDto> {
        let url_ = this.baseUrl + "/api/Portal/GetPatient?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfPatientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfPatientDto>;
        }));
    }

    protected processGetPatient(response: HttpResponseBase): Observable<ResponseTransportOfPatientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfPatientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfPatientDto>(null as any);
    }

    assignClinician(patientId: number | undefined, clinicianId: number | undefined): Observable<ResponseTransportOfBoolean> {
        let url_ = this.baseUrl + "/api/Portal/AssignClinician?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (clinicianId === null)
            throw new Error("The parameter 'clinicianId' cannot be null.");
        else if (clinicianId !== undefined)
            url_ += "clinicianId=" + encodeURIComponent("" + clinicianId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignClinician(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignClinician(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfBoolean>;
        }));
    }

    protected processAssignClinician(response: HttpResponseBase): Observable<ResponseTransportOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfBoolean>(null as any);
    }

    changeEnrollStatus(patientId: number | undefined, isEnrolled: boolean | undefined): Observable<ResponseTransportOfBoolean> {
        let url_ = this.baseUrl + "/api/Portal/ChangeEnrollStatus?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (isEnrolled === null)
            throw new Error("The parameter 'isEnrolled' cannot be null.");
        else if (isEnrolled !== undefined)
            url_ += "isEnrolled=" + encodeURIComponent("" + isEnrolled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeEnrollStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeEnrollStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfBoolean>;
        }));
    }

    protected processChangeEnrollStatus(response: HttpResponseBase): Observable<ResponseTransportOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfBoolean>(null as any);
    }

    updatePatientDataField(patientId: number | undefined, fieldName: string | null | undefined, fieldValue: string | null | undefined): Observable<ResponseTransportOfPatientDataDto> {
        let url_ = this.baseUrl + "/api/Portal/UpdatePatientDataField?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (fieldName !== undefined && fieldName !== null)
            url_ += "fieldName=" + encodeURIComponent("" + fieldName) + "&";
        if (fieldValue !== undefined && fieldValue !== null)
            url_ += "fieldValue=" + encodeURIComponent("" + fieldValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePatientDataField(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePatientDataField(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfPatientDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfPatientDataDto>;
        }));
    }

    protected processUpdatePatientDataField(response: HttpResponseBase): Observable<ResponseTransportOfPatientDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfPatientDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfPatientDataDto>(null as any);
    }

    getPatientMOSData(patientId: number | undefined, startDate: Date | undefined, endDate: Date | undefined): Observable<ResponseTransportOfListOfPatientMOSItem> {
        let url_ = this.baseUrl + "/api/Portal/GetPatientMOSData?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientMOSData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientMOSData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfListOfPatientMOSItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfListOfPatientMOSItem>;
        }));
    }

    protected processGetPatientMOSData(response: HttpResponseBase): Observable<ResponseTransportOfListOfPatientMOSItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfListOfPatientMOSItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfListOfPatientMOSItem>(null as any);
    }

    getScoreHistory(scoreHistoryDbRequest: PatientScoreHistoryDbRequest): Observable<ResponseTransportOfScoreChartDbResponse> {
        let url_ = this.baseUrl + "/api/Portal/GetScoreHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scoreHistoryDbRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScoreHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScoreHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfScoreChartDbResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfScoreChartDbResponse>;
        }));
    }

    protected processGetScoreHistory(response: HttpResponseBase): Observable<ResponseTransportOfScoreChartDbResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfScoreChartDbResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfScoreChartDbResponse>(null as any);
    }

    getPatientHaloZombieUsage(patientId: number | undefined, startDate: Date | undefined, endDate: Date | null | undefined): Observable<ResponseTransportOfListOfPatientHaloZombieItem> {
        let url_ = this.baseUrl + "/api/Portal/GetPatientHaloZombieUsage?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientHaloZombieUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientHaloZombieUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfListOfPatientHaloZombieItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfListOfPatientHaloZombieItem>;
        }));
    }

    protected processGetPatientHaloZombieUsage(response: HttpResponseBase): Observable<ResponseTransportOfListOfPatientHaloZombieItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfListOfPatientHaloZombieItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfListOfPatientHaloZombieItem>(null as any);
    }

    getPatietMOSByTimeOfDay(): Observable<ResponseTransportOfListOfPatientMOSByTimeOfDay> {
        let url_ = this.baseUrl + "/api/Portal/GetPatietMOSByTimeOfDay";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatietMOSByTimeOfDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatietMOSByTimeOfDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfListOfPatientMOSByTimeOfDay>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfListOfPatientMOSByTimeOfDay>;
        }));
    }

    protected processGetPatietMOSByTimeOfDay(response: HttpResponseBase): Observable<ResponseTransportOfListOfPatientMOSByTimeOfDay> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfListOfPatientMOSByTimeOfDay.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfListOfPatientMOSByTimeOfDay>(null as any);
    }

    getAvgDailyUserHitByWeek(): Observable<ResponseTransportOfListOfAverageUserHit> {
        let url_ = this.baseUrl + "/api/Portal/GetAvgDailyUserHitByWeek";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvgDailyUserHitByWeek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvgDailyUserHitByWeek(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfListOfAverageUserHit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfListOfAverageUserHit>;
        }));
    }

    protected processGetAvgDailyUserHitByWeek(response: HttpResponseBase): Observable<ResponseTransportOfListOfAverageUserHit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfListOfAverageUserHit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfListOfAverageUserHit>(null as any);
    }

    getPatientMedicationChartData(patientId: number | undefined, periodType: string | null | undefined): Observable<ResponseTransportOfGetPatientMedicationChartDataOutput> {
        let url_ = this.baseUrl + "/api/Portal/GetPatientMedicationChartData?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (periodType !== undefined && periodType !== null)
            url_ += "periodType=" + encodeURIComponent("" + periodType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientMedicationChartData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientMedicationChartData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfGetPatientMedicationChartDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfGetPatientMedicationChartDataOutput>;
        }));
    }

    protected processGetPatientMedicationChartData(response: HttpResponseBase): Observable<ResponseTransportOfGetPatientMedicationChartDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfGetPatientMedicationChartDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfGetPatientMedicationChartDataOutput>(null as any);
    }

    getPatientWorkHoursChartData(patientId: number | undefined): Observable<ResponseTransportOfGetPatientWorkHoursChartDataOutput> {
        let url_ = this.baseUrl + "/api/Portal/GetPatientWorkHoursChartData?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientWorkHoursChartData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientWorkHoursChartData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfGetPatientWorkHoursChartDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfGetPatientWorkHoursChartDataOutput>;
        }));
    }

    protected processGetPatientWorkHoursChartData(response: HttpResponseBase): Observable<ResponseTransportOfGetPatientWorkHoursChartDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfGetPatientWorkHoursChartDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfGetPatientWorkHoursChartDataOutput>(null as any);
    }

    getPatientPercentOfDutiesChartData(patientId: number | undefined): Observable<ResponseTransportOfGetPatientWorkPercentageChartDataOutput> {
        let url_ = this.baseUrl + "/api/Portal/GetPatientPercentOfDutiesChartData?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientPercentOfDutiesChartData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientPercentOfDutiesChartData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfGetPatientWorkPercentageChartDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfGetPatientWorkPercentageChartDataOutput>;
        }));
    }

    protected processGetPatientPercentOfDutiesChartData(response: HttpResponseBase): Observable<ResponseTransportOfGetPatientWorkPercentageChartDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfGetPatientWorkPercentageChartDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfGetPatientWorkPercentageChartDataOutput>(null as any);
    }

    getPatientWorkIntensityChartData(patientId: number | undefined): Observable<ResponseTransportOfGetPatientWorkIntensityChartDataOutput> {
        let url_ = this.baseUrl + "/api/Portal/GetPatientWorkIntensityChartData?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientWorkIntensityChartData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientWorkIntensityChartData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfGetPatientWorkIntensityChartDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfGetPatientWorkIntensityChartDataOutput>;
        }));
    }

    protected processGetPatientWorkIntensityChartData(response: HttpResponseBase): Observable<ResponseTransportOfGetPatientWorkIntensityChartDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfGetPatientWorkIntensityChartDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfGetPatientWorkIntensityChartDataOutput>(null as any);
    }
}

export interface IProfileService {
    getProfileDetails(): Observable<ResponseTransportOfProfileDetailsDto>;
    updateProfileDetails(input: UpdateProfileDetailsInput): Observable<ResponseTransportOfProfileDetailsDto>;
    get2FASetupCode(): Observable<ResponseTransportOfGet2FASetupCodeOutput>;
    verify2FASetupCode(input: Verify2FASetupCodeInput): Observable<ResponseTransportOfBoolean>;
    disableGoogleAuthenticator(): Observable<ResponseTransportOfBoolean>;
}

@Injectable()
export class ProfileService implements IProfileService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getProfileDetails(): Observable<ResponseTransportOfProfileDetailsDto> {
        let url_ = this.baseUrl + "/api/Profile/GetProfileDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfProfileDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfProfileDetailsDto>;
        }));
    }

    protected processGetProfileDetails(response: HttpResponseBase): Observable<ResponseTransportOfProfileDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfProfileDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfProfileDetailsDto>(null as any);
    }

    updateProfileDetails(input: UpdateProfileDetailsInput): Observable<ResponseTransportOfProfileDetailsDto> {
        let url_ = this.baseUrl + "/api/Profile/UpdateProfileDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfileDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfileDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfProfileDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfProfileDetailsDto>;
        }));
    }

    protected processUpdateProfileDetails(response: HttpResponseBase): Observable<ResponseTransportOfProfileDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfProfileDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfProfileDetailsDto>(null as any);
    }

    get2FASetupCode(): Observable<ResponseTransportOfGet2FASetupCodeOutput> {
        let url_ = this.baseUrl + "/api/Profile/Get2FASetupCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2FASetupCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2FASetupCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfGet2FASetupCodeOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfGet2FASetupCodeOutput>;
        }));
    }

    protected processGet2FASetupCode(response: HttpResponseBase): Observable<ResponseTransportOfGet2FASetupCodeOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfGet2FASetupCodeOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfGet2FASetupCodeOutput>(null as any);
    }

    verify2FASetupCode(input: Verify2FASetupCodeInput): Observable<ResponseTransportOfBoolean> {
        let url_ = this.baseUrl + "/api/Profile/Verify2FASetupCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerify2FASetupCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerify2FASetupCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfBoolean>;
        }));
    }

    protected processVerify2FASetupCode(response: HttpResponseBase): Observable<ResponseTransportOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfBoolean>(null as any);
    }

    disableGoogleAuthenticator(): Observable<ResponseTransportOfBoolean> {
        let url_ = this.baseUrl + "/api/Profile/DisableGoogleAuthenticator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableGoogleAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableGoogleAuthenticator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfBoolean>;
        }));
    }

    protected processDisableGoogleAuthenticator(response: HttpResponseBase): Observable<ResponseTransportOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfBoolean>(null as any);
    }
}

export interface ISafetyPlanService {
    getUserPlan(): Observable<ResponseTransportOfSafetyPlanDto>;
    create(input: SafetyPlanDto): Observable<ResponseTransportOfSafetyPlanDto>;
    update(id: number, safetyPlanDto: SafetyPlanDto): Observable<ResponseTransportOfSafetyPlanDto>;
}

@Injectable()
export class SafetyPlanService implements ISafetyPlanService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getUserPlan(): Observable<ResponseTransportOfSafetyPlanDto> {
        let url_ = this.baseUrl + "/api/SafetyPlan/GetUserPlan";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfSafetyPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfSafetyPlanDto>;
        }));
    }

    protected processGetUserPlan(response: HttpResponseBase): Observable<ResponseTransportOfSafetyPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfSafetyPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfSafetyPlanDto>(null as any);
    }

    create(input: SafetyPlanDto): Observable<ResponseTransportOfSafetyPlanDto> {
        let url_ = this.baseUrl + "/api/SafetyPlan/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfSafetyPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfSafetyPlanDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResponseTransportOfSafetyPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfSafetyPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfSafetyPlanDto>(null as any);
    }

    update(id: number, safetyPlanDto: SafetyPlanDto): Observable<ResponseTransportOfSafetyPlanDto> {
        let url_ = this.baseUrl + "/api/SafetyPlan/Update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(safetyPlanDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfSafetyPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfSafetyPlanDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResponseTransportOfSafetyPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfSafetyPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfSafetyPlanDto>(null as any);
    }
}

export interface IScienceBitesService {
    get(getNextDaily: number | undefined, isFavourite: number | undefined, localDateTime: string | null | undefined, biteId: number | null | undefined, registerView: number | undefined): Observable<ScienceBitesResponse[]>;
    save(scienceBiteSave: ScienceBitesSaveDbRequest): Observable<void>;
}

@Injectable()
export class ScienceBitesService implements IScienceBitesService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    get(getNextDaily: number | undefined, isFavourite: number | undefined, localDateTime: string | null | undefined, biteId: number | null | undefined, registerView: number | undefined): Observable<ScienceBitesResponse[]> {
        let url_ = this.baseUrl + "/api/ScienceBites/Get?";
        if (getNextDaily === null)
            throw new Error("The parameter 'getNextDaily' cannot be null.");
        else if (getNextDaily !== undefined)
            url_ += "GetNextDaily=" + encodeURIComponent("" + getNextDaily) + "&";
        if (isFavourite === null)
            throw new Error("The parameter 'isFavourite' cannot be null.");
        else if (isFavourite !== undefined)
            url_ += "IsFavourite=" + encodeURIComponent("" + isFavourite) + "&";
        if (localDateTime !== undefined && localDateTime !== null)
            url_ += "localDateTime=" + encodeURIComponent("" + localDateTime) + "&";
        if (biteId !== undefined && biteId !== null)
            url_ += "BiteId=" + encodeURIComponent("" + biteId) + "&";
        if (registerView === null)
            throw new Error("The parameter 'registerView' cannot be null.");
        else if (registerView !== undefined)
            url_ += "RegisterView=" + encodeURIComponent("" + registerView) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScienceBitesResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScienceBitesResponse[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ScienceBitesResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScienceBitesResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScienceBitesResponse[]>(null as any);
    }

    save(scienceBiteSave: ScienceBitesSaveDbRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/ScienceBites/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scienceBiteSave);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IScoreService {
    get(returnHalosOnly: number | undefined): Observable<ScoreResponse>;
    getTopHalos(): Observable<TopHalosResponse>;
    getLastScore(isAcceptButton: boolean | undefined, localDateTime: string | null | undefined): Observable<LastScoreResponse>;
    getLastScoreWithCount(isAcceptButton: boolean | undefined, localDateTime: string | null | undefined): Observable<LastScoreWithCountResponse>;
    saveScores(scoreSave: ScoreSave): Observable<void>;
    marginScoreChange(): Observable<ScoreChangeDay[]>;
    getScoreAndMessage(halosAndZombiesList: HalosAndZombies[]): Observable<ScoreCalculationDbResponse>;
    getTotalHaloZombiesNumber(): Observable<TotalHaloZombiesNumberResponse[]>;
    getTags(): Observable<TagDto[]>;
    getCategories(): Observable<CategoryDto[]>;
    createTag(name: string | null | undefined, categoryId: number | undefined): Observable<TagDto[]>;
}

@Injectable()
export class ScoreService implements IScoreService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    get(returnHalosOnly: number | undefined): Observable<ScoreResponse> {
        let url_ = this.baseUrl + "/api/Score/Get?";
        if (returnHalosOnly === null)
            throw new Error("The parameter 'returnHalosOnly' cannot be null.");
        else if (returnHalosOnly !== undefined)
            url_ += "ReturnHalosOnly=" + encodeURIComponent("" + returnHalosOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ScoreResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScoreResponse>(null as any);
    }

    getTopHalos(): Observable<TopHalosResponse> {
        let url_ = this.baseUrl + "/api/Score/GetTopHalos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopHalos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopHalos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopHalosResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopHalosResponse>;
        }));
    }

    protected processGetTopHalos(response: HttpResponseBase): Observable<TopHalosResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopHalosResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopHalosResponse>(null as any);
    }

    getLastScore(isAcceptButton: boolean | undefined, localDateTime: string | null | undefined): Observable<LastScoreResponse> {
        let url_ = this.baseUrl + "/api/Score/GetLastScore?";
        if (isAcceptButton === null)
            throw new Error("The parameter 'isAcceptButton' cannot be null.");
        else if (isAcceptButton !== undefined)
            url_ += "IsAcceptButton=" + encodeURIComponent("" + isAcceptButton) + "&";
        if (localDateTime !== undefined && localDateTime !== null)
            url_ += "LocalDateTime=" + encodeURIComponent("" + localDateTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LastScoreResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LastScoreResponse>;
        }));
    }

    protected processGetLastScore(response: HttpResponseBase): Observable<LastScoreResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LastScoreResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LastScoreResponse>(null as any);
    }

    getLastScoreWithCount(isAcceptButton: boolean | undefined, localDateTime: string | null | undefined): Observable<LastScoreWithCountResponse> {
        let url_ = this.baseUrl + "/api/Score/GetLastScoreWithCount?";
        if (isAcceptButton === null)
            throw new Error("The parameter 'isAcceptButton' cannot be null.");
        else if (isAcceptButton !== undefined)
            url_ += "IsAcceptButton=" + encodeURIComponent("" + isAcceptButton) + "&";
        if (localDateTime !== undefined && localDateTime !== null)
            url_ += "LocalDateTime=" + encodeURIComponent("" + localDateTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastScoreWithCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastScoreWithCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LastScoreWithCountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LastScoreWithCountResponse>;
        }));
    }

    protected processGetLastScoreWithCount(response: HttpResponseBase): Observable<LastScoreWithCountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LastScoreWithCountResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LastScoreWithCountResponse>(null as any);
    }

    saveScores(scoreSave: ScoreSave): Observable<void> {
        let url_ = this.baseUrl + "/api/Score/SaveScores";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scoreSave);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveScores(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveScores(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveScores(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    marginScoreChange(): Observable<ScoreChangeDay[]> {
        let url_ = this.baseUrl + "/api/Score/MarginScoreChange";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarginScoreChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarginScoreChange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreChangeDay[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreChangeDay[]>;
        }));
    }

    protected processMarginScoreChange(response: HttpResponseBase): Observable<ScoreChangeDay[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScoreChangeDay.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScoreChangeDay[]>(null as any);
    }

    getScoreAndMessage(halosAndZombiesList: HalosAndZombies[]): Observable<ScoreCalculationDbResponse> {
        let url_ = this.baseUrl + "/api/Score/GetScoreAndMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(halosAndZombiesList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScoreAndMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScoreAndMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreCalculationDbResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreCalculationDbResponse>;
        }));
    }

    protected processGetScoreAndMessage(response: HttpResponseBase): Observable<ScoreCalculationDbResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreCalculationDbResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScoreCalculationDbResponse>(null as any);
    }

    getTotalHaloZombiesNumber(): Observable<TotalHaloZombiesNumberResponse[]> {
        let url_ = this.baseUrl + "/api/Score/GetTotalHaloZombiesNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalHaloZombiesNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalHaloZombiesNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotalHaloZombiesNumberResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotalHaloZombiesNumberResponse[]>;
        }));
    }

    protected processGetTotalHaloZombiesNumber(response: HttpResponseBase): Observable<TotalHaloZombiesNumberResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TotalHaloZombiesNumberResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TotalHaloZombiesNumberResponse[]>(null as any);
    }

    getTags(): Observable<TagDto[]> {
        let url_ = this.baseUrl + "/api/Score/GetTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagDto[]>;
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<TagDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TagDto[]>(null as any);
    }

    getCategories(): Observable<CategoryDto[]> {
        let url_ = this.baseUrl + "/api/Score/GetCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDto[]>;
        }));
    }

    protected processGetCategories(response: HttpResponseBase): Observable<CategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDto[]>(null as any);
    }

    createTag(name: string | null | undefined, categoryId: number | undefined): Observable<TagDto[]> {
        let url_ = this.baseUrl + "/api/Score/CreateTag?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagDto[]>;
        }));
    }

    protected processCreateTag(response: HttpResponseBase): Observable<TagDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TagDto[]>(null as any);
    }
}

export interface ISettingsService {
    testSendBsbNotification(): Observable<FileResponse>;
    get(): Observable<UserSettingDto>;
    addOrUpdateUserSetting(name: string | null | undefined, value: string | null | undefined, type: string | null | undefined): Observable<ResponseTransportOfUserSettingDto>;
    downloadPass(): Observable<FileResponse>;
    updateScorePromptSetting(userSettingScorePromptRequest: UserSettingScorePromptRequest): Observable<ResponseTransportOfBoolean>;
    saveSettings(userSettingsSaveDbRequest: UserSettingsSaveDbRequest): Observable<UserSettingsSaveDbResponse>;
    saveUserTimezone(timezone: string): Observable<string>;
    getNovaInsightSettings(): Observable<NotificationSettingDto>;
    saveNovaInsightSettings(request: NotificationSettingSaveRequest): Observable<NotificationSettingDto>;
    getPlanReminderSettings(): Observable<NotificationSettingDto>;
    savePlanReminderSettings(request: NotificationSettingSaveRequest): Observable<NotificationSettingDto>;
    getCommunitySettings(): Observable<CommunityNotificationSettingsDto>;
    saveCommunitySettings(request: CommunityNotificationSettingsDto): Observable<CommunityNotificationSettingsDto>;
    getNovaCompanionSettings(): Observable<boolean>;
    saveNovaCompanionSettings(isEnabled: boolean): Observable<boolean>;
    webPushSubscribe(subscriptionObj: AndroidSubscribe): Observable<number>;
    webPushUnsubscribe(): Observable<boolean>;
    /**
     * @deprecated
     */
    androidSubscribe(subscriptionObj: AndroidSubscribe): Observable<number>;
    /**
     * @deprecated
     */
    androidUnsubscribe(): Observable<boolean>;
    mobileUnsubscribe(): Observable<boolean>;
    mobileSubscribe(mobileSubscribe: MobileSubscribe): Observable<number>;
    readFiles(filePath: string | null | undefined): Observable<string>;
}

@Injectable()
export class SettingsService implements ISettingsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    testSendBsbNotification(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Settings/TestSendBsbNotification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestSendBsbNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestSendBsbNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processTestSendBsbNotification(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    get(): Observable<UserSettingDto> {
        let url_ = this.baseUrl + "/api/Settings/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSettingDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSettingDto>(null as any);
    }

    addOrUpdateUserSetting(name: string | null | undefined, value: string | null | undefined, type: string | null | undefined): Observable<ResponseTransportOfUserSettingDto> {
        let url_ = this.baseUrl + "/api/Settings/AddOrUpdateUserSetting?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (value !== undefined && value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateUserSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateUserSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfUserSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfUserSettingDto>;
        }));
    }

    protected processAddOrUpdateUserSetting(response: HttpResponseBase): Observable<ResponseTransportOfUserSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfUserSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfUserSettingDto>(null as any);
    }

    downloadPass(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Settings/DownloadPass";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPass(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadPass(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    updateScorePromptSetting(userSettingScorePromptRequest: UserSettingScorePromptRequest): Observable<ResponseTransportOfBoolean> {
        let url_ = this.baseUrl + "/api/Settings/UpdateScorePromptSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userSettingScorePromptRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateScorePromptSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateScorePromptSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseTransportOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseTransportOfBoolean>;
        }));
    }

    protected processUpdateScorePromptSetting(response: HttpResponseBase): Observable<ResponseTransportOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseTransportOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseTransportOfBoolean>(null as any);
    }

    saveSettings(userSettingsSaveDbRequest: UserSettingsSaveDbRequest): Observable<UserSettingsSaveDbResponse> {
        let url_ = this.baseUrl + "/api/Settings/SaveSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userSettingsSaveDbRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSettingsSaveDbResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSettingsSaveDbResponse>;
        }));
    }

    protected processSaveSettings(response: HttpResponseBase): Observable<UserSettingsSaveDbResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSettingsSaveDbResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSettingsSaveDbResponse>(null as any);
    }

    saveUserTimezone(timezone: string): Observable<string> {
        let url_ = this.baseUrl + "/api/Settings/SaveUserTimezone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(timezone);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveUserTimezone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUserTimezone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveUserTimezone(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getNovaInsightSettings(): Observable<NotificationSettingDto> {
        let url_ = this.baseUrl + "/api/Settings/GetNovaInsightSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNovaInsightSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNovaInsightSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationSettingDto>;
        }));
    }

    protected processGetNovaInsightSettings(response: HttpResponseBase): Observable<NotificationSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationSettingDto>(null as any);
    }

    saveNovaInsightSettings(request: NotificationSettingSaveRequest): Observable<NotificationSettingDto> {
        let url_ = this.baseUrl + "/api/Settings/SaveNovaInsightSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveNovaInsightSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveNovaInsightSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationSettingDto>;
        }));
    }

    protected processSaveNovaInsightSettings(response: HttpResponseBase): Observable<NotificationSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationSettingDto>(null as any);
    }

    getPlanReminderSettings(): Observable<NotificationSettingDto> {
        let url_ = this.baseUrl + "/api/Settings/GetPlanReminderSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanReminderSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanReminderSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationSettingDto>;
        }));
    }

    protected processGetPlanReminderSettings(response: HttpResponseBase): Observable<NotificationSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationSettingDto>(null as any);
    }

    savePlanReminderSettings(request: NotificationSettingSaveRequest): Observable<NotificationSettingDto> {
        let url_ = this.baseUrl + "/api/Settings/SavePlanReminderSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePlanReminderSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePlanReminderSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationSettingDto>;
        }));
    }

    protected processSavePlanReminderSettings(response: HttpResponseBase): Observable<NotificationSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationSettingDto>(null as any);
    }

    getCommunitySettings(): Observable<CommunityNotificationSettingsDto> {
        let url_ = this.baseUrl + "/api/Settings/GetCommunitySettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommunitySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunitySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunityNotificationSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunityNotificationSettingsDto>;
        }));
    }

    protected processGetCommunitySettings(response: HttpResponseBase): Observable<CommunityNotificationSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunityNotificationSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunityNotificationSettingsDto>(null as any);
    }

    saveCommunitySettings(request: CommunityNotificationSettingsDto): Observable<CommunityNotificationSettingsDto> {
        let url_ = this.baseUrl + "/api/Settings/SaveCommunitySettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCommunitySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCommunitySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunityNotificationSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunityNotificationSettingsDto>;
        }));
    }

    protected processSaveCommunitySettings(response: HttpResponseBase): Observable<CommunityNotificationSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunityNotificationSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunityNotificationSettingsDto>(null as any);
    }

    getNovaCompanionSettings(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Settings/GetNovaCompanionSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNovaCompanionSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNovaCompanionSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetNovaCompanionSettings(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    saveNovaCompanionSettings(isEnabled: boolean): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Settings/SaveNovaCompanionSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(isEnabled);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveNovaCompanionSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveNovaCompanionSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveNovaCompanionSettings(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    webPushSubscribe(subscriptionObj: AndroidSubscribe): Observable<number> {
        let url_ = this.baseUrl + "/api/Settings/WebPushSubscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionObj);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWebPushSubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWebPushSubscribe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processWebPushSubscribe(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    webPushUnsubscribe(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Settings/WebPushUnsubscribe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWebPushUnsubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWebPushUnsubscribe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processWebPushUnsubscribe(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @deprecated
     */
    androidSubscribe(subscriptionObj: AndroidSubscribe): Observable<number> {
        let url_ = this.baseUrl + "/api/Settings/AndroidSubscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionObj);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAndroidSubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAndroidSubscribe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAndroidSubscribe(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @deprecated
     */
    androidUnsubscribe(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Settings/AndroidUnsubscribe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAndroidUnsubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAndroidUnsubscribe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAndroidUnsubscribe(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    mobileUnsubscribe(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Settings/MobileUnsubscribe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileUnsubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileUnsubscribe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMobileUnsubscribe(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    mobileSubscribe(mobileSubscribe: MobileSubscribe): Observable<number> {
        let url_ = this.baseUrl + "/api/Settings/MobileSubscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mobileSubscribe);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileSubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileSubscribe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMobileSubscribe(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    readFiles(filePath: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Settings/ReadFiles?";
        if (filePath !== undefined && filePath !== null)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processReadFiles(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

export interface IStoreSubscriptionsService {
    validateAppleTransaction(request: ValidateAppleTransactionRequest): Observable<ResponseModelOfSubscriptionStatusResponse>;
    validateGooglePurchase(request: ValidateGooglePurchaseRequest): Observable<ResponseModelOfSubscriptionStatusResponse>;
}

@Injectable()
export class StoreSubscriptionsService implements IStoreSubscriptionsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    validateAppleTransaction(request: ValidateAppleTransactionRequest): Observable<ResponseModelOfSubscriptionStatusResponse> {
        let url_ = this.baseUrl + "/api/StoreSubscriptions/ValidateAppleTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateAppleTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateAppleTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfSubscriptionStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfSubscriptionStatusResponse>;
        }));
    }

    protected processValidateAppleTransaction(response: HttpResponseBase): Observable<ResponseModelOfSubscriptionStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfSubscriptionStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfSubscriptionStatusResponse>(null as any);
    }

    validateGooglePurchase(request: ValidateGooglePurchaseRequest): Observable<ResponseModelOfSubscriptionStatusResponse> {
        let url_ = this.baseUrl + "/api/StoreSubscriptions/ValidateGooglePurchase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateGooglePurchase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateGooglePurchase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfSubscriptionStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfSubscriptionStatusResponse>;
        }));
    }

    protected processValidateGooglePurchase(response: HttpResponseBase): Observable<ResponseModelOfSubscriptionStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfSubscriptionStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfSubscriptionStatusResponse>(null as any);
    }
}

export interface IStoreWebhookService {
    apple(): Observable<FileResponse>;
    google(): Observable<FileResponse>;
}

@Injectable()
export class StoreWebhookService implements IStoreWebhookService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    apple(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/webhooks/apple";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApple(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processApple(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    google(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/webhooks/google";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGoogle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGoogle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGoogle(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IStripeWebhookService {
    handle(): Observable<FileResponse>;
}

@Injectable()
export class StripeWebhookService implements IStripeWebhookService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    handle(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/webhooks/stripe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processHandle(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface ISubscriptionService {
    saveProduct(productSaveModel: ProductSaveDbRequest): Observable<ProductSaveDbResponse>;
    createLicence(licenceDbRequest: LicenceDbRequest): Observable<string>;
    renewSubscription(subscriptionRenewDbRequest: SubscriptionRenewDbRequest): Observable<SubscriptionRenewDbResponse>;
}

@Injectable()
export class SubscriptionService implements ISubscriptionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    saveProduct(productSaveModel: ProductSaveDbRequest): Observable<ProductSaveDbResponse> {
        let url_ = this.baseUrl + "/api/Subscription/SaveProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productSaveModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSaveDbResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSaveDbResponse>;
        }));
    }

    protected processSaveProduct(response: HttpResponseBase): Observable<ProductSaveDbResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductSaveDbResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSaveDbResponse>(null as any);
    }

    createLicence(licenceDbRequest: LicenceDbRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/Subscription/CreateLicence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(licenceDbRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateLicence(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    renewSubscription(subscriptionRenewDbRequest: SubscriptionRenewDbRequest): Observable<SubscriptionRenewDbResponse> {
        let url_ = this.baseUrl + "/api/Subscription/RenewSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionRenewDbRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenewSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionRenewDbResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionRenewDbResponse>;
        }));
    }

    protected processRenewSubscription(response: HttpResponseBase): Observable<SubscriptionRenewDbResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionRenewDbResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionRenewDbResponse>(null as any);
    }
}

export interface IThoughtForTodayService {
    getToday(date: string | null | undefined): Observable<ThoughtForTodayDto>;
}

@Injectable()
export class ThoughtForTodayService implements IThoughtForTodayService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getToday(date: string | null | undefined): Observable<ThoughtForTodayDto> {
        let url_ = this.baseUrl + "/api/ThoughtForToday/GetToday?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThoughtForTodayDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThoughtForTodayDto>;
        }));
    }

    protected processGetToday(response: HttpResponseBase): Observable<ThoughtForTodayDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ThoughtForTodayDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ThoughtForTodayDto>(null as any);
    }
}

export interface ITrackingService {
    track(request: TrackEventsRequest): Observable<FileResponse>;
    history(eventNames: string[] | null | undefined): Observable<FileResponse>;
}

@Injectable()
export class TrackingService implements ITrackingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    track(request: TrackEventsRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Tracking/Track";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrack(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processTrack(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    history(eventNames: string[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Tracking/History?";
        if (eventNames !== undefined && eventNames !== null)
            eventNames && eventNames.forEach(item => { url_ += "eventNames=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processHistory(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IUserActivityService {
    recordEvent(request: UserActivityEventRequest): Observable<ResponseModelOfBoolean>;
}

@Injectable()
export class UserActivityService implements IUserActivityService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    recordEvent(request: UserActivityEventRequest): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/activity/events";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecordEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecordEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processRecordEvent(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }
}

export interface IUserPromoFlagsService {
    getSeenFlagKeys(): Observable<ResponseModelOfListOfString>;
    markFlagSeen(request: MarkPromoFlagSeenRequest): Observable<ResponseModelOfBoolean>;
}

@Injectable()
export class UserPromoFlagsService implements IUserPromoFlagsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5001";
    }

    getSeenFlagKeys(): Observable<ResponseModelOfListOfString> {
        let url_ = this.baseUrl + "/api/UserPromoFlags/GetSeenFlagKeys";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeenFlagKeys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeenFlagKeys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfListOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfListOfString>;
        }));
    }

    protected processGetSeenFlagKeys(response: HttpResponseBase): Observable<ResponseModelOfListOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfListOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfListOfString>(null as any);
    }

    markFlagSeen(request: MarkPromoFlagSeenRequest): Observable<ResponseModelOfBoolean> {
        let url_ = this.baseUrl + "/api/UserPromoFlags/MarkFlagSeen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkFlagSeen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkFlagSeen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelOfBoolean>;
        }));
    }

    protected processMarkFlagSeen(response: HttpResponseBase): Observable<ResponseModelOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseModelOfBoolean>(null as any);
    }
}

export class ResponseModelOfLoginResponse implements IResponseModelOfLoginResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: LoginResponse | undefined;

    constructor(data?: IResponseModelOfLoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? LoginResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfLoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfLoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfLoginResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: LoginResponse | undefined;
}

export class ResultStatus implements IResultStatus {
    errorText?: string | undefined;
    statusCode?: Status;
    statusText?: string | undefined;

    constructor(data?: IResultStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorText = _data["errorText"];
            this.statusCode = _data["statusCode"];
            this.statusText = _data["statusText"];
        }
    }

    static fromJS(data: any): ResultStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ResultStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorText"] = this.errorText;
        data["statusCode"] = this.statusCode;
        data["statusText"] = this.statusText;
        return data;
    }
}

export interface IResultStatus {
    errorText?: string | undefined;
    statusCode?: Status;
    statusText?: string | undefined;
}

export enum Status {
    Success = 1,
    Error = 2,
    LoginDetailsMissing = 3,
    IncorrectLogin = 4,
    AccountDisabled = 5,
    EmailNotVerified = 6,
    UserExists = 7,
    OrganisationExists = 8,
    RegistrationDetailsMissing = 9,
    TwoFARequired = 10,
    VerificationCodeWrong = 11,
}

export class LoginResponse implements ILoginResponse {
    userGuid?: string;
    username?: string | undefined;
    token?: string | undefined;
    tokenExpirationDate?: Date;
    isFirstLogin?: boolean;
    preferredName?: string | undefined;
    registerDate?: Date;
    userRole?: string | undefined;
    is2FAEnabled?: boolean;
    deviceId?: string | undefined;
    licenceStream?: LicenceStreamDto | undefined;
    onboardingComplete?: boolean;
    emailConfirmed?: boolean;

    constructor(data?: ILoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGuid = _data["userGuid"];
            this.username = _data["username"];
            this.token = _data["token"];
            this.tokenExpirationDate = _data["tokenExpirationDate"] ? new Date(_data["tokenExpirationDate"].toString()) : <any>undefined;
            this.isFirstLogin = _data["isFirstLogin"];
            this.preferredName = _data["preferredName"];
            this.registerDate = _data["registerDate"] ? new Date(_data["registerDate"].toString()) : <any>undefined;
            this.userRole = _data["userRole"];
            this.is2FAEnabled = _data["is2FAEnabled"];
            this.deviceId = _data["deviceId"];
            this.licenceStream = _data["licenceStream"] ? LicenceStreamDto.fromJS(_data["licenceStream"]) : <any>undefined;
            this.onboardingComplete = _data["onboardingComplete"];
            this.emailConfirmed = _data["emailConfirmed"];
        }
    }

    static fromJS(data: any): LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGuid"] = this.userGuid;
        data["username"] = this.username;
        data["token"] = this.token;
        data["tokenExpirationDate"] = this.tokenExpirationDate ? this.tokenExpirationDate.toISOString() : <any>undefined;
        data["isFirstLogin"] = this.isFirstLogin;
        data["preferredName"] = this.preferredName;
        data["registerDate"] = this.registerDate ? this.registerDate.toISOString() : <any>undefined;
        data["userRole"] = this.userRole;
        data["is2FAEnabled"] = this.is2FAEnabled;
        data["deviceId"] = this.deviceId;
        data["licenceStream"] = this.licenceStream ? this.licenceStream.toJSON() : <any>undefined;
        data["onboardingComplete"] = this.onboardingComplete;
        data["emailConfirmed"] = this.emailConfirmed;
        return data;
    }
}

export interface ILoginResponse {
    userGuid?: string;
    username?: string | undefined;
    token?: string | undefined;
    tokenExpirationDate?: Date;
    isFirstLogin?: boolean;
    preferredName?: string | undefined;
    registerDate?: Date;
    userRole?: string | undefined;
    is2FAEnabled?: boolean;
    deviceId?: string | undefined;
    licenceStream?: LicenceStreamDto | undefined;
    onboardingComplete?: boolean;
    emailConfirmed?: boolean;
}

export class LicenceStreamDto implements ILicenceStreamDto {
    licenceStreamId?: number;
    licenceStreamName?: string | undefined;
    description?: string | undefined;

    constructor(data?: ILicenceStreamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceStreamId = _data["licenceStreamId"];
            this.licenceStreamName = _data["licenceStreamName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): LicenceStreamDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceStreamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceStreamId"] = this.licenceStreamId;
        data["licenceStreamName"] = this.licenceStreamName;
        data["description"] = this.description;
        return data;
    }
}

export interface ILicenceStreamDto {
    licenceStreamId?: number;
    licenceStreamName?: string | undefined;
    description?: string | undefined;
}

export class LoginRequest implements ILoginRequest {
    username!: string;
    password!: string;
    verificationCode?: string | undefined;
    rememberMe?: boolean;
    deviceId?: string | undefined;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.verificationCode = _data["verificationCode"];
            this.rememberMe = _data["rememberMe"];
            this.deviceId = _data["deviceId"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["verificationCode"] = this.verificationCode;
        data["rememberMe"] = this.rememberMe;
        data["deviceId"] = this.deviceId;
        return data;
    }
}

export interface ILoginRequest {
    username: string;
    password: string;
    verificationCode?: string | undefined;
    rememberMe?: boolean;
    deviceId?: string | undefined;
}

export class LicenceCheckDbResponse implements ILicenceCheckDbResponse {
    errorMessage?: string | undefined;
    isLicenceValid?: number;
    isLicenceAvailable?: number;

    constructor(data?: ILicenceCheckDbResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isLicenceValid = _data["isLicenceValid"];
            this.isLicenceAvailable = _data["isLicenceAvailable"];
        }
    }

    static fromJS(data: any): LicenceCheckDbResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceCheckDbResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isLicenceValid"] = this.isLicenceValid;
        data["isLicenceAvailable"] = this.isLicenceAvailable;
        return data;
    }
}

export interface ILicenceCheckDbResponse {
    errorMessage?: string | undefined;
    isLicenceValid?: number;
    isLicenceAvailable?: number;
}

export class RegisterDbRequest implements IRegisterDbRequest {
    emailAddress!: string;
    userName!: string;
    firstName!: string;
    lastName!: string;
    password!: string;
    genderId!: number;
    yearOfBirth!: number;
    licenceCode!: string;
    localDateTime!: string;

    constructor(data?: IRegisterDbRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.password = _data["password"];
            this.genderId = _data["genderId"];
            this.yearOfBirth = _data["yearOfBirth"];
            this.licenceCode = _data["licenceCode"];
            this.localDateTime = _data["localDateTime"];
        }
    }

    static fromJS(data: any): RegisterDbRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDbRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["password"] = this.password;
        data["genderId"] = this.genderId;
        data["yearOfBirth"] = this.yearOfBirth;
        data["licenceCode"] = this.licenceCode;
        data["localDateTime"] = this.localDateTime;
        return data;
    }
}

export interface IRegisterDbRequest {
    emailAddress: string;
    userName: string;
    firstName: string;
    lastName: string;
    password: string;
    genderId: number;
    yearOfBirth: number;
    licenceCode: string;
    localDateTime: string;
}

export class SelfRegisterDbRequest implements ISelfRegisterDbRequest {
    emailAddress!: string;
    userName!: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    password!: string;
    localDateTime!: string;
    timezone?: string | undefined;

    constructor(data?: ISelfRegisterDbRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.password = _data["password"];
            this.localDateTime = _data["localDateTime"];
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): SelfRegisterDbRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SelfRegisterDbRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["password"] = this.password;
        data["localDateTime"] = this.localDateTime;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface ISelfRegisterDbRequest {
    emailAddress: string;
    userName: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    password: string;
    localDateTime: string;
    timezone?: string | undefined;
}

export class ResponseModelOfConfirmEmailResponse implements IResponseModelOfConfirmEmailResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: ConfirmEmailResponse | undefined;

    constructor(data?: IResponseModelOfConfirmEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? ConfirmEmailResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfConfirmEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfConfirmEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfConfirmEmailResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: ConfirmEmailResponse | undefined;
}

export class ConfirmEmailResponse implements IConfirmEmailResponse {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IConfirmEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ConfirmEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IConfirmEmailResponse {
    success?: boolean;
    message?: string | undefined;
}

export class ChangeUnconfirmedEmailRequest implements IChangeUnconfirmedEmailRequest {
    newEmail?: string | undefined;

    constructor(data?: IChangeUnconfirmedEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newEmail = _data["newEmail"];
        }
    }

    static fromJS(data: any): ChangeUnconfirmedEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUnconfirmedEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newEmail"] = this.newEmail;
        return data;
    }
}

export interface IChangeUnconfirmedEmailRequest {
    newEmail?: string | undefined;
}

export class ResponseModelOfEmailConfirmationStatusResponse implements IResponseModelOfEmailConfirmationStatusResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: EmailConfirmationStatusResponse | undefined;

    constructor(data?: IResponseModelOfEmailConfirmationStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? EmailConfirmationStatusResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfEmailConfirmationStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfEmailConfirmationStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfEmailConfirmationStatusResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: EmailConfirmationStatusResponse | undefined;
}

export class EmailConfirmationStatusResponse implements IEmailConfirmationStatusResponse {
    confirmed?: boolean;
    email?: string | undefined;

    constructor(data?: IEmailConfirmationStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confirmed = _data["confirmed"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): EmailConfirmationStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmailConfirmationStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmed"] = this.confirmed;
        data["email"] = this.email;
        return data;
    }
}

export interface IEmailConfirmationStatusResponse {
    confirmed?: boolean;
    email?: string | undefined;
}

export class ChangePasswordResponse implements IChangePasswordResponse {
    responseMessage?: string | undefined;

    constructor(data?: IChangePasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): ChangePasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IChangePasswordResponse {
    responseMessage?: string | undefined;
}

export class ChangePasswordDbRequest implements IChangePasswordDbRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IChangePasswordDbRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDbRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDbRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordDbRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class ResetPasswordResponse implements IResetPasswordResponse {
    responseMessage?: string | undefined;

    constructor(data?: IResetPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): ResetPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IResetPasswordResponse {
    responseMessage?: string | undefined;
}

export class ResetPasswordConfirmRequest implements IResetPasswordConfirmRequest {
    token?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IResetPasswordConfirmRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordConfirmRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordConfirmRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IResetPasswordConfirmRequest {
    token?: string | undefined;
    newPassword?: string | undefined;
}

export class ResponseModelOfCheckAccountSubscriptionResponse implements IResponseModelOfCheckAccountSubscriptionResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: CheckAccountSubscriptionResponse | undefined;

    constructor(data?: IResponseModelOfCheckAccountSubscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? CheckAccountSubscriptionResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfCheckAccountSubscriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfCheckAccountSubscriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfCheckAccountSubscriptionResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: CheckAccountSubscriptionResponse | undefined;
}

export class CheckAccountSubscriptionResponse implements ICheckAccountSubscriptionResponse {
    accountExists?: boolean;
    hasActiveSubscription?: boolean;

    constructor(data?: ICheckAccountSubscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountExists = _data["accountExists"];
            this.hasActiveSubscription = _data["hasActiveSubscription"];
        }
    }

    static fromJS(data: any): CheckAccountSubscriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckAccountSubscriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountExists"] = this.accountExists;
        data["hasActiveSubscription"] = this.hasActiveSubscription;
        return data;
    }
}

export interface ICheckAccountSubscriptionResponse {
    accountExists?: boolean;
    hasActiveSubscription?: boolean;
}

export class ResponseModelOfBoolean implements IResponseModelOfBoolean {
    resultStatus?: ResultStatus | undefined;
    responseData?: boolean;

    constructor(data?: IResponseModelOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"];
        }
    }

    static fromJS(data: any): ResponseModelOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData;
        return data;
    }
}

export interface IResponseModelOfBoolean {
    resultStatus?: ResultStatus | undefined;
    responseData?: boolean;
}

export class UpdatePreferredNameRequest implements IUpdatePreferredNameRequest {
    preferredName!: string;

    constructor(data?: IUpdatePreferredNameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preferredName = _data["preferredName"];
        }
    }

    static fromJS(data: any): UpdatePreferredNameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePreferredNameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preferredName"] = this.preferredName;
        return data;
    }
}

export interface IUpdatePreferredNameRequest {
    preferredName: string;
}

export class ResponseModelOfGetCommunityUsernameResponse implements IResponseModelOfGetCommunityUsernameResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: GetCommunityUsernameResponse | undefined;

    constructor(data?: IResponseModelOfGetCommunityUsernameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? GetCommunityUsernameResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfGetCommunityUsernameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfGetCommunityUsernameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfGetCommunityUsernameResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: GetCommunityUsernameResponse | undefined;
}

export class GetCommunityUsernameResponse implements IGetCommunityUsernameResponse {
    username?: string | undefined;

    constructor(data?: IGetCommunityUsernameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): GetCommunityUsernameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommunityUsernameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export interface IGetCommunityUsernameResponse {
    username?: string | undefined;
}

export class UpdateCommunityUsernameRequest implements IUpdateCommunityUsernameRequest {
    communityUsername!: string;

    constructor(data?: IUpdateCommunityUsernameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.communityUsername = _data["communityUsername"];
        }
    }

    static fromJS(data: any): UpdateCommunityUsernameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCommunityUsernameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communityUsername"] = this.communityUsername;
        return data;
    }
}

export interface IUpdateCommunityUsernameRequest {
    communityUsername: string;
}

export class ResponseModelOfPreviewCommunityUsernameResponse implements IResponseModelOfPreviewCommunityUsernameResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: PreviewCommunityUsernameResponse | undefined;

    constructor(data?: IResponseModelOfPreviewCommunityUsernameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? PreviewCommunityUsernameResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfPreviewCommunityUsernameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfPreviewCommunityUsernameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfPreviewCommunityUsernameResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: PreviewCommunityUsernameResponse | undefined;
}

export class PreviewCommunityUsernameResponse implements IPreviewCommunityUsernameResponse {
    username?: string | undefined;

    constructor(data?: IPreviewCommunityUsernameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): PreviewCommunityUsernameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewCommunityUsernameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export interface IPreviewCommunityUsernameResponse {
    username?: string | undefined;
}

export class PreviewCommunityUsernameRequest implements IPreviewCommunityUsernameRequest {
    preferredName!: string;

    constructor(data?: IPreviewCommunityUsernameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preferredName = _data["preferredName"];
        }
    }

    static fromJS(data: any): PreviewCommunityUsernameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewCommunityUsernameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preferredName"] = this.preferredName;
        return data;
    }
}

export interface IPreviewCommunityUsernameRequest {
    preferredName: string;
}

export class ListUpdatedPasses implements IListUpdatedPasses {
    serialNumbers?: string[] | undefined;
    lastUpdated?: string | undefined;

    constructor(data?: IListUpdatedPasses) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serialNumbers"])) {
                this.serialNumbers = [] as any;
                for (let item of _data["serialNumbers"])
                    this.serialNumbers!.push(item);
            }
            this.lastUpdated = _data["lastUpdated"];
        }
    }

    static fromJS(data: any): ListUpdatedPasses {
        data = typeof data === 'object' ? data : {};
        let result = new ListUpdatedPasses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serialNumbers)) {
            data["serialNumbers"] = [];
            for (let item of this.serialNumbers)
                data["serialNumbers"].push(item);
        }
        data["lastUpdated"] = this.lastUpdated;
        return data;
    }
}

export interface IListUpdatedPasses {
    serialNumbers?: string[] | undefined;
    lastUpdated?: string | undefined;
}

export class TriggerData implements ITriggerData {
    times?: string | undefined;
    pushToken?: string | undefined;

    constructor(data?: ITriggerData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.times = _data["times"];
            this.pushToken = _data["pushToken"];
        }
    }

    static fromJS(data: any): TriggerData {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["times"] = this.times;
        data["pushToken"] = this.pushToken;
        return data;
    }
}

export interface ITriggerData {
    times?: string | undefined;
    pushToken?: string | undefined;
}

export class NotificationTriggers implements INotificationTriggers {
    times?: string | undefined;
    uri?: string | undefined;
    auth?: string | undefined;
    p256dh?: string | undefined;

    constructor(data?: INotificationTriggers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.times = _data["times"];
            this.uri = _data["uri"];
            this.auth = _data["auth"];
            this.p256dh = _data["p256dh"];
        }
    }

    static fromJS(data: any): NotificationTriggers {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTriggers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["times"] = this.times;
        data["uri"] = this.uri;
        data["auth"] = this.auth;
        data["p256dh"] = this.p256dh;
        return data;
    }
}

export interface INotificationTriggers {
    times?: string | undefined;
    uri?: string | undefined;
    auth?: string | undefined;
    p256dh?: string | undefined;
}

export class ResponseModelOfListOfAppUpdateAnnouncementResponse implements IResponseModelOfListOfAppUpdateAnnouncementResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: AppUpdateAnnouncementResponse[] | undefined;

    constructor(data?: IResponseModelOfListOfAppUpdateAnnouncementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(AppUpdateAnnouncementResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseModelOfListOfAppUpdateAnnouncementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfListOfAppUpdateAnnouncementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseModelOfListOfAppUpdateAnnouncementResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: AppUpdateAnnouncementResponse[] | undefined;
}

export class AppUpdateAnnouncementResponse implements IAppUpdateAnnouncementResponse {
    version?: string | undefined;
    title?: string | undefined;
    newFeatures?: string[] | undefined;
    bugFixes?: string[] | undefined;
    isRequired?: boolean;
    requiresMobileUpdate?: boolean;
    requiresIosUpdate?: boolean;
    requiresAndroidUpdate?: boolean;
    communityPostId?: number | undefined;
    communityPostUrl?: string | undefined;

    constructor(data?: IAppUpdateAnnouncementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.title = _data["title"];
            if (Array.isArray(_data["newFeatures"])) {
                this.newFeatures = [] as any;
                for (let item of _data["newFeatures"])
                    this.newFeatures!.push(item);
            }
            if (Array.isArray(_data["bugFixes"])) {
                this.bugFixes = [] as any;
                for (let item of _data["bugFixes"])
                    this.bugFixes!.push(item);
            }
            this.isRequired = _data["isRequired"];
            this.requiresMobileUpdate = _data["requiresMobileUpdate"];
            this.requiresIosUpdate = _data["requiresIosUpdate"];
            this.requiresAndroidUpdate = _data["requiresAndroidUpdate"];
            this.communityPostId = _data["communityPostId"];
            this.communityPostUrl = _data["communityPostUrl"];
        }
    }

    static fromJS(data: any): AppUpdateAnnouncementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppUpdateAnnouncementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["title"] = this.title;
        if (Array.isArray(this.newFeatures)) {
            data["newFeatures"] = [];
            for (let item of this.newFeatures)
                data["newFeatures"].push(item);
        }
        if (Array.isArray(this.bugFixes)) {
            data["bugFixes"] = [];
            for (let item of this.bugFixes)
                data["bugFixes"].push(item);
        }
        data["isRequired"] = this.isRequired;
        data["requiresMobileUpdate"] = this.requiresMobileUpdate;
        data["requiresIosUpdate"] = this.requiresIosUpdate;
        data["requiresAndroidUpdate"] = this.requiresAndroidUpdate;
        data["communityPostId"] = this.communityPostId;
        data["communityPostUrl"] = this.communityPostUrl;
        return data;
    }
}

export interface IAppUpdateAnnouncementResponse {
    version?: string | undefined;
    title?: string | undefined;
    newFeatures?: string[] | undefined;
    bugFixes?: string[] | undefined;
    isRequired?: boolean;
    requiresMobileUpdate?: boolean;
    requiresIosUpdate?: boolean;
    requiresAndroidUpdate?: boolean;
    communityPostId?: number | undefined;
    communityPostUrl?: string | undefined;
}

export class MarkAppUpdateSeenRequest implements IMarkAppUpdateSeenRequest {
    version?: string | undefined;
    deviceId?: string | undefined;

    constructor(data?: IMarkAppUpdateSeenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.deviceId = _data["deviceId"];
        }
    }

    static fromJS(data: any): MarkAppUpdateSeenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAppUpdateSeenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["deviceId"] = this.deviceId;
        return data;
    }
}

export interface IMarkAppUpdateSeenRequest {
    version?: string | undefined;
    deviceId?: string | undefined;
}

export class ResponseModelOfAppUpdatePromptResponse implements IResponseModelOfAppUpdatePromptResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: AppUpdatePromptResponse | undefined;

    constructor(data?: IResponseModelOfAppUpdatePromptResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? AppUpdatePromptResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfAppUpdatePromptResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfAppUpdatePromptResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfAppUpdatePromptResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: AppUpdatePromptResponse | undefined;
}

export class AppUpdatePromptResponse implements IAppUpdatePromptResponse {
    isRequired?: boolean;
    suppress?: boolean;

    constructor(data?: IAppUpdatePromptResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isRequired = _data["isRequired"];
            this.suppress = _data["suppress"];
        }
    }

    static fromJS(data: any): AppUpdatePromptResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppUpdatePromptResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRequired"] = this.isRequired;
        data["suppress"] = this.suppress;
        return data;
    }
}

export interface IAppUpdatePromptResponse {
    isRequired?: boolean;
    suppress?: boolean;
}

export class BaseTransportOfUploadAttachmentOutputAndBaseError implements IBaseTransportOfUploadAttachmentOutputAndBaseError {
    result?: UploadAttachmentOutput | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfUploadAttachmentOutputAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? UploadAttachmentOutput.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfUploadAttachmentOutputAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfUploadAttachmentOutputAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfUploadAttachmentOutputAndBaseError {
    result?: UploadAttachmentOutput | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfUploadAttachmentOutput extends BaseTransportOfUploadAttachmentOutputAndBaseError implements IResponseTransportOfUploadAttachmentOutput {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfUploadAttachmentOutput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfUploadAttachmentOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfUploadAttachmentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfUploadAttachmentOutput extends IBaseTransportOfUploadAttachmentOutputAndBaseError {
    status?: ResponseStatus;
}

export enum ResponseStatus {
    Success = 0,
    Error = 1,
    Pending = 2,
    NotAuthorized = 3,
}

export class UploadAttachmentOutput implements IUploadAttachmentOutput {
    attachment?: AttachmentDto | undefined;

    constructor(data?: IUploadAttachmentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachment = _data["attachment"] ? AttachmentDto.fromJS(_data["attachment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UploadAttachmentOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UploadAttachmentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachment"] = this.attachment ? this.attachment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUploadAttachmentOutput {
    attachment?: AttachmentDto | undefined;
}

export class AttachmentDto implements IAttachmentDto {
    id?: number;
    lessonId?: number | undefined;
    lessonGuid?: string | undefined;
    slideId?: number | undefined;
    fileName?: string | undefined;
    blobName?: string | undefined;
    url?: string | undefined;
    fileSize?: number;
    attachmentType?: AttachmentType;
    isActive?: boolean;
    insertDate?: Date;
    position?: number;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lessonId = _data["lessonId"];
            this.lessonGuid = _data["lessonGuid"];
            this.slideId = _data["slideId"];
            this.fileName = _data["fileName"];
            this.blobName = _data["blobName"];
            this.url = _data["url"];
            this.fileSize = _data["fileSize"];
            this.attachmentType = _data["attachmentType"];
            this.isActive = _data["isActive"];
            this.insertDate = _data["insertDate"] ? new Date(_data["insertDate"].toString()) : <any>undefined;
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lessonId"] = this.lessonId;
        data["lessonGuid"] = this.lessonGuid;
        data["slideId"] = this.slideId;
        data["fileName"] = this.fileName;
        data["blobName"] = this.blobName;
        data["url"] = this.url;
        data["fileSize"] = this.fileSize;
        data["attachmentType"] = this.attachmentType;
        data["isActive"] = this.isActive;
        data["insertDate"] = this.insertDate ? this.insertDate.toISOString() : <any>undefined;
        data["position"] = this.position;
        return data;
    }
}

export interface IAttachmentDto {
    id?: number;
    lessonId?: number | undefined;
    lessonGuid?: string | undefined;
    slideId?: number | undefined;
    fileName?: string | undefined;
    blobName?: string | undefined;
    url?: string | undefined;
    fileSize?: number;
    attachmentType?: AttachmentType;
    isActive?: boolean;
    insertDate?: Date;
    position?: number;
}

export enum AttachmentType {
    Video = 0,
    Download = 1,
    Pdf = 2,
    Audio = 3,
    Presentation = 4,
    Image = 5,
}

export class BaseError implements IBaseError {
    errorCode?: ErrorType | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): BaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IBaseError {
    errorCode?: ErrorType | undefined;
    errorMessage?: string | undefined;
}

export enum ErrorType {
    OK = 0,
    ACCESS_DENIED = 1,
    SYSTEM_ERROR = 20,
    NOT_FOUND = 40,
    UNKNOWN = 99,
}

export class BaseTransportOfStringAndBaseError implements IBaseTransportOfStringAndBaseError {
    result?: string | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfStringAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfStringAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfStringAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfStringAndBaseError {
    result?: string | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfString extends BaseTransportOfStringAndBaseError implements IResponseTransportOfString {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfString) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfString extends IBaseTransportOfStringAndBaseError {
    status?: ResponseStatus;
}

export class BaseTransportOfBooleanAndBaseError implements IBaseTransportOfBooleanAndBaseError {
    result?: boolean;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfBooleanAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfBooleanAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfBooleanAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfBooleanAndBaseError {
    result?: boolean;
    error?: BaseError | undefined;
}

export class ResponseTransportOfBoolean extends BaseTransportOfBooleanAndBaseError implements IResponseTransportOfBoolean {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfBoolean) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfBoolean extends IBaseTransportOfBooleanAndBaseError {
    status?: ResponseStatus;
}

export class CountryResponse implements ICountryResponse {
    countryId?: number;
    countryName?: string | undefined;

    constructor(data?: ICountryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
        }
    }

    static fromJS(data: any): CountryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        return data;
    }
}

export interface ICountryResponse {
    countryId?: number;
    countryName?: string | undefined;
}

export class CountryDbRequest implements ICountryDbRequest {
    countryId?: number | undefined;
    countryName?: string | undefined;

    constructor(data?: ICountryDbRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
        }
    }

    static fromJS(data: any): CountryDbRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDbRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        return data;
    }
}

export interface ICountryDbRequest {
    countryId?: number | undefined;
    countryName?: string | undefined;
}

export class ProfessionResponse implements IProfessionResponse {
    professionId?: number;
    professionName?: string | undefined;
    professionTypeId?: number;
    professionTypeName?: string | undefined;

    constructor(data?: IProfessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.professionName = _data["professionName"];
            this.professionTypeId = _data["professionTypeId"];
            this.professionTypeName = _data["professionTypeName"];
        }
    }

    static fromJS(data: any): ProfessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["professionName"] = this.professionName;
        data["professionTypeId"] = this.professionTypeId;
        data["professionTypeName"] = this.professionTypeName;
        return data;
    }
}

export interface IProfessionResponse {
    professionId?: number;
    professionName?: string | undefined;
    professionTypeId?: number;
    professionTypeName?: string | undefined;
}

export class ProfessionDbRequest implements IProfessionDbRequest {
    professionId?: number | undefined;
    professionName?: string | undefined;
    professionTypeId?: number | undefined;
    professionTypeName?: string | undefined;

    constructor(data?: IProfessionDbRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.professionName = _data["professionName"];
            this.professionTypeId = _data["professionTypeId"];
            this.professionTypeName = _data["professionTypeName"];
        }
    }

    static fromJS(data: any): ProfessionDbRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionDbRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["professionName"] = this.professionName;
        data["professionTypeId"] = this.professionTypeId;
        data["professionTypeName"] = this.professionTypeName;
        return data;
    }
}

export interface IProfessionDbRequest {
    professionId?: number | undefined;
    professionName?: string | undefined;
    professionTypeId?: number | undefined;
    professionTypeName?: string | undefined;
}

export class GenderResponse implements IGenderResponse {
    genderId?: number;
    genderName?: string | undefined;
    sortOrder?: number;

    constructor(data?: IGenderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.genderId = _data["genderId"];
            this.genderName = _data["genderName"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): GenderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["genderId"] = this.genderId;
        data["genderName"] = this.genderName;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IGenderResponse {
    genderId?: number;
    genderName?: string | undefined;
    sortOrder?: number;
}

export class CardDecks implements ICardDecks {
    isPatientDeck?: boolean;
    cardDeckId?: number;
    cardDeckName?: string | undefined;
    cards?: Cards[] | undefined;

    constructor(data?: ICardDecks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPatientDeck = _data["isPatientDeck"];
            this.cardDeckId = _data["cardDeckId"];
            this.cardDeckName = _data["cardDeckName"];
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(Cards.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CardDecks {
        data = typeof data === 'object' ? data : {};
        let result = new CardDecks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPatientDeck"] = this.isPatientDeck;
        data["cardDeckId"] = this.cardDeckId;
        data["cardDeckName"] = this.cardDeckName;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICardDecks {
    isPatientDeck?: boolean;
    cardDeckId?: number;
    cardDeckName?: string | undefined;
    cards?: Cards[] | undefined;
}

export class Cards implements ICards {
    cardCategoryId?: number;
    cardCategoryName?: string | undefined;
    cardCategoryShortDesc?: string | undefined;
    cardId?: number;
    cardName?: string | undefined;
    periodMinutes?: number;
    isMandatory?: boolean;
    isFavourite?: boolean;
    sortOrder?: number;

    constructor(data?: ICards) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardCategoryId = _data["cardCategoryId"];
            this.cardCategoryName = _data["cardCategoryName"];
            this.cardCategoryShortDesc = _data["cardCategoryShortDesc"];
            this.cardId = _data["cardId"];
            this.cardName = _data["cardName"];
            this.periodMinutes = _data["periodMinutes"];
            this.isMandatory = _data["isMandatory"];
            this.isFavourite = _data["isFavourite"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): Cards {
        data = typeof data === 'object' ? data : {};
        let result = new Cards();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardCategoryId"] = this.cardCategoryId;
        data["cardCategoryName"] = this.cardCategoryName;
        data["cardCategoryShortDesc"] = this.cardCategoryShortDesc;
        data["cardId"] = this.cardId;
        data["cardName"] = this.cardName;
        data["periodMinutes"] = this.periodMinutes;
        data["isMandatory"] = this.isMandatory;
        data["isFavourite"] = this.isFavourite;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ICards {
    cardCategoryId?: number;
    cardCategoryName?: string | undefined;
    cardCategoryShortDesc?: string | undefined;
    cardId?: number;
    cardName?: string | undefined;
    periodMinutes?: number;
    isMandatory?: boolean;
    isFavourite?: boolean;
    sortOrder?: number;
}

export class CardDeckType implements ICardDeckType {
    cardDeckId?: number;
    cardDeckName?: string | undefined;
    cardDeckDescription?: string | undefined;

    constructor(data?: ICardDeckType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardDeckId = _data["cardDeckId"];
            this.cardDeckName = _data["cardDeckName"];
            this.cardDeckDescription = _data["cardDeckDescription"];
        }
    }

    static fromJS(data: any): CardDeckType {
        data = typeof data === 'object' ? data : {};
        let result = new CardDeckType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardDeckId"] = this.cardDeckId;
        data["cardDeckName"] = this.cardDeckName;
        data["cardDeckDescription"] = this.cardDeckDescription;
        return data;
    }
}

export interface ICardDeckType {
    cardDeckId?: number;
    cardDeckName?: string | undefined;
    cardDeckDescription?: string | undefined;
}

export class CardCategories implements ICardCategories {
    cardCategoryId?: number;
    cardCategoryName?: string | undefined;
    cardCategoryShortDesc?: string | undefined;

    checked: boolean = false;

    constructor(data?: ICardCategories) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardCategoryId = _data["cardCategoryId"];
            this.cardCategoryName = _data["cardCategoryName"];
            this.cardCategoryShortDesc = _data["cardCategoryShortDesc"];
        }
    }

    static fromJS(data: any): CardCategories {
        data = typeof data === 'object' ? data : {};
        let result = new CardCategories();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardCategoryId"] = this.cardCategoryId;
        data["cardCategoryName"] = this.cardCategoryName;
        data["cardCategoryShortDesc"] = this.cardCategoryShortDesc;
        return data;
    }
}

export interface ICardCategories {
    cardCategoryId?: number;
    cardCategoryName?: string | undefined;
    cardCategoryShortDesc?: string | undefined;
}

export class CardModelResponse implements ICardModelResponse {
    cards?: CardModel[] | undefined;
    cardCategories?: CardCategories[] | undefined;
    cardDeckTypes?: CardDeckType[] | undefined;
    cardSelectionType?: CardSelectionType[] | undefined;

    constructor(data?: ICardModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(CardModel.fromJS(item));
            }
            if (Array.isArray(_data["cardCategories"])) {
                this.cardCategories = [] as any;
                for (let item of _data["cardCategories"])
                    this.cardCategories!.push(CardCategories.fromJS(item));
            }
            if (Array.isArray(_data["cardDeckTypes"])) {
                this.cardDeckTypes = [] as any;
                for (let item of _data["cardDeckTypes"])
                    this.cardDeckTypes!.push(CardDeckType.fromJS(item));
            }
            if (Array.isArray(_data["cardSelectionType"])) {
                this.cardSelectionType = [] as any;
                for (let item of _data["cardSelectionType"])
                    this.cardSelectionType!.push(CardSelectionType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CardModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CardModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item.toJSON());
        }
        if (Array.isArray(this.cardCategories)) {
            data["cardCategories"] = [];
            for (let item of this.cardCategories)
                data["cardCategories"].push(item.toJSON());
        }
        if (Array.isArray(this.cardDeckTypes)) {
            data["cardDeckTypes"] = [];
            for (let item of this.cardDeckTypes)
                data["cardDeckTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.cardSelectionType)) {
            data["cardSelectionType"] = [];
            for (let item of this.cardSelectionType)
                data["cardSelectionType"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICardModelResponse {
    cards?: CardModel[] | undefined;
    cardCategories?: CardCategories[] | undefined;
    cardDeckTypes?: CardDeckType[] | undefined;
    cardSelectionType?: CardSelectionType[] | undefined;
}

export class CardModel implements ICardModel {
    cardDeckId?: number;
    cardId?: number;
    cardName?: string | undefined;
    cardDescription?: string | undefined;
    isMandatory?: boolean;
    dailyPeriodId?: number;
    dailyPeriod?: string | undefined;
    periodMinutes?: number;
    isPatientFavourite?: boolean;
    isPatientDeck?: boolean;
    isComplete?: boolean;
    isUserDefined?: boolean;
    isEditableTemplate?: boolean;
    cardSessionCardId?: number;
    htmlScript?: string | undefined;
    sortOrder?: number;
    cardCategory?: CardCategories | undefined;
    cardDeckType?: CardDeckType | undefined;
    cardGuid?: string;

    selected: boolean = false;
  editable: boolean = false;
  //cardGuid: string;

    constructor(data?: ICardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardDeckId = _data["cardDeckId"];
            this.cardId = _data["cardId"];
            this.cardName = _data["cardName"];
            this.cardDescription = _data["cardDescription"];
            this.isMandatory = _data["isMandatory"];
            this.dailyPeriodId = _data["dailyPeriodId"];
            this.dailyPeriod = _data["dailyPeriod"];
            this.periodMinutes = _data["periodMinutes"];
            this.isPatientFavourite = _data["isPatientFavourite"];
            this.isPatientDeck = _data["isPatientDeck"];
            this.isComplete = _data["isComplete"];
            this.isUserDefined = _data["isUserDefined"];
            this.isEditableTemplate = _data["isEditableTemplate"];
            this.cardSessionCardId = _data["cardSessionCardId"];
            this.htmlScript = _data["htmlScript"];
            this.sortOrder = _data["sortOrder"];
            this.cardCategory = _data["cardCategory"] ? CardCategories.fromJS(_data["cardCategory"]) : <any>undefined;
            this.cardDeckType = _data["cardDeckType"] ? CardDeckType.fromJS(_data["cardDeckType"]) : <any>undefined;
            this.cardGuid = _data["cardGuid"];
        }
    }

    static fromJS(data: any): CardModel {
        data = typeof data === 'object' ? data : {};
        let result = new CardModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardDeckId"] = this.cardDeckId;
        data["cardId"] = this.cardId;
        data["cardName"] = this.cardName;
        data["cardDescription"] = this.cardDescription;
        data["isMandatory"] = this.isMandatory;
        data["dailyPeriodId"] = this.dailyPeriodId;
        data["dailyPeriod"] = this.dailyPeriod;
        data["periodMinutes"] = this.periodMinutes;
        data["isPatientFavourite"] = this.isPatientFavourite;
        data["isPatientDeck"] = this.isPatientDeck;
        data["isComplete"] = this.isComplete;
        data["isUserDefined"] = this.isUserDefined;
        data["isEditableTemplate"] = this.isEditableTemplate;
        data["cardSessionCardId"] = this.cardSessionCardId;
        data["htmlScript"] = this.htmlScript;
        data["sortOrder"] = this.sortOrder;
        data["cardCategory"] = this.cardCategory ? this.cardCategory.toJSON() : <any>undefined;
        data["cardDeckType"] = this.cardDeckType ? this.cardDeckType.toJSON() : <any>undefined;
        data["cardGuid"] = this.cardGuid;
        return data;
    }
}

export interface ICardModel {
    cardDeckId?: number;
    cardId?: number;
    cardName?: string | undefined;
    cardDescription?: string | undefined;
    isMandatory?: boolean;
    dailyPeriodId?: number;
    dailyPeriod?: string | undefined;
    periodMinutes?: number;
    isPatientFavourite?: boolean;
    isPatientDeck?: boolean;
    isComplete?: boolean;
    isUserDefined?: boolean;
    isEditableTemplate?: boolean;
    cardSessionCardId?: number;
    htmlScript?: string | undefined;
    sortOrder?: number;
    cardCategory?: CardCategories | undefined;
    cardDeckType?: CardDeckType | undefined;
    cardGuid?: string;
}

export class CardSelectionType implements ICardSelectionType {
    name?: string | undefined;
    value?: number;

    constructor(data?: ICardSelectionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CardSelectionType {
        data = typeof data === 'object' ? data : {};
        let result = new CardSelectionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ICardSelectionType {
    name?: string | undefined;
    value?: number;
}

export class CardCollectionStatsResponse implements ICardCollectionStatsResponse {
    totalCards?: number;
    addedThisMonth?: number;
    favourites?: number;
    notUsedRecently?: number;

    constructor(data?: ICardCollectionStatsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCards = _data["totalCards"];
            this.addedThisMonth = _data["addedThisMonth"];
            this.favourites = _data["favourites"];
            this.notUsedRecently = _data["notUsedRecently"];
        }
    }

    static fromJS(data: any): CardCollectionStatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CardCollectionStatsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCards"] = this.totalCards;
        data["addedThisMonth"] = this.addedThisMonth;
        data["favourites"] = this.favourites;
        data["notUsedRecently"] = this.notUsedRecently;
        return data;
    }
}

export interface ICardCollectionStatsResponse {
    totalCards?: number;
    addedThisMonth?: number;
    favourites?: number;
    notUsedRecently?: number;
}

export class CardSessionCompleteRequest implements ICardSessionCompleteRequest {
    cardSessionCardId?: number;
    isComplete?: boolean;
    userGuid?: string | undefined;

    constructor(data?: ICardSessionCompleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardSessionCardId = _data["cardSessionCardId"];
            this.isComplete = _data["isComplete"];
            this.userGuid = _data["userGuid"];
        }
    }

    static fromJS(data: any): CardSessionCompleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CardSessionCompleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardSessionCardId"] = this.cardSessionCardId;
        data["isComplete"] = this.isComplete;
        data["userGuid"] = this.userGuid;
        return data;
    }
}

export interface ICardSessionCompleteRequest {
    cardSessionCardId?: number;
    isComplete?: boolean;
    userGuid?: string | undefined;
}

export class MyDeckModel implements IMyDeckModel {
    cardModelList?: CardModel[] | undefined;
    isRemoveFromDeck?: boolean;

    constructor(data?: IMyDeckModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cardModelList"])) {
                this.cardModelList = [] as any;
                for (let item of _data["cardModelList"])
                    this.cardModelList!.push(CardModel.fromJS(item));
            }
            this.isRemoveFromDeck = _data["isRemoveFromDeck"];
        }
    }

    static fromJS(data: any): MyDeckModel {
        data = typeof data === 'object' ? data : {};
        let result = new MyDeckModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cardModelList)) {
            data["cardModelList"] = [];
            for (let item of this.cardModelList)
                data["cardModelList"].push(item.toJSON());
        }
        data["isRemoveFromDeck"] = this.isRemoveFromDeck;
        return data;
    }
}

export interface IMyDeckModel {
    cardModelList?: CardModel[] | undefined;
    isRemoveFromDeck?: boolean;
}

export class CreateUserCardRequest implements ICreateUserCardRequest {
    cardName?: string | undefined;
    cardCategoryId?: number | undefined;
    periodMinutes?: number | undefined;
    deckTypeId?: number | undefined;
    cardDescription?: string | undefined;

    constructor(data?: ICreateUserCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardName = _data["cardName"];
            this.cardCategoryId = _data["cardCategoryId"];
            this.periodMinutes = _data["periodMinutes"];
            this.deckTypeId = _data["deckTypeId"];
            this.cardDescription = _data["cardDescription"];
        }
    }

    static fromJS(data: any): CreateUserCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardName"] = this.cardName;
        data["cardCategoryId"] = this.cardCategoryId;
        data["periodMinutes"] = this.periodMinutes;
        data["deckTypeId"] = this.deckTypeId;
        data["cardDescription"] = this.cardDescription;
        return data;
    }
}

export interface ICreateUserCardRequest {
    cardName?: string | undefined;
    cardCategoryId?: number | undefined;
    periodMinutes?: number | undefined;
    deckTypeId?: number | undefined;
    cardDescription?: string | undefined;
}

export class EditCardResponse implements IEditCardResponse {
    cardId?: number;
    createdNewCard?: boolean;
    deactivatedCardId?: number | undefined;
    outcome?: EditCardOutcome;
    validationError?: string | undefined;

    constructor(data?: IEditCardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            this.createdNewCard = _data["createdNewCard"];
            this.deactivatedCardId = _data["deactivatedCardId"];
            this.outcome = _data["outcome"];
            this.validationError = _data["validationError"];
        }
    }

    static fromJS(data: any): EditCardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditCardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["createdNewCard"] = this.createdNewCard;
        data["deactivatedCardId"] = this.deactivatedCardId;
        data["outcome"] = this.outcome;
        data["validationError"] = this.validationError;
        return data;
    }
}

export interface IEditCardResponse {
    cardId?: number;
    createdNewCard?: boolean;
    deactivatedCardId?: number | undefined;
    outcome?: EditCardOutcome;
    validationError?: string | undefined;
}

export enum EditCardOutcome {
    InPlaceUpdate = 0,
    NewVersion = 1,
    Duplicate = 2,
    MandatoryOverride = 3,
    CopyOnWrite = 4,
    ValidationFailed = 5,
}

export class EditCardRequest implements IEditCardRequest {
    cardId?: number;
    cardName?: string | undefined;
    periodMinutes?: number | undefined;
    cardCategoryId?: number | undefined;
    mode?: EditCardMode;
    cardDescription?: string | undefined;

    constructor(data?: IEditCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            this.cardName = _data["cardName"];
            this.periodMinutes = _data["periodMinutes"];
            this.cardCategoryId = _data["cardCategoryId"];
            this.mode = _data["mode"];
            this.cardDescription = _data["cardDescription"];
        }
    }

    static fromJS(data: any): EditCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["cardName"] = this.cardName;
        data["periodMinutes"] = this.periodMinutes;
        data["cardCategoryId"] = this.cardCategoryId;
        data["mode"] = this.mode;
        data["cardDescription"] = this.cardDescription;
        return data;
    }
}

export interface IEditCardRequest {
    cardId?: number;
    cardName?: string | undefined;
    periodMinutes?: number | undefined;
    cardCategoryId?: number | undefined;
    mode?: EditCardMode;
    cardDescription?: string | undefined;
}

export enum EditCardMode {
    DirectEdit = 0,
    Duplicate = 1,
}

export class ClinicianSelectResponse implements IClinicianSelectResponse {
    clinicianSelectDbResponse?: ClinicianSelectDbResponse[] | undefined;

    constructor(data?: IClinicianSelectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clinicianSelectDbResponse"])) {
                this.clinicianSelectDbResponse = [] as any;
                for (let item of _data["clinicianSelectDbResponse"])
                    this.clinicianSelectDbResponse!.push(ClinicianSelectDbResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClinicianSelectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicianSelectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clinicianSelectDbResponse)) {
            data["clinicianSelectDbResponse"] = [];
            for (let item of this.clinicianSelectDbResponse)
                data["clinicianSelectDbResponse"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClinicianSelectResponse {
    clinicianSelectDbResponse?: ClinicianSelectDbResponse[] | undefined;
}

export class ClinicianSelectDbResponse implements IClinicianSelectDbResponse {
    isActive?: boolean;
    clinicianId?: number;
    name?: string | undefined;
    description?: string | undefined;
    clinicId?: number;
    clinicName?: string | undefined;
    organisationId?: number;
    organisationName?: string | undefined;
    emailAddress?: string | undefined;
    phone?: string | undefined;
    userId?: number;
    professionId?: number;
    professionName?: string | undefined;
    locationId?: number;
    location?: string | undefined;
    country?: string | undefined;
    countryId?: number;
    licencesCount?: number;
    joiningDate?: string | undefined;

    constructor(data?: IClinicianSelectDbResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.clinicianId = _data["clinicianId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.clinicId = _data["clinicId"];
            this.clinicName = _data["clinicName"];
            this.organisationId = _data["organisationId"];
            this.organisationName = _data["organisationName"];
            this.emailAddress = _data["emailAddress"];
            this.phone = _data["phone"];
            this.userId = _data["userId"];
            this.professionId = _data["professionId"];
            this.professionName = _data["professionName"];
            this.locationId = _data["locationId"];
            this.location = _data["location"];
            this.country = _data["country"];
            this.countryId = _data["countryId"];
            this.licencesCount = _data["licencesCount"];
            this.joiningDate = _data["joiningDate"];
        }
    }

    static fromJS(data: any): ClinicianSelectDbResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicianSelectDbResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["clinicianId"] = this.clinicianId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["clinicId"] = this.clinicId;
        data["clinicName"] = this.clinicName;
        data["organisationId"] = this.organisationId;
        data["organisationName"] = this.organisationName;
        data["emailAddress"] = this.emailAddress;
        data["phone"] = this.phone;
        data["userId"] = this.userId;
        data["professionId"] = this.professionId;
        data["professionName"] = this.professionName;
        data["locationId"] = this.locationId;
        data["location"] = this.location;
        data["country"] = this.country;
        data["countryId"] = this.countryId;
        data["licencesCount"] = this.licencesCount;
        data["joiningDate"] = this.joiningDate;
        return data;
    }
}

export interface IClinicianSelectDbResponse {
    isActive?: boolean;
    clinicianId?: number;
    name?: string | undefined;
    description?: string | undefined;
    clinicId?: number;
    clinicName?: string | undefined;
    organisationId?: number;
    organisationName?: string | undefined;
    emailAddress?: string | undefined;
    phone?: string | undefined;
    userId?: number;
    professionId?: number;
    professionName?: string | undefined;
    locationId?: number;
    location?: string | undefined;
    country?: string | undefined;
    countryId?: number;
    licencesCount?: number;
    joiningDate?: string | undefined;
}

export class SaveResponse implements ISaveResponse {
    id?: number;
    responseMessage?: string | undefined;

    constructor(data?: ISaveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): SaveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface ISaveResponse {
    id?: number;
    responseMessage?: string | undefined;
}

export class ClinicianSaveRequest implements IClinicianSaveRequest {
    clinicianId?: number | undefined;
    licencesCount?: number | undefined;
    clinicianName?: string | undefined;
    clinicianDescription?: string | undefined;
    professionId?: number;
    professionName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    clinicId?: number;
    userId?: number | undefined;
    isActive?: boolean;
    locationId?: number;
    location?: string | undefined;
    countryId?: number;
    country?: string | undefined;
    joiningDate?: string | undefined;
    organisation?: string | undefined;
    userGuid?: string;

    constructor(data?: IClinicianSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicianId = _data["clinicianId"];
            this.licencesCount = _data["licencesCount"];
            this.clinicianName = _data["clinicianName"];
            this.clinicianDescription = _data["clinicianDescription"];
            this.professionId = _data["professionId"];
            this.professionName = _data["professionName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.clinicId = _data["clinicId"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
            this.locationId = _data["locationId"];
            this.location = _data["location"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.joiningDate = _data["joiningDate"];
            this.organisation = _data["organisation"];
            this.userGuid = _data["userGuid"];
        }
    }

    static fromJS(data: any): ClinicianSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicianSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicianId"] = this.clinicianId;
        data["licencesCount"] = this.licencesCount;
        data["clinicianName"] = this.clinicianName;
        data["clinicianDescription"] = this.clinicianDescription;
        data["professionId"] = this.professionId;
        data["professionName"] = this.professionName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["clinicId"] = this.clinicId;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        data["locationId"] = this.locationId;
        data["location"] = this.location;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["joiningDate"] = this.joiningDate;
        data["organisation"] = this.organisation;
        data["userGuid"] = this.userGuid;
        return data;
    }
}

export interface IClinicianSaveRequest {
    clinicianId?: number | undefined;
    licencesCount?: number | undefined;
    clinicianName?: string | undefined;
    clinicianDescription?: string | undefined;
    professionId?: number;
    professionName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    clinicId?: number;
    userId?: number | undefined;
    isActive?: boolean;
    locationId?: number;
    location?: string | undefined;
    countryId?: number;
    country?: string | undefined;
    joiningDate?: string | undefined;
    organisation?: string | undefined;
    userGuid?: string;
}

export class ClinicSelectResponse implements IClinicSelectResponse {
    clinicSelectDbResponse?: ClinicSelectDbResponse[] | undefined;

    constructor(data?: IClinicSelectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clinicSelectDbResponse"])) {
                this.clinicSelectDbResponse = [] as any;
                for (let item of _data["clinicSelectDbResponse"])
                    this.clinicSelectDbResponse!.push(ClinicSelectDbResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClinicSelectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicSelectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clinicSelectDbResponse)) {
            data["clinicSelectDbResponse"] = [];
            for (let item of this.clinicSelectDbResponse)
                data["clinicSelectDbResponse"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClinicSelectResponse {
    clinicSelectDbResponse?: ClinicSelectDbResponse[] | undefined;
}

export class ClinicSelectDbResponse implements IClinicSelectDbResponse {
    isActive?: boolean;
    clinicId?: number;
    name?: string | undefined;
    description?: string | undefined;
    organisationId?: number;
    organisationName?: string | undefined;
    contactName?: string | undefined;
    emailAddress?: string | undefined;
    phone?: string | undefined;
    location?: string | undefined;
    locationId?: number | undefined;
    country?: string | undefined;
    countryId?: number;
    cliniciansCount?: number;
    joiningDate?: string | undefined;

    constructor(data?: IClinicSelectDbResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.clinicId = _data["clinicId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.organisationId = _data["organisationId"];
            this.organisationName = _data["organisationName"];
            this.contactName = _data["contactName"];
            this.emailAddress = _data["emailAddress"];
            this.phone = _data["phone"];
            this.location = _data["location"];
            this.locationId = _data["locationId"];
            this.country = _data["country"];
            this.countryId = _data["countryId"];
            this.cliniciansCount = _data["cliniciansCount"];
            this.joiningDate = _data["joiningDate"];
        }
    }

    static fromJS(data: any): ClinicSelectDbResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicSelectDbResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["clinicId"] = this.clinicId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["organisationId"] = this.organisationId;
        data["organisationName"] = this.organisationName;
        data["contactName"] = this.contactName;
        data["emailAddress"] = this.emailAddress;
        data["phone"] = this.phone;
        data["location"] = this.location;
        data["locationId"] = this.locationId;
        data["country"] = this.country;
        data["countryId"] = this.countryId;
        data["cliniciansCount"] = this.cliniciansCount;
        data["joiningDate"] = this.joiningDate;
        return data;
    }
}

export interface IClinicSelectDbResponse {
    isActive?: boolean;
    clinicId?: number;
    name?: string | undefined;
    description?: string | undefined;
    organisationId?: number;
    organisationName?: string | undefined;
    contactName?: string | undefined;
    emailAddress?: string | undefined;
    phone?: string | undefined;
    location?: string | undefined;
    locationId?: number | undefined;
    country?: string | undefined;
    countryId?: number;
    cliniciansCount?: number;
    joiningDate?: string | undefined;
}

export class ClinicSaveRequest implements IClinicSaveRequest {
    clinicId?: number | undefined;
    cliniciansCount?: number | undefined;
    clinicName?: string | undefined;
    clinicDescription?: string | undefined;
    clinicTypeId?: number;
    contactName?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    organisationId?: number;
    locationId?: number;
    location?: string | undefined;
    countryId?: number;
    country?: string | undefined;
    isActive?: boolean;
    organizationName?: string | undefined;

    constructor(data?: IClinicSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicId = _data["clinicId"];
            this.cliniciansCount = _data["cliniciansCount"];
            this.clinicName = _data["clinicName"];
            this.clinicDescription = _data["clinicDescription"];
            this.clinicTypeId = _data["clinicTypeId"];
            this.contactName = _data["contactName"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.organisationId = _data["organisationId"];
            this.locationId = _data["locationId"];
            this.location = _data["location"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.isActive = _data["isActive"];
            this.organizationName = _data["organizationName"];
        }
    }

    static fromJS(data: any): ClinicSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicId"] = this.clinicId;
        data["cliniciansCount"] = this.cliniciansCount;
        data["clinicName"] = this.clinicName;
        data["clinicDescription"] = this.clinicDescription;
        data["clinicTypeId"] = this.clinicTypeId;
        data["contactName"] = this.contactName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["organisationId"] = this.organisationId;
        data["locationId"] = this.locationId;
        data["location"] = this.location;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["isActive"] = this.isActive;
        data["organizationName"] = this.organizationName;
        return data;
    }
}

export interface IClinicSaveRequest {
    clinicId?: number | undefined;
    cliniciansCount?: number | undefined;
    clinicName?: string | undefined;
    clinicDescription?: string | undefined;
    clinicTypeId?: number;
    contactName?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    organisationId?: number;
    locationId?: number;
    location?: string | undefined;
    countryId?: number;
    country?: string | undefined;
    isActive?: boolean;
    organizationName?: string | undefined;
}

export class ConsoleOrganisationResponse implements IConsoleOrganisationResponse {
    consoleOrganisationDbResponses?: ConsoleOrganisationDbResponse[] | undefined;

    constructor(data?: IConsoleOrganisationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["consoleOrganisationDbResponses"])) {
                this.consoleOrganisationDbResponses = [] as any;
                for (let item of _data["consoleOrganisationDbResponses"])
                    this.consoleOrganisationDbResponses!.push(ConsoleOrganisationDbResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsoleOrganisationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConsoleOrganisationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.consoleOrganisationDbResponses)) {
            data["consoleOrganisationDbResponses"] = [];
            for (let item of this.consoleOrganisationDbResponses)
                data["consoleOrganisationDbResponses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConsoleOrganisationResponse {
    consoleOrganisationDbResponses?: ConsoleOrganisationDbResponse[] | undefined;
}

export class ConsoleOrganisationDbResponse implements IConsoleOrganisationDbResponse {
    isActive?: boolean;
    organisationId?: number;
    name?: string | undefined;
    description?: string | undefined;
    contactName?: string | undefined;
    emailAddress?: string | undefined;
    phone?: string | undefined;
    country?: string | undefined;
    countryId?: number;
    location?: string | undefined;
    locationId?: number;
    clinicsCount?: number;
    joiningDate?: string | undefined;

    constructor(data?: IConsoleOrganisationDbResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.organisationId = _data["organisationId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.contactName = _data["contactName"];
            this.emailAddress = _data["emailAddress"];
            this.phone = _data["phone"];
            this.country = _data["country"];
            this.countryId = _data["countryId"];
            this.location = _data["location"];
            this.locationId = _data["locationId"];
            this.clinicsCount = _data["clinicsCount"];
            this.joiningDate = _data["joiningDate"];
        }
    }

    static fromJS(data: any): ConsoleOrganisationDbResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConsoleOrganisationDbResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["organisationId"] = this.organisationId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["contactName"] = this.contactName;
        data["emailAddress"] = this.emailAddress;
        data["phone"] = this.phone;
        data["country"] = this.country;
        data["countryId"] = this.countryId;
        data["location"] = this.location;
        data["locationId"] = this.locationId;
        data["clinicsCount"] = this.clinicsCount;
        data["joiningDate"] = this.joiningDate;
        return data;
    }
}

export interface IConsoleOrganisationDbResponse {
    isActive?: boolean;
    organisationId?: number;
    name?: string | undefined;
    description?: string | undefined;
    contactName?: string | undefined;
    emailAddress?: string | undefined;
    phone?: string | undefined;
    country?: string | undefined;
    countryId?: number;
    location?: string | undefined;
    locationId?: number;
    clinicsCount?: number;
    joiningDate?: string | undefined;
}

export class LicenceSaveResponse implements ILicenceSaveResponse {
    responseMessage?: string | undefined;
    licences?: LicenceSelectDbResponse[] | undefined;

    constructor(data?: ILicenceSaveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseMessage = _data["responseMessage"];
            if (Array.isArray(_data["licences"])) {
                this.licences = [] as any;
                for (let item of _data["licences"])
                    this.licences!.push(LicenceSelectDbResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicenceSaveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceSaveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseMessage"] = this.responseMessage;
        if (Array.isArray(this.licences)) {
            data["licences"] = [];
            for (let item of this.licences)
                data["licences"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILicenceSaveResponse {
    responseMessage?: string | undefined;
    licences?: LicenceSelectDbResponse[] | undefined;
}

export class LicenceSelectDbResponse implements ILicenceSelectDbResponse {
    masterLicenceId?: number;
    licenceName?: string | undefined;
    singleLicenceId?: number;
    licenceStreamId?: number;
    licenceNumber?: number;
    licenceCode?: string | undefined;
    codeCreationDate?: string | undefined;
    licenceIsActive?: boolean;
    licenceIsAssigned?: boolean;
    licenceExpiryDate?: string | undefined;
    deActivationDate?: string | undefined;
    userName?: string | undefined;
    emailAddress?: string | undefined;
    userIsActive?: string | undefined;
    firstLogonDate?: string | undefined;
    lastLogonDate?: string | undefined;
    isActive?: boolean;

    constructor(data?: ILicenceSelectDbResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.masterLicenceId = _data["masterLicenceId"];
            this.licenceName = _data["licenceName"];
            this.singleLicenceId = _data["singleLicenceId"];
            this.licenceStreamId = _data["licenceStreamId"];
            this.licenceNumber = _data["licenceNumber"];
            this.licenceCode = _data["licenceCode"];
            this.codeCreationDate = _data["codeCreationDate"];
            this.licenceIsActive = _data["licenceIsActive"];
            this.licenceIsAssigned = _data["licenceIsAssigned"];
            this.licenceExpiryDate = _data["licenceExpiryDate"];
            this.deActivationDate = _data["deActivationDate"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.userIsActive = _data["userIsActive"];
            this.firstLogonDate = _data["firstLogonDate"];
            this.lastLogonDate = _data["lastLogonDate"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LicenceSelectDbResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceSelectDbResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterLicenceId"] = this.masterLicenceId;
        data["licenceName"] = this.licenceName;
        data["singleLicenceId"] = this.singleLicenceId;
        data["licenceStreamId"] = this.licenceStreamId;
        data["licenceNumber"] = this.licenceNumber;
        data["licenceCode"] = this.licenceCode;
        data["codeCreationDate"] = this.codeCreationDate;
        data["licenceIsActive"] = this.licenceIsActive;
        data["licenceIsAssigned"] = this.licenceIsAssigned;
        data["licenceExpiryDate"] = this.licenceExpiryDate;
        data["deActivationDate"] = this.deActivationDate;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["userIsActive"] = this.userIsActive;
        data["firstLogonDate"] = this.firstLogonDate;
        data["lastLogonDate"] = this.lastLogonDate;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILicenceSelectDbResponse {
    masterLicenceId?: number;
    licenceName?: string | undefined;
    singleLicenceId?: number;
    licenceStreamId?: number;
    licenceNumber?: number;
    licenceCode?: string | undefined;
    codeCreationDate?: string | undefined;
    licenceIsActive?: boolean;
    licenceIsAssigned?: boolean;
    licenceExpiryDate?: string | undefined;
    deActivationDate?: string | undefined;
    userName?: string | undefined;
    emailAddress?: string | undefined;
    userIsActive?: string | undefined;
    firstLogonDate?: string | undefined;
    lastLogonDate?: string | undefined;
    isActive?: boolean;
}

export class LicenceSaveRequest implements ILicenceSaveRequest {
    masterLicenceId?: number;
    masterLicenceName?: string | undefined;
    licenceTypeId?: number;
    licenceStreamId?: number;
    maximumUsers?: number;
    expiryDate?: Date | undefined;
    clinicianId?: number;
    clinicianName?: string | undefined;
    clinicianDescription?: string | undefined;
    professionId?: number;
    email?: string | undefined;
    phone?: string | undefined;
    locationId?: number;
    clinicId?: number;
    clinicName?: string | undefined;
    clinicianUserId?: number;
    clinicianIsActive?: boolean;

    constructor(data?: ILicenceSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.masterLicenceId = _data["masterLicenceId"];
            this.masterLicenceName = _data["masterLicenceName"];
            this.licenceTypeId = _data["licenceTypeId"];
            this.licenceStreamId = _data["licenceStreamId"];
            this.maximumUsers = _data["maximumUsers"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.clinicianId = _data["clinicianId"];
            this.clinicianName = _data["clinicianName"];
            this.clinicianDescription = _data["clinicianDescription"];
            this.professionId = _data["professionId"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.locationId = _data["locationId"];
            this.clinicId = _data["clinicId"];
            this.clinicName = _data["clinicName"];
            this.clinicianUserId = _data["clinicianUserId"];
            this.clinicianIsActive = _data["clinicianIsActive"];
        }
    }

    static fromJS(data: any): LicenceSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterLicenceId"] = this.masterLicenceId;
        data["masterLicenceName"] = this.masterLicenceName;
        data["licenceTypeId"] = this.licenceTypeId;
        data["licenceStreamId"] = this.licenceStreamId;
        data["maximumUsers"] = this.maximumUsers;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["clinicianId"] = this.clinicianId;
        data["clinicianName"] = this.clinicianName;
        data["clinicianDescription"] = this.clinicianDescription;
        data["professionId"] = this.professionId;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["locationId"] = this.locationId;
        data["clinicId"] = this.clinicId;
        data["clinicName"] = this.clinicName;
        data["clinicianUserId"] = this.clinicianUserId;
        data["clinicianIsActive"] = this.clinicianIsActive;
        return data;
    }
}

export interface ILicenceSaveRequest {
    masterLicenceId?: number;
    masterLicenceName?: string | undefined;
    licenceTypeId?: number;
    licenceStreamId?: number;
    maximumUsers?: number;
    expiryDate?: Date | undefined;
    clinicianId?: number;
    clinicianName?: string | undefined;
    clinicianDescription?: string | undefined;
    professionId?: number;
    email?: string | undefined;
    phone?: string | undefined;
    locationId?: number;
    clinicId?: number;
    clinicName?: string | undefined;
    clinicianUserId?: number;
    clinicianIsActive?: boolean;
}

export class LicenceUpdateRequest implements ILicenceUpdateRequest {
    userGuid?: string | undefined;
    licenceUpdateTypes?: LicenceUpdateType[] | undefined;

    constructor(data?: ILicenceUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGuid = _data["userGuid"];
            if (Array.isArray(_data["licenceUpdateTypes"])) {
                this.licenceUpdateTypes = [] as any;
                for (let item of _data["licenceUpdateTypes"])
                    this.licenceUpdateTypes!.push(LicenceUpdateType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicenceUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGuid"] = this.userGuid;
        if (Array.isArray(this.licenceUpdateTypes)) {
            data["licenceUpdateTypes"] = [];
            for (let item of this.licenceUpdateTypes)
                data["licenceUpdateTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILicenceUpdateRequest {
    userGuid?: string | undefined;
    licenceUpdateTypes?: LicenceUpdateType[] | undefined;
}

export class LicenceUpdateType implements ILicenceUpdateType {
    masterLicenceId?: number;
    licenceNumber?: number;
    singleLicenceId?: number;
    licenceStreamId?: number;
    isActive?: boolean;
    expiryDate?: string | undefined;

    constructor(data?: ILicenceUpdateType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.masterLicenceId = _data["masterLicenceId"];
            this.licenceNumber = _data["licenceNumber"];
            this.singleLicenceId = _data["singleLicenceId"];
            this.licenceStreamId = _data["licenceStreamId"];
            this.isActive = _data["isActive"];
            this.expiryDate = _data["expiryDate"];
        }
    }

    static fromJS(data: any): LicenceUpdateType {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceUpdateType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterLicenceId"] = this.masterLicenceId;
        data["licenceNumber"] = this.licenceNumber;
        data["singleLicenceId"] = this.singleLicenceId;
        data["licenceStreamId"] = this.licenceStreamId;
        data["isActive"] = this.isActive;
        data["expiryDate"] = this.expiryDate;
        return data;
    }
}

export interface ILicenceUpdateType {
    masterLicenceId?: number;
    licenceNumber?: number;
    singleLicenceId?: number;
    licenceStreamId?: number;
    isActive?: boolean;
    expiryDate?: string | undefined;
}

export class LicenceAssignResponse implements ILicenceAssignResponse {
    responseMessage?: string | undefined;
    licenceList?: LicenceList[] | undefined;

    constructor(data?: ILicenceAssignResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseMessage = _data["responseMessage"];
            if (Array.isArray(_data["licenceList"])) {
                this.licenceList = [] as any;
                for (let item of _data["licenceList"])
                    this.licenceList!.push(LicenceList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicenceAssignResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceAssignResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseMessage"] = this.responseMessage;
        if (Array.isArray(this.licenceList)) {
            data["licenceList"] = [];
            for (let item of this.licenceList)
                data["licenceList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILicenceAssignResponse {
    responseMessage?: string | undefined;
    licenceList?: LicenceList[] | undefined;
}

export class LicenceList implements ILicenceList {
    singleLicenceId?: number;
    licenceCode?: string | undefined;

    constructor(data?: ILicenceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.singleLicenceId = _data["singleLicenceId"];
            this.licenceCode = _data["licenceCode"];
        }
    }

    static fromJS(data: any): LicenceList {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["singleLicenceId"] = this.singleLicenceId;
        data["licenceCode"] = this.licenceCode;
        return data;
    }
}

export interface ILicenceList {
    singleLicenceId?: number;
    licenceCode?: string | undefined;
}

export class LicenceAssignRequest implements ILicenceAssignRequest {
    email?: string | undefined;
    userGuid?: string | undefined;
    licenceCode?: string | undefined;
    clinicName?: string | undefined;
    clinicianName?: string | undefined;
    licenceAssignTypes?: LicenceAssignType[] | undefined;

    constructor(data?: ILicenceAssignRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.userGuid = _data["userGuid"];
            this.licenceCode = _data["licenceCode"];
            this.clinicName = _data["clinicName"];
            this.clinicianName = _data["clinicianName"];
            if (Array.isArray(_data["licenceAssignTypes"])) {
                this.licenceAssignTypes = [] as any;
                for (let item of _data["licenceAssignTypes"])
                    this.licenceAssignTypes!.push(LicenceAssignType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicenceAssignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceAssignRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["userGuid"] = this.userGuid;
        data["licenceCode"] = this.licenceCode;
        data["clinicName"] = this.clinicName;
        data["clinicianName"] = this.clinicianName;
        if (Array.isArray(this.licenceAssignTypes)) {
            data["licenceAssignTypes"] = [];
            for (let item of this.licenceAssignTypes)
                data["licenceAssignTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILicenceAssignRequest {
    email?: string | undefined;
    userGuid?: string | undefined;
    licenceCode?: string | undefined;
    clinicName?: string | undefined;
    clinicianName?: string | undefined;
    licenceAssignTypes?: LicenceAssignType[] | undefined;
}

export class LicenceAssignType implements ILicenceAssignType {
    masterLicenceId?: number | undefined;
    licenceNumber?: number | undefined;
    singleLicenceId?: number;
    licenceStreamId?: number;
    isAssigned?: boolean;
    expiryDate?: string | undefined;
    isActive?: boolean;

    constructor(data?: ILicenceAssignType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.masterLicenceId = _data["masterLicenceId"];
            this.licenceNumber = _data["licenceNumber"];
            this.singleLicenceId = _data["singleLicenceId"];
            this.licenceStreamId = _data["licenceStreamId"];
            this.isAssigned = _data["isAssigned"];
            this.expiryDate = _data["expiryDate"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LicenceAssignType {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceAssignType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterLicenceId"] = this.masterLicenceId;
        data["licenceNumber"] = this.licenceNumber;
        data["singleLicenceId"] = this.singleLicenceId;
        data["licenceStreamId"] = this.licenceStreamId;
        data["isAssigned"] = this.isAssigned;
        data["expiryDate"] = this.expiryDate;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILicenceAssignType {
    masterLicenceId?: number | undefined;
    licenceNumber?: number | undefined;
    singleLicenceId?: number;
    licenceStreamId?: number;
    isAssigned?: boolean;
    expiryDate?: string | undefined;
    isActive?: boolean;
}

export class OrganisationSaveRequest implements IOrganisationSaveRequest {
    organisationId?: number | undefined;
    clinicsCount?: number | undefined;
    organisationName?: string | undefined;
    organisationDescription?: string | undefined;
    contactName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    countryId?: number;
    country?: string | undefined;
    locationId?: number;
    location?: string | undefined;
    isActive?: boolean;
    userGuid?: string;

    constructor(data?: IOrganisationSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            this.clinicsCount = _data["clinicsCount"];
            this.organisationName = _data["organisationName"];
            this.organisationDescription = _data["organisationDescription"];
            this.contactName = _data["contactName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.locationId = _data["locationId"];
            this.location = _data["location"];
            this.isActive = _data["isActive"];
            this.userGuid = _data["userGuid"];
        }
    }

    static fromJS(data: any): OrganisationSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        data["clinicsCount"] = this.clinicsCount;
        data["organisationName"] = this.organisationName;
        data["organisationDescription"] = this.organisationDescription;
        data["contactName"] = this.contactName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["locationId"] = this.locationId;
        data["location"] = this.location;
        data["isActive"] = this.isActive;
        data["userGuid"] = this.userGuid;
        return data;
    }
}

export interface IOrganisationSaveRequest {
    organisationId?: number | undefined;
    clinicsCount?: number | undefined;
    organisationName?: string | undefined;
    organisationDescription?: string | undefined;
    contactName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    countryId?: number;
    country?: string | undefined;
    locationId?: number;
    location?: string | undefined;
    isActive?: boolean;
    userGuid?: string;
}

export class LicenceSelectResponse implements ILicenceSelectResponse {
    licenceSelectDbResponse?: LicenceSelectDbResponse[] | undefined;

    constructor(data?: ILicenceSelectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["licenceSelectDbResponse"])) {
                this.licenceSelectDbResponse = [] as any;
                for (let item of _data["licenceSelectDbResponse"])
                    this.licenceSelectDbResponse!.push(LicenceSelectDbResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicenceSelectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceSelectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.licenceSelectDbResponse)) {
            data["licenceSelectDbResponse"] = [];
            for (let item of this.licenceSelectDbResponse)
                data["licenceSelectDbResponse"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILicenceSelectResponse {
    licenceSelectDbResponse?: LicenceSelectDbResponse[] | undefined;
}

export class ProfessionSelectResponse implements IProfessionSelectResponse {
    professionId?: number;
    professionName?: string | undefined;
    professionTypeId?: number;
    professionTypeName?: string | undefined;

    constructor(data?: IProfessionSelectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.professionName = _data["professionName"];
            this.professionTypeId = _data["professionTypeId"];
            this.professionTypeName = _data["professionTypeName"];
        }
    }

    static fromJS(data: any): ProfessionSelectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionSelectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["professionName"] = this.professionName;
        data["professionTypeId"] = this.professionTypeId;
        data["professionTypeName"] = this.professionTypeName;
        return data;
    }
}

export interface IProfessionSelectResponse {
    professionId?: number;
    professionName?: string | undefined;
    professionTypeId?: number;
    professionTypeName?: string | undefined;
}

export class Country implements ICountry {
    countryId?: number;
    countryName?: string | undefined;
    locationCount?: number;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.locationCount = _data["locationCount"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["locationCount"] = this.locationCount;
        return data;
    }
}

export interface ICountry {
    countryId?: number;
    countryName?: string | undefined;
    locationCount?: number;
}

export class Locations implements ILocations {
    locationId?: number;
    locationName?: string | undefined;

    constructor(data?: ILocations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): Locations {
        data = typeof data === 'object' ? data : {};
        let result = new Locations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface ILocations {
    locationId?: number;
    locationName?: string | undefined;
}

export class ClinicTypeSelectResponse implements IClinicTypeSelectResponse {
    clinicTypeSelectDbResponse?: ClinicTypeSelectDbResponse[] | undefined;

    constructor(data?: IClinicTypeSelectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clinicTypeSelectDbResponse"])) {
                this.clinicTypeSelectDbResponse = [] as any;
                for (let item of _data["clinicTypeSelectDbResponse"])
                    this.clinicTypeSelectDbResponse!.push(ClinicTypeSelectDbResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClinicTypeSelectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicTypeSelectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clinicTypeSelectDbResponse)) {
            data["clinicTypeSelectDbResponse"] = [];
            for (let item of this.clinicTypeSelectDbResponse)
                data["clinicTypeSelectDbResponse"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClinicTypeSelectResponse {
    clinicTypeSelectDbResponse?: ClinicTypeSelectDbResponse[] | undefined;
}

export class ClinicTypeSelectDbResponse implements IClinicTypeSelectDbResponse {
    clinicTypeId?: number;
    name?: string | undefined;

    constructor(data?: IClinicTypeSelectDbResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicTypeId = _data["clinicTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ClinicTypeSelectDbResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicTypeSelectDbResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicTypeId"] = this.clinicTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface IClinicTypeSelectDbResponse {
    clinicTypeId?: number;
    name?: string | undefined;
}

export class AppFeatureSuggestionRequest implements IAppFeatureSuggestionRequest {
    topic?: string | undefined;
    thoughts?: string | undefined;

    constructor(data?: IAppFeatureSuggestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topic = _data["topic"];
            this.thoughts = _data["thoughts"];
        }
    }

    static fromJS(data: any): AppFeatureSuggestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AppFeatureSuggestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topic"] = this.topic;
        data["thoughts"] = this.thoughts;
        return data;
    }
}

export interface IAppFeatureSuggestionRequest {
    topic?: string | undefined;
    thoughts?: string | undefined;
}

export class BugReportRequest implements IBugReportRequest {
    problemType?: string | undefined;
    device?: string | undefined;
    detail?: string | undefined;

    constructor(data?: IBugReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.problemType = _data["problemType"];
            this.device = _data["device"];
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): BugReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BugReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["problemType"] = this.problemType;
        data["device"] = this.device;
        data["detail"] = this.detail;
        return data;
    }
}

export interface IBugReportRequest {
    problemType?: string | undefined;
    device?: string | undefined;
    detail?: string | undefined;
}

export class BaseTransportOfListOfCourseEditDtoAndBaseError implements IBaseTransportOfListOfCourseEditDtoAndBaseError {
    result?: CourseEditDto[] | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfListOfCourseEditDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(CourseEditDto.fromJS(item));
            }
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfListOfCourseEditDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfListOfCourseEditDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfListOfCourseEditDtoAndBaseError {
    result?: CourseEditDto[] | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfListOfCourseEditDto extends BaseTransportOfListOfCourseEditDtoAndBaseError implements IResponseTransportOfListOfCourseEditDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfListOfCourseEditDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfListOfCourseEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfListOfCourseEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfListOfCourseEditDto extends IBaseTransportOfListOfCourseEditDtoAndBaseError {
    status?: ResponseStatus;
}

export class CourseEditDto implements ICourseEditDto {
    id?: number | undefined;
    guid?: string | undefined;
    title!: string;
    description?: string | undefined;
    isPublished?: boolean;
    isActive?: boolean;
    updateTime?: Date | undefined;
    chapters?: ChapterEditDto[] | undefined;

    constructor(data?: ICourseEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.isPublished = _data["isPublished"];
            this.isActive = _data["isActive"];
            this.updateTime = _data["updateTime"] ? new Date(_data["updateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["chapters"])) {
                this.chapters = [] as any;
                for (let item of _data["chapters"])
                    this.chapters!.push(ChapterEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["description"] = this.description;
        data["isPublished"] = this.isPublished;
        data["isActive"] = this.isActive;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.chapters)) {
            data["chapters"] = [];
            for (let item of this.chapters)
                data["chapters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICourseEditDto {
    id?: number | undefined;
    guid?: string | undefined;
    title: string;
    description?: string | undefined;
    isPublished?: boolean;
    isActive?: boolean;
    updateTime?: Date | undefined;
    chapters?: ChapterEditDto[] | undefined;
}

export class ChapterEditDto implements IChapterEditDto {
    id?: number | undefined;
    guid?: string | undefined;
    title!: string;
    description?: string | undefined;
    longDescription?: string | undefined;
    isActive?: boolean;
    updateTime?: Date | undefined;
    position?: number;
    lessons?: LessonEditDto[] | undefined;

    constructor(data?: IChapterEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.longDescription = _data["longDescription"];
            this.isActive = _data["isActive"];
            this.updateTime = _data["updateTime"] ? new Date(_data["updateTime"].toString()) : <any>undefined;
            this.position = _data["position"];
            if (Array.isArray(_data["lessons"])) {
                this.lessons = [] as any;
                for (let item of _data["lessons"])
                    this.lessons!.push(LessonEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChapterEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChapterEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["description"] = this.description;
        data["longDescription"] = this.longDescription;
        data["isActive"] = this.isActive;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["position"] = this.position;
        if (Array.isArray(this.lessons)) {
            data["lessons"] = [];
            for (let item of this.lessons)
                data["lessons"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChapterEditDto {
    id?: number | undefined;
    guid?: string | undefined;
    title: string;
    description?: string | undefined;
    longDescription?: string | undefined;
    isActive?: boolean;
    updateTime?: Date | undefined;
    position?: number;
    lessons?: LessonEditDto[] | undefined;
}

export class LessonEditDto implements ILessonEditDto {
    id?: number | undefined;
    guid?: string | undefined;
    title!: string;
    text?: string | undefined;
    readMinutes?: number | undefined;
    isActive?: boolean;
    position?: number;
    updateTime?: Date | undefined;
    lessonType?: LessonType;
    attachments?: AttachmentDto[] | undefined;
    slides?: LessonSlideEditDto[] | undefined;

    constructor(data?: ILessonEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.text = _data["text"];
            this.readMinutes = _data["readMinutes"];
            this.isActive = _data["isActive"];
            this.position = _data["position"];
            this.updateTime = _data["updateTime"] ? new Date(_data["updateTime"].toString()) : <any>undefined;
            this.lessonType = _data["lessonType"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            if (Array.isArray(_data["slides"])) {
                this.slides = [] as any;
                for (let item of _data["slides"])
                    this.slides!.push(LessonSlideEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LessonEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LessonEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["text"] = this.text;
        data["readMinutes"] = this.readMinutes;
        data["isActive"] = this.isActive;
        data["position"] = this.position;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["lessonType"] = this.lessonType;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.slides)) {
            data["slides"] = [];
            for (let item of this.slides)
                data["slides"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILessonEditDto {
    id?: number | undefined;
    guid?: string | undefined;
    title: string;
    text?: string | undefined;
    readMinutes?: number | undefined;
    isActive?: boolean;
    position?: number;
    updateTime?: Date | undefined;
    lessonType?: LessonType;
    attachments?: AttachmentDto[] | undefined;
    slides?: LessonSlideEditDto[] | undefined;
}

export enum LessonType {
    Text = 0,
    Video = 1,
    Download = 2,
    Pdf = 3,
    Audio = 4,
    Presentation = 5,
}

export class LessonSlideEditDto implements ILessonSlideEditDto {
    id?: number | undefined;
    guid?: string | undefined;
    isActive?: boolean;
    updateTime?: Date | undefined;
    position?: number;
    heading?: string | undefined;
    contentType?: SlideContentType;
    bodyHtml?: string | undefined;
    attachments?: AttachmentDto[] | undefined;

    constructor(data?: ILessonSlideEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.guid = _data["guid"];
            this.isActive = _data["isActive"];
            this.updateTime = _data["updateTime"] ? new Date(_data["updateTime"].toString()) : <any>undefined;
            this.position = _data["position"];
            this.heading = _data["heading"];
            this.contentType = _data["contentType"];
            this.bodyHtml = _data["bodyHtml"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LessonSlideEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LessonSlideEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["guid"] = this.guid;
        data["isActive"] = this.isActive;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["position"] = this.position;
        data["heading"] = this.heading;
        data["contentType"] = this.contentType;
        data["bodyHtml"] = this.bodyHtml;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILessonSlideEditDto {
    id?: number | undefined;
    guid?: string | undefined;
    isActive?: boolean;
    updateTime?: Date | undefined;
    position?: number;
    heading?: string | undefined;
    contentType?: SlideContentType;
    bodyHtml?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
}

export enum SlideContentType {
    Standard = 0,
    List = 1,
    Takeaway = 2,
    SourceList = 3,
}

export class BaseTransportOfCourseEditDtoAndBaseError implements IBaseTransportOfCourseEditDtoAndBaseError {
    result?: CourseEditDto | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfCourseEditDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? CourseEditDto.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfCourseEditDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfCourseEditDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfCourseEditDtoAndBaseError {
    result?: CourseEditDto | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfCourseEditDto extends BaseTransportOfCourseEditDtoAndBaseError implements IResponseTransportOfCourseEditDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfCourseEditDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfCourseEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfCourseEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfCourseEditDto extends IBaseTransportOfCourseEditDtoAndBaseError {
    status?: ResponseStatus;
}

export class ResponseModelOfFavouriteHandOperationResponse implements IResponseModelOfFavouriteHandOperationResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: FavouriteHandOperationResponse | undefined;

    constructor(data?: IResponseModelOfFavouriteHandOperationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? FavouriteHandOperationResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfFavouriteHandOperationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfFavouriteHandOperationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfFavouriteHandOperationResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: FavouriteHandOperationResponse | undefined;
}

export class FavouriteHandOperationResponse implements IFavouriteHandOperationResponse {
    outcome?: string | undefined;
    favouriteHand?: FavouriteHandResponse | undefined;
    favouriteHands?: FavouriteHandResponse[] | undefined;

    constructor(data?: IFavouriteHandOperationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outcome = _data["outcome"];
            this.favouriteHand = _data["favouriteHand"] ? FavouriteHandResponse.fromJS(_data["favouriteHand"]) : <any>undefined;
            if (Array.isArray(_data["favouriteHands"])) {
                this.favouriteHands = [] as any;
                for (let item of _data["favouriteHands"])
                    this.favouriteHands!.push(FavouriteHandResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FavouriteHandOperationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FavouriteHandOperationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outcome"] = this.outcome;
        data["favouriteHand"] = this.favouriteHand ? this.favouriteHand.toJSON() : <any>undefined;
        if (Array.isArray(this.favouriteHands)) {
            data["favouriteHands"] = [];
            for (let item of this.favouriteHands)
                data["favouriteHands"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFavouriteHandOperationResponse {
    outcome?: string | undefined;
    favouriteHand?: FavouriteHandResponse | undefined;
    favouriteHands?: FavouriteHandResponse[] | undefined;
}

export class FavouriteHandResponse implements IFavouriteHandResponse {
    favouriteHandId?: number;
    name?: string | undefined;
    description?: string | undefined;
    totalMinutes?: number;
    useCount?: number;
    lastUsedDate?: Date | undefined;
    createdDate?: Date;
    modifiedDate?: Date;
    cards?: FavouriteHandCardResponse[] | undefined;

    constructor(data?: IFavouriteHandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.favouriteHandId = _data["favouriteHandId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.totalMinutes = _data["totalMinutes"];
            this.useCount = _data["useCount"];
            this.lastUsedDate = _data["lastUsedDate"] ? new Date(_data["lastUsedDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(FavouriteHandCardResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FavouriteHandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FavouriteHandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["favouriteHandId"] = this.favouriteHandId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["totalMinutes"] = this.totalMinutes;
        data["useCount"] = this.useCount;
        data["lastUsedDate"] = this.lastUsedDate ? this.lastUsedDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFavouriteHandResponse {
    favouriteHandId?: number;
    name?: string | undefined;
    description?: string | undefined;
    totalMinutes?: number;
    useCount?: number;
    lastUsedDate?: Date | undefined;
    createdDate?: Date;
    modifiedDate?: Date;
    cards?: FavouriteHandCardResponse[] | undefined;
}

export class FavouriteHandCardResponse implements IFavouriteHandCardResponse {
    favouriteHandCardId?: number;
    cardId?: number;
    dailyPeriodId?: number;
    sortOrder?: number;
    periodMinutes?: number;
    cardName?: string | undefined;
    cardDescription?: string | undefined;

    constructor(data?: IFavouriteHandCardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.favouriteHandCardId = _data["favouriteHandCardId"];
            this.cardId = _data["cardId"];
            this.dailyPeriodId = _data["dailyPeriodId"];
            this.sortOrder = _data["sortOrder"];
            this.periodMinutes = _data["periodMinutes"];
            this.cardName = _data["cardName"];
            this.cardDescription = _data["cardDescription"];
        }
    }

    static fromJS(data: any): FavouriteHandCardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FavouriteHandCardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["favouriteHandCardId"] = this.favouriteHandCardId;
        data["cardId"] = this.cardId;
        data["dailyPeriodId"] = this.dailyPeriodId;
        data["sortOrder"] = this.sortOrder;
        data["periodMinutes"] = this.periodMinutes;
        data["cardName"] = this.cardName;
        data["cardDescription"] = this.cardDescription;
        return data;
    }
}

export interface IFavouriteHandCardResponse {
    favouriteHandCardId?: number;
    cardId?: number;
    dailyPeriodId?: number;
    sortOrder?: number;
    periodMinutes?: number;
    cardName?: string | undefined;
    cardDescription?: string | undefined;
}

export class CreateFavouriteHandRequest implements ICreateFavouriteHandRequest {
    handId?: number;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICreateFavouriteHandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.handId = _data["handId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateFavouriteHandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFavouriteHandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["handId"] = this.handId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateFavouriteHandRequest {
    handId?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export class RenameFavouriteHandRequest implements IRenameFavouriteHandRequest {
    favouriteHandId?: number;
    name?: string | undefined;

    constructor(data?: IRenameFavouriteHandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.favouriteHandId = _data["favouriteHandId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenameFavouriteHandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenameFavouriteHandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["favouriteHandId"] = this.favouriteHandId;
        data["name"] = this.name;
        return data;
    }
}

export interface IRenameFavouriteHandRequest {
    favouriteHandId?: number;
    name?: string | undefined;
}

export class DeleteFavouriteHandRequest implements IDeleteFavouriteHandRequest {
    favouriteHandId?: number;

    constructor(data?: IDeleteFavouriteHandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.favouriteHandId = _data["favouriteHandId"];
        }
    }

    static fromJS(data: any): DeleteFavouriteHandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFavouriteHandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["favouriteHandId"] = this.favouriteHandId;
        return data;
    }
}

export interface IDeleteFavouriteHandRequest {
    favouriteHandId?: number;
}

export class ResponseModelOfDictionaryOfStringAndBoolean implements IResponseModelOfDictionaryOfStringAndBoolean {
    resultStatus?: ResultStatus | undefined;
    responseData?: { [key: string]: boolean; } | undefined;

    constructor(data?: IResponseModelOfDictionaryOfStringAndBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            if (_data["responseData"]) {
                this.responseData = {} as any;
                for (let key in _data["responseData"]) {
                    if (_data["responseData"].hasOwnProperty(key))
                        (<any>this.responseData)![key] = _data["responseData"][key];
                }
            }
        }
    }

    static fromJS(data: any): ResponseModelOfDictionaryOfStringAndBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfDictionaryOfStringAndBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        if (this.responseData) {
            data["responseData"] = {};
            for (let key in this.responseData) {
                if (this.responseData.hasOwnProperty(key))
                    (<any>data["responseData"])[key] = (<any>this.responseData)[key];
            }
        }
        return data;
    }
}

export interface IResponseModelOfDictionaryOfStringAndBoolean {
    resultStatus?: ResultStatus | undefined;
    responseData?: { [key: string]: boolean; } | undefined;
}

export class ResponseModelOfListOfFeatureFlagAdminDto implements IResponseModelOfListOfFeatureFlagAdminDto {
    resultStatus?: ResultStatus | undefined;
    responseData?: FeatureFlagAdminDto[] | undefined;

    constructor(data?: IResponseModelOfListOfFeatureFlagAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(FeatureFlagAdminDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseModelOfListOfFeatureFlagAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfListOfFeatureFlagAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseModelOfListOfFeatureFlagAdminDto {
    resultStatus?: ResultStatus | undefined;
    responseData?: FeatureFlagAdminDto[] | undefined;
}

export class FeatureFlagAdminDto implements IFeatureFlagAdminDto {
    key?: string | undefined;
    defaultEnabled?: boolean;
    description?: string | undefined;
    overrideUserGuids?: string[] | undefined;

    constructor(data?: IFeatureFlagAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.defaultEnabled = _data["defaultEnabled"];
            this.description = _data["description"];
            if (Array.isArray(_data["overrideUserGuids"])) {
                this.overrideUserGuids = [] as any;
                for (let item of _data["overrideUserGuids"])
                    this.overrideUserGuids!.push(item);
            }
        }
    }

    static fromJS(data: any): FeatureFlagAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureFlagAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["defaultEnabled"] = this.defaultEnabled;
        data["description"] = this.description;
        if (Array.isArray(this.overrideUserGuids)) {
            data["overrideUserGuids"] = [];
            for (let item of this.overrideUserGuids)
                data["overrideUserGuids"].push(item);
        }
        return data;
    }
}

export interface IFeatureFlagAdminDto {
    key?: string | undefined;
    defaultEnabled?: boolean;
    description?: string | undefined;
    overrideUserGuids?: string[] | undefined;
}

export class UpsertFeatureFlagRequest implements IUpsertFeatureFlagRequest {
    key!: string;
    defaultEnabled!: boolean;
    description?: string | undefined;

    constructor(data?: IUpsertFeatureFlagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.defaultEnabled = _data["defaultEnabled"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpsertFeatureFlagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertFeatureFlagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["defaultEnabled"] = this.defaultEnabled;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpsertFeatureFlagRequest {
    key: string;
    defaultEnabled: boolean;
    description?: string | undefined;
}

export class FeatureFlagOverrideRequest implements IFeatureFlagOverrideRequest {
    flagKey!: string;
    userGuid!: string;

    constructor(data?: IFeatureFlagOverrideRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flagKey = _data["flagKey"];
            this.userGuid = _data["userGuid"];
        }
    }

    static fromJS(data: any): FeatureFlagOverrideRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureFlagOverrideRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flagKey"] = this.flagKey;
        data["userGuid"] = this.userGuid;
        return data;
    }
}

export interface IFeatureFlagOverrideRequest {
    flagKey: string;
    userGuid: string;
}

export class BaseTransportOfFlareUpPlanDtoAndBaseError implements IBaseTransportOfFlareUpPlanDtoAndBaseError {
    result?: FlareUpPlanDto | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfFlareUpPlanDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? FlareUpPlanDto.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfFlareUpPlanDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfFlareUpPlanDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfFlareUpPlanDtoAndBaseError {
    result?: FlareUpPlanDto | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfFlareUpPlanDto extends BaseTransportOfFlareUpPlanDtoAndBaseError implements IResponseTransportOfFlareUpPlanDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfFlareUpPlanDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfFlareUpPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfFlareUpPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfFlareUpPlanDto extends IBaseTransportOfFlareUpPlanDtoAndBaseError {
    status?: ResponseStatus;
}

export class FlareUpPlanDto implements IFlareUpPlanDto {
    id?: number;
    updateTime?: Date | undefined;
    flareUpPlanItems?: FlareUpPlanItemDto[] | undefined;

    constructor(data?: IFlareUpPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.updateTime = _data["updateTime"] ? new Date(_data["updateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["flareUpPlanItems"])) {
                this.flareUpPlanItems = [] as any;
                for (let item of _data["flareUpPlanItems"])
                    this.flareUpPlanItems!.push(FlareUpPlanItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlareUpPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlareUpPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.flareUpPlanItems)) {
            data["flareUpPlanItems"] = [];
            for (let item of this.flareUpPlanItems)
                data["flareUpPlanItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFlareUpPlanDto {
    id?: number;
    updateTime?: Date | undefined;
    flareUpPlanItems?: FlareUpPlanItemDto[] | undefined;
}

export class FlareUpPlanItemDto implements IFlareUpPlanItemDto {
    id?: number;
    guid?: string;
    flareUpPlanId?: number;
    flareUpPlanItemType?: FlareUpPlanItemType;
    cardId?: number | undefined;
    card?: CardModel | undefined;
    order?: number;
    isActive?: boolean;
    text?: string | undefined;

    constructor(data?: IFlareUpPlanItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.guid = _data["guid"];
            this.flareUpPlanId = _data["flareUpPlanId"];
            this.flareUpPlanItemType = _data["flareUpPlanItemType"];
            this.cardId = _data["cardId"];
            this.card = _data["card"] ? CardModel.fromJS(_data["card"]) : <any>undefined;
            this.order = _data["order"];
            this.isActive = _data["isActive"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): FlareUpPlanItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlareUpPlanItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["guid"] = this.guid;
        data["flareUpPlanId"] = this.flareUpPlanId;
        data["flareUpPlanItemType"] = this.flareUpPlanItemType;
        data["cardId"] = this.cardId;
        data["card"] = this.card ? this.card.toJSON() : <any>undefined;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        data["text"] = this.text;
        return data;
    }
}

export interface IFlareUpPlanItemDto {
    id?: number;
    guid?: string;
    flareUpPlanId?: number;
    flareUpPlanItemType?: FlareUpPlanItemType;
    cardId?: number | undefined;
    card?: CardModel | undefined;
    order?: number;
    isActive?: boolean;
    text?: string | undefined;
}

export enum FlareUpPlanItemType {
    NotesToSelf = 0,
    EdgeOffThings = 1,
    ThreeDaysThings = 2,
}

export class BaseTransportOfSurveyDtoAndBaseError implements IBaseTransportOfSurveyDtoAndBaseError {
    result?: SurveyDto | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfSurveyDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SurveyDto.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfSurveyDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfSurveyDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfSurveyDtoAndBaseError {
    result?: SurveyDto | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfSurveyDto extends BaseTransportOfSurveyDtoAndBaseError implements IResponseTransportOfSurveyDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfSurveyDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfSurveyDto extends IBaseTransportOfSurveyDtoAndBaseError {
    status?: ResponseStatus;
}

export class SurveyDto implements ISurveyDto {
    surveyId?: number;
    title?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    isActive?: boolean;
    surveyType?: SurveyType;
    insertDate?: Date;
    updateDate?: Date | undefined;
    surveySections?: SurveySectionDto[] | undefined;
    canBeActivatedByClinician?: boolean;
    isActivatedByClinician?: boolean;
    topChosenImages?: number[] | undefined;
    isCompleted?: boolean;

    constructor(data?: ISurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.isActive = _data["isActive"];
            this.surveyType = _data["surveyType"];
            this.insertDate = _data["insertDate"] ? new Date(_data["insertDate"].toString()) : <any>undefined;
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["surveySections"])) {
                this.surveySections = [] as any;
                for (let item of _data["surveySections"])
                    this.surveySections!.push(SurveySectionDto.fromJS(item));
            }
            this.canBeActivatedByClinician = _data["canBeActivatedByClinician"];
            this.isActivatedByClinician = _data["isActivatedByClinician"];
            if (Array.isArray(_data["topChosenImages"])) {
                this.topChosenImages = [] as any;
                for (let item of _data["topChosenImages"])
                    this.topChosenImages!.push(item);
            }
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): SurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["isActive"] = this.isActive;
        data["surveyType"] = this.surveyType;
        data["insertDate"] = this.insertDate ? this.insertDate.toISOString() : <any>undefined;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        if (Array.isArray(this.surveySections)) {
            data["surveySections"] = [];
            for (let item of this.surveySections)
                data["surveySections"].push(item.toJSON());
        }
        data["canBeActivatedByClinician"] = this.canBeActivatedByClinician;
        data["isActivatedByClinician"] = this.isActivatedByClinician;
        if (Array.isArray(this.topChosenImages)) {
            data["topChosenImages"] = [];
            for (let item of this.topChosenImages)
                data["topChosenImages"].push(item);
        }
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface ISurveyDto {
    surveyId?: number;
    title?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    isActive?: boolean;
    surveyType?: SurveyType;
    insertDate?: Date;
    updateDate?: Date | undefined;
    surveySections?: SurveySectionDto[] | undefined;
    canBeActivatedByClinician?: boolean;
    isActivatedByClinician?: boolean;
    topChosenImages?: number[] | undefined;
    isCompleted?: boolean;
}

export enum SurveyType {
    IntakeForm = 1,
    PainQuestionnaire = 2,
    SixWeekAssessment = 3,
    TwelveWeekAssessment = 4,
    PostProgramAssessment = 5,
    LIFT = 6,
    LIFT2 = 7,
    DASS21 = 8,
    ScreeningQuestionnaire = 9,
    EndProgram = 10,
    FeedbackForm = 11,
}

export class SurveySectionDto implements ISurveySectionDto {
    surveySectionId?: number;
    sectionTitle?: string | undefined;
    sectionIsActive?: boolean;
    sectionIcon?: string | undefined;
    sectionDescription?: string | undefined;
    sectionSortOrder?: number;
    questions?: QuestionDto[] | undefined;

    constructor(data?: ISurveySectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveySectionId = _data["surveySectionId"];
            this.sectionTitle = _data["sectionTitle"];
            this.sectionIsActive = _data["sectionIsActive"];
            this.sectionIcon = _data["sectionIcon"];
            this.sectionDescription = _data["sectionDescription"];
            this.sectionSortOrder = _data["sectionSortOrder"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(QuestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveySectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveySectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveySectionId"] = this.surveySectionId;
        data["sectionTitle"] = this.sectionTitle;
        data["sectionIsActive"] = this.sectionIsActive;
        data["sectionIcon"] = this.sectionIcon;
        data["sectionDescription"] = this.sectionDescription;
        data["sectionSortOrder"] = this.sectionSortOrder;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveySectionDto {
    surveySectionId?: number;
    sectionTitle?: string | undefined;
    sectionIsActive?: boolean;
    sectionIcon?: string | undefined;
    sectionDescription?: string | undefined;
    sectionSortOrder?: number;
    questions?: QuestionDto[] | undefined;
}

export class QuestionDto implements IQuestionDto {
    questionId?: number;
    questionGuid?: string;
    questionTitle?: string | undefined;
    questionDescription?: string | undefined;
    questionImageUrl?: string | undefined;
    questionIsRequired?: boolean | undefined;
    questionSortOrder?: number;
    questionType?: QuestionType;
    questionIsHidden?: boolean | undefined;
    questionIsActive?: boolean;
    displayQuestionId?: number | undefined;
    displayOptionId?: number | undefined;
    options?: OptionDto[] | undefined;
    answers?: SurveyResponseAnswerDto[] | undefined;

    constructor(data?: IQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.questionGuid = _data["questionGuid"];
            this.questionTitle = _data["questionTitle"];
            this.questionDescription = _data["questionDescription"];
            this.questionImageUrl = _data["questionImageUrl"];
            this.questionIsRequired = _data["questionIsRequired"];
            this.questionSortOrder = _data["questionSortOrder"];
            this.questionType = _data["questionType"];
            this.questionIsHidden = _data["questionIsHidden"];
            this.questionIsActive = _data["questionIsActive"];
            this.displayQuestionId = _data["displayQuestionId"];
            this.displayOptionId = _data["displayOptionId"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(OptionDto.fromJS(item));
            }
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(SurveyResponseAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["questionGuid"] = this.questionGuid;
        data["questionTitle"] = this.questionTitle;
        data["questionDescription"] = this.questionDescription;
        data["questionImageUrl"] = this.questionImageUrl;
        data["questionIsRequired"] = this.questionIsRequired;
        data["questionSortOrder"] = this.questionSortOrder;
        data["questionType"] = this.questionType;
        data["questionIsHidden"] = this.questionIsHidden;
        data["questionIsActive"] = this.questionIsActive;
        data["displayQuestionId"] = this.displayQuestionId;
        data["displayOptionId"] = this.displayOptionId;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionDto {
    questionId?: number;
    questionGuid?: string;
    questionTitle?: string | undefined;
    questionDescription?: string | undefined;
    questionImageUrl?: string | undefined;
    questionIsRequired?: boolean | undefined;
    questionSortOrder?: number;
    questionType?: QuestionType;
    questionIsHidden?: boolean | undefined;
    questionIsActive?: boolean;
    displayQuestionId?: number | undefined;
    displayOptionId?: number | undefined;
    options?: OptionDto[] | undefined;
    answers?: SurveyResponseAnswerDto[] | undefined;
}

export enum QuestionType {
    MultipleChoice = 1,
    CheckboxMultipleChoice = 2,
    Rating = 3,
    ShortAnswer = 4,
    LongAnswer = 5,
    ImageMultipleRating = 6,
    Date = 7,
    DateTime = 8,
    Time = 9,
    Number = 10,
    Text = 11,
    MedicationMultipleInput = 12,
    MedicationMultipleInputPerWeek = 13,
    DropDownNumberRange = 14,
    Address = 15,
}

export class OptionDto implements IOptionDto {
    questionOptionId?: number;
    optionGuid?: string;
    optionTitle?: string | undefined;
    optionDescription?: string | undefined;
    optionPlaceholder?: string | undefined;
    optionMinValue?: number;
    optionMinName?: string | undefined;
    optionMaxValue?: number;
    optionMaxName?: string | undefined;
    optionId?: number | undefined;
    optionSortOrder?: number;
    optionRegex?: string | undefined;
    optionRegexErrorMessage?: string | undefined;
    optionIsOther?: boolean | undefined;
    optionValue?: number | undefined;
    externalRecordId?: number | undefined;

    constructor(data?: IOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionOptionId = _data["questionOptionId"];
            this.optionGuid = _data["optionGuid"];
            this.optionTitle = _data["optionTitle"];
            this.optionDescription = _data["optionDescription"];
            this.optionPlaceholder = _data["optionPlaceholder"];
            this.optionMinValue = _data["optionMinValue"];
            this.optionMinName = _data["optionMinName"];
            this.optionMaxValue = _data["optionMaxValue"];
            this.optionMaxName = _data["optionMaxName"];
            this.optionId = _data["optionId"];
            this.optionSortOrder = _data["optionSortOrder"];
            this.optionRegex = _data["optionRegex"];
            this.optionRegexErrorMessage = _data["optionRegexErrorMessage"];
            this.optionIsOther = _data["optionIsOther"];
            this.optionValue = _data["optionValue"];
            this.externalRecordId = _data["externalRecordId"];
        }
    }

    static fromJS(data: any): OptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionOptionId"] = this.questionOptionId;
        data["optionGuid"] = this.optionGuid;
        data["optionTitle"] = this.optionTitle;
        data["optionDescription"] = this.optionDescription;
        data["optionPlaceholder"] = this.optionPlaceholder;
        data["optionMinValue"] = this.optionMinValue;
        data["optionMinName"] = this.optionMinName;
        data["optionMaxValue"] = this.optionMaxValue;
        data["optionMaxName"] = this.optionMaxName;
        data["optionId"] = this.optionId;
        data["optionSortOrder"] = this.optionSortOrder;
        data["optionRegex"] = this.optionRegex;
        data["optionRegexErrorMessage"] = this.optionRegexErrorMessage;
        data["optionIsOther"] = this.optionIsOther;
        data["optionValue"] = this.optionValue;
        data["externalRecordId"] = this.externalRecordId;
        return data;
    }
}

export interface IOptionDto {
    questionOptionId?: number;
    optionGuid?: string;
    optionTitle?: string | undefined;
    optionDescription?: string | undefined;
    optionPlaceholder?: string | undefined;
    optionMinValue?: number;
    optionMinName?: string | undefined;
    optionMaxValue?: number;
    optionMaxName?: string | undefined;
    optionId?: number | undefined;
    optionSortOrder?: number;
    optionRegex?: string | undefined;
    optionRegexErrorMessage?: string | undefined;
    optionIsOther?: boolean | undefined;
    optionValue?: number | undefined;
    externalRecordId?: number | undefined;
}

export class SurveyResponseAnswerDto implements ISurveyResponseAnswerDto {
    responseAnswerId?: number | undefined;
    responseId?: number | undefined;
    questionId?: number;
    optionId?: number | undefined;
    value?: string | undefined;
    isActive?: boolean;
    insertDate?: string | undefined;
    optionTitle?: string | undefined;
    optionColorGrading?: ColorGrading | undefined;
    externalUserRecordId?: number | undefined;
    externalUserRecord?: IExternalUserRecord | undefined;
    userMedicationRecordDto?: UserMedicationRecordDto | undefined;

    constructor(data?: ISurveyResponseAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseAnswerId = _data["responseAnswerId"];
            this.responseId = _data["responseId"];
            this.questionId = _data["questionId"];
            this.optionId = _data["optionId"];
            this.value = _data["value"];
            this.isActive = _data["isActive"];
            this.insertDate = _data["insertDate"];
            this.optionTitle = _data["optionTitle"];
            this.optionColorGrading = _data["optionColorGrading"];
            this.externalUserRecordId = _data["externalUserRecordId"];
            this.externalUserRecord = _data["externalUserRecord"] ? IExternalUserRecord.fromJS(_data["externalUserRecord"]) : <any>undefined;
            this.userMedicationRecordDto = _data["userMedicationRecordDto"] ? UserMedicationRecordDto.fromJS(_data["userMedicationRecordDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyResponseAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponseAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseAnswerId"] = this.responseAnswerId;
        data["responseId"] = this.responseId;
        data["questionId"] = this.questionId;
        data["optionId"] = this.optionId;
        data["value"] = this.value;
        data["isActive"] = this.isActive;
        data["insertDate"] = this.insertDate;
        data["optionTitle"] = this.optionTitle;
        data["optionColorGrading"] = this.optionColorGrading;
        data["externalUserRecordId"] = this.externalUserRecordId;
        data["externalUserRecord"] = this.externalUserRecord ? this.externalUserRecord.toJSON() : <any>undefined;
        data["userMedicationRecordDto"] = this.userMedicationRecordDto ? this.userMedicationRecordDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISurveyResponseAnswerDto {
    responseAnswerId?: number | undefined;
    responseId?: number | undefined;
    questionId?: number;
    optionId?: number | undefined;
    value?: string | undefined;
    isActive?: boolean;
    insertDate?: string | undefined;
    optionTitle?: string | undefined;
    optionColorGrading?: ColorGrading | undefined;
    externalUserRecordId?: number | undefined;
    externalUserRecord?: IExternalUserRecord | undefined;
    userMedicationRecordDto?: UserMedicationRecordDto | undefined;
}

export enum ColorGrading {
    Neutral = 0,
    Green = 1,
    Yellow = 2,
    Red = 3,
}

export abstract class IExternalUserRecord implements IIExternalUserRecord {
    id?: number | undefined;

    constructor(data?: IIExternalUserRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IExternalUserRecord {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IExternalUserRecord' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IIExternalUserRecord {
    id?: number | undefined;
}

export class UserMedicationRecordDto implements IUserMedicationRecordDto {
    id?: number | undefined;
    medicationDoseId?: number | undefined;
    count?: number;
    frequency?: number;
    customMedicationName?: string | undefined;
    customMedicationDosage?: number | undefined;
    customMedicationDosageUnit?: DoseUnitType | undefined;
    periodType?: MedicationPeriodType | undefined;
    isCustom?: boolean;
    isActive?: boolean;

    constructor(data?: IUserMedicationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.medicationDoseId = _data["medicationDoseId"];
            this.count = _data["count"];
            this.frequency = _data["frequency"];
            this.customMedicationName = _data["customMedicationName"];
            this.customMedicationDosage = _data["customMedicationDosage"];
            this.customMedicationDosageUnit = _data["customMedicationDosageUnit"];
            this.periodType = _data["periodType"];
            this.isCustom = _data["isCustom"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UserMedicationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserMedicationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["medicationDoseId"] = this.medicationDoseId;
        data["count"] = this.count;
        data["frequency"] = this.frequency;
        data["customMedicationName"] = this.customMedicationName;
        data["customMedicationDosage"] = this.customMedicationDosage;
        data["customMedicationDosageUnit"] = this.customMedicationDosageUnit;
        data["periodType"] = this.periodType;
        data["isCustom"] = this.isCustom;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUserMedicationRecordDto {
    id?: number | undefined;
    medicationDoseId?: number | undefined;
    count?: number;
    frequency?: number;
    customMedicationName?: string | undefined;
    customMedicationDosage?: number | undefined;
    customMedicationDosageUnit?: DoseUnitType | undefined;
    periodType?: MedicationPeriodType | undefined;
    isCustom?: boolean;
    isActive?: boolean;
}

export enum DoseUnitType {
    Mg = 0,
}

export enum MedicationPeriodType {
    PerDay = 0,
    PerWeek = 1,
}

export class BaseTransportOfSurveyEditDtoAndBaseError implements IBaseTransportOfSurveyEditDtoAndBaseError {
    result?: SurveyEditDto | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfSurveyEditDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SurveyEditDto.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfSurveyEditDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfSurveyEditDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfSurveyEditDtoAndBaseError {
    result?: SurveyEditDto | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfSurveyEditDto extends BaseTransportOfSurveyEditDtoAndBaseError implements IResponseTransportOfSurveyEditDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfSurveyEditDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfSurveyEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfSurveyEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfSurveyEditDto extends IBaseTransportOfSurveyEditDtoAndBaseError {
    status?: ResponseStatus;
}

export class SurveyEditDto implements ISurveyEditDto {
    surveyId?: number;
    title?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    isActive?: boolean;
    surveyType?: SurveyType;
    insertDate?: Date;
    updateDate?: Date;
    surveySections?: SurveySectionEditDto[] | undefined;
    canBeActivatedByClinician?: boolean;

    constructor(data?: ISurveyEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.isActive = _data["isActive"];
            this.surveyType = _data["surveyType"];
            this.insertDate = _data["insertDate"] ? new Date(_data["insertDate"].toString()) : <any>undefined;
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["surveySections"])) {
                this.surveySections = [] as any;
                for (let item of _data["surveySections"])
                    this.surveySections!.push(SurveySectionEditDto.fromJS(item));
            }
            this.canBeActivatedByClinician = _data["canBeActivatedByClinician"];
        }
    }

    static fromJS(data: any): SurveyEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["isActive"] = this.isActive;
        data["surveyType"] = this.surveyType;
        data["insertDate"] = this.insertDate ? this.insertDate.toISOString() : <any>undefined;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        if (Array.isArray(this.surveySections)) {
            data["surveySections"] = [];
            for (let item of this.surveySections)
                data["surveySections"].push(item.toJSON());
        }
        data["canBeActivatedByClinician"] = this.canBeActivatedByClinician;
        return data;
    }
}

export interface ISurveyEditDto {
    surveyId?: number;
    title?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    isActive?: boolean;
    surveyType?: SurveyType;
    insertDate?: Date;
    updateDate?: Date;
    surveySections?: SurveySectionEditDto[] | undefined;
    canBeActivatedByClinician?: boolean;
}

export class SurveySectionEditDto implements ISurveySectionEditDto {
    surveySectionId?: number;
    surveySectionGuid?: string;
    sectionTitle?: string | undefined;
    sectionIsActive?: boolean;
    sectionIcon?: string | undefined;
    sectionDescription?: string | undefined;
    sectionSortOrder?: number;
    questions?: QuestionEditDto[] | undefined;

    constructor(data?: ISurveySectionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveySectionId = _data["surveySectionId"];
            this.surveySectionGuid = _data["surveySectionGuid"];
            this.sectionTitle = _data["sectionTitle"];
            this.sectionIsActive = _data["sectionIsActive"];
            this.sectionIcon = _data["sectionIcon"];
            this.sectionDescription = _data["sectionDescription"];
            this.sectionSortOrder = _data["sectionSortOrder"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(QuestionEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveySectionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveySectionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveySectionId"] = this.surveySectionId;
        data["surveySectionGuid"] = this.surveySectionGuid;
        data["sectionTitle"] = this.sectionTitle;
        data["sectionIsActive"] = this.sectionIsActive;
        data["sectionIcon"] = this.sectionIcon;
        data["sectionDescription"] = this.sectionDescription;
        data["sectionSortOrder"] = this.sectionSortOrder;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveySectionEditDto {
    surveySectionId?: number;
    surveySectionGuid?: string;
    sectionTitle?: string | undefined;
    sectionIsActive?: boolean;
    sectionIcon?: string | undefined;
    sectionDescription?: string | undefined;
    sectionSortOrder?: number;
    questions?: QuestionEditDto[] | undefined;
}

export class QuestionEditDto implements IQuestionEditDto {
    questionId?: number;
    questionGuid?: string;
    questionTitle?: string | undefined;
    questionDescription?: string | undefined;
    questionImageUrl?: string | undefined;
    questionIsRequired?: boolean | undefined;
    questionSortOrder?: number;
    questionType?: QuestionType;
    questionIsHidden?: boolean | undefined;
    displayQuestionId?: number | undefined;
    displayQuestionGuidId?: string | undefined;
    displayOptionId?: number | undefined;
    displayOptionGuidId?: string | undefined;
    options?: OptionEditDto[] | undefined;

    constructor(data?: IQuestionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.questionGuid = _data["questionGuid"];
            this.questionTitle = _data["questionTitle"];
            this.questionDescription = _data["questionDescription"];
            this.questionImageUrl = _data["questionImageUrl"];
            this.questionIsRequired = _data["questionIsRequired"];
            this.questionSortOrder = _data["questionSortOrder"];
            this.questionType = _data["questionType"];
            this.questionIsHidden = _data["questionIsHidden"];
            this.displayQuestionId = _data["displayQuestionId"];
            this.displayQuestionGuidId = _data["displayQuestionGuidId"];
            this.displayOptionId = _data["displayOptionId"];
            this.displayOptionGuidId = _data["displayOptionGuidId"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(OptionEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["questionGuid"] = this.questionGuid;
        data["questionTitle"] = this.questionTitle;
        data["questionDescription"] = this.questionDescription;
        data["questionImageUrl"] = this.questionImageUrl;
        data["questionIsRequired"] = this.questionIsRequired;
        data["questionSortOrder"] = this.questionSortOrder;
        data["questionType"] = this.questionType;
        data["questionIsHidden"] = this.questionIsHidden;
        data["displayQuestionId"] = this.displayQuestionId;
        data["displayQuestionGuidId"] = this.displayQuestionGuidId;
        data["displayOptionId"] = this.displayOptionId;
        data["displayOptionGuidId"] = this.displayOptionGuidId;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionEditDto {
    questionId?: number;
    questionGuid?: string;
    questionTitle?: string | undefined;
    questionDescription?: string | undefined;
    questionImageUrl?: string | undefined;
    questionIsRequired?: boolean | undefined;
    questionSortOrder?: number;
    questionType?: QuestionType;
    questionIsHidden?: boolean | undefined;
    displayQuestionId?: number | undefined;
    displayQuestionGuidId?: string | undefined;
    displayOptionId?: number | undefined;
    displayOptionGuidId?: string | undefined;
    options?: OptionEditDto[] | undefined;
}

export class OptionEditDto implements IOptionEditDto {
    questionOptionId?: number;
    optionGuid?: string;
    optionTitle?: string | undefined;
    optionDescription?: string | undefined;
    optionPlaceholder?: string | undefined;
    optionMinValue?: number;
    optionMinName?: string | undefined;
    optionMaxValue?: number;
    optionMaxName?: string | undefined;
    optionId?: number | undefined;
    optionSortOrder?: number;
    optionRegex?: string | undefined;
    optionRegexErrorMessage?: string | undefined;
    optionIsOther?: boolean | undefined;
    optionValue?: number | undefined;
    optionColorGrading?: ColorGrading;

    constructor(data?: IOptionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionOptionId = _data["questionOptionId"];
            this.optionGuid = _data["optionGuid"];
            this.optionTitle = _data["optionTitle"];
            this.optionDescription = _data["optionDescription"];
            this.optionPlaceholder = _data["optionPlaceholder"];
            this.optionMinValue = _data["optionMinValue"];
            this.optionMinName = _data["optionMinName"];
            this.optionMaxValue = _data["optionMaxValue"];
            this.optionMaxName = _data["optionMaxName"];
            this.optionId = _data["optionId"];
            this.optionSortOrder = _data["optionSortOrder"];
            this.optionRegex = _data["optionRegex"];
            this.optionRegexErrorMessage = _data["optionRegexErrorMessage"];
            this.optionIsOther = _data["optionIsOther"];
            this.optionValue = _data["optionValue"];
            this.optionColorGrading = _data["optionColorGrading"];
        }
    }

    static fromJS(data: any): OptionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionOptionId"] = this.questionOptionId;
        data["optionGuid"] = this.optionGuid;
        data["optionTitle"] = this.optionTitle;
        data["optionDescription"] = this.optionDescription;
        data["optionPlaceholder"] = this.optionPlaceholder;
        data["optionMinValue"] = this.optionMinValue;
        data["optionMinName"] = this.optionMinName;
        data["optionMaxValue"] = this.optionMaxValue;
        data["optionMaxName"] = this.optionMaxName;
        data["optionId"] = this.optionId;
        data["optionSortOrder"] = this.optionSortOrder;
        data["optionRegex"] = this.optionRegex;
        data["optionRegexErrorMessage"] = this.optionRegexErrorMessage;
        data["optionIsOther"] = this.optionIsOther;
        data["optionValue"] = this.optionValue;
        data["optionColorGrading"] = this.optionColorGrading;
        return data;
    }
}

export interface IOptionEditDto {
    questionOptionId?: number;
    optionGuid?: string;
    optionTitle?: string | undefined;
    optionDescription?: string | undefined;
    optionPlaceholder?: string | undefined;
    optionMinValue?: number;
    optionMinName?: string | undefined;
    optionMaxValue?: number;
    optionMaxName?: string | undefined;
    optionId?: number | undefined;
    optionSortOrder?: number;
    optionRegex?: string | undefined;
    optionRegexErrorMessage?: string | undefined;
    optionIsOther?: boolean | undefined;
    optionValue?: number | undefined;
    optionColorGrading?: ColorGrading;
}

export class BaseTransportOfSurveyEntityEditDtoAndBaseError implements IBaseTransportOfSurveyEntityEditDtoAndBaseError {
    result?: SurveyEntityEditDto | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfSurveyEntityEditDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SurveyEntityEditDto.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfSurveyEntityEditDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfSurveyEntityEditDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfSurveyEntityEditDtoAndBaseError {
    result?: SurveyEntityEditDto | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfSurveyEntityEditDto extends BaseTransportOfSurveyEntityEditDtoAndBaseError implements IResponseTransportOfSurveyEntityEditDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfSurveyEntityEditDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfSurveyEntityEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfSurveyEntityEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfSurveyEntityEditDto extends IBaseTransportOfSurveyEntityEditDtoAndBaseError {
    status?: ResponseStatus;
}

export class SurveyEntityEditDto implements ISurveyEntityEditDto {
    surveyId?: number;
    title?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    isActive?: boolean;
    surveyType?: SurveyType;
    insertDate?: Date;
    insertedByUserId?: number;
    updateDate?: Date | undefined;
    updatedByUserId?: number | undefined;
    canBeActivatedByClinician?: boolean | undefined;
    surveySections?: SurveySectionEntityDto[] | undefined;
    licenceStreamId?: number;

    constructor(data?: ISurveyEntityEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.isActive = _data["isActive"];
            this.surveyType = _data["surveyType"];
            this.insertDate = _data["insertDate"] ? new Date(_data["insertDate"].toString()) : <any>undefined;
            this.insertedByUserId = _data["insertedByUserId"];
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.updatedByUserId = _data["updatedByUserId"];
            this.canBeActivatedByClinician = _data["canBeActivatedByClinician"];
            if (Array.isArray(_data["surveySections"])) {
                this.surveySections = [] as any;
                for (let item of _data["surveySections"])
                    this.surveySections!.push(SurveySectionEntityDto.fromJS(item));
            }
            this.licenceStreamId = _data["licenceStreamId"];
        }
    }

    static fromJS(data: any): SurveyEntityEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyEntityEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["isActive"] = this.isActive;
        data["surveyType"] = this.surveyType;
        data["insertDate"] = this.insertDate ? this.insertDate.toISOString() : <any>undefined;
        data["insertedByUserId"] = this.insertedByUserId;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["updatedByUserId"] = this.updatedByUserId;
        data["canBeActivatedByClinician"] = this.canBeActivatedByClinician;
        if (Array.isArray(this.surveySections)) {
            data["surveySections"] = [];
            for (let item of this.surveySections)
                data["surveySections"].push(item.toJSON());
        }
        data["licenceStreamId"] = this.licenceStreamId;
        return data;
    }
}

export interface ISurveyEntityEditDto {
    surveyId?: number;
    title?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    isActive?: boolean;
    surveyType?: SurveyType;
    insertDate?: Date;
    insertedByUserId?: number;
    updateDate?: Date | undefined;
    updatedByUserId?: number | undefined;
    canBeActivatedByClinician?: boolean | undefined;
    surveySections?: SurveySectionEntityDto[] | undefined;
    licenceStreamId?: number;
}

export class SurveySectionEntityDto implements ISurveySectionEntityDto {
    surveySectionGuid?: string;
    sectionTitle?: string | undefined;
    sectionIsActive?: boolean;
    sectionIcon?: string | undefined;
    sectionDescription?: string | undefined;
    sectionSortOrder?: number;
    surveyQuestions?: SurveySectionQuestionsEntityDto[] | undefined;

    constructor(data?: ISurveySectionEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveySectionGuid = _data["surveySectionGuid"];
            this.sectionTitle = _data["sectionTitle"];
            this.sectionIsActive = _data["sectionIsActive"];
            this.sectionIcon = _data["sectionIcon"];
            this.sectionDescription = _data["sectionDescription"];
            this.sectionSortOrder = _data["sectionSortOrder"];
            if (Array.isArray(_data["surveyQuestions"])) {
                this.surveyQuestions = [] as any;
                for (let item of _data["surveyQuestions"])
                    this.surveyQuestions!.push(SurveySectionQuestionsEntityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveySectionEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveySectionEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveySectionGuid"] = this.surveySectionGuid;
        data["sectionTitle"] = this.sectionTitle;
        data["sectionIsActive"] = this.sectionIsActive;
        data["sectionIcon"] = this.sectionIcon;
        data["sectionDescription"] = this.sectionDescription;
        data["sectionSortOrder"] = this.sectionSortOrder;
        if (Array.isArray(this.surveyQuestions)) {
            data["surveyQuestions"] = [];
            for (let item of this.surveyQuestions)
                data["surveyQuestions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveySectionEntityDto {
    surveySectionGuid?: string;
    sectionTitle?: string | undefined;
    sectionIsActive?: boolean;
    sectionIcon?: string | undefined;
    sectionDescription?: string | undefined;
    sectionSortOrder?: number;
    surveyQuestions?: SurveySectionQuestionsEntityDto[] | undefined;
}

export class SurveySectionQuestionsEntityDto implements ISurveySectionQuestionsEntityDto {
    question?: QuestionEntityDto | undefined;
    isActive?: boolean;
    questionIsRequired?: boolean | undefined;
    sortOrder?: number;
    isHidden?: boolean | undefined;
    displayOptionId?: number | undefined;
    displayOptionGuid?: string | undefined;
    displayQuestionId?: number | undefined;

    constructor(data?: ISurveySectionQuestionsEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"] ? QuestionEntityDto.fromJS(_data["question"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.questionIsRequired = _data["questionIsRequired"];
            this.sortOrder = _data["sortOrder"];
            this.isHidden = _data["isHidden"];
            this.displayOptionId = _data["displayOptionId"];
            this.displayOptionGuid = _data["displayOptionGuid"];
            this.displayQuestionId = _data["displayQuestionId"];
        }
    }

    static fromJS(data: any): SurveySectionQuestionsEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveySectionQuestionsEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["questionIsRequired"] = this.questionIsRequired;
        data["sortOrder"] = this.sortOrder;
        data["isHidden"] = this.isHidden;
        data["displayOptionId"] = this.displayOptionId;
        data["displayOptionGuid"] = this.displayOptionGuid;
        data["displayQuestionId"] = this.displayQuestionId;
        return data;
    }
}

export interface ISurveySectionQuestionsEntityDto {
    question?: QuestionEntityDto | undefined;
    isActive?: boolean;
    questionIsRequired?: boolean | undefined;
    sortOrder?: number;
    isHidden?: boolean | undefined;
    displayOptionId?: number | undefined;
    displayOptionGuid?: string | undefined;
    displayQuestionId?: number | undefined;
}

export class QuestionEntityDto implements IQuestionEntityDto {
    questionId?: number;
    questionGuid?: string;
    questionTitle?: string | undefined;
    questionDescription?: string | undefined;
    questionImageUrl?: string | undefined;
    questionSortOrder?: number;
    questionIsActive?: boolean;
    questionPlaceholder?: string | undefined;
    questionType?: QuestionType;
    chartDataQuestionType?: ChartDataQuestionType | undefined;
    options?: OptionEntityDto[] | undefined;

    constructor(data?: IQuestionEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.questionGuid = _data["questionGuid"];
            this.questionTitle = _data["questionTitle"];
            this.questionDescription = _data["questionDescription"];
            this.questionImageUrl = _data["questionImageUrl"];
            this.questionSortOrder = _data["questionSortOrder"];
            this.questionIsActive = _data["questionIsActive"];
            this.questionPlaceholder = _data["questionPlaceholder"];
            this.questionType = _data["questionType"];
            this.chartDataQuestionType = _data["chartDataQuestionType"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(OptionEntityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["questionGuid"] = this.questionGuid;
        data["questionTitle"] = this.questionTitle;
        data["questionDescription"] = this.questionDescription;
        data["questionImageUrl"] = this.questionImageUrl;
        data["questionSortOrder"] = this.questionSortOrder;
        data["questionIsActive"] = this.questionIsActive;
        data["questionPlaceholder"] = this.questionPlaceholder;
        data["questionType"] = this.questionType;
        data["chartDataQuestionType"] = this.chartDataQuestionType;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionEntityDto {
    questionId?: number;
    questionGuid?: string;
    questionTitle?: string | undefined;
    questionDescription?: string | undefined;
    questionImageUrl?: string | undefined;
    questionSortOrder?: number;
    questionIsActive?: boolean;
    questionPlaceholder?: string | undefined;
    questionType?: QuestionType;
    chartDataQuestionType?: ChartDataQuestionType | undefined;
    options?: OptionEntityDto[] | undefined;
}

export enum ChartDataQuestionType {
    WorkHoursBefore = 1,
    WorkHoursNow = 2,
    PercentageOfDutiesNow = 3,
}

export class OptionEntityDto implements IOptionEntityDto {
    optionId?: number;
    optionGuid?: string;
    optionTitle?: string | undefined;
    optionDescription?: string | undefined;
    optionPlaceholder?: string | undefined;
    optionMinValue?: number;
    optionMinName?: string | undefined;
    optionMaxValue?: number;
    optionMaxName?: string | undefined;
    optionSortOrder?: number | undefined;
    optionRegex?: string | undefined;
    optionRegexErrorMessage?: string | undefined;
    optionIsOther?: boolean | undefined;
    optionIsActive?: boolean;
    value?: number | undefined;
    optionColorGrading?: ColorGrading | undefined;

    constructor(data?: IOptionEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optionId = _data["optionId"];
            this.optionGuid = _data["optionGuid"];
            this.optionTitle = _data["optionTitle"];
            this.optionDescription = _data["optionDescription"];
            this.optionPlaceholder = _data["optionPlaceholder"];
            this.optionMinValue = _data["optionMinValue"];
            this.optionMinName = _data["optionMinName"];
            this.optionMaxValue = _data["optionMaxValue"];
            this.optionMaxName = _data["optionMaxName"];
            this.optionSortOrder = _data["optionSortOrder"];
            this.optionRegex = _data["optionRegex"];
            this.optionRegexErrorMessage = _data["optionRegexErrorMessage"];
            this.optionIsOther = _data["optionIsOther"];
            this.optionIsActive = _data["optionIsActive"];
            this.value = _data["value"];
            this.optionColorGrading = _data["optionColorGrading"];
        }
    }

    static fromJS(data: any): OptionEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptionEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optionId"] = this.optionId;
        data["optionGuid"] = this.optionGuid;
        data["optionTitle"] = this.optionTitle;
        data["optionDescription"] = this.optionDescription;
        data["optionPlaceholder"] = this.optionPlaceholder;
        data["optionMinValue"] = this.optionMinValue;
        data["optionMinName"] = this.optionMinName;
        data["optionMaxValue"] = this.optionMaxValue;
        data["optionMaxName"] = this.optionMaxName;
        data["optionSortOrder"] = this.optionSortOrder;
        data["optionRegex"] = this.optionRegex;
        data["optionRegexErrorMessage"] = this.optionRegexErrorMessage;
        data["optionIsOther"] = this.optionIsOther;
        data["optionIsActive"] = this.optionIsActive;
        data["value"] = this.value;
        data["optionColorGrading"] = this.optionColorGrading;
        return data;
    }
}

export interface IOptionEntityDto {
    optionId?: number;
    optionGuid?: string;
    optionTitle?: string | undefined;
    optionDescription?: string | undefined;
    optionPlaceholder?: string | undefined;
    optionMinValue?: number;
    optionMinName?: string | undefined;
    optionMaxValue?: number;
    optionMaxName?: string | undefined;
    optionSortOrder?: number | undefined;
    optionRegex?: string | undefined;
    optionRegexErrorMessage?: string | undefined;
    optionIsOther?: boolean | undefined;
    optionIsActive?: boolean;
    value?: number | undefined;
    optionColorGrading?: ColorGrading | undefined;
}

export class BaseTransportOfIntegerAndBaseError implements IBaseTransportOfIntegerAndBaseError {
    result?: number;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfIntegerAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfIntegerAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfIntegerAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfIntegerAndBaseError {
    result?: number;
    error?: BaseError | undefined;
}

export class ResponseTransportOfInteger extends BaseTransportOfIntegerAndBaseError implements IResponseTransportOfInteger {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfInteger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfInteger extends IBaseTransportOfIntegerAndBaseError {
    status?: ResponseStatus;
}

export class BaseTransportOfDependencyQuestionsDtoAndBaseError implements IBaseTransportOfDependencyQuestionsDtoAndBaseError {
    result?: DependencyQuestionsDto | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfDependencyQuestionsDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? DependencyQuestionsDto.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfDependencyQuestionsDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfDependencyQuestionsDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfDependencyQuestionsDtoAndBaseError {
    result?: DependencyQuestionsDto | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfDependencyQuestionsDto extends BaseTransportOfDependencyQuestionsDtoAndBaseError implements IResponseTransportOfDependencyQuestionsDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfDependencyQuestionsDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfDependencyQuestionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfDependencyQuestionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfDependencyQuestionsDto extends IBaseTransportOfDependencyQuestionsDtoAndBaseError {
    status?: ResponseStatus;
}

export class DependencyQuestionsDto implements IDependencyQuestionsDto {
    surveyId?: number;
    questions?: QuestionEntityDto[] | undefined;
    dependencyQuestions?: DependencyQuestionDto[] | undefined;

    constructor(data?: IDependencyQuestionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(QuestionEntityDto.fromJS(item));
            }
            if (Array.isArray(_data["dependencyQuestions"])) {
                this.dependencyQuestions = [] as any;
                for (let item of _data["dependencyQuestions"])
                    this.dependencyQuestions!.push(DependencyQuestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DependencyQuestionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DependencyQuestionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        if (Array.isArray(this.dependencyQuestions)) {
            data["dependencyQuestions"] = [];
            for (let item of this.dependencyQuestions)
                data["dependencyQuestions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDependencyQuestionsDto {
    surveyId?: number;
    questions?: QuestionEntityDto[] | undefined;
    dependencyQuestions?: DependencyQuestionDto[] | undefined;
}

export class DependencyQuestionDto implements IDependencyQuestionDto {
    questionId?: number;
    displayOptionId?: number | undefined;
    displayQuestionId?: number | undefined;

    constructor(data?: IDependencyQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.displayOptionId = _data["displayOptionId"];
            this.displayQuestionId = _data["displayQuestionId"];
        }
    }

    static fromJS(data: any): DependencyQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DependencyQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["displayOptionId"] = this.displayOptionId;
        data["displayQuestionId"] = this.displayQuestionId;
        return data;
    }
}

export interface IDependencyQuestionDto {
    questionId?: number;
    displayOptionId?: number | undefined;
    displayQuestionId?: number | undefined;
}

export class SurveyResponseDto implements ISurveyResponseDto {
    surveyResponseId?: number | undefined;
    surveyId?: number;
    userGuid?: string;
    localInsertDateTime?: string | undefined;
    localUpdateDateTime?: string | undefined;
    insertDate?: Date;
    updateDate?: Date;
    isTemporary?: boolean | undefined;
    summary?: string | undefined;
    summaryUserName?: string | undefined;
    summaryUserId?: number | undefined;
    answers?: SurveyResponseAnswerDto[] | undefined;
    deletedUserMedicationRecordIds?: number[] | undefined;

    constructor(data?: ISurveyResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyResponseId = _data["surveyResponseId"];
            this.surveyId = _data["surveyId"];
            this.userGuid = _data["userGuid"];
            this.localInsertDateTime = _data["localInsertDateTime"];
            this.localUpdateDateTime = _data["localUpdateDateTime"];
            this.insertDate = _data["insertDate"] ? new Date(_data["insertDate"].toString()) : <any>undefined;
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.isTemporary = _data["isTemporary"];
            this.summary = _data["summary"];
            this.summaryUserName = _data["summaryUserName"];
            this.summaryUserId = _data["summaryUserId"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(SurveyResponseAnswerDto.fromJS(item));
            }
            if (Array.isArray(_data["deletedUserMedicationRecordIds"])) {
                this.deletedUserMedicationRecordIds = [] as any;
                for (let item of _data["deletedUserMedicationRecordIds"])
                    this.deletedUserMedicationRecordIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SurveyResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyResponseId"] = this.surveyResponseId;
        data["surveyId"] = this.surveyId;
        data["userGuid"] = this.userGuid;
        data["localInsertDateTime"] = this.localInsertDateTime;
        data["localUpdateDateTime"] = this.localUpdateDateTime;
        data["insertDate"] = this.insertDate ? this.insertDate.toISOString() : <any>undefined;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["isTemporary"] = this.isTemporary;
        data["summary"] = this.summary;
        data["summaryUserName"] = this.summaryUserName;
        data["summaryUserId"] = this.summaryUserId;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        if (Array.isArray(this.deletedUserMedicationRecordIds)) {
            data["deletedUserMedicationRecordIds"] = [];
            for (let item of this.deletedUserMedicationRecordIds)
                data["deletedUserMedicationRecordIds"].push(item);
        }
        return data;
    }
}

export interface ISurveyResponseDto {
    surveyResponseId?: number | undefined;
    surveyId?: number;
    userGuid?: string;
    localInsertDateTime?: string | undefined;
    localUpdateDateTime?: string | undefined;
    insertDate?: Date;
    updateDate?: Date;
    isTemporary?: boolean | undefined;
    summary?: string | undefined;
    summaryUserName?: string | undefined;
    summaryUserId?: number | undefined;
    answers?: SurveyResponseAnswerDto[] | undefined;
    deletedUserMedicationRecordIds?: number[] | undefined;
}

export class SurveyResponseSaveRequest extends SurveyResponseDto implements ISurveyResponseSaveRequest {

    constructor(data?: ISurveyResponseSaveRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SurveyResponseSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponseSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISurveyResponseSaveRequest extends ISurveyResponseDto {
}

export class LiftResponseSaveRequest extends SurveyResponseSaveRequest implements ILiftResponseSaveRequest {
    topImages?: number[] | undefined;
    topChosenImages?: number[] | undefined;

    constructor(data?: ILiftResponseSaveRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["topImages"])) {
                this.topImages = [] as any;
                for (let item of _data["topImages"])
                    this.topImages!.push(item);
            }
            if (Array.isArray(_data["topChosenImages"])) {
                this.topChosenImages = [] as any;
                for (let item of _data["topChosenImages"])
                    this.topChosenImages!.push(item);
            }
        }
    }

    static fromJS(data: any): LiftResponseSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LiftResponseSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.topImages)) {
            data["topImages"] = [];
            for (let item of this.topImages)
                data["topImages"].push(item);
        }
        if (Array.isArray(this.topChosenImages)) {
            data["topChosenImages"] = [];
            for (let item of this.topChosenImages)
                data["topChosenImages"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILiftResponseSaveRequest extends ISurveyResponseSaveRequest {
    topImages?: number[] | undefined;
    topChosenImages?: number[] | undefined;
}

export class PatientSurveyResponseSaveRequest extends SurveyResponseSaveRequest implements IPatientSurveyResponseSaveRequest {
    patientId?: number;

    constructor(data?: IPatientSurveyResponseSaveRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): PatientSurveyResponseSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSurveyResponseSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientSurveyResponseSaveRequest extends ISurveyResponseSaveRequest {
    patientId?: number;
}

export class BaseTransportOfSurveyResponseDtoAndBaseError implements IBaseTransportOfSurveyResponseDtoAndBaseError {
    result?: SurveyResponseDto | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfSurveyResponseDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SurveyResponseDto.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfSurveyResponseDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfSurveyResponseDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfSurveyResponseDtoAndBaseError {
    result?: SurveyResponseDto | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfSurveyResponseDto extends BaseTransportOfSurveyResponseDtoAndBaseError implements IResponseTransportOfSurveyResponseDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfSurveyResponseDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfSurveyResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfSurveyResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfSurveyResponseDto extends IBaseTransportOfSurveyResponseDtoAndBaseError {
    status?: ResponseStatus;
}

export class BaseTransportOfSurveyCompletionResponseAndBaseError implements IBaseTransportOfSurveyCompletionResponseAndBaseError {
    result?: SurveyCompletionResponse | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfSurveyCompletionResponseAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SurveyCompletionResponse.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfSurveyCompletionResponseAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfSurveyCompletionResponseAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfSurveyCompletionResponseAndBaseError {
    result?: SurveyCompletionResponse | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfSurveyCompletionResponse extends BaseTransportOfSurveyCompletionResponseAndBaseError implements IResponseTransportOfSurveyCompletionResponse {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfSurveyCompletionResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfSurveyCompletionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfSurveyCompletionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfSurveyCompletionResponse extends IBaseTransportOfSurveyCompletionResponseAndBaseError {
    status?: ResponseStatus;
}

export class SurveyCompletionResponse implements ISurveyCompletionResponse {
    surveyCompletions?: SurveyCompletion[] | undefined;

    constructor(data?: ISurveyCompletionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["surveyCompletions"])) {
                this.surveyCompletions = [] as any;
                for (let item of _data["surveyCompletions"])
                    this.surveyCompletions!.push(SurveyCompletion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyCompletionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyCompletionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.surveyCompletions)) {
            data["surveyCompletions"] = [];
            for (let item of this.surveyCompletions)
                data["surveyCompletions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyCompletionResponse {
    surveyCompletions?: SurveyCompletion[] | undefined;
}

export class SurveyCompletion implements ISurveyCompletion {
    surveyId?: number;
    title?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    isActive?: boolean;
    surveyType?: SurveyType;
    insertDate?: Date;
    updateDate?: Date;
    canBeActivatedByClinician?: boolean;
    clinicianIsActivated?: boolean;
    surveyResponses?: SurveyResponse[] | undefined;

    constructor(data?: ISurveyCompletion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.isActive = _data["isActive"];
            this.surveyType = _data["surveyType"];
            this.insertDate = _data["insertDate"] ? new Date(_data["insertDate"].toString()) : <any>undefined;
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.canBeActivatedByClinician = _data["canBeActivatedByClinician"];
            this.clinicianIsActivated = _data["clinicianIsActivated"];
            if (Array.isArray(_data["surveyResponses"])) {
                this.surveyResponses = [] as any;
                for (let item of _data["surveyResponses"])
                    this.surveyResponses!.push(SurveyResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyCompletion {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyCompletion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["isActive"] = this.isActive;
        data["surveyType"] = this.surveyType;
        data["insertDate"] = this.insertDate ? this.insertDate.toISOString() : <any>undefined;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["canBeActivatedByClinician"] = this.canBeActivatedByClinician;
        data["clinicianIsActivated"] = this.clinicianIsActivated;
        if (Array.isArray(this.surveyResponses)) {
            data["surveyResponses"] = [];
            for (let item of this.surveyResponses)
                data["surveyResponses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyCompletion {
    surveyId?: number;
    title?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    isActive?: boolean;
    surveyType?: SurveyType;
    insertDate?: Date;
    updateDate?: Date;
    canBeActivatedByClinician?: boolean;
    clinicianIsActivated?: boolean;
    surveyResponses?: SurveyResponse[] | undefined;
}

export class SurveyResponse implements ISurveyResponse {
    surveyResponseId?: number | undefined;
    surveyId?: number;
    userGuid?: string;
    localInsertDateTime?: string | undefined;
    localUpdateDateTime?: string | undefined;
    insertDate?: Date;
    updateDate?: Date;
    isTemporary?: boolean | undefined;
    summary?: string | undefined;
    summaryUserName?: string | undefined;
    summaryUserId?: number | undefined;
    answers?: SurveyResponseAnswer[] | undefined;

    constructor(data?: ISurveyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyResponseId = _data["surveyResponseId"];
            this.surveyId = _data["surveyId"];
            this.userGuid = _data["userGuid"];
            this.localInsertDateTime = _data["localInsertDateTime"];
            this.localUpdateDateTime = _data["localUpdateDateTime"];
            this.insertDate = _data["insertDate"] ? new Date(_data["insertDate"].toString()) : <any>undefined;
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.isTemporary = _data["isTemporary"];
            this.summary = _data["summary"];
            this.summaryUserName = _data["summaryUserName"];
            this.summaryUserId = _data["summaryUserId"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(SurveyResponseAnswer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyResponseId"] = this.surveyResponseId;
        data["surveyId"] = this.surveyId;
        data["userGuid"] = this.userGuid;
        data["localInsertDateTime"] = this.localInsertDateTime;
        data["localUpdateDateTime"] = this.localUpdateDateTime;
        data["insertDate"] = this.insertDate ? this.insertDate.toISOString() : <any>undefined;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["isTemporary"] = this.isTemporary;
        data["summary"] = this.summary;
        data["summaryUserName"] = this.summaryUserName;
        data["summaryUserId"] = this.summaryUserId;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyResponse {
    surveyResponseId?: number | undefined;
    surveyId?: number;
    userGuid?: string;
    localInsertDateTime?: string | undefined;
    localUpdateDateTime?: string | undefined;
    insertDate?: Date;
    updateDate?: Date;
    isTemporary?: boolean | undefined;
    summary?: string | undefined;
    summaryUserName?: string | undefined;
    summaryUserId?: number | undefined;
    answers?: SurveyResponseAnswer[] | undefined;
}

export class SurveyResponseAnswer implements ISurveyResponseAnswer {
    responseAnswerId?: number | undefined;
    responseId?: number | undefined;
    questionId?: number;
    optionId?: number | undefined;
    value?: string | undefined;
    isActive?: boolean;
    insertDate?: string | undefined;
    optionTitle?: string | undefined;
    optionColorGrading?: ColorGrading | undefined;
    externalUserRecordId?: number | undefined;

    constructor(data?: ISurveyResponseAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseAnswerId = _data["responseAnswerId"];
            this.responseId = _data["responseId"];
            this.questionId = _data["questionId"];
            this.optionId = _data["optionId"];
            this.value = _data["value"];
            this.isActive = _data["isActive"];
            this.insertDate = _data["insertDate"];
            this.optionTitle = _data["optionTitle"];
            this.optionColorGrading = _data["optionColorGrading"];
            this.externalUserRecordId = _data["externalUserRecordId"];
        }
    }

    static fromJS(data: any): SurveyResponseAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponseAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseAnswerId"] = this.responseAnswerId;
        data["responseId"] = this.responseId;
        data["questionId"] = this.questionId;
        data["optionId"] = this.optionId;
        data["value"] = this.value;
        data["isActive"] = this.isActive;
        data["insertDate"] = this.insertDate;
        data["optionTitle"] = this.optionTitle;
        data["optionColorGrading"] = this.optionColorGrading;
        data["externalUserRecordId"] = this.externalUserRecordId;
        return data;
    }
}

export interface ISurveyResponseAnswer {
    responseAnswerId?: number | undefined;
    responseId?: number | undefined;
    questionId?: number;
    optionId?: number | undefined;
    value?: string | undefined;
    isActive?: boolean;
    insertDate?: string | undefined;
    optionTitle?: string | undefined;
    optionColorGrading?: ColorGrading | undefined;
    externalUserRecordId?: number | undefined;
}

export class BaseTransportOfPatientSurveyResponseAndBaseError implements IBaseTransportOfPatientSurveyResponseAndBaseError {
    result?: PatientSurveyResponse | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfPatientSurveyResponseAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? PatientSurveyResponse.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfPatientSurveyResponseAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfPatientSurveyResponseAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfPatientSurveyResponseAndBaseError {
    result?: PatientSurveyResponse | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfPatientSurveyResponse extends BaseTransportOfPatientSurveyResponseAndBaseError implements IResponseTransportOfPatientSurveyResponse {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfPatientSurveyResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfPatientSurveyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfPatientSurveyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfPatientSurveyResponse extends IBaseTransportOfPatientSurveyResponseAndBaseError {
    status?: ResponseStatus;
}

export class PatientSurveyResponse implements IPatientSurveyResponse {
    survey?: SurveyDto | undefined;
    surveyResponseId?: number | undefined;

    constructor(data?: IPatientSurveyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.survey = _data["survey"] ? SurveyDto.fromJS(_data["survey"]) : <any>undefined;
            this.surveyResponseId = _data["surveyResponseId"];
        }
    }

    static fromJS(data: any): PatientSurveyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSurveyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["survey"] = this.survey ? this.survey.toJSON() : <any>undefined;
        data["surveyResponseId"] = this.surveyResponseId;
        return data;
    }
}

export interface IPatientSurveyResponse {
    survey?: SurveyDto | undefined;
    surveyResponseId?: number | undefined;
}

export class ResponseModelOfHandOperationResponse implements IResponseModelOfHandOperationResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: HandOperationResponse | undefined;

    constructor(data?: IResponseModelOfHandOperationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? HandOperationResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfHandOperationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfHandOperationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfHandOperationResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: HandOperationResponse | undefined;
}

export class HandOperationResponse implements IHandOperationResponse {
    outcome?: string | undefined;
    hand?: HandResponse | undefined;
    justCompleted?: boolean;

    constructor(data?: IHandOperationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outcome = _data["outcome"];
            this.hand = _data["hand"] ? HandResponse.fromJS(_data["hand"]) : <any>undefined;
            this.justCompleted = _data["justCompleted"];
        }
    }

    static fromJS(data: any): HandOperationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HandOperationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outcome"] = this.outcome;
        data["hand"] = this.hand ? this.hand.toJSON() : <any>undefined;
        data["justCompleted"] = this.justCompleted;
        return data;
    }
}

export interface IHandOperationResponse {
    outcome?: string | undefined;
    hand?: HandResponse | undefined;
    justCompleted?: boolean;
}

export class HandResponse implements IHandResponse {
    handId?: number;
    handDate?: string | undefined;
    isComplete?: boolean;
    favouriteHandId?: number | undefined;
    startedFromFavouriteHandId?: number | undefined;
    cards?: HandCardResponse[] | undefined;

    constructor(data?: IHandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.handId = _data["handId"];
            this.handDate = _data["handDate"];
            this.isComplete = _data["isComplete"];
            this.favouriteHandId = _data["favouriteHandId"];
            this.startedFromFavouriteHandId = _data["startedFromFavouriteHandId"];
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(HandCardResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["handId"] = this.handId;
        data["handDate"] = this.handDate;
        data["isComplete"] = this.isComplete;
        data["favouriteHandId"] = this.favouriteHandId;
        data["startedFromFavouriteHandId"] = this.startedFromFavouriteHandId;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHandResponse {
    handId?: number;
    handDate?: string | undefined;
    isComplete?: boolean;
    favouriteHandId?: number | undefined;
    startedFromFavouriteHandId?: number | undefined;
    cards?: HandCardResponse[] | undefined;
}

export class HandCardResponse implements IHandCardResponse {
    handCardId?: number;
    cardId?: number;
    dailyPeriodId?: number;
    sortOrder?: number;
    periodMinutes?: number;
    cardName?: string | undefined;
    cardDescription?: string | undefined;
    isPlayed?: boolean;
    playedDate?: Date | undefined;

    constructor(data?: IHandCardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.handCardId = _data["handCardId"];
            this.cardId = _data["cardId"];
            this.dailyPeriodId = _data["dailyPeriodId"];
            this.sortOrder = _data["sortOrder"];
            this.periodMinutes = _data["periodMinutes"];
            this.cardName = _data["cardName"];
            this.cardDescription = _data["cardDescription"];
            this.isPlayed = _data["isPlayed"];
            this.playedDate = _data["playedDate"] ? new Date(_data["playedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HandCardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HandCardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["handCardId"] = this.handCardId;
        data["cardId"] = this.cardId;
        data["dailyPeriodId"] = this.dailyPeriodId;
        data["sortOrder"] = this.sortOrder;
        data["periodMinutes"] = this.periodMinutes;
        data["cardName"] = this.cardName;
        data["cardDescription"] = this.cardDescription;
        data["isPlayed"] = this.isPlayed;
        data["playedDate"] = this.playedDate ? this.playedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHandCardResponse {
    handCardId?: number;
    cardId?: number;
    dailyPeriodId?: number;
    sortOrder?: number;
    periodMinutes?: number;
    cardName?: string | undefined;
    cardDescription?: string | undefined;
    isPlayed?: boolean;
    playedDate?: Date | undefined;
}

export class SaveHandRequest implements ISaveHandRequest {
    handId?: number | undefined;
    handDate?: string | undefined;
    cards?: HandCardRequest[] | undefined;

    constructor(data?: ISaveHandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.handId = _data["handId"];
            this.handDate = _data["handDate"];
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(HandCardRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveHandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveHandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["handId"] = this.handId;
        data["handDate"] = this.handDate;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveHandRequest {
    handId?: number | undefined;
    handDate?: string | undefined;
    cards?: HandCardRequest[] | undefined;
}

export class HandCardRequest implements IHandCardRequest {
    handCardId?: number | undefined;
    cardId?: number;
    dailyPeriodId?: number;
    sortOrder?: number;
    periodMinutes?: number;

    constructor(data?: IHandCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.handCardId = _data["handCardId"];
            this.cardId = _data["cardId"];
            this.dailyPeriodId = _data["dailyPeriodId"];
            this.sortOrder = _data["sortOrder"];
            this.periodMinutes = _data["periodMinutes"];
        }
    }

    static fromJS(data: any): HandCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HandCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["handCardId"] = this.handCardId;
        data["cardId"] = this.cardId;
        data["dailyPeriodId"] = this.dailyPeriodId;
        data["sortOrder"] = this.sortOrder;
        data["periodMinutes"] = this.periodMinutes;
        return data;
    }
}

export interface IHandCardRequest {
    handCardId?: number | undefined;
    cardId?: number;
    dailyPeriodId?: number;
    sortOrder?: number;
    periodMinutes?: number;
}

export class CopyHandRequest implements ICopyHandRequest {
    handId?: number;
    toDate?: string | undefined;

    constructor(data?: ICopyHandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.handId = _data["handId"];
            this.toDate = _data["toDate"];
        }
    }

    static fromJS(data: any): CopyHandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyHandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["handId"] = this.handId;
        data["toDate"] = this.toDate;
        return data;
    }
}

export interface ICopyHandRequest {
    handId?: number;
    toDate?: string | undefined;
}

export class SetHandCardPlayedRequest implements ISetHandCardPlayedRequest {
    handCardId?: number;
    isPlayed?: boolean;

    constructor(data?: ISetHandCardPlayedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.handCardId = _data["handCardId"];
            this.isPlayed = _data["isPlayed"];
        }
    }

    static fromJS(data: any): SetHandCardPlayedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetHandCardPlayedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["handCardId"] = this.handCardId;
        data["isPlayed"] = this.isPlayed;
        return data;
    }
}

export interface ISetHandCardPlayedRequest {
    handCardId?: number;
    isPlayed?: boolean;
}

export class DeleteHandRequest implements IDeleteHandRequest {
    handId?: number;

    constructor(data?: IDeleteHandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.handId = _data["handId"];
        }
    }

    static fromJS(data: any): DeleteHandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteHandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["handId"] = this.handId;
        return data;
    }
}

export interface IDeleteHandRequest {
    handId?: number;
}

export class UseFavouriteHandRequest implements IUseFavouriteHandRequest {
    favouriteHandId?: number;
    toDate?: string | undefined;

    constructor(data?: IUseFavouriteHandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.favouriteHandId = _data["favouriteHandId"];
            this.toDate = _data["toDate"];
        }
    }

    static fromJS(data: any): UseFavouriteHandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UseFavouriteHandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["favouriteHandId"] = this.favouriteHandId;
        data["toDate"] = this.toDate;
        return data;
    }
}

export interface IUseFavouriteHandRequest {
    favouriteHandId?: number;
    toDate?: string | undefined;
}

export class BaseTransportOfListOfHelpCategoryViewDtoAndBaseError implements IBaseTransportOfListOfHelpCategoryViewDtoAndBaseError {
    result?: HelpCategoryViewDto[] | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfListOfHelpCategoryViewDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(HelpCategoryViewDto.fromJS(item));
            }
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfListOfHelpCategoryViewDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfListOfHelpCategoryViewDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfListOfHelpCategoryViewDtoAndBaseError {
    result?: HelpCategoryViewDto[] | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfListOfHelpCategoryViewDto extends BaseTransportOfListOfHelpCategoryViewDtoAndBaseError implements IResponseTransportOfListOfHelpCategoryViewDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfListOfHelpCategoryViewDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfListOfHelpCategoryViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfListOfHelpCategoryViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfListOfHelpCategoryViewDto extends IBaseTransportOfListOfHelpCategoryViewDtoAndBaseError {
    status?: ResponseStatus;
}

export class HelpCategoryViewDto implements IHelpCategoryViewDto {
    id?: number;
    externalRef?: string | undefined;
    name?: string | undefined;
    slug?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    status?: string | undefined;

    constructor(data?: IHelpCategoryViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalRef = _data["externalRef"];
            this.name = _data["name"];
            this.slug = _data["slug"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): HelpCategoryViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new HelpCategoryViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalRef"] = this.externalRef;
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["status"] = this.status;
        return data;
    }
}

export interface IHelpCategoryViewDto {
    id?: number;
    externalRef?: string | undefined;
    name?: string | undefined;
    slug?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    status?: string | undefined;
}

export class BaseTransportOfListOfHelpArticleSummaryViewDtoAndBaseError implements IBaseTransportOfListOfHelpArticleSummaryViewDtoAndBaseError {
    result?: HelpArticleSummaryViewDto[] | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfListOfHelpArticleSummaryViewDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(HelpArticleSummaryViewDto.fromJS(item));
            }
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfListOfHelpArticleSummaryViewDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfListOfHelpArticleSummaryViewDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfListOfHelpArticleSummaryViewDtoAndBaseError {
    result?: HelpArticleSummaryViewDto[] | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfListOfHelpArticleSummaryViewDto extends BaseTransportOfListOfHelpArticleSummaryViewDtoAndBaseError implements IResponseTransportOfListOfHelpArticleSummaryViewDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfListOfHelpArticleSummaryViewDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfListOfHelpArticleSummaryViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfListOfHelpArticleSummaryViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfListOfHelpArticleSummaryViewDto extends IBaseTransportOfListOfHelpArticleSummaryViewDtoAndBaseError {
    status?: ResponseStatus;
}

export class HelpArticleSummaryViewDto implements IHelpArticleSummaryViewDto {
    id?: number;
    slug?: string | undefined;
    title?: string | undefined;
    categoryExternalRef?: string | undefined;
    categorySlug?: string | undefined;
    categoryName?: string | undefined;
    searchSummary?: string | undefined;
    sortOrder?: number;

    constructor(data?: IHelpArticleSummaryViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.slug = _data["slug"];
            this.title = _data["title"];
            this.categoryExternalRef = _data["categoryExternalRef"];
            this.categorySlug = _data["categorySlug"];
            this.categoryName = _data["categoryName"];
            this.searchSummary = _data["searchSummary"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): HelpArticleSummaryViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new HelpArticleSummaryViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slug"] = this.slug;
        data["title"] = this.title;
        data["categoryExternalRef"] = this.categoryExternalRef;
        data["categorySlug"] = this.categorySlug;
        data["categoryName"] = this.categoryName;
        data["searchSummary"] = this.searchSummary;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IHelpArticleSummaryViewDto {
    id?: number;
    slug?: string | undefined;
    title?: string | undefined;
    categoryExternalRef?: string | undefined;
    categorySlug?: string | undefined;
    categoryName?: string | undefined;
    searchSummary?: string | undefined;
    sortOrder?: number;
}

export class BaseTransportOfHelpArticleViewDtoAndBaseError implements IBaseTransportOfHelpArticleViewDtoAndBaseError {
    result?: HelpArticleViewDto | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfHelpArticleViewDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? HelpArticleViewDto.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfHelpArticleViewDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfHelpArticleViewDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfHelpArticleViewDtoAndBaseError {
    result?: HelpArticleViewDto | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfHelpArticleViewDto extends BaseTransportOfHelpArticleViewDtoAndBaseError implements IResponseTransportOfHelpArticleViewDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfHelpArticleViewDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfHelpArticleViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfHelpArticleViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfHelpArticleViewDto extends IBaseTransportOfHelpArticleViewDtoAndBaseError {
    status?: ResponseStatus;
}

export class HelpArticleViewDto implements IHelpArticleViewDto {
    id?: number;
    externalRef?: string | undefined;
    slug?: string | undefined;
    title?: string | undefined;
    categoryId?: number;
    categoryExternalRef?: string | undefined;
    categoryName?: string | undefined;
    categorySlug?: string | undefined;
    searchSummary?: string | undefined;
    bodyMarkdown?: string | undefined;
    contentFormat?: string | undefined;
    status?: string | undefined;
    platformScope?: string | undefined;
    sortOrder?: number;
    lastUpdated?: Date;
    relatedArticles?: HelpRelatedArticleViewDto[] | undefined;
    learnLinks?: HelpLearnLinkViewDto[] | undefined;

    constructor(data?: IHelpArticleViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalRef = _data["externalRef"];
            this.slug = _data["slug"];
            this.title = _data["title"];
            this.categoryId = _data["categoryId"];
            this.categoryExternalRef = _data["categoryExternalRef"];
            this.categoryName = _data["categoryName"];
            this.categorySlug = _data["categorySlug"];
            this.searchSummary = _data["searchSummary"];
            this.bodyMarkdown = _data["bodyMarkdown"];
            this.contentFormat = _data["contentFormat"];
            this.status = _data["status"];
            this.platformScope = _data["platformScope"];
            this.sortOrder = _data["sortOrder"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            if (Array.isArray(_data["relatedArticles"])) {
                this.relatedArticles = [] as any;
                for (let item of _data["relatedArticles"])
                    this.relatedArticles!.push(HelpRelatedArticleViewDto.fromJS(item));
            }
            if (Array.isArray(_data["learnLinks"])) {
                this.learnLinks = [] as any;
                for (let item of _data["learnLinks"])
                    this.learnLinks!.push(HelpLearnLinkViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HelpArticleViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new HelpArticleViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalRef"] = this.externalRef;
        data["slug"] = this.slug;
        data["title"] = this.title;
        data["categoryId"] = this.categoryId;
        data["categoryExternalRef"] = this.categoryExternalRef;
        data["categoryName"] = this.categoryName;
        data["categorySlug"] = this.categorySlug;
        data["searchSummary"] = this.searchSummary;
        data["bodyMarkdown"] = this.bodyMarkdown;
        data["contentFormat"] = this.contentFormat;
        data["status"] = this.status;
        data["platformScope"] = this.platformScope;
        data["sortOrder"] = this.sortOrder;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        if (Array.isArray(this.relatedArticles)) {
            data["relatedArticles"] = [];
            for (let item of this.relatedArticles)
                data["relatedArticles"].push(item.toJSON());
        }
        if (Array.isArray(this.learnLinks)) {
            data["learnLinks"] = [];
            for (let item of this.learnLinks)
                data["learnLinks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHelpArticleViewDto {
    id?: number;
    externalRef?: string | undefined;
    slug?: string | undefined;
    title?: string | undefined;
    categoryId?: number;
    categoryExternalRef?: string | undefined;
    categoryName?: string | undefined;
    categorySlug?: string | undefined;
    searchSummary?: string | undefined;
    bodyMarkdown?: string | undefined;
    contentFormat?: string | undefined;
    status?: string | undefined;
    platformScope?: string | undefined;
    sortOrder?: number;
    lastUpdated?: Date;
    relatedArticles?: HelpRelatedArticleViewDto[] | undefined;
    learnLinks?: HelpLearnLinkViewDto[] | undefined;
}

export class HelpRelatedArticleViewDto implements IHelpRelatedArticleViewDto {
    articleId?: number;
    slug?: string | undefined;
    title?: string | undefined;
    displayLabel?: string | undefined;
    displayOrder?: number;

    constructor(data?: IHelpRelatedArticleViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.slug = _data["slug"];
            this.title = _data["title"];
            this.displayLabel = _data["displayLabel"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): HelpRelatedArticleViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new HelpRelatedArticleViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["slug"] = this.slug;
        data["title"] = this.title;
        data["displayLabel"] = this.displayLabel;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IHelpRelatedArticleViewDto {
    articleId?: number;
    slug?: string | undefined;
    title?: string | undefined;
    displayLabel?: string | undefined;
    displayOrder?: number;
}

export class HelpLearnLinkViewDto implements IHelpLearnLinkViewDto {
    lessonKey?: string | undefined;
    lessonTitle?: string | undefined;
    displayCopy?: string | undefined;
    displayOrder?: number;

    constructor(data?: IHelpLearnLinkViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lessonKey = _data["lessonKey"];
            this.lessonTitle = _data["lessonTitle"];
            this.displayCopy = _data["displayCopy"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): HelpLearnLinkViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new HelpLearnLinkViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lessonKey"] = this.lessonKey;
        data["lessonTitle"] = this.lessonTitle;
        data["displayCopy"] = this.displayCopy;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IHelpLearnLinkViewDto {
    lessonKey?: string | undefined;
    lessonTitle?: string | undefined;
    displayCopy?: string | undefined;
    displayOrder?: number;
}

export class ScoreChartDbResponse implements IScoreChartDbResponse {
    maximum?: ScoreChartDbItem[] | undefined;
    minimum?: ScoreChartDbItem[] | undefined;

    constructor(data?: IScoreChartDbResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["maximum"])) {
                this.maximum = [] as any;
                for (let item of _data["maximum"])
                    this.maximum!.push(ScoreChartDbItem.fromJS(item));
            }
            if (Array.isArray(_data["minimum"])) {
                this.minimum = [] as any;
                for (let item of _data["minimum"])
                    this.minimum!.push(ScoreChartDbItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScoreChartDbResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreChartDbResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.maximum)) {
            data["maximum"] = [];
            for (let item of this.maximum)
                data["maximum"].push(item.toJSON());
        }
        if (Array.isArray(this.minimum)) {
            data["minimum"] = [];
            for (let item of this.minimum)
                data["minimum"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScoreChartDbResponse {
    maximum?: ScoreChartDbItem[] | undefined;
    minimum?: ScoreChartDbItem[] | undefined;
}

export class ScoreChartDbItem implements IScoreChartDbItem {
    year?: string | undefined;
    month?: string | undefined;
    week?: string | undefined;
    day?: string | undefined;
    startDate?: string | undefined;
    totalScore?: number;
    pointType?: string | undefined;
    marginOfSafetySetId?: number;
    insertLocalDate?: string | undefined;

    constructor(data?: IScoreChartDbItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.week = _data["week"];
            this.day = _data["day"];
            this.startDate = _data["startDate"];
            this.totalScore = _data["totalScore"];
            this.pointType = _data["pointType"];
            this.marginOfSafetySetId = _data["marginOfSafetySetId"];
            this.insertLocalDate = _data["insertLocalDate"];
        }
    }

    static fromJS(data: any): ScoreChartDbItem {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreChartDbItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["week"] = this.week;
        data["day"] = this.day;
        data["startDate"] = this.startDate;
        data["totalScore"] = this.totalScore;
        data["pointType"] = this.pointType;
        data["marginOfSafetySetId"] = this.marginOfSafetySetId;
        data["insertLocalDate"] = this.insertLocalDate;
        return data;
    }
}

export interface IScoreChartDbItem {
    year?: string | undefined;
    month?: string | undefined;
    week?: string | undefined;
    day?: string | undefined;
    startDate?: string | undefined;
    totalScore?: number;
    pointType?: string | undefined;
    marginOfSafetySetId?: number;
    insertLocalDate?: string | undefined;
}

export class ScoreHistoryDbRequest implements IScoreHistoryDbRequest {
    period?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;

    constructor(data?: IScoreHistoryDbRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any): ScoreHistoryDbRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreHistoryDbRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data;
    }
}

export interface IScoreHistoryDbRequest {
    period?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
}

export class TopHaloZombiResponse implements ITopHaloZombiResponse {
    name?: string | undefined;
    totalScore?: string | undefined;
    itemType?: number;

    constructor(data?: ITopHaloZombiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.totalScore = _data["totalScore"];
            this.itemType = _data["itemType"];
        }
    }

    static fromJS(data: any): TopHaloZombiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TopHaloZombiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["totalScore"] = this.totalScore;
        data["itemType"] = this.itemType;
        return data;
    }
}

export interface ITopHaloZombiResponse {
    name?: string | undefined;
    totalScore?: string | undefined;
    itemType?: number;
}

export class TopHaloZombiRequest implements ITopHaloZombiRequest {
    period?: string | undefined;
    seriesName?: string | undefined;
    day?: number | undefined;
    week?: number | undefined;
    month?: number | undefined;
    year?: number | undefined;

    constructor(data?: ITopHaloZombiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"];
            this.seriesName = _data["seriesName"];
            this.day = _data["day"];
            this.week = _data["week"];
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): TopHaloZombiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TopHaloZombiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["seriesName"] = this.seriesName;
        data["day"] = this.day;
        data["week"] = this.week;
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }
}

export interface ITopHaloZombiRequest {
    period?: string | undefined;
    seriesName?: string | undefined;
    day?: number | undefined;
    week?: number | undefined;
    month?: number | undefined;
    year?: number | undefined;
}

export class HaloZombiResponse implements IHaloZombiResponse {
    name?: string | undefined;
    scoreValue?: string | undefined;
    itemType?: number;
    tags?: TagDto[] | undefined;

    constructor(data?: IHaloZombiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.scoreValue = _data["scoreValue"];
            this.itemType = _data["itemType"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HaloZombiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HaloZombiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["scoreValue"] = this.scoreValue;
        data["itemType"] = this.itemType;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHaloZombiResponse {
    name?: string | undefined;
    scoreValue?: string | undefined;
    itemType?: number;
    tags?: TagDto[] | undefined;
}

export class TagDto implements ITagDto {
    id?: number;
    name?: string | undefined;
    categoryId?: number;
    userId?: number | undefined;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ITagDto {
    id?: number;
    name?: string | undefined;
    categoryId?: number;
    userId?: number | undefined;
}

export class ScoreCompoDbResponse implements IScoreCompoDbResponse {
    marginOfSafetyTypeId?: number;
    halosOrZombies?: string | undefined;
    itemName?: string | undefined;
    scoreValue?: number;
    sortOrder?: number;

    constructor(data?: IScoreCompoDbResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.marginOfSafetyTypeId = _data["marginOfSafetyTypeId"];
            this.halosOrZombies = _data["halosOrZombies"];
            this.itemName = _data["itemName"];
            this.scoreValue = _data["scoreValue"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ScoreCompoDbResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreCompoDbResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marginOfSafetyTypeId"] = this.marginOfSafetyTypeId;
        data["halosOrZombies"] = this.halosOrZombies;
        data["itemName"] = this.itemName;
        data["scoreValue"] = this.scoreValue;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IScoreCompoDbResponse {
    marginOfSafetyTypeId?: number;
    halosOrZombies?: string | undefined;
    itemName?: string | undefined;
    scoreValue?: number;
    sortOrder?: number;
}

export class InteractionEventRequest implements IInteractionEventRequest {
    screen?: string | undefined;
    eventName?: string | undefined;
    interactionType?: InteractionType;
    detail?: string | undefined;
    entityType?: string | undefined;
    entityId?: number | undefined;
    correlationId?: string | undefined;
    previousDetail?: string | undefined;

    constructor(data?: IInteractionEventRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.screen = _data["screen"];
            this.eventName = _data["eventName"];
            this.interactionType = _data["interactionType"];
            this.detail = _data["detail"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.correlationId = _data["correlationId"];
            this.previousDetail = _data["previousDetail"];
        }
    }

    static fromJS(data: any): InteractionEventRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionEventRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["screen"] = this.screen;
        data["eventName"] = this.eventName;
        data["interactionType"] = this.interactionType;
        data["detail"] = this.detail;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["correlationId"] = this.correlationId;
        data["previousDetail"] = this.previousDetail;
        return data;
    }
}

export interface IInteractionEventRequest {
    screen?: string | undefined;
    eventName?: string | undefined;
    interactionType?: InteractionType;
    detail?: string | undefined;
    entityType?: string | undefined;
    entityId?: number | undefined;
    correlationId?: string | undefined;
    previousDetail?: string | undefined;
}

export enum InteractionType {
    Add = 1,
    Edit = 2,
    Delete = 3,
    Selection = 4,
    ClearAll = 5,
    Confirm = 6,
    Cancel = 7,
    Start = 8,
    Complete = 9,
}

export class BaseTransportOfCourseViewDtoAndBaseError implements IBaseTransportOfCourseViewDtoAndBaseError {
    result?: CourseViewDto | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfCourseViewDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? CourseViewDto.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfCourseViewDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfCourseViewDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfCourseViewDtoAndBaseError {
    result?: CourseViewDto | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfCourseViewDto extends BaseTransportOfCourseViewDtoAndBaseError implements IResponseTransportOfCourseViewDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfCourseViewDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfCourseViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfCourseViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfCourseViewDto extends IBaseTransportOfCourseViewDtoAndBaseError {
    status?: ResponseStatus;
}

export class CourseViewDto implements ICourseViewDto {
    id?: number;
    title?: string | undefined;
    description?: string | undefined;
    isPublished?: boolean;
    chapters?: ChapterViewDto[] | undefined;

    constructor(data?: ICourseViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.isPublished = _data["isPublished"];
            if (Array.isArray(_data["chapters"])) {
                this.chapters = [] as any;
                for (let item of _data["chapters"])
                    this.chapters!.push(ChapterViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["isPublished"] = this.isPublished;
        if (Array.isArray(this.chapters)) {
            data["chapters"] = [];
            for (let item of this.chapters)
                data["chapters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICourseViewDto {
    id?: number;
    title?: string | undefined;
    description?: string | undefined;
    isPublished?: boolean;
    chapters?: ChapterViewDto[] | undefined;
}

export class ChapterViewDto implements IChapterViewDto {
    id?: number;
    title?: string | undefined;
    description?: string | undefined;
    longDescription?: string | undefined;
    position?: number;
    lessons?: LessonViewDto[] | undefined;

    constructor(data?: IChapterViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.longDescription = _data["longDescription"];
            this.position = _data["position"];
            if (Array.isArray(_data["lessons"])) {
                this.lessons = [] as any;
                for (let item of _data["lessons"])
                    this.lessons!.push(LessonViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChapterViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChapterViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["longDescription"] = this.longDescription;
        data["position"] = this.position;
        if (Array.isArray(this.lessons)) {
            data["lessons"] = [];
            for (let item of this.lessons)
                data["lessons"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChapterViewDto {
    id?: number;
    title?: string | undefined;
    description?: string | undefined;
    longDescription?: string | undefined;
    position?: number;
    lessons?: LessonViewDto[] | undefined;
}

export class LessonViewDto implements ILessonViewDto {
    id?: number;
    externalRef?: string | undefined;
    title?: string | undefined;
    text?: string | undefined;
    readMinutes?: number | undefined;
    isActive?: boolean;
    position?: number;
    isCompleted?: boolean;
    lastViewedSlideIndex?: number | undefined;
    furthestSlideIndex?: number | undefined;
    lastViewedDate?: Date | undefined;
    lessonType?: LessonType;
    attachments?: AttachmentDto[] | undefined;
    slides?: LessonSlideViewDto[] | undefined;

    constructor(data?: ILessonViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalRef = _data["externalRef"];
            this.title = _data["title"];
            this.text = _data["text"];
            this.readMinutes = _data["readMinutes"];
            this.isActive = _data["isActive"];
            this.position = _data["position"];
            this.isCompleted = _data["isCompleted"];
            this.lastViewedSlideIndex = _data["lastViewedSlideIndex"];
            this.furthestSlideIndex = _data["furthestSlideIndex"];
            this.lastViewedDate = _data["lastViewedDate"] ? new Date(_data["lastViewedDate"].toString()) : <any>undefined;
            this.lessonType = _data["lessonType"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            if (Array.isArray(_data["slides"])) {
                this.slides = [] as any;
                for (let item of _data["slides"])
                    this.slides!.push(LessonSlideViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LessonViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new LessonViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalRef"] = this.externalRef;
        data["title"] = this.title;
        data["text"] = this.text;
        data["readMinutes"] = this.readMinutes;
        data["isActive"] = this.isActive;
        data["position"] = this.position;
        data["isCompleted"] = this.isCompleted;
        data["lastViewedSlideIndex"] = this.lastViewedSlideIndex;
        data["furthestSlideIndex"] = this.furthestSlideIndex;
        data["lastViewedDate"] = this.lastViewedDate ? this.lastViewedDate.toISOString() : <any>undefined;
        data["lessonType"] = this.lessonType;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.slides)) {
            data["slides"] = [];
            for (let item of this.slides)
                data["slides"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILessonViewDto {
    id?: number;
    externalRef?: string | undefined;
    title?: string | undefined;
    text?: string | undefined;
    readMinutes?: number | undefined;
    isActive?: boolean;
    position?: number;
    isCompleted?: boolean;
    lastViewedSlideIndex?: number | undefined;
    furthestSlideIndex?: number | undefined;
    lastViewedDate?: Date | undefined;
    lessonType?: LessonType;
    attachments?: AttachmentDto[] | undefined;
    slides?: LessonSlideViewDto[] | undefined;
}

export class LessonSlideViewDto implements ILessonSlideViewDto {
    id?: number;
    position?: number;
    heading?: string | undefined;
    contentType?: SlideContentType;
    bodyHtml?: string | undefined;
    attachments?: AttachmentDto[] | undefined;

    constructor(data?: ILessonSlideViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.position = _data["position"];
            this.heading = _data["heading"];
            this.contentType = _data["contentType"];
            this.bodyHtml = _data["bodyHtml"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LessonSlideViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new LessonSlideViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["position"] = this.position;
        data["heading"] = this.heading;
        data["contentType"] = this.contentType;
        data["bodyHtml"] = this.bodyHtml;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILessonSlideViewDto {
    id?: number;
    position?: number;
    heading?: string | undefined;
    contentType?: SlideContentType;
    bodyHtml?: string | undefined;
    attachments?: AttachmentDto[] | undefined;
}

export class LicenceDto implements ILicenceDto {
    masterLicenceId?: number;
    licenceName?: string | undefined;
    singleLicenceId?: number;
    licenceStreamId?: number;
    licenceStreamName?: string | undefined;
    licenceNumber?: number;
    licenceCode?: string | undefined;
    codeCreationDate?: string | undefined;
    licenceIsActive?: boolean;
    licenceIsAssigned?: boolean;
    licenceExpiryDate?: string | undefined;
    deActivationDate?: string | undefined;
    userName?: string | undefined;
    emailAddress?: string | undefined;
    userIsActive?: string | undefined;
    firstLogonDate?: string | undefined;
    lastLogonDate?: string | undefined;

    constructor(data?: ILicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.masterLicenceId = _data["masterLicenceId"];
            this.licenceName = _data["licenceName"];
            this.singleLicenceId = _data["singleLicenceId"];
            this.licenceStreamId = _data["licenceStreamId"];
            this.licenceStreamName = _data["licenceStreamName"];
            this.licenceNumber = _data["licenceNumber"];
            this.licenceCode = _data["licenceCode"];
            this.codeCreationDate = _data["codeCreationDate"];
            this.licenceIsActive = _data["licenceIsActive"];
            this.licenceIsAssigned = _data["licenceIsAssigned"];
            this.licenceExpiryDate = _data["licenceExpiryDate"];
            this.deActivationDate = _data["deActivationDate"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.userIsActive = _data["userIsActive"];
            this.firstLogonDate = _data["firstLogonDate"];
            this.lastLogonDate = _data["lastLogonDate"];
        }
    }

    static fromJS(data: any): LicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterLicenceId"] = this.masterLicenceId;
        data["licenceName"] = this.licenceName;
        data["singleLicenceId"] = this.singleLicenceId;
        data["licenceStreamId"] = this.licenceStreamId;
        data["licenceStreamName"] = this.licenceStreamName;
        data["licenceNumber"] = this.licenceNumber;
        data["licenceCode"] = this.licenceCode;
        data["codeCreationDate"] = this.codeCreationDate;
        data["licenceIsActive"] = this.licenceIsActive;
        data["licenceIsAssigned"] = this.licenceIsAssigned;
        data["licenceExpiryDate"] = this.licenceExpiryDate;
        data["deActivationDate"] = this.deActivationDate;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["userIsActive"] = this.userIsActive;
        data["firstLogonDate"] = this.firstLogonDate;
        data["lastLogonDate"] = this.lastLogonDate;
        return data;
    }
}

export interface ILicenceDto {
    masterLicenceId?: number;
    licenceName?: string | undefined;
    singleLicenceId?: number;
    licenceStreamId?: number;
    licenceStreamName?: string | undefined;
    licenceNumber?: number;
    licenceCode?: string | undefined;
    codeCreationDate?: string | undefined;
    licenceIsActive?: boolean;
    licenceIsAssigned?: boolean;
    licenceExpiryDate?: string | undefined;
    deActivationDate?: string | undefined;
    userName?: string | undefined;
    emailAddress?: string | undefined;
    userIsActive?: string | undefined;
    firstLogonDate?: string | undefined;
    lastLogonDate?: string | undefined;
}

export class BaseTransportOfListOfMedicationDtoAndBaseError implements IBaseTransportOfListOfMedicationDtoAndBaseError {
    result?: MedicationDto[] | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfListOfMedicationDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(MedicationDto.fromJS(item));
            }
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfListOfMedicationDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfListOfMedicationDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfListOfMedicationDtoAndBaseError {
    result?: MedicationDto[] | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfListOfMedicationDto extends BaseTransportOfListOfMedicationDtoAndBaseError implements IResponseTransportOfListOfMedicationDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfListOfMedicationDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfListOfMedicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfListOfMedicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfListOfMedicationDto extends IBaseTransportOfListOfMedicationDtoAndBaseError {
    status?: ResponseStatus;
}

export abstract class BaseEntityOfInteger implements IBaseEntityOfInteger {
    id?: number;
    insertDate?: Date | undefined;
    insertLocalDate?: Date | undefined;

    constructor(data?: IBaseEntityOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.insertDate = _data["insertDate"] ? new Date(_data["insertDate"].toString()) : <any>undefined;
            this.insertLocalDate = _data["insertLocalDate"] ? new Date(_data["insertLocalDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseEntityOfInteger {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEntityOfInteger' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["insertDate"] = this.insertDate ? this.insertDate.toISOString() : <any>undefined;
        data["insertLocalDate"] = this.insertLocalDate ? this.insertLocalDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBaseEntityOfInteger {
    id?: number;
    insertDate?: Date | undefined;
    insertLocalDate?: Date | undefined;
}

export abstract class ActiveBaseEntityOfInteger extends BaseEntityOfInteger implements IActiveBaseEntityOfInteger {
    isActive?: boolean;
    diactivaterUserId?: number | undefined;
    updateTime?: Date | undefined;
    updateLocalDate?: Date | undefined;

    constructor(data?: IActiveBaseEntityOfInteger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isActive = _data["isActive"];
            this.diactivaterUserId = _data["diactivaterUserId"];
            this.updateTime = _data["updateTime"] ? new Date(_data["updateTime"].toString()) : <any>undefined;
            this.updateLocalDate = _data["updateLocalDate"] ? new Date(_data["updateLocalDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ActiveBaseEntityOfInteger {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ActiveBaseEntityOfInteger' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["diactivaterUserId"] = this.diactivaterUserId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateLocalDate"] = this.updateLocalDate ? this.updateLocalDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IActiveBaseEntityOfInteger extends IBaseEntityOfInteger {
    isActive?: boolean;
    diactivaterUserId?: number | undefined;
    updateTime?: Date | undefined;
    updateLocalDate?: Date | undefined;
}

export abstract class ActiveBaseEntity extends ActiveBaseEntityOfInteger implements IActiveBaseEntity {

    constructor(data?: IActiveBaseEntity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ActiveBaseEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ActiveBaseEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IActiveBaseEntity extends IActiveBaseEntityOfInteger {
}

export class MedicationDto extends ActiveBaseEntity implements IMedicationDto {
    brandName?: string | undefined;
    brandDescription?: string | undefined;
    medicationDoses?: MedicationDoseDto[] | undefined;

    constructor(data?: IMedicationDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.brandName = _data["brandName"];
            this.brandDescription = _data["brandDescription"];
            if (Array.isArray(_data["medicationDoses"])) {
                this.medicationDoses = [] as any;
                for (let item of _data["medicationDoses"])
                    this.medicationDoses!.push(MedicationDoseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandName"] = this.brandName;
        data["brandDescription"] = this.brandDescription;
        if (Array.isArray(this.medicationDoses)) {
            data["medicationDoses"] = [];
            for (let item of this.medicationDoses)
                data["medicationDoses"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMedicationDto extends IActiveBaseEntity {
    brandName?: string | undefined;
    brandDescription?: string | undefined;
    medicationDoses?: MedicationDoseDto[] | undefined;
}

export class MedicationDoseDto extends ActiveBaseEntity implements IMedicationDoseDto {
    medicationId?: number;
    medicationDoseCompositions?: MedicationDoseCompositionDto[] | undefined;

    constructor(data?: IMedicationDoseDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.medicationId = _data["medicationId"];
            if (Array.isArray(_data["medicationDoseCompositions"])) {
                this.medicationDoseCompositions = [] as any;
                for (let item of _data["medicationDoseCompositions"])
                    this.medicationDoseCompositions!.push(MedicationDoseCompositionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicationDoseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDoseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationId"] = this.medicationId;
        if (Array.isArray(this.medicationDoseCompositions)) {
            data["medicationDoseCompositions"] = [];
            for (let item of this.medicationDoseCompositions)
                data["medicationDoseCompositions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMedicationDoseDto extends IActiveBaseEntity {
    medicationId?: number;
    medicationDoseCompositions?: MedicationDoseCompositionDto[] | undefined;
}

export class MedicationDoseCompositionDto extends ActiveBaseEntity implements IMedicationDoseCompositionDto {
    medicationDoseId?: number;
    chemicalId?: number;
    chemical?: ChemicalDto | undefined;
    value?: number;
    doseUnitType?: DoseUnitType;

    constructor(data?: IMedicationDoseCompositionDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.medicationDoseId = _data["medicationDoseId"];
            this.chemicalId = _data["chemicalId"];
            this.chemical = _data["chemical"] ? ChemicalDto.fromJS(_data["chemical"]) : <any>undefined;
            this.value = _data["value"];
            this.doseUnitType = _data["doseUnitType"];
        }
    }

    static fromJS(data: any): MedicationDoseCompositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDoseCompositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationDoseId"] = this.medicationDoseId;
        data["chemicalId"] = this.chemicalId;
        data["chemical"] = this.chemical ? this.chemical.toJSON() : <any>undefined;
        data["value"] = this.value;
        data["doseUnitType"] = this.doseUnitType;
        super.toJSON(data);
        return data;
    }
}

export interface IMedicationDoseCompositionDto extends IActiveBaseEntity {
    medicationDoseId?: number;
    chemicalId?: number;
    chemical?: ChemicalDto | undefined;
    value?: number;
    doseUnitType?: DoseUnitType;
}

export class ChemicalDto extends ActiveBaseEntity implements IChemicalDto {
    name?: string | undefined;
    description?: string | undefined;
    categoryId?: number | undefined;
    category?: ChemicalCategoryDto | undefined;

    constructor(data?: IChemicalDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.categoryId = _data["categoryId"];
            this.category = _data["category"] ? ChemicalCategoryDto.fromJS(_data["category"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChemicalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChemicalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IChemicalDto extends IActiveBaseEntity {
    name?: string | undefined;
    description?: string | undefined;
    categoryId?: number | undefined;
    category?: ChemicalCategoryDto | undefined;
}

export class ChemicalCategoryDto extends ActiveBaseEntity implements IChemicalCategoryDto {
    name?: string | undefined;

    constructor(data?: IChemicalCategoryDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ChemicalCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChemicalCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface IChemicalCategoryDto extends IActiveBaseEntity {
    name?: string | undefined;
}

export class BaseTransportOfListOfMedicationListDtoAndBaseError implements IBaseTransportOfListOfMedicationListDtoAndBaseError {
    result?: MedicationListDto[] | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfListOfMedicationListDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(MedicationListDto.fromJS(item));
            }
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfListOfMedicationListDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfListOfMedicationListDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfListOfMedicationListDtoAndBaseError {
    result?: MedicationListDto[] | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfListOfMedicationListDto extends BaseTransportOfListOfMedicationListDtoAndBaseError implements IResponseTransportOfListOfMedicationListDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfListOfMedicationListDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfListOfMedicationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfListOfMedicationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfListOfMedicationListDto extends IBaseTransportOfListOfMedicationListDtoAndBaseError {
    status?: ResponseStatus;
}

export class MedicationListDto implements IMedicationListDto {
    name?: string | undefined;
    medicationDoseId?: number;

    constructor(data?: IMedicationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.medicationDoseId = _data["medicationDoseId"];
        }
    }

    static fromJS(data: any): MedicationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["medicationDoseId"] = this.medicationDoseId;
        return data;
    }
}

export interface IMedicationListDto {
    name?: string | undefined;
    medicationDoseId?: number;
}

export class BaseTransportOfMedicationAndBaseError implements IBaseTransportOfMedicationAndBaseError {
    result?: Medication | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfMedicationAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? Medication.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfMedicationAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfMedicationAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfMedicationAndBaseError {
    result?: Medication | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfMedication extends BaseTransportOfMedicationAndBaseError implements IResponseTransportOfMedication {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfMedication) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfMedication {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfMedication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfMedication extends IBaseTransportOfMedicationAndBaseError {
    status?: ResponseStatus;
}

export class Medication extends ActiveBaseEntity implements IMedication {
    brandName!: string;
    brandDescription?: string | undefined;
    userId?: number | undefined;
    user?: User | undefined;
    medicationDoses?: MedicationDose[] | undefined;

    constructor(data?: IMedication) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.brandName = _data["brandName"];
            this.brandDescription = _data["brandDescription"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["medicationDoses"])) {
                this.medicationDoses = [] as any;
                for (let item of _data["medicationDoses"])
                    this.medicationDoses!.push(MedicationDose.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Medication {
        data = typeof data === 'object' ? data : {};
        let result = new Medication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandName"] = this.brandName;
        data["brandDescription"] = this.brandDescription;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.medicationDoses)) {
            data["medicationDoses"] = [];
            for (let item of this.medicationDoses)
                data["medicationDoses"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMedication extends IActiveBaseEntity {
    brandName: string;
    brandDescription?: string | undefined;
    userId?: number | undefined;
    user?: User | undefined;
    medicationDoses?: MedicationDose[] | undefined;
}

export class User implements IUser {
    userId?: number;
    userGuid?: string;
    userName?: string | undefined;
    email?: string | undefined;
    isActive?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userRole?: string | undefined;
    insertDate?: Date;
    isAdmin?: boolean;
    is2FAEnabled?: boolean;
    preferredName?: string | undefined;
    userConfirmedEmail?: boolean;
    onboardingComplete?: boolean;
    communityUsername?: string | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userGuid = _data["userGuid"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.isActive = _data["isActive"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userRole = _data["userRole"];
            this.insertDate = _data["insertDate"] ? new Date(_data["insertDate"].toString()) : <any>undefined;
            this.isAdmin = _data["isAdmin"];
            this.is2FAEnabled = _data["is2FAEnabled"];
            this.preferredName = _data["preferredName"];
            this.userConfirmedEmail = _data["userConfirmedEmail"];
            this.onboardingComplete = _data["onboardingComplete"];
            this.communityUsername = _data["communityUsername"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userGuid"] = this.userGuid;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userRole"] = this.userRole;
        data["insertDate"] = this.insertDate ? this.insertDate.toISOString() : <any>undefined;
        data["isAdmin"] = this.isAdmin;
        data["is2FAEnabled"] = this.is2FAEnabled;
        data["preferredName"] = this.preferredName;
        data["userConfirmedEmail"] = this.userConfirmedEmail;
        data["onboardingComplete"] = this.onboardingComplete;
        data["communityUsername"] = this.communityUsername;
        return data;
    }
}

export interface IUser {
    userId?: number;
    userGuid?: string;
    userName?: string | undefined;
    email?: string | undefined;
    isActive?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userRole?: string | undefined;
    insertDate?: Date;
    isAdmin?: boolean;
    is2FAEnabled?: boolean;
    preferredName?: string | undefined;
    userConfirmedEmail?: boolean;
    onboardingComplete?: boolean;
    communityUsername?: string | undefined;
}

export class MedicationDose extends ActiveBaseEntity implements IMedicationDose {
    medicationId!: number;
    medication?: Medication | undefined;
    userId?: number | undefined;
    user?: User | undefined;
    medicationDoseCompositions?: MedicationDoseComposition[] | undefined;

    constructor(data?: IMedicationDose) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.medicationId = _data["medicationId"];
            this.medication = _data["medication"] ? Medication.fromJS(_data["medication"]) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["medicationDoseCompositions"])) {
                this.medicationDoseCompositions = [] as any;
                for (let item of _data["medicationDoseCompositions"])
                    this.medicationDoseCompositions!.push(MedicationDoseComposition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicationDose {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDose();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationId"] = this.medicationId;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.medicationDoseCompositions)) {
            data["medicationDoseCompositions"] = [];
            for (let item of this.medicationDoseCompositions)
                data["medicationDoseCompositions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMedicationDose extends IActiveBaseEntity {
    medicationId: number;
    medication?: Medication | undefined;
    userId?: number | undefined;
    user?: User | undefined;
    medicationDoseCompositions?: MedicationDoseComposition[] | undefined;
}

export class MedicationDoseComposition extends ActiveBaseEntity implements IMedicationDoseComposition {
    medicationDoseId!: number;
    medicationDose?: MedicationDose | undefined;
    chemicalId!: number;
    chemical?: Chemical | undefined;
    value!: number;
    doseUnitType!: DoseUnitType;
    userId?: number | undefined;
    user?: User | undefined;

    constructor(data?: IMedicationDoseComposition) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.medicationDoseId = _data["medicationDoseId"];
            this.medicationDose = _data["medicationDose"] ? MedicationDose.fromJS(_data["medicationDose"]) : <any>undefined;
            this.chemicalId = _data["chemicalId"];
            this.chemical = _data["chemical"] ? Chemical.fromJS(_data["chemical"]) : <any>undefined;
            this.value = _data["value"];
            this.doseUnitType = _data["doseUnitType"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MedicationDoseComposition {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDoseComposition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationDoseId"] = this.medicationDoseId;
        data["medicationDose"] = this.medicationDose ? this.medicationDose.toJSON() : <any>undefined;
        data["chemicalId"] = this.chemicalId;
        data["chemical"] = this.chemical ? this.chemical.toJSON() : <any>undefined;
        data["value"] = this.value;
        data["doseUnitType"] = this.doseUnitType;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMedicationDoseComposition extends IActiveBaseEntity {
    medicationDoseId: number;
    medicationDose?: MedicationDose | undefined;
    chemicalId: number;
    chemical?: Chemical | undefined;
    value: number;
    doseUnitType: DoseUnitType;
    userId?: number | undefined;
    user?: User | undefined;
}

export class Chemical extends ActiveBaseEntity implements IChemical {
    name!: string;
    description?: string | undefined;
    categoryId?: number | undefined;
    category?: ChemicalCategory | undefined;

    constructor(data?: IChemical) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.categoryId = _data["categoryId"];
            this.category = _data["category"] ? ChemicalCategory.fromJS(_data["category"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Chemical {
        data = typeof data === 'object' ? data : {};
        let result = new Chemical();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IChemical extends IActiveBaseEntity {
    name: string;
    description?: string | undefined;
    categoryId?: number | undefined;
    category?: ChemicalCategory | undefined;
}

export class ChemicalCategory extends ActiveBaseEntity implements IChemicalCategory {
    name!: string;

    constructor(data?: IChemicalCategory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ChemicalCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ChemicalCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface IChemicalCategory extends IActiveBaseEntity {
    name: string;
}

export class BaseTransportOfMedicationDtoAndBaseError implements IBaseTransportOfMedicationDtoAndBaseError {
    result?: MedicationDto | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfMedicationDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? MedicationDto.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfMedicationDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfMedicationDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfMedicationDtoAndBaseError {
    result?: MedicationDto | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfMedicationDto extends BaseTransportOfMedicationDtoAndBaseError implements IResponseTransportOfMedicationDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfMedicationDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfMedicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfMedicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfMedicationDto extends IBaseTransportOfMedicationDtoAndBaseError {
    status?: ResponseStatus;
}

export class BaseTransportOfListOfChemicalAndBaseError implements IBaseTransportOfListOfChemicalAndBaseError {
    result?: Chemical[] | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfListOfChemicalAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(Chemical.fromJS(item));
            }
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfListOfChemicalAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfListOfChemicalAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfListOfChemicalAndBaseError {
    result?: Chemical[] | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfListOfChemical extends BaseTransportOfListOfChemicalAndBaseError implements IResponseTransportOfListOfChemical {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfListOfChemical) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfListOfChemical {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfListOfChemical();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfListOfChemical extends IBaseTransportOfListOfChemicalAndBaseError {
    status?: ResponseStatus;
}

export class BaseTransportOfChemicalAndBaseError implements IBaseTransportOfChemicalAndBaseError {
    result?: Chemical | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfChemicalAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? Chemical.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfChemicalAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfChemicalAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfChemicalAndBaseError {
    result?: Chemical | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfChemical extends BaseTransportOfChemicalAndBaseError implements IResponseTransportOfChemical {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfChemical) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfChemical {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfChemical();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfChemical extends IBaseTransportOfChemicalAndBaseError {
    status?: ResponseStatus;
}

export class BaseTransportOfListOfChemicalCategoryAndBaseError implements IBaseTransportOfListOfChemicalCategoryAndBaseError {
    result?: ChemicalCategory[] | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfListOfChemicalCategoryAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(ChemicalCategory.fromJS(item));
            }
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfListOfChemicalCategoryAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfListOfChemicalCategoryAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfListOfChemicalCategoryAndBaseError {
    result?: ChemicalCategory[] | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfListOfChemicalCategory extends BaseTransportOfListOfChemicalCategoryAndBaseError implements IResponseTransportOfListOfChemicalCategory {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfListOfChemicalCategory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfListOfChemicalCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfListOfChemicalCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfListOfChemicalCategory extends IBaseTransportOfListOfChemicalCategoryAndBaseError {
    status?: ResponseStatus;
}

export class BaseTransportOfChemicalCategoryAndBaseError implements IBaseTransportOfChemicalCategoryAndBaseError {
    result?: ChemicalCategory | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfChemicalCategoryAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ChemicalCategory.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfChemicalCategoryAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfChemicalCategoryAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfChemicalCategoryAndBaseError {
    result?: ChemicalCategory | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfChemicalCategory extends BaseTransportOfChemicalCategoryAndBaseError implements IResponseTransportOfChemicalCategory {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfChemicalCategory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfChemicalCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfChemicalCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfChemicalCategory extends IBaseTransportOfChemicalCategoryAndBaseError {
    status?: ResponseStatus;
}

export class BaseTransportOfListOfMedicationDoseAndBaseError implements IBaseTransportOfListOfMedicationDoseAndBaseError {
    result?: MedicationDose[] | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfListOfMedicationDoseAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(MedicationDose.fromJS(item));
            }
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfListOfMedicationDoseAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfListOfMedicationDoseAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfListOfMedicationDoseAndBaseError {
    result?: MedicationDose[] | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfListOfMedicationDose extends BaseTransportOfListOfMedicationDoseAndBaseError implements IResponseTransportOfListOfMedicationDose {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfListOfMedicationDose) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfListOfMedicationDose {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfListOfMedicationDose();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfListOfMedicationDose extends IBaseTransportOfListOfMedicationDoseAndBaseError {
    status?: ResponseStatus;
}

export class BaseTransportOfMedicationDoseAndBaseError implements IBaseTransportOfMedicationDoseAndBaseError {
    result?: MedicationDose | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfMedicationDoseAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? MedicationDose.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfMedicationDoseAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfMedicationDoseAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfMedicationDoseAndBaseError {
    result?: MedicationDose | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfMedicationDose extends BaseTransportOfMedicationDoseAndBaseError implements IResponseTransportOfMedicationDose {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfMedicationDose) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfMedicationDose {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfMedicationDose();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfMedicationDose extends IBaseTransportOfMedicationDoseAndBaseError {
    status?: ResponseStatus;
}

export class BaseTransportOfMedicationDoseDtoAndBaseError implements IBaseTransportOfMedicationDoseDtoAndBaseError {
    result?: MedicationDoseDto | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfMedicationDoseDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? MedicationDoseDto.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfMedicationDoseDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfMedicationDoseDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfMedicationDoseDtoAndBaseError {
    result?: MedicationDoseDto | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfMedicationDoseDto extends BaseTransportOfMedicationDoseDtoAndBaseError implements IResponseTransportOfMedicationDoseDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfMedicationDoseDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfMedicationDoseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfMedicationDoseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfMedicationDoseDto extends IBaseTransportOfMedicationDoseDtoAndBaseError {
    status?: ResponseStatus;
}

export class BaseTransportOfListOfMedicationDoseCompositionAndBaseError implements IBaseTransportOfListOfMedicationDoseCompositionAndBaseError {
    result?: MedicationDoseComposition[] | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfListOfMedicationDoseCompositionAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(MedicationDoseComposition.fromJS(item));
            }
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfListOfMedicationDoseCompositionAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfListOfMedicationDoseCompositionAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfListOfMedicationDoseCompositionAndBaseError {
    result?: MedicationDoseComposition[] | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfListOfMedicationDoseComposition extends BaseTransportOfListOfMedicationDoseCompositionAndBaseError implements IResponseTransportOfListOfMedicationDoseComposition {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfListOfMedicationDoseComposition) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfListOfMedicationDoseComposition {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfListOfMedicationDoseComposition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfListOfMedicationDoseComposition extends IBaseTransportOfListOfMedicationDoseCompositionAndBaseError {
    status?: ResponseStatus;
}

export class BaseTransportOfMedicationDoseCompositionAndBaseError implements IBaseTransportOfMedicationDoseCompositionAndBaseError {
    result?: MedicationDoseComposition | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfMedicationDoseCompositionAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? MedicationDoseComposition.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfMedicationDoseCompositionAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfMedicationDoseCompositionAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfMedicationDoseCompositionAndBaseError {
    result?: MedicationDoseComposition | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfMedicationDoseComposition extends BaseTransportOfMedicationDoseCompositionAndBaseError implements IResponseTransportOfMedicationDoseComposition {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfMedicationDoseComposition) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfMedicationDoseComposition {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfMedicationDoseComposition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfMedicationDoseComposition extends IBaseTransportOfMedicationDoseCompositionAndBaseError {
    status?: ResponseStatus;
}

export class MessageDbResponse implements IMessageDbResponse {
    applicationMessageId?: number;
    titleText?: string | undefined;
    bodyText?: string | undefined;

    constructor(data?: IMessageDbResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationMessageId = _data["applicationMessageId"];
            this.titleText = _data["titleText"];
            this.bodyText = _data["bodyText"];
        }
    }

    static fromJS(data: any): MessageDbResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDbResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationMessageId"] = this.applicationMessageId;
        data["titleText"] = this.titleText;
        data["bodyText"] = this.bodyText;
        return data;
    }
}

export interface IMessageDbResponse {
    applicationMessageId?: number;
    titleText?: string | undefined;
    bodyText?: string | undefined;
}

export class NavigationEventRequest implements INavigationEventRequest {
    fromScreen?: string | undefined;
    toScreen?: string | undefined;
    triggerType?: NavigationTriggerType;
    eventName?: string | undefined;
    correlationId?: string | undefined;

    constructor(data?: INavigationEventRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromScreen = _data["fromScreen"];
            this.toScreen = _data["toScreen"];
            this.triggerType = _data["triggerType"];
            this.eventName = _data["eventName"];
            this.correlationId = _data["correlationId"];
        }
    }

    static fromJS(data: any): NavigationEventRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NavigationEventRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromScreen"] = this.fromScreen;
        data["toScreen"] = this.toScreen;
        data["triggerType"] = this.triggerType;
        data["eventName"] = this.eventName;
        data["correlationId"] = this.correlationId;
        return data;
    }
}

export interface INavigationEventRequest {
    fromScreen?: string | undefined;
    toScreen?: string | undefined;
    triggerType?: NavigationTriggerType;
    eventName?: string | undefined;
    correlationId?: string | undefined;
}

export enum NavigationTriggerType {
    ViaNavigation = 1,
    InPageNav = 2,
    RouteChange = 3,
}

export class ResponseModelOfNotificationBellResponse implements IResponseModelOfNotificationBellResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: NotificationBellResponse | undefined;

    constructor(data?: IResponseModelOfNotificationBellResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? NotificationBellResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfNotificationBellResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfNotificationBellResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfNotificationBellResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: NotificationBellResponse | undefined;
}

export class NotificationBellResponse implements INotificationBellResponse {
    total?: number;
    score?: BellScoreItem | undefined;
    plan?: BellPlanItem | undefined;
    bites?: BellBiteItem[] | undefined;
    community?: BellCommunityItem[] | undefined;

    constructor(data?: INotificationBellResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.score = _data["score"] ? BellScoreItem.fromJS(_data["score"]) : <any>undefined;
            this.plan = _data["plan"] ? BellPlanItem.fromJS(_data["plan"]) : <any>undefined;
            if (Array.isArray(_data["bites"])) {
                this.bites = [] as any;
                for (let item of _data["bites"])
                    this.bites!.push(BellBiteItem.fromJS(item));
            }
            if (Array.isArray(_data["community"])) {
                this.community = [] as any;
                for (let item of _data["community"])
                    this.community!.push(BellCommunityItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationBellResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationBellResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["score"] = this.score ? this.score.toJSON() : <any>undefined;
        data["plan"] = this.plan ? this.plan.toJSON() : <any>undefined;
        if (Array.isArray(this.bites)) {
            data["bites"] = [];
            for (let item of this.bites)
                data["bites"].push(item.toJSON());
        }
        if (Array.isArray(this.community)) {
            data["community"] = [];
            for (let item of this.community)
                data["community"].push(item.toJSON());
        }
        return data;
    }
}

export interface INotificationBellResponse {
    total?: number;
    score?: BellScoreItem | undefined;
    plan?: BellPlanItem | undefined;
    bites?: BellBiteItem[] | undefined;
    community?: BellCommunityItem[] | undefined;
}

export class BellScoreItem implements IBellScoreItem {
    notificationLogIds?: number[] | undefined;
    receivedUtc?: Date;

    constructor(data?: IBellScoreItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notificationLogIds"])) {
                this.notificationLogIds = [] as any;
                for (let item of _data["notificationLogIds"])
                    this.notificationLogIds!.push(item);
            }
            this.receivedUtc = _data["receivedUtc"] ? new Date(_data["receivedUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BellScoreItem {
        data = typeof data === 'object' ? data : {};
        let result = new BellScoreItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notificationLogIds)) {
            data["notificationLogIds"] = [];
            for (let item of this.notificationLogIds)
                data["notificationLogIds"].push(item);
        }
        data["receivedUtc"] = this.receivedUtc ? this.receivedUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBellScoreItem {
    notificationLogIds?: number[] | undefined;
    receivedUtc?: Date;
}

export class BellPlanItem implements IBellPlanItem {
    notificationLogIds?: number[] | undefined;
    receivedUtc?: Date;

    constructor(data?: IBellPlanItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notificationLogIds"])) {
                this.notificationLogIds = [] as any;
                for (let item of _data["notificationLogIds"])
                    this.notificationLogIds!.push(item);
            }
            this.receivedUtc = _data["receivedUtc"] ? new Date(_data["receivedUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BellPlanItem {
        data = typeof data === 'object' ? data : {};
        let result = new BellPlanItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notificationLogIds)) {
            data["notificationLogIds"] = [];
            for (let item of this.notificationLogIds)
                data["notificationLogIds"].push(item);
        }
        data["receivedUtc"] = this.receivedUtc ? this.receivedUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBellPlanItem {
    notificationLogIds?: number[] | undefined;
    receivedUtc?: Date;
}

export class BellBiteItem implements IBellBiteItem {
    notificationLogIds?: number[] | undefined;
    biteId?: number;
    text?: string | undefined;
    receivedUtc?: Date;

    constructor(data?: IBellBiteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notificationLogIds"])) {
                this.notificationLogIds = [] as any;
                for (let item of _data["notificationLogIds"])
                    this.notificationLogIds!.push(item);
            }
            this.biteId = _data["biteId"];
            this.text = _data["text"];
            this.receivedUtc = _data["receivedUtc"] ? new Date(_data["receivedUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BellBiteItem {
        data = typeof data === 'object' ? data : {};
        let result = new BellBiteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notificationLogIds)) {
            data["notificationLogIds"] = [];
            for (let item of this.notificationLogIds)
                data["notificationLogIds"].push(item);
        }
        data["biteId"] = this.biteId;
        data["text"] = this.text;
        data["receivedUtc"] = this.receivedUtc ? this.receivedUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBellBiteItem {
    notificationLogIds?: number[] | undefined;
    biteId?: number;
    text?: string | undefined;
    receivedUtc?: Date;
}

export class BellCommunityItem implements IBellCommunityItem {
    notificationLogIds?: number[] | undefined;
    title?: string | undefined;
    body?: string | undefined;
    deepLink?: string | undefined;
    receivedUtc?: Date;

    constructor(data?: IBellCommunityItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notificationLogIds"])) {
                this.notificationLogIds = [] as any;
                for (let item of _data["notificationLogIds"])
                    this.notificationLogIds!.push(item);
            }
            this.title = _data["title"];
            this.body = _data["body"];
            this.deepLink = _data["deepLink"];
            this.receivedUtc = _data["receivedUtc"] ? new Date(_data["receivedUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BellCommunityItem {
        data = typeof data === 'object' ? data : {};
        let result = new BellCommunityItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notificationLogIds)) {
            data["notificationLogIds"] = [];
            for (let item of this.notificationLogIds)
                data["notificationLogIds"].push(item);
        }
        data["title"] = this.title;
        data["body"] = this.body;
        data["deepLink"] = this.deepLink;
        data["receivedUtc"] = this.receivedUtc ? this.receivedUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBellCommunityItem {
    notificationLogIds?: number[] | undefined;
    title?: string | undefined;
    body?: string | undefined;
    deepLink?: string | undefined;
    receivedUtc?: Date;
}

export class ResponseModelOfInteger implements IResponseModelOfInteger {
    resultStatus?: ResultStatus | undefined;
    responseData?: number;

    constructor(data?: IResponseModelOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"];
        }
    }

    static fromJS(data: any): ResponseModelOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData;
        return data;
    }
}

export interface IResponseModelOfInteger {
    resultStatus?: ResultStatus | undefined;
    responseData?: number;
}

export class MarkSeenRequest implements IMarkSeenRequest {
    notificationLogIds?: number[] | undefined;
    target?: string | undefined;

    constructor(data?: IMarkSeenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notificationLogIds"])) {
                this.notificationLogIds = [] as any;
                for (let item of _data["notificationLogIds"])
                    this.notificationLogIds!.push(item);
            }
            this.target = _data["target"];
        }
    }

    static fromJS(data: any): MarkSeenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkSeenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notificationLogIds)) {
            data["notificationLogIds"] = [];
            for (let item of this.notificationLogIds)
                data["notificationLogIds"].push(item);
        }
        data["target"] = this.target;
        return data;
    }
}

export interface IMarkSeenRequest {
    notificationLogIds?: number[] | undefined;
    target?: string | undefined;
}

export class InsightCardDto implements IInsightCardDto {
    category?: string | undefined;
    snackbarTitle?: string | undefined;
    snackbarSentence?: string | undefined;
    expandedTitle?: string | undefined;
    noticed?: string | undefined;
    matters?: string | undefined;
    question?: string | undefined;
    action?: string | undefined;
    actionTargetLesson?: string | undefined;
    actionTargetId?: string | undefined;

    constructor(data?: IInsightCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.snackbarTitle = _data["snackbarTitle"];
            this.snackbarSentence = _data["snackbarSentence"];
            this.expandedTitle = _data["expandedTitle"];
            this.noticed = _data["noticed"];
            this.matters = _data["matters"];
            this.question = _data["question"];
            this.action = _data["action"];
            this.actionTargetLesson = _data["actionTargetLesson"];
            this.actionTargetId = _data["actionTargetId"];
        }
    }

    static fromJS(data: any): InsightCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsightCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["snackbarTitle"] = this.snackbarTitle;
        data["snackbarSentence"] = this.snackbarSentence;
        data["expandedTitle"] = this.expandedTitle;
        data["noticed"] = this.noticed;
        data["matters"] = this.matters;
        data["question"] = this.question;
        data["action"] = this.action;
        data["actionTargetLesson"] = this.actionTargetLesson;
        data["actionTargetId"] = this.actionTargetId;
        return data;
    }
}

export interface IInsightCardDto {
    category?: string | undefined;
    snackbarTitle?: string | undefined;
    snackbarSentence?: string | undefined;
    expandedTitle?: string | undefined;
    noticed?: string | undefined;
    matters?: string | undefined;
    question?: string | undefined;
    action?: string | undefined;
    actionTargetLesson?: string | undefined;
    actionTargetId?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = (<any>this.extensions)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export class NovaRecordInsightShownRequest implements INovaRecordInsightShownRequest {
    category?: string | undefined;
    expandedTitle?: string | undefined;
    snackbarTitle?: string | undefined;
    noticed?: string | undefined;
    matters?: string | undefined;
    question?: string | undefined;
    action?: string | undefined;

    constructor(data?: INovaRecordInsightShownRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.expandedTitle = _data["expandedTitle"];
            this.snackbarTitle = _data["snackbarTitle"];
            this.noticed = _data["noticed"];
            this.matters = _data["matters"];
            this.question = _data["question"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): NovaRecordInsightShownRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NovaRecordInsightShownRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["expandedTitle"] = this.expandedTitle;
        data["snackbarTitle"] = this.snackbarTitle;
        data["noticed"] = this.noticed;
        data["matters"] = this.matters;
        data["question"] = this.question;
        data["action"] = this.action;
        return data;
    }
}

export interface INovaRecordInsightShownRequest {
    category?: string | undefined;
    expandedTitle?: string | undefined;
    snackbarTitle?: string | undefined;
    noticed?: string | undefined;
    matters?: string | undefined;
    question?: string | undefined;
    action?: string | undefined;
}

export class NovaChatContextResponse implements INovaChatContextResponse {
    firstName?: string | undefined;
    bufferBand?: string | undefined;
    conversationIdleMinutes?: number;
    realtimeEnabled?: boolean;

    constructor(data?: INovaChatContextResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.bufferBand = _data["bufferBand"];
            this.conversationIdleMinutes = _data["conversationIdleMinutes"];
            this.realtimeEnabled = _data["realtimeEnabled"];
        }
    }

    static fromJS(data: any): NovaChatContextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NovaChatContextResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["bufferBand"] = this.bufferBand;
        data["conversationIdleMinutes"] = this.conversationIdleMinutes;
        data["realtimeEnabled"] = this.realtimeEnabled;
        return data;
    }
}

export interface INovaChatContextResponse {
    firstName?: string | undefined;
    bufferBand?: string | undefined;
    conversationIdleMinutes?: number;
    realtimeEnabled?: boolean;
}

export class NovaChatHistoryResponse implements INovaChatHistoryResponse {
    turns?: NovaChatHistoryTurn[] | undefined;

    constructor(data?: INovaChatHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["turns"])) {
                this.turns = [] as any;
                for (let item of _data["turns"])
                    this.turns!.push(NovaChatHistoryTurn.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NovaChatHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NovaChatHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.turns)) {
            data["turns"] = [];
            for (let item of this.turns)
                data["turns"].push(item.toJSON());
        }
        return data;
    }
}

export interface INovaChatHistoryResponse {
    turns?: NovaChatHistoryTurn[] | undefined;
}

export class NovaChatHistoryTurn implements INovaChatHistoryTurn {
    role?: string | undefined;
    content?: string | undefined;
    occurredAt?: Date;
    conversationId?: string | undefined;

    constructor(data?: INovaChatHistoryTurn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.content = _data["content"];
            this.occurredAt = _data["occurredAt"] ? new Date(_data["occurredAt"].toString()) : <any>undefined;
            this.conversationId = _data["conversationId"];
        }
    }

    static fromJS(data: any): NovaChatHistoryTurn {
        data = typeof data === 'object' ? data : {};
        let result = new NovaChatHistoryTurn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["content"] = this.content;
        data["occurredAt"] = this.occurredAt ? this.occurredAt.toISOString() : <any>undefined;
        data["conversationId"] = this.conversationId;
        return data;
    }
}

export interface INovaChatHistoryTurn {
    role?: string | undefined;
    content?: string | undefined;
    occurredAt?: Date;
    conversationId?: string | undefined;
}

export class NovaChipsResponse implements INovaChipsResponse {
    chips?: string[] | undefined;

    constructor(data?: INovaChipsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["chips"])) {
                this.chips = [] as any;
                for (let item of _data["chips"])
                    this.chips!.push(item);
            }
        }
    }

    static fromJS(data: any): NovaChipsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NovaChipsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.chips)) {
            data["chips"] = [];
            for (let item of this.chips)
                data["chips"].push(item);
        }
        return data;
    }
}

export interface INovaChipsResponse {
    chips?: string[] | undefined;
}

export class NovaSendMessageResponse implements INovaSendMessageResponse {
    reply?: string | undefined;
    safetyEscalationTriggered?: boolean;
    nav?: NovaNavigationTarget | undefined;

    constructor(data?: INovaSendMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reply = _data["reply"];
            this.safetyEscalationTriggered = _data["safetyEscalationTriggered"];
            this.nav = _data["nav"] ? NovaNavigationTarget.fromJS(_data["nav"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NovaSendMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NovaSendMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reply"] = this.reply;
        data["safetyEscalationTriggered"] = this.safetyEscalationTriggered;
        data["nav"] = this.nav ? this.nav.toJSON() : <any>undefined;
        return data;
    }
}

export interface INovaSendMessageResponse {
    reply?: string | undefined;
    safetyEscalationTriggered?: boolean;
    nav?: NovaNavigationTarget | undefined;
}

export class NovaNavigationTarget implements INovaNavigationTarget {
    area?: string | undefined;
    route?: string | undefined;
    kind?: string | undefined;
    targetId?: number;
    title?: string | undefined;

    constructor(data?: INovaNavigationTarget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.area = _data["area"];
            this.route = _data["route"];
            this.kind = _data["kind"];
            this.targetId = _data["targetId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): NovaNavigationTarget {
        data = typeof data === 'object' ? data : {};
        let result = new NovaNavigationTarget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["area"] = this.area;
        data["route"] = this.route;
        data["kind"] = this.kind;
        data["targetId"] = this.targetId;
        data["title"] = this.title;
        return data;
    }
}

export interface INovaNavigationTarget {
    area?: string | undefined;
    route?: string | undefined;
    kind?: string | undefined;
    targetId?: number;
    title?: string | undefined;
}

export class NovaSendMessageRequest implements INovaSendMessageRequest {
    messages?: NovaChatMessage[] | undefined;
    voice?: boolean;
    walkthrough?: NovaWalkthroughState | undefined;
    device?: string | undefined;

    constructor(data?: INovaSendMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(NovaChatMessage.fromJS(item));
            }
            this.voice = _data["voice"];
            this.walkthrough = _data["walkthrough"] ? NovaWalkthroughState.fromJS(_data["walkthrough"]) : <any>undefined;
            this.device = _data["device"];
        }
    }

    static fromJS(data: any): NovaSendMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NovaSendMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["voice"] = this.voice;
        data["walkthrough"] = this.walkthrough ? this.walkthrough.toJSON() : <any>undefined;
        data["device"] = this.device;
        return data;
    }
}

export interface INovaSendMessageRequest {
    messages?: NovaChatMessage[] | undefined;
    voice?: boolean;
    walkthrough?: NovaWalkthroughState | undefined;
    device?: string | undefined;
}

export class NovaChatMessage implements INovaChatMessage {
    role?: string | undefined;
    content?: string | undefined;

    constructor(data?: INovaChatMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): NovaChatMessage {
        data = typeof data === 'object' ? data : {};
        let result = new NovaChatMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["content"] = this.content;
        return data;
    }
}

export interface INovaChatMessage {
    role?: string | undefined;
    content?: string | undefined;
}

export class NovaWalkthroughState implements INovaWalkthroughState {
    walkthroughId?: string | undefined;
    currentStepId?: string | undefined;
    armedStepId?: string | undefined;
    paused?: boolean;

    constructor(data?: INovaWalkthroughState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.walkthroughId = _data["walkthroughId"];
            this.currentStepId = _data["currentStepId"];
            this.armedStepId = _data["armedStepId"];
            this.paused = _data["paused"];
        }
    }

    static fromJS(data: any): NovaWalkthroughState {
        data = typeof data === 'object' ? data : {};
        let result = new NovaWalkthroughState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walkthroughId"] = this.walkthroughId;
        data["currentStepId"] = this.currentStepId;
        data["armedStepId"] = this.armedStepId;
        data["paused"] = this.paused;
        return data;
    }
}

export interface INovaWalkthroughState {
    walkthroughId?: string | undefined;
    currentStepId?: string | undefined;
    armedStepId?: string | undefined;
    paused?: boolean;
}

export class NovaWarmUpResponse implements INovaWarmUpResponse {
    enabled?: boolean;
    digestPrimed?: boolean;
    promptCachePrimed?: boolean;
    speechPrimed?: boolean;
    elapsedMs?: number;

    constructor(data?: INovaWarmUpResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.digestPrimed = _data["digestPrimed"];
            this.promptCachePrimed = _data["promptCachePrimed"];
            this.speechPrimed = _data["speechPrimed"];
            this.elapsedMs = _data["elapsedMs"];
        }
    }

    static fromJS(data: any): NovaWarmUpResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NovaWarmUpResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["digestPrimed"] = this.digestPrimed;
        data["promptCachePrimed"] = this.promptCachePrimed;
        data["speechPrimed"] = this.speechPrimed;
        data["elapsedMs"] = this.elapsedMs;
        return data;
    }
}

export interface INovaWarmUpResponse {
    enabled?: boolean;
    digestPrimed?: boolean;
    promptCachePrimed?: boolean;
    speechPrimed?: boolean;
    elapsedMs?: number;
}

export class NovaSpeakRequest implements INovaSpeakRequest {
    text?: string | undefined;

    constructor(data?: INovaSpeakRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): NovaSpeakRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NovaSpeakRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        return data;
    }
}

export interface INovaSpeakRequest {
    text?: string | undefined;
}

export class NovaRealtimeSessionResponse implements INovaRealtimeSessionResponse {
    clientSecret?: string | undefined;
    expiresAt?: Date;
    conversationId?: string;
    model?: string | undefined;
    maxSessionMinutes?: number;
    sessionId?: string;

    constructor(data?: INovaRealtimeSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientSecret = _data["clientSecret"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.conversationId = _data["conversationId"];
            this.model = _data["model"];
            this.maxSessionMinutes = _data["maxSessionMinutes"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): NovaRealtimeSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NovaRealtimeSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientSecret"] = this.clientSecret;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["conversationId"] = this.conversationId;
        data["model"] = this.model;
        data["maxSessionMinutes"] = this.maxSessionMinutes;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface INovaRealtimeSessionResponse {
    clientSecret?: string | undefined;
    expiresAt?: Date;
    conversationId?: string;
    model?: string | undefined;
    maxSessionMinutes?: number;
    sessionId?: string;
}

export class NovaRealtimeRefusalResponse implements INovaRealtimeRefusalResponse {
    reason?: string | undefined;
    message?: string | undefined;
    retryAfterSeconds?: number;

    constructor(data?: INovaRealtimeRefusalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.message = _data["message"];
            this.retryAfterSeconds = _data["retryAfterSeconds"];
        }
    }

    static fromJS(data: any): NovaRealtimeRefusalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NovaRealtimeRefusalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["message"] = this.message;
        data["retryAfterSeconds"] = this.retryAfterSeconds;
        return data;
    }
}

export interface INovaRealtimeRefusalResponse {
    reason?: string | undefined;
    message?: string | undefined;
    retryAfterSeconds?: number;
}

export class NovaRealtimeEndSessionResponse implements INovaRealtimeEndSessionResponse {
    closed?: boolean;
    durationSeconds?: number;

    constructor(data?: INovaRealtimeEndSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.closed = _data["closed"];
            this.durationSeconds = _data["durationSeconds"];
        }
    }

    static fromJS(data: any): NovaRealtimeEndSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NovaRealtimeEndSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["closed"] = this.closed;
        data["durationSeconds"] = this.durationSeconds;
        return data;
    }
}

export interface INovaRealtimeEndSessionResponse {
    closed?: boolean;
    durationSeconds?: number;
}

export class NovaRealtimeEndSessionRequest implements INovaRealtimeEndSessionRequest {
    sessionId?: string;
    reason?: string | undefined;

    constructor(data?: INovaRealtimeEndSessionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): NovaRealtimeEndSessionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NovaRealtimeEndSessionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface INovaRealtimeEndSessionRequest {
    sessionId?: string;
    reason?: string | undefined;
}

export class NovaLogEventsResponse implements INovaLogEventsResponse {
    accepted?: number;
    dropped?: number;

    constructor(data?: INovaLogEventsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accepted = _data["accepted"];
            this.dropped = _data["dropped"];
        }
    }

    static fromJS(data: any): NovaLogEventsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NovaLogEventsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accepted"] = this.accepted;
        data["dropped"] = this.dropped;
        return data;
    }
}

export interface INovaLogEventsResponse {
    accepted?: number;
    dropped?: number;
}

export class NovaLogEventsRequest implements INovaLogEventsRequest {
    events?: NovaClientLogEvent[] | undefined;

    constructor(data?: INovaLogEventsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(NovaClientLogEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NovaLogEventsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NovaLogEventsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data;
    }
}

export interface INovaLogEventsRequest {
    events?: NovaClientLogEvent[] | undefined;
}

export class NovaClientLogEvent implements INovaClientLogEvent {
    timestamp?: Date | undefined;
    level?: string | undefined;
    event?: string | undefined;
    sessionId?: string | undefined;
    transport?: string | undefined;
    message?: string | undefined;
    properties?: { [key: string]: any; } | undefined;

    constructor(data?: INovaClientLogEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.level = _data["level"];
            this.event = _data["event"];
            this.sessionId = _data["sessionId"];
            this.transport = _data["transport"];
            this.message = _data["message"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NovaClientLogEvent {
        data = typeof data === 'object' ? data : {};
        let result = new NovaClientLogEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["level"] = this.level;
        data["event"] = this.event;
        data["sessionId"] = this.sessionId;
        data["transport"] = this.transport;
        data["message"] = this.message;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        return data;
    }
}

export interface INovaClientLogEvent {
    timestamp?: Date | undefined;
    level?: string | undefined;
    event?: string | undefined;
    sessionId?: string | undefined;
    transport?: string | undefined;
    message?: string | undefined;
    properties?: { [key: string]: any; } | undefined;
}

export class NovaWalkthroughSliceResponse implements INovaWalkthroughSliceResponse {
    walkthroughSteps?: NovaWalkthroughStep[] | undefined;
    walkthroughNextArea?: string | undefined;

    constructor(data?: INovaWalkthroughSliceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["walkthroughSteps"])) {
                this.walkthroughSteps = [] as any;
                for (let item of _data["walkthroughSteps"])
                    this.walkthroughSteps!.push(NovaWalkthroughStep.fromJS(item));
            }
            this.walkthroughNextArea = _data["walkthroughNextArea"];
        }
    }

    static fromJS(data: any): NovaWalkthroughSliceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NovaWalkthroughSliceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.walkthroughSteps)) {
            data["walkthroughSteps"] = [];
            for (let item of this.walkthroughSteps)
                data["walkthroughSteps"].push(item.toJSON());
        }
        data["walkthroughNextArea"] = this.walkthroughNextArea;
        return data;
    }
}

export interface INovaWalkthroughSliceResponse {
    walkthroughSteps?: NovaWalkthroughStep[] | undefined;
    walkthroughNextArea?: string | undefined;
}

export class NovaWalkthroughStep implements INovaWalkthroughStep {
    id?: string | undefined;
    walkthrough?: string | undefined;
    order?: number;
    area?: string | undefined;
    route?: string | undefined;
    screen?: string | undefined;
    instruction?: string | undefined;
    expect?: string | undefined;
    nav?: any | undefined;
    branch?: any | undefined;
    location?: string | undefined;

    constructor(data?: INovaWalkthroughStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.walkthrough = _data["walkthrough"];
            this.order = _data["order"];
            this.area = _data["area"];
            this.route = _data["route"];
            this.screen = _data["screen"];
            this.instruction = _data["instruction"];
            this.expect = _data["expect"];
            this.nav = _data["nav"];
            this.branch = _data["branch"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): NovaWalkthroughStep {
        data = typeof data === 'object' ? data : {};
        let result = new NovaWalkthroughStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["walkthrough"] = this.walkthrough;
        data["order"] = this.order;
        data["area"] = this.area;
        data["route"] = this.route;
        data["screen"] = this.screen;
        data["instruction"] = this.instruction;
        data["expect"] = this.expect;
        data["nav"] = this.nav;
        data["branch"] = this.branch;
        data["location"] = this.location;
        return data;
    }
}

export interface INovaWalkthroughStep {
    id?: string | undefined;
    walkthrough?: string | undefined;
    order?: number;
    area?: string | undefined;
    route?: string | undefined;
    screen?: string | undefined;
    instruction?: string | undefined;
    expect?: string | undefined;
    nav?: any | undefined;
    branch?: any | undefined;
    location?: string | undefined;
}

export class NovaWalkthroughSliceRequest implements INovaWalkthroughSliceRequest {
    walkthroughId?: string | undefined;
    location?: string | undefined;

    constructor(data?: INovaWalkthroughSliceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.walkthroughId = _data["walkthroughId"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): NovaWalkthroughSliceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NovaWalkthroughSliceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walkthroughId"] = this.walkthroughId;
        data["location"] = this.location;
        return data;
    }
}

export interface INovaWalkthroughSliceRequest {
    walkthroughId?: string | undefined;
    location?: string | undefined;
}

export class NovaRealtimeEventResponse implements INovaRealtimeEventResponse {
    recorded?: boolean;
    duplicate?: boolean;
    nav?: NovaNavigationTarget | undefined;
    walkthroughSteps?: NovaWalkthroughStep[] | undefined;
    walkthroughNextArea?: string | undefined;
    functionCallOutput?: string | undefined;
    callId?: string | undefined;
    safetyEscalationTriggered?: boolean;
    sessionTerminated?: boolean;
    message?: string | undefined;

    constructor(data?: INovaRealtimeEventResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recorded = _data["recorded"];
            this.duplicate = _data["duplicate"];
            this.nav = _data["nav"] ? NovaNavigationTarget.fromJS(_data["nav"]) : <any>undefined;
            if (Array.isArray(_data["walkthroughSteps"])) {
                this.walkthroughSteps = [] as any;
                for (let item of _data["walkthroughSteps"])
                    this.walkthroughSteps!.push(NovaWalkthroughStep.fromJS(item));
            }
            this.walkthroughNextArea = _data["walkthroughNextArea"];
            this.functionCallOutput = _data["functionCallOutput"];
            this.callId = _data["callId"];
            this.safetyEscalationTriggered = _data["safetyEscalationTriggered"];
            this.sessionTerminated = _data["sessionTerminated"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): NovaRealtimeEventResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NovaRealtimeEventResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recorded"] = this.recorded;
        data["duplicate"] = this.duplicate;
        data["nav"] = this.nav ? this.nav.toJSON() : <any>undefined;
        if (Array.isArray(this.walkthroughSteps)) {
            data["walkthroughSteps"] = [];
            for (let item of this.walkthroughSteps)
                data["walkthroughSteps"].push(item.toJSON());
        }
        data["walkthroughNextArea"] = this.walkthroughNextArea;
        data["functionCallOutput"] = this.functionCallOutput;
        data["callId"] = this.callId;
        data["safetyEscalationTriggered"] = this.safetyEscalationTriggered;
        data["sessionTerminated"] = this.sessionTerminated;
        data["message"] = this.message;
        return data;
    }
}

export interface INovaRealtimeEventResponse {
    recorded?: boolean;
    duplicate?: boolean;
    nav?: NovaNavigationTarget | undefined;
    walkthroughSteps?: NovaWalkthroughStep[] | undefined;
    walkthroughNextArea?: string | undefined;
    functionCallOutput?: string | undefined;
    callId?: string | undefined;
    safetyEscalationTriggered?: boolean;
    sessionTerminated?: boolean;
    message?: string | undefined;
}

export class NovaRealtimeEventRequest implements INovaRealtimeEventRequest {
    sessionId?: string;
    conversationId?: string;
    type?: string | undefined;
    itemId?: string | undefined;
    transcript?: string | undefined;
    functionName?: string | undefined;
    arguments?: string | undefined;
    callId?: string | undefined;
    turnId?: number | undefined;
    device?: string | undefined;

    constructor(data?: INovaRealtimeEventRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.conversationId = _data["conversationId"];
            this.type = _data["type"];
            this.itemId = _data["itemId"];
            this.transcript = _data["transcript"];
            this.functionName = _data["functionName"];
            this.arguments = _data["arguments"];
            this.callId = _data["callId"];
            this.turnId = _data["turnId"];
            this.device = _data["device"];
        }
    }

    static fromJS(data: any): NovaRealtimeEventRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NovaRealtimeEventRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["conversationId"] = this.conversationId;
        data["type"] = this.type;
        data["itemId"] = this.itemId;
        data["transcript"] = this.transcript;
        data["functionName"] = this.functionName;
        data["arguments"] = this.arguments;
        data["callId"] = this.callId;
        data["turnId"] = this.turnId;
        data["device"] = this.device;
        return data;
    }
}

export interface INovaRealtimeEventRequest {
    sessionId?: string;
    conversationId?: string;
    type?: string | undefined;
    itemId?: string | undefined;
    transcript?: string | undefined;
    functionName?: string | undefined;
    arguments?: string | undefined;
    callId?: string | undefined;
    turnId?: number | undefined;
    device?: string | undefined;
}

export class NovaProviderStatusResponse implements INovaProviderStatusResponse {
    configuredProvider?: string | undefined;
    novaEnabled?: boolean;
    effort?: string | undefined;
    maxTokens?: number;
    anthropicModel?: string | undefined;
    anthropicCredentialConfigured?: boolean;
    anthropicCredentialSource?: string | undefined;
    openAiModel?: string | undefined;
    openAiCredentialConfigured?: boolean;
    openAiCredentialSource?: string | undefined;
    speechModel?: string | undefined;
    speechVoice?: string | undefined;
    speechCredentialConfigured?: boolean;
    speechCredentialSource?: string | undefined;

    constructor(data?: INovaProviderStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configuredProvider = _data["configuredProvider"];
            this.novaEnabled = _data["novaEnabled"];
            this.effort = _data["effort"];
            this.maxTokens = _data["maxTokens"];
            this.anthropicModel = _data["anthropicModel"];
            this.anthropicCredentialConfigured = _data["anthropicCredentialConfigured"];
            this.anthropicCredentialSource = _data["anthropicCredentialSource"];
            this.openAiModel = _data["openAiModel"];
            this.openAiCredentialConfigured = _data["openAiCredentialConfigured"];
            this.openAiCredentialSource = _data["openAiCredentialSource"];
            this.speechModel = _data["speechModel"];
            this.speechVoice = _data["speechVoice"];
            this.speechCredentialConfigured = _data["speechCredentialConfigured"];
            this.speechCredentialSource = _data["speechCredentialSource"];
        }
    }

    static fromJS(data: any): NovaProviderStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NovaProviderStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configuredProvider"] = this.configuredProvider;
        data["novaEnabled"] = this.novaEnabled;
        data["effort"] = this.effort;
        data["maxTokens"] = this.maxTokens;
        data["anthropicModel"] = this.anthropicModel;
        data["anthropicCredentialConfigured"] = this.anthropicCredentialConfigured;
        data["anthropicCredentialSource"] = this.anthropicCredentialSource;
        data["openAiModel"] = this.openAiModel;
        data["openAiCredentialConfigured"] = this.openAiCredentialConfigured;
        data["openAiCredentialSource"] = this.openAiCredentialSource;
        data["speechModel"] = this.speechModel;
        data["speechVoice"] = this.speechVoice;
        data["speechCredentialConfigured"] = this.speechCredentialConfigured;
        data["speechCredentialSource"] = this.speechCredentialSource;
        return data;
    }
}

export interface INovaProviderStatusResponse {
    configuredProvider?: string | undefined;
    novaEnabled?: boolean;
    effort?: string | undefined;
    maxTokens?: number;
    anthropicModel?: string | undefined;
    anthropicCredentialConfigured?: boolean;
    anthropicCredentialSource?: string | undefined;
    openAiModel?: string | undefined;
    openAiCredentialConfigured?: boolean;
    openAiCredentialSource?: string | undefined;
    speechModel?: string | undefined;
    speechVoice?: string | undefined;
    speechCredentialConfigured?: boolean;
    speechCredentialSource?: string | undefined;
}

export class NovaLatencyReport implements INovaLatencyReport {
    startedUtc?: Date;
    completedUtc?: Date;
    iterations?: number;
    userMessage?: string | undefined;
    systemPromptCharacters?: number;
    effort?: string | undefined;
    speechModel?: string | undefined;
    speechVoice?: string | undefined;
    claudeTextOpenAiSpeech?: NovaPathResult | undefined;
    allOpenAi?: NovaPathResult | undefined;
    verdict?: string | undefined;

    constructor(data?: INovaLatencyReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startedUtc = _data["startedUtc"] ? new Date(_data["startedUtc"].toString()) : <any>undefined;
            this.completedUtc = _data["completedUtc"] ? new Date(_data["completedUtc"].toString()) : <any>undefined;
            this.iterations = _data["iterations"];
            this.userMessage = _data["userMessage"];
            this.systemPromptCharacters = _data["systemPromptCharacters"];
            this.effort = _data["effort"];
            this.speechModel = _data["speechModel"];
            this.speechVoice = _data["speechVoice"];
            this.claudeTextOpenAiSpeech = _data["claudeTextOpenAiSpeech"] ? NovaPathResult.fromJS(_data["claudeTextOpenAiSpeech"]) : <any>undefined;
            this.allOpenAi = _data["allOpenAi"] ? NovaPathResult.fromJS(_data["allOpenAi"]) : <any>undefined;
            this.verdict = _data["verdict"];
        }
    }

    static fromJS(data: any): NovaLatencyReport {
        data = typeof data === 'object' ? data : {};
        let result = new NovaLatencyReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startedUtc"] = this.startedUtc ? this.startedUtc.toISOString() : <any>undefined;
        data["completedUtc"] = this.completedUtc ? this.completedUtc.toISOString() : <any>undefined;
        data["iterations"] = this.iterations;
        data["userMessage"] = this.userMessage;
        data["systemPromptCharacters"] = this.systemPromptCharacters;
        data["effort"] = this.effort;
        data["speechModel"] = this.speechModel;
        data["speechVoice"] = this.speechVoice;
        data["claudeTextOpenAiSpeech"] = this.claudeTextOpenAiSpeech ? this.claudeTextOpenAiSpeech.toJSON() : <any>undefined;
        data["allOpenAi"] = this.allOpenAi ? this.allOpenAi.toJSON() : <any>undefined;
        data["verdict"] = this.verdict;
        return data;
    }
}

export interface INovaLatencyReport {
    startedUtc?: Date;
    completedUtc?: Date;
    iterations?: number;
    userMessage?: string | undefined;
    systemPromptCharacters?: number;
    effort?: string | undefined;
    speechModel?: string | undefined;
    speechVoice?: string | undefined;
    claudeTextOpenAiSpeech?: NovaPathResult | undefined;
    allOpenAi?: NovaPathResult | undefined;
    verdict?: string | undefined;
}

export class NovaPathResult implements INovaPathResult {
    label?: string | undefined;
    textModel?: string | undefined;
    text?: NovaLatencyStats | undefined;
    speech?: NovaLatencyStats | undefined;
    total?: NovaLatencyStats | undefined;
    failures?: number;
    errors?: string[] | undefined;
    meanReplyCharacters?: number;
    meanAudioBytes?: number;

    constructor(data?: INovaPathResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.textModel = _data["textModel"];
            this.text = _data["text"] ? NovaLatencyStats.fromJS(_data["text"]) : <any>undefined;
            this.speech = _data["speech"] ? NovaLatencyStats.fromJS(_data["speech"]) : <any>undefined;
            this.total = _data["total"] ? NovaLatencyStats.fromJS(_data["total"]) : <any>undefined;
            this.failures = _data["failures"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.meanReplyCharacters = _data["meanReplyCharacters"];
            this.meanAudioBytes = _data["meanAudioBytes"];
        }
    }

    static fromJS(data: any): NovaPathResult {
        data = typeof data === 'object' ? data : {};
        let result = new NovaPathResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["textModel"] = this.textModel;
        data["text"] = this.text ? this.text.toJSON() : <any>undefined;
        data["speech"] = this.speech ? this.speech.toJSON() : <any>undefined;
        data["total"] = this.total ? this.total.toJSON() : <any>undefined;
        data["failures"] = this.failures;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["meanReplyCharacters"] = this.meanReplyCharacters;
        data["meanAudioBytes"] = this.meanAudioBytes;
        return data;
    }
}

export interface INovaPathResult {
    label?: string | undefined;
    textModel?: string | undefined;
    text?: NovaLatencyStats | undefined;
    speech?: NovaLatencyStats | undefined;
    total?: NovaLatencyStats | undefined;
    failures?: number;
    errors?: string[] | undefined;
    meanReplyCharacters?: number;
    meanAudioBytes?: number;
}

export class NovaLatencyStats implements INovaLatencyStats {
    count?: number;
    minMs?: number;
    medianMs?: number;
    meanMs?: number;
    p95Ms?: number;
    maxMs?: number;

    constructor(data?: INovaLatencyStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.minMs = _data["minMs"];
            this.medianMs = _data["medianMs"];
            this.meanMs = _data["meanMs"];
            this.p95Ms = _data["p95Ms"];
            this.maxMs = _data["maxMs"];
        }
    }

    static fromJS(data: any): NovaLatencyStats {
        data = typeof data === 'object' ? data : {};
        let result = new NovaLatencyStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["minMs"] = this.minMs;
        data["medianMs"] = this.medianMs;
        data["meanMs"] = this.meanMs;
        data["p95Ms"] = this.p95Ms;
        data["maxMs"] = this.maxMs;
        return data;
    }
}

export interface INovaLatencyStats {
    count?: number;
    minMs?: number;
    medianMs?: number;
    meanMs?: number;
    p95Ms?: number;
    maxMs?: number;
}

export class SaveProfileRequest implements ISaveProfileRequest {
    preferredName?: string | undefined;
    ageRange?: string | undefined;
    gender?: string | undefined;

    constructor(data?: ISaveProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preferredName = _data["preferredName"];
            this.ageRange = _data["ageRange"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): SaveProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preferredName"] = this.preferredName;
        data["ageRange"] = this.ageRange;
        data["gender"] = this.gender;
        return data;
    }
}

export interface ISaveProfileRequest {
    preferredName?: string | undefined;
    ageRange?: string | undefined;
    gender?: string | undefined;
}

export class SaveCheckInRequest implements ISaveCheckInRequest {
    moodRating?: number | undefined;
    symptomInterferenceRating?: number | undefined;

    constructor(data?: ISaveCheckInRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moodRating = _data["moodRating"];
            this.symptomInterferenceRating = _data["symptomInterferenceRating"];
        }
    }

    static fromJS(data: any): SaveCheckInRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCheckInRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moodRating"] = this.moodRating;
        data["symptomInterferenceRating"] = this.symptomInterferenceRating;
        return data;
    }
}

export interface ISaveCheckInRequest {
    moodRating?: number | undefined;
    symptomInterferenceRating?: number | undefined;
}

export class ResponseModelOfListOfUserOnboardingStepDto implements IResponseModelOfListOfUserOnboardingStepDto {
    resultStatus?: ResultStatus | undefined;
    responseData?: UserOnboardingStepDto[] | undefined;

    constructor(data?: IResponseModelOfListOfUserOnboardingStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(UserOnboardingStepDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseModelOfListOfUserOnboardingStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfListOfUserOnboardingStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseModelOfListOfUserOnboardingStepDto {
    resultStatus?: ResultStatus | undefined;
    responseData?: UserOnboardingStepDto[] | undefined;
}

export class UserOnboardingStepDto implements IUserOnboardingStepDto {
    stepKey?: string | undefined;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    lastViewedAt?: Date | undefined;
    deferredUntil?: Date | undefined;
    dismissed?: boolean;
    deferralCount?: number;

    constructor(data?: IUserOnboardingStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepKey = _data["stepKey"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : <any>undefined;
            this.lastViewedAt = _data["lastViewedAt"] ? new Date(_data["lastViewedAt"].toString()) : <any>undefined;
            this.deferredUntil = _data["deferredUntil"] ? new Date(_data["deferredUntil"].toString()) : <any>undefined;
            this.dismissed = _data["dismissed"];
            this.deferralCount = _data["deferralCount"];
        }
    }

    static fromJS(data: any): UserOnboardingStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserOnboardingStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepKey"] = this.stepKey;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["lastViewedAt"] = this.lastViewedAt ? this.lastViewedAt.toISOString() : <any>undefined;
        data["deferredUntil"] = this.deferredUntil ? this.deferredUntil.toISOString() : <any>undefined;
        data["dismissed"] = this.dismissed;
        data["deferralCount"] = this.deferralCount;
        return data;
    }
}

export interface IUserOnboardingStepDto {
    stepKey?: string | undefined;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    lastViewedAt?: Date | undefined;
    deferredUntil?: Date | undefined;
    dismissed?: boolean;
    deferralCount?: number;
}

export class UpsertOnboardingStepRequest implements IUpsertOnboardingStepRequest {
    stepKey!: string;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    lastViewedAt?: Date | undefined;
    deferredUntil?: Date | undefined;
    dismissed?: boolean | undefined;
    incrementDeferral?: boolean;

    constructor(data?: IUpsertOnboardingStepRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepKey = _data["stepKey"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : <any>undefined;
            this.lastViewedAt = _data["lastViewedAt"] ? new Date(_data["lastViewedAt"].toString()) : <any>undefined;
            this.deferredUntil = _data["deferredUntil"] ? new Date(_data["deferredUntil"].toString()) : <any>undefined;
            this.dismissed = _data["dismissed"];
            this.incrementDeferral = _data["incrementDeferral"];
        }
    }

    static fromJS(data: any): UpsertOnboardingStepRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertOnboardingStepRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepKey"] = this.stepKey;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["lastViewedAt"] = this.lastViewedAt ? this.lastViewedAt.toISOString() : <any>undefined;
        data["deferredUntil"] = this.deferredUntil ? this.deferredUntil.toISOString() : <any>undefined;
        data["dismissed"] = this.dismissed;
        data["incrementDeferral"] = this.incrementDeferral;
        return data;
    }
}

export interface IUpsertOnboardingStepRequest {
    stepKey: string;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    lastViewedAt?: Date | undefined;
    deferredUntil?: Date | undefined;
    dismissed?: boolean | undefined;
    incrementDeferral?: boolean;
}

export class ResetOnboardingStepsRequest implements IResetOnboardingStepsRequest {
    stepKey?: string | undefined;
    path?: string | undefined;
    userGuid?: string | undefined;

    constructor(data?: IResetOnboardingStepsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepKey = _data["stepKey"];
            this.path = _data["path"];
            this.userGuid = _data["userGuid"];
        }
    }

    static fromJS(data: any): ResetOnboardingStepsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetOnboardingStepsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepKey"] = this.stepKey;
        data["path"] = this.path;
        data["userGuid"] = this.userGuid;
        return data;
    }
}

export interface IResetOnboardingStepsRequest {
    stepKey?: string | undefined;
    path?: string | undefined;
    userGuid?: string | undefined;
}

export class PatientPlanDto implements IPatientPlanDto {
    patientPlanId?: number;
    startDate?: Date;
    patientId?: number;
    insertLocalDate?: Date;
    isActive?: boolean;
    insertDate?: Date;
    insertedByUserId?: number;
    updateDate?: Date;
    updatedByUserId?: number;
    cardSessions?: CardSessionDto[] | undefined;

    constructor(data?: IPatientPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientPlanId = _data["patientPlanId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.patientId = _data["patientId"];
            this.insertLocalDate = _data["insertLocalDate"] ? new Date(_data["insertLocalDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.insertDate = _data["insertDate"] ? new Date(_data["insertDate"].toString()) : <any>undefined;
            this.insertedByUserId = _data["insertedByUserId"];
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.updatedByUserId = _data["updatedByUserId"];
            if (Array.isArray(_data["cardSessions"])) {
                this.cardSessions = [] as any;
                for (let item of _data["cardSessions"])
                    this.cardSessions!.push(CardSessionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientPlanId"] = this.patientPlanId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["patientId"] = this.patientId;
        data["insertLocalDate"] = this.insertLocalDate ? this.insertLocalDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["insertDate"] = this.insertDate ? this.insertDate.toISOString() : <any>undefined;
        data["insertedByUserId"] = this.insertedByUserId;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["updatedByUserId"] = this.updatedByUserId;
        if (Array.isArray(this.cardSessions)) {
            data["cardSessions"] = [];
            for (let item of this.cardSessions)
                data["cardSessions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientPlanDto {
    patientPlanId?: number;
    startDate?: Date;
    patientId?: number;
    insertLocalDate?: Date;
    isActive?: boolean;
    insertDate?: Date;
    insertedByUserId?: number;
    updateDate?: Date;
    updatedByUserId?: number;
    cardSessions?: CardSessionDto[] | undefined;
}

export class CardSessionDto implements ICardSessionDto {
    cardSessionId?: number;
    patientPlanId?: number;
    dailyPeriodId?: number;
    dailyPeriodName?: string | undefined;
    sortOrder?: number;
    isActive?: boolean;
    insertDate?: Date;
    insertedByUserId?: number;
    updateDate?: Date;
    updatedByUserId?: number;
    cardSessionCards?: CardSessionCardDto[] | undefined;

    constructor(data?: ICardSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardSessionId = _data["cardSessionId"];
            this.patientPlanId = _data["patientPlanId"];
            this.dailyPeriodId = _data["dailyPeriodId"];
            this.dailyPeriodName = _data["dailyPeriodName"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
            this.insertDate = _data["insertDate"] ? new Date(_data["insertDate"].toString()) : <any>undefined;
            this.insertedByUserId = _data["insertedByUserId"];
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.updatedByUserId = _data["updatedByUserId"];
            if (Array.isArray(_data["cardSessionCards"])) {
                this.cardSessionCards = [] as any;
                for (let item of _data["cardSessionCards"])
                    this.cardSessionCards!.push(CardSessionCardDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CardSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardSessionId"] = this.cardSessionId;
        data["patientPlanId"] = this.patientPlanId;
        data["dailyPeriodId"] = this.dailyPeriodId;
        data["dailyPeriodName"] = this.dailyPeriodName;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        data["insertDate"] = this.insertDate ? this.insertDate.toISOString() : <any>undefined;
        data["insertedByUserId"] = this.insertedByUserId;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["updatedByUserId"] = this.updatedByUserId;
        if (Array.isArray(this.cardSessionCards)) {
            data["cardSessionCards"] = [];
            for (let item of this.cardSessionCards)
                data["cardSessionCards"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICardSessionDto {
    cardSessionId?: number;
    patientPlanId?: number;
    dailyPeriodId?: number;
    dailyPeriodName?: string | undefined;
    sortOrder?: number;
    isActive?: boolean;
    insertDate?: Date;
    insertedByUserId?: number;
    updateDate?: Date;
    updatedByUserId?: number;
    cardSessionCards?: CardSessionCardDto[] | undefined;
}

export class CardSessionCardDto implements ICardSessionCardDto {
    cardSessionCardId?: number;
    cardSessionId?: number;
    cardId?: number;
    cardName?: string | undefined;
    cardDescription?: string | undefined;
    periodMinutes?: number;
    sortOrder?: number;
    isComplete?: boolean;
    isActive?: boolean;
    insertDate?: Date;
    insertedByUserId?: number;
    updateDate?: Date;
    updatedByUserId?: number;
    cardCategoryId?: number;
    cardCategoryName?: string | undefined;
    cardDeckId?: number;
    cardDeckName?: string | undefined;
    htmlScript?: string | undefined;
    isMandatory?: boolean;

    constructor(data?: ICardSessionCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardSessionCardId = _data["cardSessionCardId"];
            this.cardSessionId = _data["cardSessionId"];
            this.cardId = _data["cardId"];
            this.cardName = _data["cardName"];
            this.cardDescription = _data["cardDescription"];
            this.periodMinutes = _data["periodMinutes"];
            this.sortOrder = _data["sortOrder"];
            this.isComplete = _data["isComplete"];
            this.isActive = _data["isActive"];
            this.insertDate = _data["insertDate"] ? new Date(_data["insertDate"].toString()) : <any>undefined;
            this.insertedByUserId = _data["insertedByUserId"];
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.updatedByUserId = _data["updatedByUserId"];
            this.cardCategoryId = _data["cardCategoryId"];
            this.cardCategoryName = _data["cardCategoryName"];
            this.cardDeckId = _data["cardDeckId"];
            this.cardDeckName = _data["cardDeckName"];
            this.htmlScript = _data["htmlScript"];
            this.isMandatory = _data["isMandatory"];
        }
    }

    static fromJS(data: any): CardSessionCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardSessionCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardSessionCardId"] = this.cardSessionCardId;
        data["cardSessionId"] = this.cardSessionId;
        data["cardId"] = this.cardId;
        data["cardName"] = this.cardName;
        data["cardDescription"] = this.cardDescription;
        data["periodMinutes"] = this.periodMinutes;
        data["sortOrder"] = this.sortOrder;
        data["isComplete"] = this.isComplete;
        data["isActive"] = this.isActive;
        data["insertDate"] = this.insertDate ? this.insertDate.toISOString() : <any>undefined;
        data["insertedByUserId"] = this.insertedByUserId;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["updatedByUserId"] = this.updatedByUserId;
        data["cardCategoryId"] = this.cardCategoryId;
        data["cardCategoryName"] = this.cardCategoryName;
        data["cardDeckId"] = this.cardDeckId;
        data["cardDeckName"] = this.cardDeckName;
        data["htmlScript"] = this.htmlScript;
        data["isMandatory"] = this.isMandatory;
        return data;
    }
}

export interface ICardSessionCardDto {
    cardSessionCardId?: number;
    cardSessionId?: number;
    cardId?: number;
    cardName?: string | undefined;
    cardDescription?: string | undefined;
    periodMinutes?: number;
    sortOrder?: number;
    isComplete?: boolean;
    isActive?: boolean;
    insertDate?: Date;
    insertedByUserId?: number;
    updateDate?: Date;
    updatedByUserId?: number;
    cardCategoryId?: number;
    cardCategoryName?: string | undefined;
    cardDeckId?: number;
    cardDeckName?: string | undefined;
    htmlScript?: string | undefined;
    isMandatory?: boolean;
}

export class PatientPlanWithScoreResponse implements IPatientPlanWithScoreResponse {
    patientId?: number;
    localDate?: Date;
    totalScore?: number;
    averageScore?: number;
    patientPlanId?: number | undefined;
    handId?: number | undefined;
    handIsComplete?: boolean;

    constructor(data?: IPatientPlanWithScoreResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.localDate = _data["localDate"] ? new Date(_data["localDate"].toString()) : <any>undefined;
            this.totalScore = _data["totalScore"];
            this.averageScore = _data["averageScore"];
            this.patientPlanId = _data["patientPlanId"];
            this.handId = _data["handId"];
            this.handIsComplete = _data["handIsComplete"];
        }
    }

    static fromJS(data: any): PatientPlanWithScoreResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPlanWithScoreResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["localDate"] = this.localDate ? this.localDate.toISOString() : <any>undefined;
        data["totalScore"] = this.totalScore;
        data["averageScore"] = this.averageScore;
        data["patientPlanId"] = this.patientPlanId;
        data["handId"] = this.handId;
        data["handIsComplete"] = this.handIsComplete;
        return data;
    }
}

export interface IPatientPlanWithScoreResponse {
    patientId?: number;
    localDate?: Date;
    totalScore?: number;
    averageScore?: number;
    patientPlanId?: number | undefined;
    handId?: number | undefined;
    handIsComplete?: boolean;
}

export class PatientPlanFavouriteListResponse implements IPatientPlanFavouriteListResponse {
    patientId?: number;
    localDateTime?: Date;
    patientPlanFavouriteId?: number;
    favouritePlanName?: string | undefined;
    useCount?: number;
    lastUsedDate?: Date | undefined;
    createdDate?: Date;
    modifiedDate?: Date;

    constructor(data?: IPatientPlanFavouriteListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.localDateTime = _data["localDateTime"] ? new Date(_data["localDateTime"].toString()) : <any>undefined;
            this.patientPlanFavouriteId = _data["patientPlanFavouriteId"];
            this.favouritePlanName = _data["favouritePlanName"];
            this.useCount = _data["useCount"];
            this.lastUsedDate = _data["lastUsedDate"] ? new Date(_data["lastUsedDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientPlanFavouriteListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPlanFavouriteListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["localDateTime"] = this.localDateTime ? this.localDateTime.toISOString() : <any>undefined;
        data["patientPlanFavouriteId"] = this.patientPlanFavouriteId;
        data["favouritePlanName"] = this.favouritePlanName;
        data["useCount"] = this.useCount;
        data["lastUsedDate"] = this.lastUsedDate ? this.lastUsedDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPatientPlanFavouriteListResponse {
    patientId?: number;
    localDateTime?: Date;
    patientPlanFavouriteId?: number;
    favouritePlanName?: string | undefined;
    useCount?: number;
    lastUsedDate?: Date | undefined;
    createdDate?: Date;
    modifiedDate?: Date;
}

export class PatientPlanFavouriteSaveRequest implements IPatientPlanFavouriteSaveRequest {
    patientPlanId?: number;
    patientId?: number;
    planName?: string | undefined;
    type?: PatientPlanFavouriteSaveRequestType;
    patientPlan?: PatientPlanDto | undefined;

    constructor(data?: IPatientPlanFavouriteSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientPlanId = _data["patientPlanId"];
            this.patientId = _data["patientId"];
            this.planName = _data["planName"];
            this.type = _data["type"];
            this.patientPlan = _data["patientPlan"] ? PatientPlanDto.fromJS(_data["patientPlan"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientPlanFavouriteSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPlanFavouriteSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientPlanId"] = this.patientPlanId;
        data["patientId"] = this.patientId;
        data["planName"] = this.planName;
        data["type"] = this.type;
        data["patientPlan"] = this.patientPlan ? this.patientPlan.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPatientPlanFavouriteSaveRequest {
    patientPlanId?: number;
    patientId?: number;
    planName?: string | undefined;
    type?: PatientPlanFavouriteSaveRequestType;
    patientPlan?: PatientPlanDto | undefined;
}

export enum PatientPlanFavouriteSaveRequestType {
    New = 0,
    Edit = 1,
    Delete = 2,
}

export class PatientPlanDetailResponse implements IPatientPlanDetailResponse {
    insertLocalDate?: Date;
    updateDate?: Date;
    updateLocalDate?: Date | undefined;
    patientPlanId?: number;
    startDate?: Date;
    isFavouritePlan?: boolean;
    favouritePlanName?: string | undefined;
    isPlanComplete?: boolean;
    planDailyPeriods?: PlanDailyPeriods[] | undefined;

    constructor(data?: IPatientPlanDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insertLocalDate = _data["insertLocalDate"] ? new Date(_data["insertLocalDate"].toString()) : <any>undefined;
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.updateLocalDate = _data["updateLocalDate"] ? new Date(_data["updateLocalDate"].toString()) : <any>undefined;
            this.patientPlanId = _data["patientPlanId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.isFavouritePlan = _data["isFavouritePlan"];
            this.favouritePlanName = _data["favouritePlanName"];
            this.isPlanComplete = _data["isPlanComplete"];
            if (Array.isArray(_data["planDailyPeriods"])) {
                this.planDailyPeriods = [] as any;
                for (let item of _data["planDailyPeriods"])
                    this.planDailyPeriods!.push(PlanDailyPeriods.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientPlanDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPlanDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insertLocalDate"] = this.insertLocalDate ? this.insertLocalDate.toISOString() : <any>undefined;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["updateLocalDate"] = this.updateLocalDate ? this.updateLocalDate.toISOString() : <any>undefined;
        data["patientPlanId"] = this.patientPlanId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["isFavouritePlan"] = this.isFavouritePlan;
        data["favouritePlanName"] = this.favouritePlanName;
        data["isPlanComplete"] = this.isPlanComplete;
        if (Array.isArray(this.planDailyPeriods)) {
            data["planDailyPeriods"] = [];
            for (let item of this.planDailyPeriods)
                data["planDailyPeriods"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientPlanDetailResponse {
    insertLocalDate?: Date;
    updateDate?: Date;
    updateLocalDate?: Date | undefined;
    patientPlanId?: number;
    startDate?: Date;
    isFavouritePlan?: boolean;
    favouritePlanName?: string | undefined;
    isPlanComplete?: boolean;
    planDailyPeriods?: PlanDailyPeriods[] | undefined;
}

export class PlanDailyPeriods implements IPlanDailyPeriods {
    dailyPeriodId?: number;
    dailyPeriod?: string | undefined;
    cardSessions?: CardSessions[] | undefined;
    periodGuid?: string;

    constructor(data?: IPlanDailyPeriods) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dailyPeriodId = _data["dailyPeriodId"];
            this.dailyPeriod = _data["dailyPeriod"];
            if (Array.isArray(_data["cardSessions"])) {
                this.cardSessions = [] as any;
                for (let item of _data["cardSessions"])
                    this.cardSessions!.push(CardSessions.fromJS(item));
            }
            this.periodGuid = _data["periodGuid"];
        }
    }

    static fromJS(data: any): PlanDailyPeriods {
        data = typeof data === 'object' ? data : {};
        let result = new PlanDailyPeriods();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dailyPeriodId"] = this.dailyPeriodId;
        data["dailyPeriod"] = this.dailyPeriod;
        if (Array.isArray(this.cardSessions)) {
            data["cardSessions"] = [];
            for (let item of this.cardSessions)
                data["cardSessions"].push(item.toJSON());
        }
        data["periodGuid"] = this.periodGuid;
        return data;
    }
}

export interface IPlanDailyPeriods {
    dailyPeriodId?: number;
    dailyPeriod?: string | undefined;
    cardSessions?: CardSessions[] | undefined;
    periodGuid?: string;
}

export class CardSessions implements ICardSessions {
    cardSessionId?: number;
    sessionSortOrder?: number;
    cardSections?: CardSection | undefined;
    sessionGuid?: string;

    constructor(data?: ICardSessions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardSessionId = _data["cardSessionId"];
            this.sessionSortOrder = _data["sessionSortOrder"];
            this.cardSections = _data["cardSections"] ? CardSection.fromJS(_data["cardSections"]) : <any>undefined;
            this.sessionGuid = _data["sessionGuid"];
        }
    }

    static fromJS(data: any): CardSessions {
        data = typeof data === 'object' ? data : {};
        let result = new CardSessions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardSessionId"] = this.cardSessionId;
        data["sessionSortOrder"] = this.sessionSortOrder;
        data["cardSections"] = this.cardSections ? this.cardSections.toJSON() : <any>undefined;
        data["sessionGuid"] = this.sessionGuid;
        return data;
    }
}

export interface ICardSessions {
    cardSessionId?: number;
    sessionSortOrder?: number;
    cardSections?: CardSection | undefined;
    sessionGuid?: string;
}

export class CardSection implements ICardSection {
    angelCardsBefore?: CardModel[] | undefined;
    activityCard?: CardModel[] | undefined;
    angelCards?: CardModel[] | undefined;

    constructor(data?: ICardSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["angelCardsBefore"])) {
                this.angelCardsBefore = [] as any;
                for (let item of _data["angelCardsBefore"])
                    this.angelCardsBefore!.push(CardModel.fromJS(item));
            }
            if (Array.isArray(_data["activityCard"])) {
                this.activityCard = [] as any;
                for (let item of _data["activityCard"])
                    this.activityCard!.push(CardModel.fromJS(item));
            }
            if (Array.isArray(_data["angelCards"])) {
                this.angelCards = [] as any;
                for (let item of _data["angelCards"])
                    this.angelCards!.push(CardModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CardSection {
        data = typeof data === 'object' ? data : {};
        let result = new CardSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.angelCardsBefore)) {
            data["angelCardsBefore"] = [];
            for (let item of this.angelCardsBefore)
                data["angelCardsBefore"].push(item.toJSON());
        }
        if (Array.isArray(this.activityCard)) {
            data["activityCard"] = [];
            for (let item of this.activityCard)
                data["activityCard"].push(item.toJSON());
        }
        if (Array.isArray(this.angelCards)) {
            data["angelCards"] = [];
            for (let item of this.angelCards)
                data["angelCards"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICardSection {
    angelCardsBefore?: CardModel[] | undefined;
    activityCard?: CardModel[] | undefined;
    angelCards?: CardModel[] | undefined;
}

export class PatientPlanSaveDbRequest implements IPatientPlanSaveDbRequest {
    localDateTime?: string | undefined;
    startDate?: Date;
    userGuid?: string;
    patientPlanItems?: PatientPlanItemsSave[] | undefined;

    constructor(data?: IPatientPlanSaveDbRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localDateTime = _data["localDateTime"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.userGuid = _data["userGuid"];
            if (Array.isArray(_data["patientPlanItems"])) {
                this.patientPlanItems = [] as any;
                for (let item of _data["patientPlanItems"])
                    this.patientPlanItems!.push(PatientPlanItemsSave.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientPlanSaveDbRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPlanSaveDbRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localDateTime"] = this.localDateTime;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["userGuid"] = this.userGuid;
        if (Array.isArray(this.patientPlanItems)) {
            data["patientPlanItems"] = [];
            for (let item of this.patientPlanItems)
                data["patientPlanItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientPlanSaveDbRequest {
    localDateTime?: string | undefined;
    startDate?: Date;
    userGuid?: string;
    patientPlanItems?: PatientPlanItemsSave[] | undefined;
}

export class PatientPlanItemsSave implements IPatientPlanItemsSave {
    patientPlanId?: number | undefined;
    isFavouritePlan?: boolean;
    favouritePlanName?: string | undefined;
    cardSessionId?: number | undefined;
    dailyPeriodId?: number;
    cardSessionSortOrder?: number;
    cardSessionCardId?: number | undefined;
    cardId?: number | undefined;
    cardCategoryId?: number | undefined;
    periodMinutes?: number;
    cardSortOrder?: number;
    cardName?: string | undefined;
    cardDescription?: string | undefined;

    constructor(data?: IPatientPlanItemsSave) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientPlanId = _data["patientPlanId"];
            this.isFavouritePlan = _data["isFavouritePlan"];
            this.favouritePlanName = _data["favouritePlanName"];
            this.cardSessionId = _data["cardSessionId"];
            this.dailyPeriodId = _data["dailyPeriodId"];
            this.cardSessionSortOrder = _data["cardSessionSortOrder"];
            this.cardSessionCardId = _data["cardSessionCardId"];
            this.cardId = _data["cardId"];
            this.cardCategoryId = _data["cardCategoryId"];
            this.periodMinutes = _data["periodMinutes"];
            this.cardSortOrder = _data["cardSortOrder"];
            this.cardName = _data["cardName"];
            this.cardDescription = _data["cardDescription"];
        }
    }

    static fromJS(data: any): PatientPlanItemsSave {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPlanItemsSave();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientPlanId"] = this.patientPlanId;
        data["isFavouritePlan"] = this.isFavouritePlan;
        data["favouritePlanName"] = this.favouritePlanName;
        data["cardSessionId"] = this.cardSessionId;
        data["dailyPeriodId"] = this.dailyPeriodId;
        data["cardSessionSortOrder"] = this.cardSessionSortOrder;
        data["cardSessionCardId"] = this.cardSessionCardId;
        data["cardId"] = this.cardId;
        data["cardCategoryId"] = this.cardCategoryId;
        data["periodMinutes"] = this.periodMinutes;
        data["cardSortOrder"] = this.cardSortOrder;
        data["cardName"] = this.cardName;
        data["cardDescription"] = this.cardDescription;
        return data;
    }
}

export interface IPatientPlanItemsSave {
    patientPlanId?: number | undefined;
    isFavouritePlan?: boolean;
    favouritePlanName?: string | undefined;
    cardSessionId?: number | undefined;
    dailyPeriodId?: number;
    cardSessionSortOrder?: number;
    cardSessionCardId?: number | undefined;
    cardId?: number | undefined;
    cardCategoryId?: number | undefined;
    periodMinutes?: number;
    cardSortOrder?: number;
    cardName?: string | undefined;
    cardDescription?: string | undefined;
}

export class ReusePlanRequest implements IReusePlanRequest {
    planId?: number;
    isFavouritePlan?: boolean;
    startDate?: Date;
    localDateTime?: Date;
    userGuid?: string | undefined;
    excludeCardIds?: number[] | undefined;
    excludeActivityCardIds?: number[] | undefined;

    constructor(data?: IReusePlanRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planId = _data["planId"];
            this.isFavouritePlan = _data["isFavouritePlan"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.localDateTime = _data["localDateTime"] ? new Date(_data["localDateTime"].toString()) : <any>undefined;
            this.userGuid = _data["userGuid"];
            if (Array.isArray(_data["excludeCardIds"])) {
                this.excludeCardIds = [] as any;
                for (let item of _data["excludeCardIds"])
                    this.excludeCardIds!.push(item);
            }
            if (Array.isArray(_data["excludeActivityCardIds"])) {
                this.excludeActivityCardIds = [] as any;
                for (let item of _data["excludeActivityCardIds"])
                    this.excludeActivityCardIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ReusePlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReusePlanRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planId"] = this.planId;
        data["isFavouritePlan"] = this.isFavouritePlan;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["localDateTime"] = this.localDateTime ? this.localDateTime.toISOString() : <any>undefined;
        data["userGuid"] = this.userGuid;
        if (Array.isArray(this.excludeCardIds)) {
            data["excludeCardIds"] = [];
            for (let item of this.excludeCardIds)
                data["excludeCardIds"].push(item);
        }
        if (Array.isArray(this.excludeActivityCardIds)) {
            data["excludeActivityCardIds"] = [];
            for (let item of this.excludeActivityCardIds)
                data["excludeActivityCardIds"].push(item);
        }
        return data;
    }
}

export interface IReusePlanRequest {
    planId?: number;
    isFavouritePlan?: boolean;
    startDate?: Date;
    localDateTime?: Date;
    userGuid?: string | undefined;
    excludeCardIds?: number[] | undefined;
    excludeActivityCardIds?: number[] | undefined;
}

export class DailyPeriodDbResponse implements IDailyPeriodDbResponse {
    dailyPeriodId?: number;
    name?: string | undefined;
    sortOrder?: number;

    constructor(data?: IDailyPeriodDbResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dailyPeriodId = _data["dailyPeriodId"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): DailyPeriodDbResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DailyPeriodDbResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dailyPeriodId"] = this.dailyPeriodId;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IDailyPeriodDbResponse {
    dailyPeriodId?: number;
    name?: string | undefined;
    sortOrder?: number;
}

export class DeletePlanRequest implements IDeletePlanRequest {
    patientPlanId?: number;
    userGuid?: string | undefined;

    constructor(data?: IDeletePlanRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientPlanId = _data["patientPlanId"];
            this.userGuid = _data["userGuid"];
        }
    }

    static fromJS(data: any): DeletePlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePlanRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientPlanId"] = this.patientPlanId;
        data["userGuid"] = this.userGuid;
        return data;
    }
}

export interface IDeletePlanRequest {
    patientPlanId?: number;
    userGuid?: string | undefined;
}

export class DeleteDayPlanRequest implements IDeleteDayPlanRequest {
    dayPeriod?: string | undefined;
    userGuid?: string | undefined;

    constructor(data?: IDeleteDayPlanRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayPeriod = _data["dayPeriod"];
            this.userGuid = _data["userGuid"];
        }
    }

    static fromJS(data: any): DeleteDayPlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDayPlanRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayPeriod"] = this.dayPeriod;
        data["userGuid"] = this.userGuid;
        return data;
    }
}

export interface IDeleteDayPlanRequest {
    dayPeriod?: string | undefined;
    userGuid?: string | undefined;
}

export class DeleteCardRequest implements IDeleteCardRequest {
    cardId?: number;
    isActive?: boolean;
    userGuid?: string | undefined;

    constructor(data?: IDeleteCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            this.isActive = _data["isActive"];
            this.userGuid = _data["userGuid"];
        }
    }

    static fromJS(data: any): DeleteCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["isActive"] = this.isActive;
        data["userGuid"] = this.userGuid;
        return data;
    }
}

export interface IDeleteCardRequest {
    cardId?: number;
    isActive?: boolean;
    userGuid?: string | undefined;
}

export class ResponseModelOfCreateCheckoutSessionResponse implements IResponseModelOfCreateCheckoutSessionResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: CreateCheckoutSessionResponse | undefined;

    constructor(data?: IResponseModelOfCreateCheckoutSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? CreateCheckoutSessionResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfCreateCheckoutSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfCreateCheckoutSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfCreateCheckoutSessionResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: CreateCheckoutSessionResponse | undefined;
}

export class CreateCheckoutSessionResponse implements ICreateCheckoutSessionResponse {
    url?: string | undefined;

    constructor(data?: ICreateCheckoutSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): CreateCheckoutSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCheckoutSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface ICreateCheckoutSessionResponse {
    url?: string | undefined;
}

export class CreateCheckoutSessionRequest implements ICreateCheckoutSessionRequest {
    planId!: string;
    platform?: string | undefined;
    externalTransactionToken?: string | undefined;
    currency?: string | undefined;
    storefront?: string | undefined;

    constructor(data?: ICreateCheckoutSessionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planId = _data["planId"];
            this.platform = _data["platform"];
            this.externalTransactionToken = _data["externalTransactionToken"];
            this.currency = _data["currency"];
            this.storefront = _data["storefront"];
        }
    }

    static fromJS(data: any): CreateCheckoutSessionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCheckoutSessionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planId"] = this.planId;
        data["platform"] = this.platform;
        data["externalTransactionToken"] = this.externalTransactionToken;
        data["currency"] = this.currency;
        data["storefront"] = this.storefront;
        return data;
    }
}

export interface ICreateCheckoutSessionRequest {
    planId: string;
    platform?: string | undefined;
    externalTransactionToken?: string | undefined;
    currency?: string | undefined;
    storefront?: string | undefined;
}

export class ResponseModelOfVerifySessionResponse implements IResponseModelOfVerifySessionResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: VerifySessionResponse | undefined;

    constructor(data?: IResponseModelOfVerifySessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? VerifySessionResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfVerifySessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfVerifySessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfVerifySessionResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: VerifySessionResponse | undefined;
}

export class VerifySessionResponse implements IVerifySessionResponse {
    verified?: boolean;
    subscriptionActive?: boolean;

    constructor(data?: IVerifySessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verified = _data["verified"];
            this.subscriptionActive = _data["subscriptionActive"];
        }
    }

    static fromJS(data: any): VerifySessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verified"] = this.verified;
        data["subscriptionActive"] = this.subscriptionActive;
        return data;
    }
}

export interface IVerifySessionResponse {
    verified?: boolean;
    subscriptionActive?: boolean;
}

export class ResponseModelOfCreateBillingPortalSessionResponse implements IResponseModelOfCreateBillingPortalSessionResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: CreateBillingPortalSessionResponse | undefined;

    constructor(data?: IResponseModelOfCreateBillingPortalSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? CreateBillingPortalSessionResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfCreateBillingPortalSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfCreateBillingPortalSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfCreateBillingPortalSessionResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: CreateBillingPortalSessionResponse | undefined;
}

export class CreateBillingPortalSessionResponse implements ICreateBillingPortalSessionResponse {
    url?: string | undefined;

    constructor(data?: ICreateBillingPortalSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): CreateBillingPortalSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBillingPortalSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface ICreateBillingPortalSessionResponse {
    url?: string | undefined;
}

export class ResponseModelOfSubscriptionStatusResponse implements IResponseModelOfSubscriptionStatusResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: SubscriptionStatusResponse | undefined;

    constructor(data?: IResponseModelOfSubscriptionStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? SubscriptionStatusResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfSubscriptionStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfSubscriptionStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfSubscriptionStatusResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: SubscriptionStatusResponse | undefined;
}

export class SubscriptionStatusResponse implements ISubscriptionStatusResponse {
    status?: string | undefined;
    isActive?: boolean;
    planId?: string | undefined;
    purchaseDate?: Date | undefined;
    termEndDate?: Date | undefined;
    isLifetime?: boolean;
    tier?: string | undefined;
    isRecurring?: boolean;
    cancelAtPeriodEnd?: boolean;
    provider?: string | undefined;
    offerCode?: string | undefined;

    constructor(data?: ISubscriptionStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.planId = _data["planId"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.termEndDate = _data["termEndDate"] ? new Date(_data["termEndDate"].toString()) : <any>undefined;
            this.isLifetime = _data["isLifetime"];
            this.tier = _data["tier"];
            this.isRecurring = _data["isRecurring"];
            this.cancelAtPeriodEnd = _data["cancelAtPeriodEnd"];
            this.provider = _data["provider"];
            this.offerCode = _data["offerCode"];
        }
    }

    static fromJS(data: any): SubscriptionStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["planId"] = this.planId;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["termEndDate"] = this.termEndDate ? this.termEndDate.toISOString() : <any>undefined;
        data["isLifetime"] = this.isLifetime;
        data["tier"] = this.tier;
        data["isRecurring"] = this.isRecurring;
        data["cancelAtPeriodEnd"] = this.cancelAtPeriodEnd;
        data["provider"] = this.provider;
        data["offerCode"] = this.offerCode;
        return data;
    }
}

export interface ISubscriptionStatusResponse {
    status?: string | undefined;
    isActive?: boolean;
    planId?: string | undefined;
    purchaseDate?: Date | undefined;
    termEndDate?: Date | undefined;
    isLifetime?: boolean;
    tier?: string | undefined;
    isRecurring?: boolean;
    cancelAtPeriodEnd?: boolean;
    provider?: string | undefined;
    offerCode?: string | undefined;
}

export class ResponseModelOfCancelSubscriptionResponse implements IResponseModelOfCancelSubscriptionResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: CancelSubscriptionResponse | undefined;

    constructor(data?: IResponseModelOfCancelSubscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? CancelSubscriptionResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfCancelSubscriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfCancelSubscriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfCancelSubscriptionResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: CancelSubscriptionResponse | undefined;
}

export class CancelSubscriptionResponse implements ICancelSubscriptionResponse {
    cancelAtPeriodEnd?: boolean;
    periodEndUtc?: Date | undefined;

    constructor(data?: ICancelSubscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cancelAtPeriodEnd = _data["cancelAtPeriodEnd"];
            this.periodEndUtc = _data["periodEndUtc"] ? new Date(_data["periodEndUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CancelSubscriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CancelSubscriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cancelAtPeriodEnd"] = this.cancelAtPeriodEnd;
        data["periodEndUtc"] = this.periodEndUtc ? this.periodEndUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICancelSubscriptionResponse {
    cancelAtPeriodEnd?: boolean;
    periodEndUtc?: Date | undefined;
}

export class ResponseModelOfResumeSubscriptionResponse implements IResponseModelOfResumeSubscriptionResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: ResumeSubscriptionResponse | undefined;

    constructor(data?: IResponseModelOfResumeSubscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? ResumeSubscriptionResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfResumeSubscriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfResumeSubscriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfResumeSubscriptionResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: ResumeSubscriptionResponse | undefined;
}

export class ResumeSubscriptionResponse implements IResumeSubscriptionResponse {
    cancelAtPeriodEnd?: boolean;
    periodEndUtc?: Date | undefined;

    constructor(data?: IResumeSubscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cancelAtPeriodEnd = _data["cancelAtPeriodEnd"];
            this.periodEndUtc = _data["periodEndUtc"] ? new Date(_data["periodEndUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ResumeSubscriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeSubscriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cancelAtPeriodEnd"] = this.cancelAtPeriodEnd;
        data["periodEndUtc"] = this.periodEndUtc ? this.periodEndUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IResumeSubscriptionResponse {
    cancelAtPeriodEnd?: boolean;
    periodEndUtc?: Date | undefined;
}

export class ResponseModelOfListOfBillingHistoryItem implements IResponseModelOfListOfBillingHistoryItem {
    resultStatus?: ResultStatus | undefined;
    responseData?: BillingHistoryItem[] | undefined;

    constructor(data?: IResponseModelOfListOfBillingHistoryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(BillingHistoryItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseModelOfListOfBillingHistoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfListOfBillingHistoryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseModelOfListOfBillingHistoryItem {
    resultStatus?: ResultStatus | undefined;
    responseData?: BillingHistoryItem[] | undefined;
}

export class BillingHistoryItem implements IBillingHistoryItem {
    dateUtc?: Date;
    amount?: number;
    currency?: string | undefined;
    planId?: string | undefined;
    receiptUrl?: string | undefined;
    promotionCode?: string | undefined;

    constructor(data?: IBillingHistoryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateUtc = _data["dateUtc"] ? new Date(_data["dateUtc"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.planId = _data["planId"];
            this.receiptUrl = _data["receiptUrl"];
            this.promotionCode = _data["promotionCode"];
        }
    }

    static fromJS(data: any): BillingHistoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new BillingHistoryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateUtc"] = this.dateUtc ? this.dateUtc.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["planId"] = this.planId;
        data["receiptUrl"] = this.receiptUrl;
        data["promotionCode"] = this.promotionCode;
        return data;
    }
}

export interface IBillingHistoryItem {
    dateUtc?: Date;
    amount?: number;
    currency?: string | undefined;
    planId?: string | undefined;
    receiptUrl?: string | undefined;
    promotionCode?: string | undefined;
}

export class ResponseModelOfBackfillStripeCustomersResponse implements IResponseModelOfBackfillStripeCustomersResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: BackfillStripeCustomersResponse | undefined;

    constructor(data?: IResponseModelOfBackfillStripeCustomersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            this.responseData = _data["responseData"] ? BackfillStripeCustomersResponse.fromJS(_data["responseData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseModelOfBackfillStripeCustomersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfBackfillStripeCustomersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseModelOfBackfillStripeCustomersResponse {
    resultStatus?: ResultStatus | undefined;
    responseData?: BackfillStripeCustomersResponse | undefined;
}

export class BackfillStripeCustomersResponse implements IBackfillStripeCustomersResponse {
    dryRun?: boolean;
    backfilled?: BackfillStripeCustomerRow[] | undefined;
    ambiguous?: BackfillStripeCustomerRow[] | undefined;
    unmatched?: BackfillStripeCustomerRow[] | undefined;

    constructor(data?: IBackfillStripeCustomersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dryRun = _data["dryRun"];
            if (Array.isArray(_data["backfilled"])) {
                this.backfilled = [] as any;
                for (let item of _data["backfilled"])
                    this.backfilled!.push(BackfillStripeCustomerRow.fromJS(item));
            }
            if (Array.isArray(_data["ambiguous"])) {
                this.ambiguous = [] as any;
                for (let item of _data["ambiguous"])
                    this.ambiguous!.push(BackfillStripeCustomerRow.fromJS(item));
            }
            if (Array.isArray(_data["unmatched"])) {
                this.unmatched = [] as any;
                for (let item of _data["unmatched"])
                    this.unmatched!.push(BackfillStripeCustomerRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BackfillStripeCustomersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BackfillStripeCustomersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dryRun"] = this.dryRun;
        if (Array.isArray(this.backfilled)) {
            data["backfilled"] = [];
            for (let item of this.backfilled)
                data["backfilled"].push(item.toJSON());
        }
        if (Array.isArray(this.ambiguous)) {
            data["ambiguous"] = [];
            for (let item of this.ambiguous)
                data["ambiguous"].push(item.toJSON());
        }
        if (Array.isArray(this.unmatched)) {
            data["unmatched"] = [];
            for (let item of this.unmatched)
                data["unmatched"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBackfillStripeCustomersResponse {
    dryRun?: boolean;
    backfilled?: BackfillStripeCustomerRow[] | undefined;
    ambiguous?: BackfillStripeCustomerRow[] | undefined;
    unmatched?: BackfillStripeCustomerRow[] | undefined;
}

export class BackfillStripeCustomerRow implements IBackfillStripeCustomerRow {
    userGuid?: string;
    detail?: string | undefined;

    constructor(data?: IBackfillStripeCustomerRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGuid = _data["userGuid"];
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): BackfillStripeCustomerRow {
        data = typeof data === 'object' ? data : {};
        let result = new BackfillStripeCustomerRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGuid"] = this.userGuid;
        data["detail"] = this.detail;
        return data;
    }
}

export interface IBackfillStripeCustomerRow {
    userGuid?: string;
    detail?: string | undefined;
}

export class TodaysPerspectiveResponse implements ITodaysPerspectiveResponse {
    perspectiveMessageId?: number;
    text?: string | undefined;
    viewedLocalDate?: Date;

    constructor(data?: ITodaysPerspectiveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.perspectiveMessageId = _data["perspectiveMessageId"];
            this.text = _data["text"];
            this.viewedLocalDate = _data["viewedLocalDate"] ? new Date(_data["viewedLocalDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TodaysPerspectiveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TodaysPerspectiveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["perspectiveMessageId"] = this.perspectiveMessageId;
        data["text"] = this.text;
        data["viewedLocalDate"] = this.viewedLocalDate ? this.viewedLocalDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITodaysPerspectiveResponse {
    perspectiveMessageId?: number;
    text?: string | undefined;
    viewedLocalDate?: Date;
}

export class IntakeFormItem implements IIntakeFormItem {
    userGuid?: string;
    dateOfBirth?: string | undefined;
    address?: string | undefined;
    generalPractitionerMeetings?: string | undefined;
    medicalSpecialistMeetings?: string | undefined;
    healthProfessionalsMeetings?: string | undefined;
    emergencyHospitalVisit?: string | undefined;
    inPatientHospitalVisit?: string | undefined;
    diagnosticTestsDone?: string | undefined;
    healthProfessionalsSeen?: string | undefined;
    otherHealthProfessionalsDetails?: string | undefined;
    medicalContactDetails?: string | undefined;
    emergencyContactDetails?: string | undefined;
    legalProceedings?: string | undefined;
    medicalConditions?: string | undefined;
    otherMedicalConditions?: string | undefined;
    painLocations?: string | undefined;
    painAdditionalDetails?: string | undefined;
    currentPainDuration?: string | undefined;
    painOrigin?: string | undefined;
    painTreatments?: string | undefined;
    isOnPainMedication?: string | undefined;
    dailyPainMedications?: string | undefined;
    isOnAdditionalPainMedication?: string | undefined;
    additionalDailyPainMedications?: string | undefined;
    painDiagnosisInvestigations?: string | undefined;
    painDiagnosisResults?: string | undefined;
    isCurrentlyEmployed?: string | undefined;
    currentWork?: string | undefined;
    hoursOfWorkPerFortnight?: string | undefined;
    previousWork?: string | undefined;
    workDaysMissedDueToPain?: string | undefined;
    feelingStressedOrRushed?: string | undefined;
    focusOneThing?: string | undefined;
    dailyActivitiesPlan?: string | undefined;
    lunchAndTeaBreaks?: string | undefined;
    getProperSleep?: string | undefined;
    wellRestedMornings?: string | undefined;
    exerciseHobbiesActivities?: string | undefined;
    keepPainDiary?: string | undefined;

    constructor(data?: IIntakeFormItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGuid = _data["userGuid"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.address = _data["address"];
            this.generalPractitionerMeetings = _data["generalPractitionerMeetings"];
            this.medicalSpecialistMeetings = _data["medicalSpecialistMeetings"];
            this.healthProfessionalsMeetings = _data["healthProfessionalsMeetings"];
            this.emergencyHospitalVisit = _data["emergencyHospitalVisit"];
            this.inPatientHospitalVisit = _data["inPatientHospitalVisit"];
            this.diagnosticTestsDone = _data["diagnosticTestsDone"];
            this.healthProfessionalsSeen = _data["healthProfessionalsSeen"];
            this.otherHealthProfessionalsDetails = _data["otherHealthProfessionalsDetails"];
            this.medicalContactDetails = _data["medicalContactDetails"];
            this.emergencyContactDetails = _data["emergencyContactDetails"];
            this.legalProceedings = _data["legalProceedings"];
            this.medicalConditions = _data["medicalConditions"];
            this.otherMedicalConditions = _data["otherMedicalConditions"];
            this.painLocations = _data["painLocations"];
            this.painAdditionalDetails = _data["painAdditionalDetails"];
            this.currentPainDuration = _data["currentPainDuration"];
            this.painOrigin = _data["painOrigin"];
            this.painTreatments = _data["painTreatments"];
            this.isOnPainMedication = _data["isOnPainMedication"];
            this.dailyPainMedications = _data["dailyPainMedications"];
            this.isOnAdditionalPainMedication = _data["isOnAdditionalPainMedication"];
            this.additionalDailyPainMedications = _data["additionalDailyPainMedications"];
            this.painDiagnosisInvestigations = _data["painDiagnosisInvestigations"];
            this.painDiagnosisResults = _data["painDiagnosisResults"];
            this.isCurrentlyEmployed = _data["isCurrentlyEmployed"];
            this.currentWork = _data["currentWork"];
            this.hoursOfWorkPerFortnight = _data["hoursOfWorkPerFortnight"];
            this.previousWork = _data["previousWork"];
            this.workDaysMissedDueToPain = _data["workDaysMissedDueToPain"];
            this.feelingStressedOrRushed = _data["feelingStressedOrRushed"];
            this.focusOneThing = _data["focusOneThing"];
            this.dailyActivitiesPlan = _data["dailyActivitiesPlan"];
            this.lunchAndTeaBreaks = _data["lunchAndTeaBreaks"];
            this.getProperSleep = _data["getProperSleep"];
            this.wellRestedMornings = _data["wellRestedMornings"];
            this.exerciseHobbiesActivities = _data["exerciseHobbiesActivities"];
            this.keepPainDiary = _data["keepPainDiary"];
        }
    }

    static fromJS(data: any): IntakeFormItem {
        data = typeof data === 'object' ? data : {};
        let result = new IntakeFormItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGuid"] = this.userGuid;
        data["dateOfBirth"] = this.dateOfBirth;
        data["address"] = this.address;
        data["generalPractitionerMeetings"] = this.generalPractitionerMeetings;
        data["medicalSpecialistMeetings"] = this.medicalSpecialistMeetings;
        data["healthProfessionalsMeetings"] = this.healthProfessionalsMeetings;
        data["emergencyHospitalVisit"] = this.emergencyHospitalVisit;
        data["inPatientHospitalVisit"] = this.inPatientHospitalVisit;
        data["diagnosticTestsDone"] = this.diagnosticTestsDone;
        data["healthProfessionalsSeen"] = this.healthProfessionalsSeen;
        data["otherHealthProfessionalsDetails"] = this.otherHealthProfessionalsDetails;
        data["medicalContactDetails"] = this.medicalContactDetails;
        data["emergencyContactDetails"] = this.emergencyContactDetails;
        data["legalProceedings"] = this.legalProceedings;
        data["medicalConditions"] = this.medicalConditions;
        data["otherMedicalConditions"] = this.otherMedicalConditions;
        data["painLocations"] = this.painLocations;
        data["painAdditionalDetails"] = this.painAdditionalDetails;
        data["currentPainDuration"] = this.currentPainDuration;
        data["painOrigin"] = this.painOrigin;
        data["painTreatments"] = this.painTreatments;
        data["isOnPainMedication"] = this.isOnPainMedication;
        data["dailyPainMedications"] = this.dailyPainMedications;
        data["isOnAdditionalPainMedication"] = this.isOnAdditionalPainMedication;
        data["additionalDailyPainMedications"] = this.additionalDailyPainMedications;
        data["painDiagnosisInvestigations"] = this.painDiagnosisInvestigations;
        data["painDiagnosisResults"] = this.painDiagnosisResults;
        data["isCurrentlyEmployed"] = this.isCurrentlyEmployed;
        data["currentWork"] = this.currentWork;
        data["hoursOfWorkPerFortnight"] = this.hoursOfWorkPerFortnight;
        data["previousWork"] = this.previousWork;
        data["workDaysMissedDueToPain"] = this.workDaysMissedDueToPain;
        data["feelingStressedOrRushed"] = this.feelingStressedOrRushed;
        data["focusOneThing"] = this.focusOneThing;
        data["dailyActivitiesPlan"] = this.dailyActivitiesPlan;
        data["lunchAndTeaBreaks"] = this.lunchAndTeaBreaks;
        data["getProperSleep"] = this.getProperSleep;
        data["wellRestedMornings"] = this.wellRestedMornings;
        data["exerciseHobbiesActivities"] = this.exerciseHobbiesActivities;
        data["keepPainDiary"] = this.keepPainDiary;
        return data;
    }
}

export interface IIntakeFormItem {
    userGuid?: string;
    dateOfBirth?: string | undefined;
    address?: string | undefined;
    generalPractitionerMeetings?: string | undefined;
    medicalSpecialistMeetings?: string | undefined;
    healthProfessionalsMeetings?: string | undefined;
    emergencyHospitalVisit?: string | undefined;
    inPatientHospitalVisit?: string | undefined;
    diagnosticTestsDone?: string | undefined;
    healthProfessionalsSeen?: string | undefined;
    otherHealthProfessionalsDetails?: string | undefined;
    medicalContactDetails?: string | undefined;
    emergencyContactDetails?: string | undefined;
    legalProceedings?: string | undefined;
    medicalConditions?: string | undefined;
    otherMedicalConditions?: string | undefined;
    painLocations?: string | undefined;
    painAdditionalDetails?: string | undefined;
    currentPainDuration?: string | undefined;
    painOrigin?: string | undefined;
    painTreatments?: string | undefined;
    isOnPainMedication?: string | undefined;
    dailyPainMedications?: string | undefined;
    isOnAdditionalPainMedication?: string | undefined;
    additionalDailyPainMedications?: string | undefined;
    painDiagnosisInvestigations?: string | undefined;
    painDiagnosisResults?: string | undefined;
    isCurrentlyEmployed?: string | undefined;
    currentWork?: string | undefined;
    hoursOfWorkPerFortnight?: string | undefined;
    previousWork?: string | undefined;
    workDaysMissedDueToPain?: string | undefined;
    feelingStressedOrRushed?: string | undefined;
    focusOneThing?: string | undefined;
    dailyActivitiesPlan?: string | undefined;
    lunchAndTeaBreaks?: string | undefined;
    getProperSleep?: string | undefined;
    wellRestedMornings?: string | undefined;
    exerciseHobbiesActivities?: string | undefined;
    keepPainDiary?: string | undefined;
}

export class PainQuestionnairesItem implements IPainQuestionnairesItem {
    userGuid?: string;
    worstPainLastWeek?: string | undefined;
    leastPainLastWeek?: string | undefined;
    painAverage?: string | undefined;
    currentPain?: string | undefined;
    generalActivity?: string | undefined;
    mood?: string | undefined;
    walkingAbility?: string | undefined;
    normalWork?: string | undefined;
    relationsOtherPeople?: string | undefined;
    sleep?: string | undefined;
    lifeEnjoyment?: string | undefined;
    windDown?: string | undefined;
    mouthDryness?: string | undefined;
    positiveFeeling?: string | undefined;
    initiativeDoThings?: string | undefined;
    overreact?: string | undefined;
    trembling?: string | undefined;
    nervousEnergy?: string | undefined;
    panicFoolMyself?: string | undefined;
    nothingLookForward?: string | undefined;
    agitated?: string | undefined;
    relaxDifficult?: string | undefined;
    downHeartedBlue?: string | undefined;
    intolerant?: string | undefined;
    clostToPanic?: string | undefined;
    enthusiastic?: string | undefined;
    worthPerson?: string | undefined;
    touchy?: string | undefined;
    heartAware?: string | undefined;
    scared?: string | undefined;
    meaninglessLife?: string | undefined;
    enjoyDespitePain?: string | undefined;
    doHouseholdChores?: string | undefined;
    socialiseDespitePain?: string | undefined;
    copeWithPain?: string | undefined;
    doSomeWork?: string | undefined;
    hobbiesActivities?: string | undefined;
    painWithoutMedication?: string | undefined;
    accomplishGoals?: string | undefined;
    normalLifestyle?: string | undefined;
    moreActive?: string | undefined;
    worryPainEnd?: string | undefined;
    cantGoOn?: string | undefined;
    neverGetBetter?: string | undefined;
    awfulOverwhelming?: string | undefined;
    cantStandIt?: string | undefined;
    afraidPainWorse?: string | undefined;
    thinkingPainfulEvents?: string | undefined;
    anxiouslyPainGoAway?: string | undefined;
    keepOutOfMind?: string | undefined;
    howMuchItHurts?: string | undefined;
    painToStop?: string | undefined;
    reducePain?: string | undefined;
    wonderSeriousHappen?: string | undefined;

    constructor(data?: IPainQuestionnairesItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGuid = _data["userGuid"];
            this.worstPainLastWeek = _data["worstPainLastWeek"];
            this.leastPainLastWeek = _data["leastPainLastWeek"];
            this.painAverage = _data["painAverage"];
            this.currentPain = _data["currentPain"];
            this.generalActivity = _data["generalActivity"];
            this.mood = _data["mood"];
            this.walkingAbility = _data["walkingAbility"];
            this.normalWork = _data["normalWork"];
            this.relationsOtherPeople = _data["relationsOtherPeople"];
            this.sleep = _data["sleep"];
            this.lifeEnjoyment = _data["lifeEnjoyment"];
            this.windDown = _data["windDown"];
            this.mouthDryness = _data["mouthDryness"];
            this.positiveFeeling = _data["positiveFeeling"];
            this.initiativeDoThings = _data["initiativeDoThings"];
            this.overreact = _data["overreact"];
            this.trembling = _data["trembling"];
            this.nervousEnergy = _data["nervousEnergy"];
            this.panicFoolMyself = _data["panicFoolMyself"];
            this.nothingLookForward = _data["nothingLookForward"];
            this.agitated = _data["agitated"];
            this.relaxDifficult = _data["relaxDifficult"];
            this.downHeartedBlue = _data["downHeartedBlue"];
            this.intolerant = _data["intolerant"];
            this.clostToPanic = _data["clostToPanic"];
            this.enthusiastic = _data["enthusiastic"];
            this.worthPerson = _data["worthPerson"];
            this.touchy = _data["touchy"];
            this.heartAware = _data["heartAware"];
            this.scared = _data["scared"];
            this.meaninglessLife = _data["meaninglessLife"];
            this.enjoyDespitePain = _data["enjoyDespitePain"];
            this.doHouseholdChores = _data["doHouseholdChores"];
            this.socialiseDespitePain = _data["socialiseDespitePain"];
            this.copeWithPain = _data["copeWithPain"];
            this.doSomeWork = _data["doSomeWork"];
            this.hobbiesActivities = _data["hobbiesActivities"];
            this.painWithoutMedication = _data["painWithoutMedication"];
            this.accomplishGoals = _data["accomplishGoals"];
            this.normalLifestyle = _data["normalLifestyle"];
            this.moreActive = _data["moreActive"];
            this.worryPainEnd = _data["worryPainEnd"];
            this.cantGoOn = _data["cantGoOn"];
            this.neverGetBetter = _data["neverGetBetter"];
            this.awfulOverwhelming = _data["awfulOverwhelming"];
            this.cantStandIt = _data["cantStandIt"];
            this.afraidPainWorse = _data["afraidPainWorse"];
            this.thinkingPainfulEvents = _data["thinkingPainfulEvents"];
            this.anxiouslyPainGoAway = _data["anxiouslyPainGoAway"];
            this.keepOutOfMind = _data["keepOutOfMind"];
            this.howMuchItHurts = _data["howMuchItHurts"];
            this.painToStop = _data["painToStop"];
            this.reducePain = _data["reducePain"];
            this.wonderSeriousHappen = _data["wonderSeriousHappen"];
        }
    }

    static fromJS(data: any): PainQuestionnairesItem {
        data = typeof data === 'object' ? data : {};
        let result = new PainQuestionnairesItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGuid"] = this.userGuid;
        data["worstPainLastWeek"] = this.worstPainLastWeek;
        data["leastPainLastWeek"] = this.leastPainLastWeek;
        data["painAverage"] = this.painAverage;
        data["currentPain"] = this.currentPain;
        data["generalActivity"] = this.generalActivity;
        data["mood"] = this.mood;
        data["walkingAbility"] = this.walkingAbility;
        data["normalWork"] = this.normalWork;
        data["relationsOtherPeople"] = this.relationsOtherPeople;
        data["sleep"] = this.sleep;
        data["lifeEnjoyment"] = this.lifeEnjoyment;
        data["windDown"] = this.windDown;
        data["mouthDryness"] = this.mouthDryness;
        data["positiveFeeling"] = this.positiveFeeling;
        data["initiativeDoThings"] = this.initiativeDoThings;
        data["overreact"] = this.overreact;
        data["trembling"] = this.trembling;
        data["nervousEnergy"] = this.nervousEnergy;
        data["panicFoolMyself"] = this.panicFoolMyself;
        data["nothingLookForward"] = this.nothingLookForward;
        data["agitated"] = this.agitated;
        data["relaxDifficult"] = this.relaxDifficult;
        data["downHeartedBlue"] = this.downHeartedBlue;
        data["intolerant"] = this.intolerant;
        data["clostToPanic"] = this.clostToPanic;
        data["enthusiastic"] = this.enthusiastic;
        data["worthPerson"] = this.worthPerson;
        data["touchy"] = this.touchy;
        data["heartAware"] = this.heartAware;
        data["scared"] = this.scared;
        data["meaninglessLife"] = this.meaninglessLife;
        data["enjoyDespitePain"] = this.enjoyDespitePain;
        data["doHouseholdChores"] = this.doHouseholdChores;
        data["socialiseDespitePain"] = this.socialiseDespitePain;
        data["copeWithPain"] = this.copeWithPain;
        data["doSomeWork"] = this.doSomeWork;
        data["hobbiesActivities"] = this.hobbiesActivities;
        data["painWithoutMedication"] = this.painWithoutMedication;
        data["accomplishGoals"] = this.accomplishGoals;
        data["normalLifestyle"] = this.normalLifestyle;
        data["moreActive"] = this.moreActive;
        data["worryPainEnd"] = this.worryPainEnd;
        data["cantGoOn"] = this.cantGoOn;
        data["neverGetBetter"] = this.neverGetBetter;
        data["awfulOverwhelming"] = this.awfulOverwhelming;
        data["cantStandIt"] = this.cantStandIt;
        data["afraidPainWorse"] = this.afraidPainWorse;
        data["thinkingPainfulEvents"] = this.thinkingPainfulEvents;
        data["anxiouslyPainGoAway"] = this.anxiouslyPainGoAway;
        data["keepOutOfMind"] = this.keepOutOfMind;
        data["howMuchItHurts"] = this.howMuchItHurts;
        data["painToStop"] = this.painToStop;
        data["reducePain"] = this.reducePain;
        data["wonderSeriousHappen"] = this.wonderSeriousHappen;
        return data;
    }
}

export interface IPainQuestionnairesItem {
    userGuid?: string;
    worstPainLastWeek?: string | undefined;
    leastPainLastWeek?: string | undefined;
    painAverage?: string | undefined;
    currentPain?: string | undefined;
    generalActivity?: string | undefined;
    mood?: string | undefined;
    walkingAbility?: string | undefined;
    normalWork?: string | undefined;
    relationsOtherPeople?: string | undefined;
    sleep?: string | undefined;
    lifeEnjoyment?: string | undefined;
    windDown?: string | undefined;
    mouthDryness?: string | undefined;
    positiveFeeling?: string | undefined;
    initiativeDoThings?: string | undefined;
    overreact?: string | undefined;
    trembling?: string | undefined;
    nervousEnergy?: string | undefined;
    panicFoolMyself?: string | undefined;
    nothingLookForward?: string | undefined;
    agitated?: string | undefined;
    relaxDifficult?: string | undefined;
    downHeartedBlue?: string | undefined;
    intolerant?: string | undefined;
    clostToPanic?: string | undefined;
    enthusiastic?: string | undefined;
    worthPerson?: string | undefined;
    touchy?: string | undefined;
    heartAware?: string | undefined;
    scared?: string | undefined;
    meaninglessLife?: string | undefined;
    enjoyDespitePain?: string | undefined;
    doHouseholdChores?: string | undefined;
    socialiseDespitePain?: string | undefined;
    copeWithPain?: string | undefined;
    doSomeWork?: string | undefined;
    hobbiesActivities?: string | undefined;
    painWithoutMedication?: string | undefined;
    accomplishGoals?: string | undefined;
    normalLifestyle?: string | undefined;
    moreActive?: string | undefined;
    worryPainEnd?: string | undefined;
    cantGoOn?: string | undefined;
    neverGetBetter?: string | undefined;
    awfulOverwhelming?: string | undefined;
    cantStandIt?: string | undefined;
    afraidPainWorse?: string | undefined;
    thinkingPainfulEvents?: string | undefined;
    anxiouslyPainGoAway?: string | undefined;
    keepOutOfMind?: string | undefined;
    howMuchItHurts?: string | undefined;
    painToStop?: string | undefined;
    reducePain?: string | undefined;
    wonderSeriousHappen?: string | undefined;
}

export class SixWeekAssessmentItem implements ISixWeekAssessmentItem {
    userGuid?: string;
    medicationChanged?: string | undefined;
    listDailyMedication?: string | undefined;
    usedAdditionalMedication?: string | undefined;
    medicationTaken?: string | undefined;
    worstPainLastWeek?: string | undefined;
    leastPainLastWeek?: string | undefined;
    painAverage?: string | undefined;
    currentPain?: string | undefined;
    generalActivity?: string | undefined;
    mood?: string | undefined;
    walkingAbility?: string | undefined;
    normalWork?: string | undefined;
    relationsOtherPeople?: string | undefined;
    sleep?: string | undefined;
    lifeEnjoyment?: string | undefined;
    windDown?: string | undefined;
    mouthDryness?: string | undefined;
    positiveFeeling?: string | undefined;
    breathingProblems?: string | undefined;
    initiativeDoThings?: string | undefined;
    overreact?: string | undefined;
    trembling?: string | undefined;
    nervousEnergy?: string | undefined;
    panicFoolMyself?: string | undefined;
    nothingLookForward?: string | undefined;
    agitated?: string | undefined;
    relaxDifficult?: string | undefined;
    downHeartedBlue?: string | undefined;
    intolerant?: string | undefined;
    clostToPanic?: string | undefined;
    enthusiastic?: string | undefined;
    worthPerson?: string | undefined;
    touchy?: string | undefined;
    heartAware?: string | undefined;
    scared?: string | undefined;
    meaninglessLife?: string | undefined;
    enjoyDespitePain?: string | undefined;
    doHouseholdChores?: string | undefined;
    socialiseDespitePain?: string | undefined;
    copeWithPain?: string | undefined;
    doSomeWork?: string | undefined;
    hobbiesActivities?: string | undefined;
    painWithoutMedication?: string | undefined;
    accomplishGoals?: string | undefined;
    normalLifestyle?: string | undefined;
    moreActive?: string | undefined;
    worryPainEnd?: string | undefined;
    cantGoOn?: string | undefined;
    neverGetBetter?: string | undefined;
    awfulOverwhelming?: string | undefined;
    cantStandIt?: string | undefined;
    afraidPainWorse?: string | undefined;
    thinkingPainfulEvents?: string | undefined;
    anxiouslyPainGoAway?: string | undefined;
    keepOutOfMind?: string | undefined;
    howMuchItHurts?: string | undefined;
    painToStop?: string | undefined;
    reducePain?: string | undefined;
    wonderSeriousHappen?: string | undefined;

    constructor(data?: ISixWeekAssessmentItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGuid = _data["userGuid"];
            this.medicationChanged = _data["medicationChanged"];
            this.listDailyMedication = _data["listDailyMedication"];
            this.usedAdditionalMedication = _data["usedAdditionalMedication"];
            this.medicationTaken = _data["medicationTaken"];
            this.worstPainLastWeek = _data["worstPainLastWeek"];
            this.leastPainLastWeek = _data["leastPainLastWeek"];
            this.painAverage = _data["painAverage"];
            this.currentPain = _data["currentPain"];
            this.generalActivity = _data["generalActivity"];
            this.mood = _data["mood"];
            this.walkingAbility = _data["walkingAbility"];
            this.normalWork = _data["normalWork"];
            this.relationsOtherPeople = _data["relationsOtherPeople"];
            this.sleep = _data["sleep"];
            this.lifeEnjoyment = _data["lifeEnjoyment"];
            this.windDown = _data["windDown"];
            this.mouthDryness = _data["mouthDryness"];
            this.positiveFeeling = _data["positiveFeeling"];
            this.breathingProblems = _data["breathingProblems"];
            this.initiativeDoThings = _data["initiativeDoThings"];
            this.overreact = _data["overreact"];
            this.trembling = _data["trembling"];
            this.nervousEnergy = _data["nervousEnergy"];
            this.panicFoolMyself = _data["panicFoolMyself"];
            this.nothingLookForward = _data["nothingLookForward"];
            this.agitated = _data["agitated"];
            this.relaxDifficult = _data["relaxDifficult"];
            this.downHeartedBlue = _data["downHeartedBlue"];
            this.intolerant = _data["intolerant"];
            this.clostToPanic = _data["clostToPanic"];
            this.enthusiastic = _data["enthusiastic"];
            this.worthPerson = _data["worthPerson"];
            this.touchy = _data["touchy"];
            this.heartAware = _data["heartAware"];
            this.scared = _data["scared"];
            this.meaninglessLife = _data["meaninglessLife"];
            this.enjoyDespitePain = _data["enjoyDespitePain"];
            this.doHouseholdChores = _data["doHouseholdChores"];
            this.socialiseDespitePain = _data["socialiseDespitePain"];
            this.copeWithPain = _data["copeWithPain"];
            this.doSomeWork = _data["doSomeWork"];
            this.hobbiesActivities = _data["hobbiesActivities"];
            this.painWithoutMedication = _data["painWithoutMedication"];
            this.accomplishGoals = _data["accomplishGoals"];
            this.normalLifestyle = _data["normalLifestyle"];
            this.moreActive = _data["moreActive"];
            this.worryPainEnd = _data["worryPainEnd"];
            this.cantGoOn = _data["cantGoOn"];
            this.neverGetBetter = _data["neverGetBetter"];
            this.awfulOverwhelming = _data["awfulOverwhelming"];
            this.cantStandIt = _data["cantStandIt"];
            this.afraidPainWorse = _data["afraidPainWorse"];
            this.thinkingPainfulEvents = _data["thinkingPainfulEvents"];
            this.anxiouslyPainGoAway = _data["anxiouslyPainGoAway"];
            this.keepOutOfMind = _data["keepOutOfMind"];
            this.howMuchItHurts = _data["howMuchItHurts"];
            this.painToStop = _data["painToStop"];
            this.reducePain = _data["reducePain"];
            this.wonderSeriousHappen = _data["wonderSeriousHappen"];
        }
    }

    static fromJS(data: any): SixWeekAssessmentItem {
        data = typeof data === 'object' ? data : {};
        let result = new SixWeekAssessmentItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGuid"] = this.userGuid;
        data["medicationChanged"] = this.medicationChanged;
        data["listDailyMedication"] = this.listDailyMedication;
        data["usedAdditionalMedication"] = this.usedAdditionalMedication;
        data["medicationTaken"] = this.medicationTaken;
        data["worstPainLastWeek"] = this.worstPainLastWeek;
        data["leastPainLastWeek"] = this.leastPainLastWeek;
        data["painAverage"] = this.painAverage;
        data["currentPain"] = this.currentPain;
        data["generalActivity"] = this.generalActivity;
        data["mood"] = this.mood;
        data["walkingAbility"] = this.walkingAbility;
        data["normalWork"] = this.normalWork;
        data["relationsOtherPeople"] = this.relationsOtherPeople;
        data["sleep"] = this.sleep;
        data["lifeEnjoyment"] = this.lifeEnjoyment;
        data["windDown"] = this.windDown;
        data["mouthDryness"] = this.mouthDryness;
        data["positiveFeeling"] = this.positiveFeeling;
        data["breathingProblems"] = this.breathingProblems;
        data["initiativeDoThings"] = this.initiativeDoThings;
        data["overreact"] = this.overreact;
        data["trembling"] = this.trembling;
        data["nervousEnergy"] = this.nervousEnergy;
        data["panicFoolMyself"] = this.panicFoolMyself;
        data["nothingLookForward"] = this.nothingLookForward;
        data["agitated"] = this.agitated;
        data["relaxDifficult"] = this.relaxDifficult;
        data["downHeartedBlue"] = this.downHeartedBlue;
        data["intolerant"] = this.intolerant;
        data["clostToPanic"] = this.clostToPanic;
        data["enthusiastic"] = this.enthusiastic;
        data["worthPerson"] = this.worthPerson;
        data["touchy"] = this.touchy;
        data["heartAware"] = this.heartAware;
        data["scared"] = this.scared;
        data["meaninglessLife"] = this.meaninglessLife;
        data["enjoyDespitePain"] = this.enjoyDespitePain;
        data["doHouseholdChores"] = this.doHouseholdChores;
        data["socialiseDespitePain"] = this.socialiseDespitePain;
        data["copeWithPain"] = this.copeWithPain;
        data["doSomeWork"] = this.doSomeWork;
        data["hobbiesActivities"] = this.hobbiesActivities;
        data["painWithoutMedication"] = this.painWithoutMedication;
        data["accomplishGoals"] = this.accomplishGoals;
        data["normalLifestyle"] = this.normalLifestyle;
        data["moreActive"] = this.moreActive;
        data["worryPainEnd"] = this.worryPainEnd;
        data["cantGoOn"] = this.cantGoOn;
        data["neverGetBetter"] = this.neverGetBetter;
        data["awfulOverwhelming"] = this.awfulOverwhelming;
        data["cantStandIt"] = this.cantStandIt;
        data["afraidPainWorse"] = this.afraidPainWorse;
        data["thinkingPainfulEvents"] = this.thinkingPainfulEvents;
        data["anxiouslyPainGoAway"] = this.anxiouslyPainGoAway;
        data["keepOutOfMind"] = this.keepOutOfMind;
        data["howMuchItHurts"] = this.howMuchItHurts;
        data["painToStop"] = this.painToStop;
        data["reducePain"] = this.reducePain;
        data["wonderSeriousHappen"] = this.wonderSeriousHappen;
        return data;
    }
}

export interface ISixWeekAssessmentItem {
    userGuid?: string;
    medicationChanged?: string | undefined;
    listDailyMedication?: string | undefined;
    usedAdditionalMedication?: string | undefined;
    medicationTaken?: string | undefined;
    worstPainLastWeek?: string | undefined;
    leastPainLastWeek?: string | undefined;
    painAverage?: string | undefined;
    currentPain?: string | undefined;
    generalActivity?: string | undefined;
    mood?: string | undefined;
    walkingAbility?: string | undefined;
    normalWork?: string | undefined;
    relationsOtherPeople?: string | undefined;
    sleep?: string | undefined;
    lifeEnjoyment?: string | undefined;
    windDown?: string | undefined;
    mouthDryness?: string | undefined;
    positiveFeeling?: string | undefined;
    breathingProblems?: string | undefined;
    initiativeDoThings?: string | undefined;
    overreact?: string | undefined;
    trembling?: string | undefined;
    nervousEnergy?: string | undefined;
    panicFoolMyself?: string | undefined;
    nothingLookForward?: string | undefined;
    agitated?: string | undefined;
    relaxDifficult?: string | undefined;
    downHeartedBlue?: string | undefined;
    intolerant?: string | undefined;
    clostToPanic?: string | undefined;
    enthusiastic?: string | undefined;
    worthPerson?: string | undefined;
    touchy?: string | undefined;
    heartAware?: string | undefined;
    scared?: string | undefined;
    meaninglessLife?: string | undefined;
    enjoyDespitePain?: string | undefined;
    doHouseholdChores?: string | undefined;
    socialiseDespitePain?: string | undefined;
    copeWithPain?: string | undefined;
    doSomeWork?: string | undefined;
    hobbiesActivities?: string | undefined;
    painWithoutMedication?: string | undefined;
    accomplishGoals?: string | undefined;
    normalLifestyle?: string | undefined;
    moreActive?: string | undefined;
    worryPainEnd?: string | undefined;
    cantGoOn?: string | undefined;
    neverGetBetter?: string | undefined;
    awfulOverwhelming?: string | undefined;
    cantStandIt?: string | undefined;
    afraidPainWorse?: string | undefined;
    thinkingPainfulEvents?: string | undefined;
    anxiouslyPainGoAway?: string | undefined;
    keepOutOfMind?: string | undefined;
    howMuchItHurts?: string | undefined;
    painToStop?: string | undefined;
    reducePain?: string | undefined;
    wonderSeriousHappen?: string | undefined;
}

export class TwelveWeekAssessmentItem implements ITwelveWeekAssessmentItem {
    userGuid?: string;
    medicationChanged?: string | undefined;
    listDailyMedication?: string | undefined;
    usedAdditionalMedication?: string | undefined;
    medicationTaken?: string | undefined;
    generalPractitionerMeetings?: string | undefined;
    medicalSpecialistMeetings?: string | undefined;
    healthProfessionalsMeetings?: string | undefined;
    emergencyHospitalVisit?: string | undefined;
    inPatientHospitalVisit?: string | undefined;
    diagnosticTestsDone?: string | undefined;
    workCertificateDutiesChanged?: string | undefined;
    ifYesWorkChanged?: string | undefined;
    ifNoWorkChanged?: string | undefined;
    worstPainLastWeek?: string | undefined;
    leastPainLastWeek?: string | undefined;
    painAverage?: string | undefined;
    currentPain?: string | undefined;
    generalActivity?: string | undefined;
    mood?: string | undefined;
    walkingAbility?: string | undefined;
    normalWork?: string | undefined;
    relationsOtherPeople?: string | undefined;
    sleep?: string | undefined;
    lifeEnjoyment?: string | undefined;
    windDown?: string | undefined;
    mouthDryness?: string | undefined;
    positiveFeeling?: string | undefined;
    breathingProblems?: string | undefined;
    initiativeDoThings?: string | undefined;
    overreact?: string | undefined;
    trembling?: string | undefined;
    nervousEnergy?: string | undefined;
    panicFoolMyself?: string | undefined;
    nothingLookForward?: string | undefined;
    agitated?: string | undefined;
    relaxDifficult?: string | undefined;
    downHeartedBlue?: string | undefined;
    intolerant?: string | undefined;
    clostToPanic?: string | undefined;
    enthusiastic?: string | undefined;
    worthPerson?: string | undefined;
    touchy?: string | undefined;
    heartAware?: string | undefined;
    scared?: string | undefined;
    meaninglessLife?: string | undefined;
    enjoyDespitePain?: string | undefined;
    doHouseholdChores?: string | undefined;
    socialiseDespitePain?: string | undefined;
    copeWithPain?: string | undefined;
    doSomeWork?: string | undefined;
    hobbiesActivities?: string | undefined;
    painWithoutMedication?: string | undefined;
    accomplishGoals?: string | undefined;
    normalLifestyle?: string | undefined;
    moreActive?: string | undefined;
    worryPainEnd?: string | undefined;
    cantGoOn?: string | undefined;
    neverGetBetter?: string | undefined;
    awfulOverwhelming?: string | undefined;
    cantStandIt?: string | undefined;
    afraidPainWorse?: string | undefined;
    thinkingPainfulEvents?: string | undefined;
    anxiouslyPainGoAway?: string | undefined;
    keepOutOfMind?: string | undefined;
    howMuchItHurts?: string | undefined;
    painToStop?: string | undefined;
    reducePain?: string | undefined;
    wonderSeriousHappen?: string | undefined;

    constructor(data?: ITwelveWeekAssessmentItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGuid = _data["userGuid"];
            this.medicationChanged = _data["medicationChanged"];
            this.listDailyMedication = _data["listDailyMedication"];
            this.usedAdditionalMedication = _data["usedAdditionalMedication"];
            this.medicationTaken = _data["medicationTaken"];
            this.generalPractitionerMeetings = _data["generalPractitionerMeetings"];
            this.medicalSpecialistMeetings = _data["medicalSpecialistMeetings"];
            this.healthProfessionalsMeetings = _data["healthProfessionalsMeetings"];
            this.emergencyHospitalVisit = _data["emergencyHospitalVisit"];
            this.inPatientHospitalVisit = _data["inPatientHospitalVisit"];
            this.diagnosticTestsDone = _data["diagnosticTestsDone"];
            this.workCertificateDutiesChanged = _data["workCertificateDutiesChanged"];
            this.ifYesWorkChanged = _data["ifYesWorkChanged"];
            this.ifNoWorkChanged = _data["ifNoWorkChanged"];
            this.worstPainLastWeek = _data["worstPainLastWeek"];
            this.leastPainLastWeek = _data["leastPainLastWeek"];
            this.painAverage = _data["painAverage"];
            this.currentPain = _data["currentPain"];
            this.generalActivity = _data["generalActivity"];
            this.mood = _data["mood"];
            this.walkingAbility = _data["walkingAbility"];
            this.normalWork = _data["normalWork"];
            this.relationsOtherPeople = _data["relationsOtherPeople"];
            this.sleep = _data["sleep"];
            this.lifeEnjoyment = _data["lifeEnjoyment"];
            this.windDown = _data["windDown"];
            this.mouthDryness = _data["mouthDryness"];
            this.positiveFeeling = _data["positiveFeeling"];
            this.breathingProblems = _data["breathingProblems"];
            this.initiativeDoThings = _data["initiativeDoThings"];
            this.overreact = _data["overreact"];
            this.trembling = _data["trembling"];
            this.nervousEnergy = _data["nervousEnergy"];
            this.panicFoolMyself = _data["panicFoolMyself"];
            this.nothingLookForward = _data["nothingLookForward"];
            this.agitated = _data["agitated"];
            this.relaxDifficult = _data["relaxDifficult"];
            this.downHeartedBlue = _data["downHeartedBlue"];
            this.intolerant = _data["intolerant"];
            this.clostToPanic = _data["clostToPanic"];
            this.enthusiastic = _data["enthusiastic"];
            this.worthPerson = _data["worthPerson"];
            this.touchy = _data["touchy"];
            this.heartAware = _data["heartAware"];
            this.scared = _data["scared"];
            this.meaninglessLife = _data["meaninglessLife"];
            this.enjoyDespitePain = _data["enjoyDespitePain"];
            this.doHouseholdChores = _data["doHouseholdChores"];
            this.socialiseDespitePain = _data["socialiseDespitePain"];
            this.copeWithPain = _data["copeWithPain"];
            this.doSomeWork = _data["doSomeWork"];
            this.hobbiesActivities = _data["hobbiesActivities"];
            this.painWithoutMedication = _data["painWithoutMedication"];
            this.accomplishGoals = _data["accomplishGoals"];
            this.normalLifestyle = _data["normalLifestyle"];
            this.moreActive = _data["moreActive"];
            this.worryPainEnd = _data["worryPainEnd"];
            this.cantGoOn = _data["cantGoOn"];
            this.neverGetBetter = _data["neverGetBetter"];
            this.awfulOverwhelming = _data["awfulOverwhelming"];
            this.cantStandIt = _data["cantStandIt"];
            this.afraidPainWorse = _data["afraidPainWorse"];
            this.thinkingPainfulEvents = _data["thinkingPainfulEvents"];
            this.anxiouslyPainGoAway = _data["anxiouslyPainGoAway"];
            this.keepOutOfMind = _data["keepOutOfMind"];
            this.howMuchItHurts = _data["howMuchItHurts"];
            this.painToStop = _data["painToStop"];
            this.reducePain = _data["reducePain"];
            this.wonderSeriousHappen = _data["wonderSeriousHappen"];
        }
    }

    static fromJS(data: any): TwelveWeekAssessmentItem {
        data = typeof data === 'object' ? data : {};
        let result = new TwelveWeekAssessmentItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGuid"] = this.userGuid;
        data["medicationChanged"] = this.medicationChanged;
        data["listDailyMedication"] = this.listDailyMedication;
        data["usedAdditionalMedication"] = this.usedAdditionalMedication;
        data["medicationTaken"] = this.medicationTaken;
        data["generalPractitionerMeetings"] = this.generalPractitionerMeetings;
        data["medicalSpecialistMeetings"] = this.medicalSpecialistMeetings;
        data["healthProfessionalsMeetings"] = this.healthProfessionalsMeetings;
        data["emergencyHospitalVisit"] = this.emergencyHospitalVisit;
        data["inPatientHospitalVisit"] = this.inPatientHospitalVisit;
        data["diagnosticTestsDone"] = this.diagnosticTestsDone;
        data["workCertificateDutiesChanged"] = this.workCertificateDutiesChanged;
        data["ifYesWorkChanged"] = this.ifYesWorkChanged;
        data["ifNoWorkChanged"] = this.ifNoWorkChanged;
        data["worstPainLastWeek"] = this.worstPainLastWeek;
        data["leastPainLastWeek"] = this.leastPainLastWeek;
        data["painAverage"] = this.painAverage;
        data["currentPain"] = this.currentPain;
        data["generalActivity"] = this.generalActivity;
        data["mood"] = this.mood;
        data["walkingAbility"] = this.walkingAbility;
        data["normalWork"] = this.normalWork;
        data["relationsOtherPeople"] = this.relationsOtherPeople;
        data["sleep"] = this.sleep;
        data["lifeEnjoyment"] = this.lifeEnjoyment;
        data["windDown"] = this.windDown;
        data["mouthDryness"] = this.mouthDryness;
        data["positiveFeeling"] = this.positiveFeeling;
        data["breathingProblems"] = this.breathingProblems;
        data["initiativeDoThings"] = this.initiativeDoThings;
        data["overreact"] = this.overreact;
        data["trembling"] = this.trembling;
        data["nervousEnergy"] = this.nervousEnergy;
        data["panicFoolMyself"] = this.panicFoolMyself;
        data["nothingLookForward"] = this.nothingLookForward;
        data["agitated"] = this.agitated;
        data["relaxDifficult"] = this.relaxDifficult;
        data["downHeartedBlue"] = this.downHeartedBlue;
        data["intolerant"] = this.intolerant;
        data["clostToPanic"] = this.clostToPanic;
        data["enthusiastic"] = this.enthusiastic;
        data["worthPerson"] = this.worthPerson;
        data["touchy"] = this.touchy;
        data["heartAware"] = this.heartAware;
        data["scared"] = this.scared;
        data["meaninglessLife"] = this.meaninglessLife;
        data["enjoyDespitePain"] = this.enjoyDespitePain;
        data["doHouseholdChores"] = this.doHouseholdChores;
        data["socialiseDespitePain"] = this.socialiseDespitePain;
        data["copeWithPain"] = this.copeWithPain;
        data["doSomeWork"] = this.doSomeWork;
        data["hobbiesActivities"] = this.hobbiesActivities;
        data["painWithoutMedication"] = this.painWithoutMedication;
        data["accomplishGoals"] = this.accomplishGoals;
        data["normalLifestyle"] = this.normalLifestyle;
        data["moreActive"] = this.moreActive;
        data["worryPainEnd"] = this.worryPainEnd;
        data["cantGoOn"] = this.cantGoOn;
        data["neverGetBetter"] = this.neverGetBetter;
        data["awfulOverwhelming"] = this.awfulOverwhelming;
        data["cantStandIt"] = this.cantStandIt;
        data["afraidPainWorse"] = this.afraidPainWorse;
        data["thinkingPainfulEvents"] = this.thinkingPainfulEvents;
        data["anxiouslyPainGoAway"] = this.anxiouslyPainGoAway;
        data["keepOutOfMind"] = this.keepOutOfMind;
        data["howMuchItHurts"] = this.howMuchItHurts;
        data["painToStop"] = this.painToStop;
        data["reducePain"] = this.reducePain;
        data["wonderSeriousHappen"] = this.wonderSeriousHappen;
        return data;
    }
}

export interface ITwelveWeekAssessmentItem {
    userGuid?: string;
    medicationChanged?: string | undefined;
    listDailyMedication?: string | undefined;
    usedAdditionalMedication?: string | undefined;
    medicationTaken?: string | undefined;
    generalPractitionerMeetings?: string | undefined;
    medicalSpecialistMeetings?: string | undefined;
    healthProfessionalsMeetings?: string | undefined;
    emergencyHospitalVisit?: string | undefined;
    inPatientHospitalVisit?: string | undefined;
    diagnosticTestsDone?: string | undefined;
    workCertificateDutiesChanged?: string | undefined;
    ifYesWorkChanged?: string | undefined;
    ifNoWorkChanged?: string | undefined;
    worstPainLastWeek?: string | undefined;
    leastPainLastWeek?: string | undefined;
    painAverage?: string | undefined;
    currentPain?: string | undefined;
    generalActivity?: string | undefined;
    mood?: string | undefined;
    walkingAbility?: string | undefined;
    normalWork?: string | undefined;
    relationsOtherPeople?: string | undefined;
    sleep?: string | undefined;
    lifeEnjoyment?: string | undefined;
    windDown?: string | undefined;
    mouthDryness?: string | undefined;
    positiveFeeling?: string | undefined;
    breathingProblems?: string | undefined;
    initiativeDoThings?: string | undefined;
    overreact?: string | undefined;
    trembling?: string | undefined;
    nervousEnergy?: string | undefined;
    panicFoolMyself?: string | undefined;
    nothingLookForward?: string | undefined;
    agitated?: string | undefined;
    relaxDifficult?: string | undefined;
    downHeartedBlue?: string | undefined;
    intolerant?: string | undefined;
    clostToPanic?: string | undefined;
    enthusiastic?: string | undefined;
    worthPerson?: string | undefined;
    touchy?: string | undefined;
    heartAware?: string | undefined;
    scared?: string | undefined;
    meaninglessLife?: string | undefined;
    enjoyDespitePain?: string | undefined;
    doHouseholdChores?: string | undefined;
    socialiseDespitePain?: string | undefined;
    copeWithPain?: string | undefined;
    doSomeWork?: string | undefined;
    hobbiesActivities?: string | undefined;
    painWithoutMedication?: string | undefined;
    accomplishGoals?: string | undefined;
    normalLifestyle?: string | undefined;
    moreActive?: string | undefined;
    worryPainEnd?: string | undefined;
    cantGoOn?: string | undefined;
    neverGetBetter?: string | undefined;
    awfulOverwhelming?: string | undefined;
    cantStandIt?: string | undefined;
    afraidPainWorse?: string | undefined;
    thinkingPainfulEvents?: string | undefined;
    anxiouslyPainGoAway?: string | undefined;
    keepOutOfMind?: string | undefined;
    howMuchItHurts?: string | undefined;
    painToStop?: string | undefined;
    reducePain?: string | undefined;
    wonderSeriousHappen?: string | undefined;
}

export class PostProgramAssessmentItem implements IPostProgramAssessmentItem {
    userGuid?: string;
    iteration?: number;
    medicationChanged?: string | undefined;
    listDailyMedication?: string | undefined;
    usedAdditionalMedication?: string | undefined;
    medicationTaken?: string | undefined;
    generalPractitionerMeetings?: string | undefined;
    medicalSpecialistMeetings?: string | undefined;
    healthProfessionalsMeetings?: string | undefined;
    emergencyHospitalVisit?: string | undefined;
    inPatientHospitalVisit?: string | undefined;
    diagnosticTestsDone?: string | undefined;
    workCertificateDutiesChanged?: string | undefined;
    ifYesWorkChanged?: string | undefined;
    ifNoWorkChanged?: string | undefined;
    worstPainLastWeek?: string | undefined;
    leastPainLastWeek?: string | undefined;
    painAverage?: string | undefined;
    currentPain?: string | undefined;
    generalActivity?: string | undefined;
    mood?: string | undefined;
    walkingAbility?: string | undefined;
    normalWork?: string | undefined;
    relationsOtherPeople?: string | undefined;
    sleep?: string | undefined;
    lifeEnjoyment?: string | undefined;
    windDown?: string | undefined;
    mouthDryness?: string | undefined;
    positiveFeeling?: string | undefined;
    breathingProblems?: string | undefined;
    initiativeDoThings?: string | undefined;
    overreact?: string | undefined;
    trembling?: string | undefined;
    nervousEnergy?: string | undefined;
    panicFoolMyself?: string | undefined;
    nothingLookForward?: string | undefined;
    agitated?: string | undefined;
    relaxDifficult?: string | undefined;
    downHeartedBlue?: string | undefined;
    intolerant?: string | undefined;
    clostToPanic?: string | undefined;
    enthusiastic?: string | undefined;
    worthPerson?: string | undefined;
    touchy?: string | undefined;
    heartAware?: string | undefined;
    scared?: string | undefined;
    meaninglessLife?: string | undefined;
    enjoyDespitePain?: string | undefined;
    doHouseholdChores?: string | undefined;
    socialiseDespitePain?: string | undefined;
    copeWithPain?: string | undefined;
    doSomeWork?: string | undefined;
    hobbiesActivities?: string | undefined;
    painWithoutMedication?: string | undefined;
    accomplishGoals?: string | undefined;
    normalLifestyle?: string | undefined;
    moreActive?: string | undefined;
    worryPainEnd?: string | undefined;
    cantGoOn?: string | undefined;
    neverGetBetter?: string | undefined;
    awfulOverwhelming?: string | undefined;
    cantStandIt?: string | undefined;
    afraidPainWorse?: string | undefined;
    thinkingPainfulEvents?: string | undefined;
    anxiouslyPainGoAway?: string | undefined;
    keepOutOfMind?: string | undefined;
    howMuchItHurts?: string | undefined;
    painToStop?: string | undefined;
    reducePain?: string | undefined;
    wonderSeriousHappen?: string | undefined;

    constructor(data?: IPostProgramAssessmentItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGuid = _data["userGuid"];
            this.iteration = _data["iteration"];
            this.medicationChanged = _data["medicationChanged"];
            this.listDailyMedication = _data["listDailyMedication"];
            this.usedAdditionalMedication = _data["usedAdditionalMedication"];
            this.medicationTaken = _data["medicationTaken"];
            this.generalPractitionerMeetings = _data["generalPractitionerMeetings"];
            this.medicalSpecialistMeetings = _data["medicalSpecialistMeetings"];
            this.healthProfessionalsMeetings = _data["healthProfessionalsMeetings"];
            this.emergencyHospitalVisit = _data["emergencyHospitalVisit"];
            this.inPatientHospitalVisit = _data["inPatientHospitalVisit"];
            this.diagnosticTestsDone = _data["diagnosticTestsDone"];
            this.workCertificateDutiesChanged = _data["workCertificateDutiesChanged"];
            this.ifYesWorkChanged = _data["ifYesWorkChanged"];
            this.ifNoWorkChanged = _data["ifNoWorkChanged"];
            this.worstPainLastWeek = _data["worstPainLastWeek"];
            this.leastPainLastWeek = _data["leastPainLastWeek"];
            this.painAverage = _data["painAverage"];
            this.currentPain = _data["currentPain"];
            this.generalActivity = _data["generalActivity"];
            this.mood = _data["mood"];
            this.walkingAbility = _data["walkingAbility"];
            this.normalWork = _data["normalWork"];
            this.relationsOtherPeople = _data["relationsOtherPeople"];
            this.sleep = _data["sleep"];
            this.lifeEnjoyment = _data["lifeEnjoyment"];
            this.windDown = _data["windDown"];
            this.mouthDryness = _data["mouthDryness"];
            this.positiveFeeling = _data["positiveFeeling"];
            this.breathingProblems = _data["breathingProblems"];
            this.initiativeDoThings = _data["initiativeDoThings"];
            this.overreact = _data["overreact"];
            this.trembling = _data["trembling"];
            this.nervousEnergy = _data["nervousEnergy"];
            this.panicFoolMyself = _data["panicFoolMyself"];
            this.nothingLookForward = _data["nothingLookForward"];
            this.agitated = _data["agitated"];
            this.relaxDifficult = _data["relaxDifficult"];
            this.downHeartedBlue = _data["downHeartedBlue"];
            this.intolerant = _data["intolerant"];
            this.clostToPanic = _data["clostToPanic"];
            this.enthusiastic = _data["enthusiastic"];
            this.worthPerson = _data["worthPerson"];
            this.touchy = _data["touchy"];
            this.heartAware = _data["heartAware"];
            this.scared = _data["scared"];
            this.meaninglessLife = _data["meaninglessLife"];
            this.enjoyDespitePain = _data["enjoyDespitePain"];
            this.doHouseholdChores = _data["doHouseholdChores"];
            this.socialiseDespitePain = _data["socialiseDespitePain"];
            this.copeWithPain = _data["copeWithPain"];
            this.doSomeWork = _data["doSomeWork"];
            this.hobbiesActivities = _data["hobbiesActivities"];
            this.painWithoutMedication = _data["painWithoutMedication"];
            this.accomplishGoals = _data["accomplishGoals"];
            this.normalLifestyle = _data["normalLifestyle"];
            this.moreActive = _data["moreActive"];
            this.worryPainEnd = _data["worryPainEnd"];
            this.cantGoOn = _data["cantGoOn"];
            this.neverGetBetter = _data["neverGetBetter"];
            this.awfulOverwhelming = _data["awfulOverwhelming"];
            this.cantStandIt = _data["cantStandIt"];
            this.afraidPainWorse = _data["afraidPainWorse"];
            this.thinkingPainfulEvents = _data["thinkingPainfulEvents"];
            this.anxiouslyPainGoAway = _data["anxiouslyPainGoAway"];
            this.keepOutOfMind = _data["keepOutOfMind"];
            this.howMuchItHurts = _data["howMuchItHurts"];
            this.painToStop = _data["painToStop"];
            this.reducePain = _data["reducePain"];
            this.wonderSeriousHappen = _data["wonderSeriousHappen"];
        }
    }

    static fromJS(data: any): PostProgramAssessmentItem {
        data = typeof data === 'object' ? data : {};
        let result = new PostProgramAssessmentItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGuid"] = this.userGuid;
        data["iteration"] = this.iteration;
        data["medicationChanged"] = this.medicationChanged;
        data["listDailyMedication"] = this.listDailyMedication;
        data["usedAdditionalMedication"] = this.usedAdditionalMedication;
        data["medicationTaken"] = this.medicationTaken;
        data["generalPractitionerMeetings"] = this.generalPractitionerMeetings;
        data["medicalSpecialistMeetings"] = this.medicalSpecialistMeetings;
        data["healthProfessionalsMeetings"] = this.healthProfessionalsMeetings;
        data["emergencyHospitalVisit"] = this.emergencyHospitalVisit;
        data["inPatientHospitalVisit"] = this.inPatientHospitalVisit;
        data["diagnosticTestsDone"] = this.diagnosticTestsDone;
        data["workCertificateDutiesChanged"] = this.workCertificateDutiesChanged;
        data["ifYesWorkChanged"] = this.ifYesWorkChanged;
        data["ifNoWorkChanged"] = this.ifNoWorkChanged;
        data["worstPainLastWeek"] = this.worstPainLastWeek;
        data["leastPainLastWeek"] = this.leastPainLastWeek;
        data["painAverage"] = this.painAverage;
        data["currentPain"] = this.currentPain;
        data["generalActivity"] = this.generalActivity;
        data["mood"] = this.mood;
        data["walkingAbility"] = this.walkingAbility;
        data["normalWork"] = this.normalWork;
        data["relationsOtherPeople"] = this.relationsOtherPeople;
        data["sleep"] = this.sleep;
        data["lifeEnjoyment"] = this.lifeEnjoyment;
        data["windDown"] = this.windDown;
        data["mouthDryness"] = this.mouthDryness;
        data["positiveFeeling"] = this.positiveFeeling;
        data["breathingProblems"] = this.breathingProblems;
        data["initiativeDoThings"] = this.initiativeDoThings;
        data["overreact"] = this.overreact;
        data["trembling"] = this.trembling;
        data["nervousEnergy"] = this.nervousEnergy;
        data["panicFoolMyself"] = this.panicFoolMyself;
        data["nothingLookForward"] = this.nothingLookForward;
        data["agitated"] = this.agitated;
        data["relaxDifficult"] = this.relaxDifficult;
        data["downHeartedBlue"] = this.downHeartedBlue;
        data["intolerant"] = this.intolerant;
        data["clostToPanic"] = this.clostToPanic;
        data["enthusiastic"] = this.enthusiastic;
        data["worthPerson"] = this.worthPerson;
        data["touchy"] = this.touchy;
        data["heartAware"] = this.heartAware;
        data["scared"] = this.scared;
        data["meaninglessLife"] = this.meaninglessLife;
        data["enjoyDespitePain"] = this.enjoyDespitePain;
        data["doHouseholdChores"] = this.doHouseholdChores;
        data["socialiseDespitePain"] = this.socialiseDespitePain;
        data["copeWithPain"] = this.copeWithPain;
        data["doSomeWork"] = this.doSomeWork;
        data["hobbiesActivities"] = this.hobbiesActivities;
        data["painWithoutMedication"] = this.painWithoutMedication;
        data["accomplishGoals"] = this.accomplishGoals;
        data["normalLifestyle"] = this.normalLifestyle;
        data["moreActive"] = this.moreActive;
        data["worryPainEnd"] = this.worryPainEnd;
        data["cantGoOn"] = this.cantGoOn;
        data["neverGetBetter"] = this.neverGetBetter;
        data["awfulOverwhelming"] = this.awfulOverwhelming;
        data["cantStandIt"] = this.cantStandIt;
        data["afraidPainWorse"] = this.afraidPainWorse;
        data["thinkingPainfulEvents"] = this.thinkingPainfulEvents;
        data["anxiouslyPainGoAway"] = this.anxiouslyPainGoAway;
        data["keepOutOfMind"] = this.keepOutOfMind;
        data["howMuchItHurts"] = this.howMuchItHurts;
        data["painToStop"] = this.painToStop;
        data["reducePain"] = this.reducePain;
        data["wonderSeriousHappen"] = this.wonderSeriousHappen;
        return data;
    }
}

export interface IPostProgramAssessmentItem {
    userGuid?: string;
    iteration?: number;
    medicationChanged?: string | undefined;
    listDailyMedication?: string | undefined;
    usedAdditionalMedication?: string | undefined;
    medicationTaken?: string | undefined;
    generalPractitionerMeetings?: string | undefined;
    medicalSpecialistMeetings?: string | undefined;
    healthProfessionalsMeetings?: string | undefined;
    emergencyHospitalVisit?: string | undefined;
    inPatientHospitalVisit?: string | undefined;
    diagnosticTestsDone?: string | undefined;
    workCertificateDutiesChanged?: string | undefined;
    ifYesWorkChanged?: string | undefined;
    ifNoWorkChanged?: string | undefined;
    worstPainLastWeek?: string | undefined;
    leastPainLastWeek?: string | undefined;
    painAverage?: string | undefined;
    currentPain?: string | undefined;
    generalActivity?: string | undefined;
    mood?: string | undefined;
    walkingAbility?: string | undefined;
    normalWork?: string | undefined;
    relationsOtherPeople?: string | undefined;
    sleep?: string | undefined;
    lifeEnjoyment?: string | undefined;
    windDown?: string | undefined;
    mouthDryness?: string | undefined;
    positiveFeeling?: string | undefined;
    breathingProblems?: string | undefined;
    initiativeDoThings?: string | undefined;
    overreact?: string | undefined;
    trembling?: string | undefined;
    nervousEnergy?: string | undefined;
    panicFoolMyself?: string | undefined;
    nothingLookForward?: string | undefined;
    agitated?: string | undefined;
    relaxDifficult?: string | undefined;
    downHeartedBlue?: string | undefined;
    intolerant?: string | undefined;
    clostToPanic?: string | undefined;
    enthusiastic?: string | undefined;
    worthPerson?: string | undefined;
    touchy?: string | undefined;
    heartAware?: string | undefined;
    scared?: string | undefined;
    meaninglessLife?: string | undefined;
    enjoyDespitePain?: string | undefined;
    doHouseholdChores?: string | undefined;
    socialiseDespitePain?: string | undefined;
    copeWithPain?: string | undefined;
    doSomeWork?: string | undefined;
    hobbiesActivities?: string | undefined;
    painWithoutMedication?: string | undefined;
    accomplishGoals?: string | undefined;
    normalLifestyle?: string | undefined;
    moreActive?: string | undefined;
    worryPainEnd?: string | undefined;
    cantGoOn?: string | undefined;
    neverGetBetter?: string | undefined;
    awfulOverwhelming?: string | undefined;
    cantStandIt?: string | undefined;
    afraidPainWorse?: string | undefined;
    thinkingPainfulEvents?: string | undefined;
    anxiouslyPainGoAway?: string | undefined;
    keepOutOfMind?: string | undefined;
    howMuchItHurts?: string | undefined;
    painToStop?: string | undefined;
    reducePain?: string | undefined;
    wonderSeriousHappen?: string | undefined;
}

export class PhodaScoreItem implements IPhodaScoreItem {
    userGuid?: string;
    phodaScore?: string | undefined;
    topImages?: string | undefined;
    topChosenImages?: string | undefined;

    constructor(data?: IPhodaScoreItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGuid = _data["userGuid"];
            this.phodaScore = _data["phodaScore"];
            this.topImages = _data["topImages"];
            this.topChosenImages = _data["topChosenImages"];
        }
    }

    static fromJS(data: any): PhodaScoreItem {
        data = typeof data === 'object' ? data : {};
        let result = new PhodaScoreItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGuid"] = this.userGuid;
        data["phodaScore"] = this.phodaScore;
        data["topImages"] = this.topImages;
        data["topChosenImages"] = this.topChosenImages;
        return data;
    }
}

export interface IPhodaScoreItem {
    userGuid?: string;
    phodaScore?: string | undefined;
    topImages?: string | undefined;
    topChosenImages?: string | undefined;
}

export class FormUserCompletionResponse implements IFormUserCompletionResponse {
    formUserCompletionId?: number;
    userGuid?: string;
    phodaLastUpdate?: Date | undefined;
    intakeForm?: Date | undefined;
    painQuestionnaires?: Date | undefined;
    sixWeekAssessment?: Date | undefined;
    twelveWeekAssessment?: Date | undefined;
    postProgramAssessment1?: Date | undefined;
    postProgramAssessment2?: Date | undefined;
    postProgramAssessment3?: Date | undefined;
    updateDate?: Date | undefined;
    insertDate?: Date;

    constructor(data?: IFormUserCompletionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formUserCompletionId = _data["formUserCompletionId"];
            this.userGuid = _data["userGuid"];
            this.phodaLastUpdate = _data["phodaLastUpdate"] ? new Date(_data["phodaLastUpdate"].toString()) : <any>undefined;
            this.intakeForm = _data["intakeForm"] ? new Date(_data["intakeForm"].toString()) : <any>undefined;
            this.painQuestionnaires = _data["painQuestionnaires"] ? new Date(_data["painQuestionnaires"].toString()) : <any>undefined;
            this.sixWeekAssessment = _data["sixWeekAssessment"] ? new Date(_data["sixWeekAssessment"].toString()) : <any>undefined;
            this.twelveWeekAssessment = _data["twelveWeekAssessment"] ? new Date(_data["twelveWeekAssessment"].toString()) : <any>undefined;
            this.postProgramAssessment1 = _data["postProgramAssessment1"] ? new Date(_data["postProgramAssessment1"].toString()) : <any>undefined;
            this.postProgramAssessment2 = _data["postProgramAssessment2"] ? new Date(_data["postProgramAssessment2"].toString()) : <any>undefined;
            this.postProgramAssessment3 = _data["postProgramAssessment3"] ? new Date(_data["postProgramAssessment3"].toString()) : <any>undefined;
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.insertDate = _data["insertDate"] ? new Date(_data["insertDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FormUserCompletionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormUserCompletionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formUserCompletionId"] = this.formUserCompletionId;
        data["userGuid"] = this.userGuid;
        data["phodaLastUpdate"] = this.phodaLastUpdate ? this.phodaLastUpdate.toISOString() : <any>undefined;
        data["intakeForm"] = this.intakeForm ? this.intakeForm.toISOString() : <any>undefined;
        data["painQuestionnaires"] = this.painQuestionnaires ? this.painQuestionnaires.toISOString() : <any>undefined;
        data["sixWeekAssessment"] = this.sixWeekAssessment ? this.sixWeekAssessment.toISOString() : <any>undefined;
        data["twelveWeekAssessment"] = this.twelveWeekAssessment ? this.twelveWeekAssessment.toISOString() : <any>undefined;
        data["postProgramAssessment1"] = this.postProgramAssessment1 ? this.postProgramAssessment1.toISOString() : <any>undefined;
        data["postProgramAssessment2"] = this.postProgramAssessment2 ? this.postProgramAssessment2.toISOString() : <any>undefined;
        data["postProgramAssessment3"] = this.postProgramAssessment3 ? this.postProgramAssessment3.toISOString() : <any>undefined;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["insertDate"] = this.insertDate ? this.insertDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFormUserCompletionResponse {
    formUserCompletionId?: number;
    userGuid?: string;
    phodaLastUpdate?: Date | undefined;
    intakeForm?: Date | undefined;
    painQuestionnaires?: Date | undefined;
    sixWeekAssessment?: Date | undefined;
    twelveWeekAssessment?: Date | undefined;
    postProgramAssessment1?: Date | undefined;
    postProgramAssessment2?: Date | undefined;
    postProgramAssessment3?: Date | undefined;
    updateDate?: Date | undefined;
    insertDate?: Date;
}

export class BaseTransportOfListOfPatientStatsAndBaseError implements IBaseTransportOfListOfPatientStatsAndBaseError {
    result?: PatientStats[] | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfListOfPatientStatsAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(PatientStats.fromJS(item));
            }
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfListOfPatientStatsAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfListOfPatientStatsAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfListOfPatientStatsAndBaseError {
    result?: PatientStats[] | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfListOfPatientStats extends BaseTransportOfListOfPatientStatsAndBaseError implements IResponseTransportOfListOfPatientStats {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfListOfPatientStats) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfListOfPatientStats {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfListOfPatientStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfListOfPatientStats extends IBaseTransportOfListOfPatientStatsAndBaseError {
    status?: ResponseStatus;
}

export class PatientStats implements IPatientStats {
    patientId?: number;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    displayName?: string | undefined;
    firstLoginDate?: Date;
    programWeek?: number;
    applicationLastUsed?: Date;
    cardsLastUsed?: Date;
    scoringLastUsed?: Date;
    brainScienceLastUsed?: Date;
    clinicianName?: string | undefined;
    clinicianId?: number;
    isEnrolled?: boolean;
    licenceStreamId?: number;
    licenceStreamName?: string | undefined;

    constructor(data?: IPatientStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.displayName = _data["displayName"];
            this.firstLoginDate = _data["firstLoginDate"] ? new Date(_data["firstLoginDate"].toString()) : <any>undefined;
            this.programWeek = _data["programWeek"];
            this.applicationLastUsed = _data["applicationLastUsed"] ? new Date(_data["applicationLastUsed"].toString()) : <any>undefined;
            this.cardsLastUsed = _data["cardsLastUsed"] ? new Date(_data["cardsLastUsed"].toString()) : <any>undefined;
            this.scoringLastUsed = _data["scoringLastUsed"] ? new Date(_data["scoringLastUsed"].toString()) : <any>undefined;
            this.brainScienceLastUsed = _data["brainScienceLastUsed"] ? new Date(_data["brainScienceLastUsed"].toString()) : <any>undefined;
            this.clinicianName = _data["clinicianName"];
            this.clinicianId = _data["clinicianId"];
            this.isEnrolled = _data["isEnrolled"];
            this.licenceStreamId = _data["licenceStreamId"];
            this.licenceStreamName = _data["licenceStreamName"];
        }
    }

    static fromJS(data: any): PatientStats {
        data = typeof data === 'object' ? data : {};
        let result = new PatientStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["displayName"] = this.displayName;
        data["firstLoginDate"] = this.firstLoginDate ? this.firstLoginDate.toISOString() : <any>undefined;
        data["programWeek"] = this.programWeek;
        data["applicationLastUsed"] = this.applicationLastUsed ? this.applicationLastUsed.toISOString() : <any>undefined;
        data["cardsLastUsed"] = this.cardsLastUsed ? this.cardsLastUsed.toISOString() : <any>undefined;
        data["scoringLastUsed"] = this.scoringLastUsed ? this.scoringLastUsed.toISOString() : <any>undefined;
        data["brainScienceLastUsed"] = this.brainScienceLastUsed ? this.brainScienceLastUsed.toISOString() : <any>undefined;
        data["clinicianName"] = this.clinicianName;
        data["clinicianId"] = this.clinicianId;
        data["isEnrolled"] = this.isEnrolled;
        data["licenceStreamId"] = this.licenceStreamId;
        data["licenceStreamName"] = this.licenceStreamName;
        return data;
    }
}

export interface IPatientStats {
    patientId?: number;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    displayName?: string | undefined;
    firstLoginDate?: Date;
    programWeek?: number;
    applicationLastUsed?: Date;
    cardsLastUsed?: Date;
    scoringLastUsed?: Date;
    brainScienceLastUsed?: Date;
    clinicianName?: string | undefined;
    clinicianId?: number;
    isEnrolled?: boolean;
    licenceStreamId?: number;
    licenceStreamName?: string | undefined;
}

export class BaseTransportOfPatientDtoAndBaseError implements IBaseTransportOfPatientDtoAndBaseError {
    result?: PatientDto | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfPatientDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? PatientDto.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfPatientDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfPatientDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfPatientDtoAndBaseError {
    result?: PatientDto | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfPatientDto extends BaseTransportOfPatientDtoAndBaseError implements IResponseTransportOfPatientDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfPatientDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfPatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfPatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfPatientDto extends IBaseTransportOfPatientDtoAndBaseError {
    status?: ResponseStatus;
}

export class PatientDto implements IPatientDto {
    patientId?: number;
    userName?: string | undefined;
    genderId?: number;
    genderName?: string | undefined;
    countryName?: string | undefined;
    stateId?: number;
    stateName?: string | undefined;
    locationId?: number;
    locationName?: string | undefined;
    professionId?: number;
    healthIssueId?: number;
    healthIssueName?: string | undefined;
    userGuid?: string;
    userId?: number;
    clinicianId?: number;
    clinicianName?: string | undefined;
    clinicianUserGuid?: string;
    isEnrolled?: boolean;
    patientData?: PatientDataDto[] | undefined;

    constructor(data?: IPatientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.userName = _data["userName"];
            this.genderId = _data["genderId"];
            this.genderName = _data["genderName"];
            this.countryName = _data["countryName"];
            this.stateId = _data["stateId"];
            this.stateName = _data["stateName"];
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.professionId = _data["professionId"];
            this.healthIssueId = _data["healthIssueId"];
            this.healthIssueName = _data["healthIssueName"];
            this.userGuid = _data["userGuid"];
            this.userId = _data["userId"];
            this.clinicianId = _data["clinicianId"];
            this.clinicianName = _data["clinicianName"];
            this.clinicianUserGuid = _data["clinicianUserGuid"];
            this.isEnrolled = _data["isEnrolled"];
            if (Array.isArray(_data["patientData"])) {
                this.patientData = [] as any;
                for (let item of _data["patientData"])
                    this.patientData!.push(PatientDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["userName"] = this.userName;
        data["genderId"] = this.genderId;
        data["genderName"] = this.genderName;
        data["countryName"] = this.countryName;
        data["stateId"] = this.stateId;
        data["stateName"] = this.stateName;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["professionId"] = this.professionId;
        data["healthIssueId"] = this.healthIssueId;
        data["healthIssueName"] = this.healthIssueName;
        data["userGuid"] = this.userGuid;
        data["userId"] = this.userId;
        data["clinicianId"] = this.clinicianId;
        data["clinicianName"] = this.clinicianName;
        data["clinicianUserGuid"] = this.clinicianUserGuid;
        data["isEnrolled"] = this.isEnrolled;
        if (Array.isArray(this.patientData)) {
            data["patientData"] = [];
            for (let item of this.patientData)
                data["patientData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientDto {
    patientId?: number;
    userName?: string | undefined;
    genderId?: number;
    genderName?: string | undefined;
    countryName?: string | undefined;
    stateId?: number;
    stateName?: string | undefined;
    locationId?: number;
    locationName?: string | undefined;
    professionId?: number;
    healthIssueId?: number;
    healthIssueName?: string | undefined;
    userGuid?: string;
    userId?: number;
    clinicianId?: number;
    clinicianName?: string | undefined;
    clinicianUserGuid?: string;
    isEnrolled?: boolean;
    patientData?: PatientDataDto[] | undefined;
}

export class PatientDataDto implements IPatientDataDto {
    name?: string | undefined;
    value?: string | undefined;
    patientId?: number;
    isActive?: boolean;

    constructor(data?: IPatientDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.patientId = _data["patientId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PatientDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["patientId"] = this.patientId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IPatientDataDto {
    name?: string | undefined;
    value?: string | undefined;
    patientId?: number;
    isActive?: boolean;
}

export class BaseTransportOfPatientDataDtoAndBaseError implements IBaseTransportOfPatientDataDtoAndBaseError {
    result?: PatientDataDto | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfPatientDataDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? PatientDataDto.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfPatientDataDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfPatientDataDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfPatientDataDtoAndBaseError {
    result?: PatientDataDto | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfPatientDataDto extends BaseTransportOfPatientDataDtoAndBaseError implements IResponseTransportOfPatientDataDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfPatientDataDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfPatientDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfPatientDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfPatientDataDto extends IBaseTransportOfPatientDataDtoAndBaseError {
    status?: ResponseStatus;
}

export class BaseTransportOfListOfPatientMOSItemAndBaseError implements IBaseTransportOfListOfPatientMOSItemAndBaseError {
    result?: PatientMOSItem[] | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfListOfPatientMOSItemAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(PatientMOSItem.fromJS(item));
            }
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfListOfPatientMOSItemAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfListOfPatientMOSItemAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfListOfPatientMOSItemAndBaseError {
    result?: PatientMOSItem[] | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfListOfPatientMOSItem extends BaseTransportOfListOfPatientMOSItemAndBaseError implements IResponseTransportOfListOfPatientMOSItem {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfListOfPatientMOSItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfListOfPatientMOSItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfListOfPatientMOSItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfListOfPatientMOSItem extends IBaseTransportOfListOfPatientMOSItemAndBaseError {
    status?: ResponseStatus;
}

export class PatientMOSItem implements IPatientMOSItem {
    id?: number;
    halos?: string | undefined;
    haloScore?: number;
    zombies?: string | undefined;
    zombieScore?: number;
    totalScore?: number;
    insertDate?: Date;

    constructor(data?: IPatientMOSItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.halos = _data["halos"];
            this.haloScore = _data["haloScore"];
            this.zombies = _data["zombies"];
            this.zombieScore = _data["zombieScore"];
            this.totalScore = _data["totalScore"];
            this.insertDate = _data["insertDate"] ? new Date(_data["insertDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientMOSItem {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMOSItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["halos"] = this.halos;
        data["haloScore"] = this.haloScore;
        data["zombies"] = this.zombies;
        data["zombieScore"] = this.zombieScore;
        data["totalScore"] = this.totalScore;
        data["insertDate"] = this.insertDate ? this.insertDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPatientMOSItem {
    id?: number;
    halos?: string | undefined;
    haloScore?: number;
    zombies?: string | undefined;
    zombieScore?: number;
    totalScore?: number;
    insertDate?: Date;
}

export class BaseTransportOfScoreChartDbResponseAndBaseError implements IBaseTransportOfScoreChartDbResponseAndBaseError {
    result?: ScoreChartDbResponse | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfScoreChartDbResponseAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ScoreChartDbResponse.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfScoreChartDbResponseAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfScoreChartDbResponseAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfScoreChartDbResponseAndBaseError {
    result?: ScoreChartDbResponse | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfScoreChartDbResponse extends BaseTransportOfScoreChartDbResponseAndBaseError implements IResponseTransportOfScoreChartDbResponse {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfScoreChartDbResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfScoreChartDbResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfScoreChartDbResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfScoreChartDbResponse extends IBaseTransportOfScoreChartDbResponseAndBaseError {
    status?: ResponseStatus;
}

export class PatientScoreHistoryDbRequest extends ScoreHistoryDbRequest implements IPatientScoreHistoryDbRequest {
    patientId?: number;

    constructor(data?: IPatientScoreHistoryDbRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): PatientScoreHistoryDbRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PatientScoreHistoryDbRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientScoreHistoryDbRequest extends IScoreHistoryDbRequest {
    patientId?: number;
}

export class BaseTransportOfListOfPatientHaloZombieItemAndBaseError implements IBaseTransportOfListOfPatientHaloZombieItemAndBaseError {
    result?: PatientHaloZombieItem[] | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfListOfPatientHaloZombieItemAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(PatientHaloZombieItem.fromJS(item));
            }
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfListOfPatientHaloZombieItemAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfListOfPatientHaloZombieItemAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfListOfPatientHaloZombieItemAndBaseError {
    result?: PatientHaloZombieItem[] | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfListOfPatientHaloZombieItem extends BaseTransportOfListOfPatientHaloZombieItemAndBaseError implements IResponseTransportOfListOfPatientHaloZombieItem {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfListOfPatientHaloZombieItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfListOfPatientHaloZombieItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfListOfPatientHaloZombieItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfListOfPatientHaloZombieItem extends IBaseTransportOfListOfPatientHaloZombieItemAndBaseError {
    status?: ResponseStatus;
}

export class PatientHaloZombieItem implements IPatientHaloZombieItem {
    totalScore?: number;
    name?: string | undefined;
    marginOfSafetyTypeId?: number;
    marginOfSafetyType?: string | undefined;

    constructor(data?: IPatientHaloZombieItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalScore = _data["totalScore"];
            this.name = _data["name"];
            this.marginOfSafetyTypeId = _data["marginOfSafetyTypeId"];
            this.marginOfSafetyType = _data["marginOfSafetyType"];
        }
    }

    static fromJS(data: any): PatientHaloZombieItem {
        data = typeof data === 'object' ? data : {};
        let result = new PatientHaloZombieItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalScore"] = this.totalScore;
        data["name"] = this.name;
        data["marginOfSafetyTypeId"] = this.marginOfSafetyTypeId;
        data["marginOfSafetyType"] = this.marginOfSafetyType;
        return data;
    }
}

export interface IPatientHaloZombieItem {
    totalScore?: number;
    name?: string | undefined;
    marginOfSafetyTypeId?: number;
    marginOfSafetyType?: string | undefined;
}

export class BaseTransportOfListOfPatientMOSByTimeOfDayAndBaseError implements IBaseTransportOfListOfPatientMOSByTimeOfDayAndBaseError {
    result?: PatientMOSByTimeOfDay[] | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfListOfPatientMOSByTimeOfDayAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(PatientMOSByTimeOfDay.fromJS(item));
            }
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfListOfPatientMOSByTimeOfDayAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfListOfPatientMOSByTimeOfDayAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfListOfPatientMOSByTimeOfDayAndBaseError {
    result?: PatientMOSByTimeOfDay[] | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfListOfPatientMOSByTimeOfDay extends BaseTransportOfListOfPatientMOSByTimeOfDayAndBaseError implements IResponseTransportOfListOfPatientMOSByTimeOfDay {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfListOfPatientMOSByTimeOfDay) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfListOfPatientMOSByTimeOfDay {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfListOfPatientMOSByTimeOfDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfListOfPatientMOSByTimeOfDay extends IBaseTransportOfListOfPatientMOSByTimeOfDayAndBaseError {
    status?: ResponseStatus;
}

export class PatientMOSByTimeOfDay implements IPatientMOSByTimeOfDay {
    timeOfDay?: string | undefined;
    avgScoreValue?: number;
    sort?: number;

    constructor(data?: IPatientMOSByTimeOfDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeOfDay = _data["timeOfDay"];
            this.avgScoreValue = _data["avgScoreValue"];
            this.sort = _data["sort"];
        }
    }

    static fromJS(data: any): PatientMOSByTimeOfDay {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMOSByTimeOfDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeOfDay"] = this.timeOfDay;
        data["avgScoreValue"] = this.avgScoreValue;
        data["sort"] = this.sort;
        return data;
    }
}

export interface IPatientMOSByTimeOfDay {
    timeOfDay?: string | undefined;
    avgScoreValue?: number;
    sort?: number;
}

export class BaseTransportOfListOfAverageUserHitAndBaseError implements IBaseTransportOfListOfAverageUserHitAndBaseError {
    result?: AverageUserHit[] | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfListOfAverageUserHitAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AverageUserHit.fromJS(item));
            }
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfListOfAverageUserHitAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfListOfAverageUserHitAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfListOfAverageUserHitAndBaseError {
    result?: AverageUserHit[] | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfListOfAverageUserHit extends BaseTransportOfListOfAverageUserHitAndBaseError implements IResponseTransportOfListOfAverageUserHit {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfListOfAverageUserHit) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfListOfAverageUserHit {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfListOfAverageUserHit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfListOfAverageUserHit extends IBaseTransportOfListOfAverageUserHitAndBaseError {
    status?: ResponseStatus;
}

export class AverageUserHit implements IAverageUserHit {
    startDate?: Date;
    endDate?: Date;
    avgDailyTotalUserHits?: number;

    constructor(data?: IAverageUserHit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.avgDailyTotalUserHits = _data["avgDailyTotalUserHits"];
        }
    }

    static fromJS(data: any): AverageUserHit {
        data = typeof data === 'object' ? data : {};
        let result = new AverageUserHit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["avgDailyTotalUserHits"] = this.avgDailyTotalUserHits;
        return data;
    }
}

export interface IAverageUserHit {
    startDate?: Date;
    endDate?: Date;
    avgDailyTotalUserHits?: number;
}

export class BaseTransportOfGetPatientMedicationChartDataOutputAndBaseError implements IBaseTransportOfGetPatientMedicationChartDataOutputAndBaseError {
    result?: GetPatientMedicationChartDataOutput | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfGetPatientMedicationChartDataOutputAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? GetPatientMedicationChartDataOutput.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfGetPatientMedicationChartDataOutputAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfGetPatientMedicationChartDataOutputAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfGetPatientMedicationChartDataOutputAndBaseError {
    result?: GetPatientMedicationChartDataOutput | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfGetPatientMedicationChartDataOutput extends BaseTransportOfGetPatientMedicationChartDataOutputAndBaseError implements IResponseTransportOfGetPatientMedicationChartDataOutput {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfGetPatientMedicationChartDataOutput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfGetPatientMedicationChartDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfGetPatientMedicationChartDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfGetPatientMedicationChartDataOutput extends IBaseTransportOfGetPatientMedicationChartDataOutputAndBaseError {
    status?: ResponseStatus;
}

export class GetPatientMedicationChartDataOutput implements IGetPatientMedicationChartDataOutput {
    chartDataMedication?: { [key: string]: PatientMedicationChartDataItem[]; } | undefined;

    constructor(data?: IGetPatientMedicationChartDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["chartDataMedication"]) {
                this.chartDataMedication = {} as any;
                for (let key in _data["chartDataMedication"]) {
                    if (_data["chartDataMedication"].hasOwnProperty(key))
                        (<any>this.chartDataMedication)![key] = _data["chartDataMedication"][key] ? _data["chartDataMedication"][key].map((i: any) => PatientMedicationChartDataItem.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): GetPatientMedicationChartDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientMedicationChartDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.chartDataMedication) {
            data["chartDataMedication"] = {};
            for (let key in this.chartDataMedication) {
                if (this.chartDataMedication.hasOwnProperty(key))
                    (<any>data["chartDataMedication"])[key] = (<any>this.chartDataMedication)[key];
            }
        }
        return data;
    }
}

export interface IGetPatientMedicationChartDataOutput {
    chartDataMedication?: { [key: string]: PatientMedicationChartDataItem[]; } | undefined;
}

export class PatientMedicationChartDataItem implements IPatientMedicationChartDataItem {
    userMedicationRecordId?: number;
    medicationId?: number;
    medicationName?: string | undefined;
    medicationDoseId?: number;
    totalMedicationDose?: number;
    periodType?: MedicationPeriodType;
    chemicalName?: string | undefined;
    medicationDose?: number;
    count?: number;
    value?: number;
    frequency?: number;
    surveyName?: string | undefined;
    surveyId?: number;
    insertDateTime?: Date;
    insertDate?: Date;

    constructor(data?: IPatientMedicationChartDataItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userMedicationRecordId = _data["userMedicationRecordId"];
            this.medicationId = _data["medicationId"];
            this.medicationName = _data["medicationName"];
            this.medicationDoseId = _data["medicationDoseId"];
            this.totalMedicationDose = _data["totalMedicationDose"];
            this.periodType = _data["periodType"];
            this.chemicalName = _data["chemicalName"];
            this.medicationDose = _data["medicationDose"];
            this.count = _data["count"];
            this.value = _data["value"];
            this.frequency = _data["frequency"];
            this.surveyName = _data["surveyName"];
            this.surveyId = _data["surveyId"];
            this.insertDateTime = _data["insertDateTime"] ? new Date(_data["insertDateTime"].toString()) : <any>undefined;
            this.insertDate = _data["insertDate"] ? new Date(_data["insertDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientMedicationChartDataItem {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationChartDataItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userMedicationRecordId"] = this.userMedicationRecordId;
        data["medicationId"] = this.medicationId;
        data["medicationName"] = this.medicationName;
        data["medicationDoseId"] = this.medicationDoseId;
        data["totalMedicationDose"] = this.totalMedicationDose;
        data["periodType"] = this.periodType;
        data["chemicalName"] = this.chemicalName;
        data["medicationDose"] = this.medicationDose;
        data["count"] = this.count;
        data["value"] = this.value;
        data["frequency"] = this.frequency;
        data["surveyName"] = this.surveyName;
        data["surveyId"] = this.surveyId;
        data["insertDateTime"] = this.insertDateTime ? this.insertDateTime.toISOString() : <any>undefined;
        data["insertDate"] = this.insertDate ? this.insertDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPatientMedicationChartDataItem {
    userMedicationRecordId?: number;
    medicationId?: number;
    medicationName?: string | undefined;
    medicationDoseId?: number;
    totalMedicationDose?: number;
    periodType?: MedicationPeriodType;
    chemicalName?: string | undefined;
    medicationDose?: number;
    count?: number;
    value?: number;
    frequency?: number;
    surveyName?: string | undefined;
    surveyId?: number;
    insertDateTime?: Date;
    insertDate?: Date;
}

export class BaseTransportOfGetPatientWorkHoursChartDataOutputAndBaseError implements IBaseTransportOfGetPatientWorkHoursChartDataOutputAndBaseError {
    result?: GetPatientWorkHoursChartDataOutput | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfGetPatientWorkHoursChartDataOutputAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? GetPatientWorkHoursChartDataOutput.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfGetPatientWorkHoursChartDataOutputAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfGetPatientWorkHoursChartDataOutputAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfGetPatientWorkHoursChartDataOutputAndBaseError {
    result?: GetPatientWorkHoursChartDataOutput | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfGetPatientWorkHoursChartDataOutput extends BaseTransportOfGetPatientWorkHoursChartDataOutputAndBaseError implements IResponseTransportOfGetPatientWorkHoursChartDataOutput {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfGetPatientWorkHoursChartDataOutput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfGetPatientWorkHoursChartDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfGetPatientWorkHoursChartDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfGetPatientWorkHoursChartDataOutput extends IBaseTransportOfGetPatientWorkHoursChartDataOutputAndBaseError {
    status?: ResponseStatus;
}

export class GetPatientWorkHoursChartDataOutput implements IGetPatientWorkHoursChartDataOutput {
    workHoursBefore?: number;
    surveyNames?: string[] | undefined;
    workHours?: number[] | undefined;

    constructor(data?: IGetPatientWorkHoursChartDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workHoursBefore = _data["workHoursBefore"];
            if (Array.isArray(_data["surveyNames"])) {
                this.surveyNames = [] as any;
                for (let item of _data["surveyNames"])
                    this.surveyNames!.push(item);
            }
            if (Array.isArray(_data["workHours"])) {
                this.workHours = [] as any;
                for (let item of _data["workHours"])
                    this.workHours!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPatientWorkHoursChartDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientWorkHoursChartDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workHoursBefore"] = this.workHoursBefore;
        if (Array.isArray(this.surveyNames)) {
            data["surveyNames"] = [];
            for (let item of this.surveyNames)
                data["surveyNames"].push(item);
        }
        if (Array.isArray(this.workHours)) {
            data["workHours"] = [];
            for (let item of this.workHours)
                data["workHours"].push(item);
        }
        return data;
    }
}

export interface IGetPatientWorkHoursChartDataOutput {
    workHoursBefore?: number;
    surveyNames?: string[] | undefined;
    workHours?: number[] | undefined;
}

export class BaseTransportOfGetPatientWorkPercentageChartDataOutputAndBaseError implements IBaseTransportOfGetPatientWorkPercentageChartDataOutputAndBaseError {
    result?: GetPatientWorkPercentageChartDataOutput | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfGetPatientWorkPercentageChartDataOutputAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? GetPatientWorkPercentageChartDataOutput.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfGetPatientWorkPercentageChartDataOutputAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfGetPatientWorkPercentageChartDataOutputAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfGetPatientWorkPercentageChartDataOutputAndBaseError {
    result?: GetPatientWorkPercentageChartDataOutput | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfGetPatientWorkPercentageChartDataOutput extends BaseTransportOfGetPatientWorkPercentageChartDataOutputAndBaseError implements IResponseTransportOfGetPatientWorkPercentageChartDataOutput {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfGetPatientWorkPercentageChartDataOutput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfGetPatientWorkPercentageChartDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfGetPatientWorkPercentageChartDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfGetPatientWorkPercentageChartDataOutput extends IBaseTransportOfGetPatientWorkPercentageChartDataOutputAndBaseError {
    status?: ResponseStatus;
}

export class GetPatientWorkPercentageChartDataOutput implements IGetPatientWorkPercentageChartDataOutput {
    points?: PatientWorkPercentageDataPoint[] | undefined;
    surveyNames?: string[] | undefined;

    constructor(data?: IGetPatientWorkPercentageChartDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(PatientWorkPercentageDataPoint.fromJS(item));
            }
            if (Array.isArray(_data["surveyNames"])) {
                this.surveyNames = [] as any;
                for (let item of _data["surveyNames"])
                    this.surveyNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPatientWorkPercentageChartDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientWorkPercentageChartDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyNames)) {
            data["surveyNames"] = [];
            for (let item of this.surveyNames)
                data["surveyNames"].push(item);
        }
        return data;
    }
}

export interface IGetPatientWorkPercentageChartDataOutput {
    points?: PatientWorkPercentageDataPoint[] | undefined;
    surveyNames?: string[] | undefined;
}

export class PatientWorkPercentageDataPoint implements IPatientWorkPercentageDataPoint {
    name?: string | undefined;
    y?: number;

    constructor(data?: IPatientWorkPercentageDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.y = _data["y"];
        }
    }

    static fromJS(data: any): PatientWorkPercentageDataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new PatientWorkPercentageDataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["y"] = this.y;
        return data;
    }
}

export interface IPatientWorkPercentageDataPoint {
    name?: string | undefined;
    y?: number;
}

export class BaseTransportOfGetPatientWorkIntensityChartDataOutputAndBaseError implements IBaseTransportOfGetPatientWorkIntensityChartDataOutputAndBaseError {
    result?: GetPatientWorkIntensityChartDataOutput | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfGetPatientWorkIntensityChartDataOutputAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? GetPatientWorkIntensityChartDataOutput.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfGetPatientWorkIntensityChartDataOutputAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfGetPatientWorkIntensityChartDataOutputAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfGetPatientWorkIntensityChartDataOutputAndBaseError {
    result?: GetPatientWorkIntensityChartDataOutput | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfGetPatientWorkIntensityChartDataOutput extends BaseTransportOfGetPatientWorkIntensityChartDataOutputAndBaseError implements IResponseTransportOfGetPatientWorkIntensityChartDataOutput {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfGetPatientWorkIntensityChartDataOutput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfGetPatientWorkIntensityChartDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfGetPatientWorkIntensityChartDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfGetPatientWorkIntensityChartDataOutput extends IBaseTransportOfGetPatientWorkIntensityChartDataOutputAndBaseError {
    status?: ResponseStatus;
}

export class GetPatientWorkIntensityChartDataOutput implements IGetPatientWorkIntensityChartDataOutput {
    surveyNames?: string[] | undefined;
    values?: number[] | undefined;

    constructor(data?: IGetPatientWorkIntensityChartDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["surveyNames"])) {
                this.surveyNames = [] as any;
                for (let item of _data["surveyNames"])
                    this.surveyNames!.push(item);
            }
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPatientWorkIntensityChartDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientWorkIntensityChartDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.surveyNames)) {
            data["surveyNames"] = [];
            for (let item of this.surveyNames)
                data["surveyNames"].push(item);
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IGetPatientWorkIntensityChartDataOutput {
    surveyNames?: string[] | undefined;
    values?: number[] | undefined;
}

export class BaseTransportOfProfileDetailsDtoAndBaseError implements IBaseTransportOfProfileDetailsDtoAndBaseError {
    result?: ProfileDetailsDto | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfProfileDetailsDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ProfileDetailsDto.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfProfileDetailsDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfProfileDetailsDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfProfileDetailsDtoAndBaseError {
    result?: ProfileDetailsDto | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfProfileDetailsDto extends BaseTransportOfProfileDetailsDtoAndBaseError implements IResponseTransportOfProfileDetailsDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfProfileDetailsDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfProfileDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfProfileDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfProfileDetailsDto extends IBaseTransportOfProfileDetailsDtoAndBaseError {
    status?: ResponseStatus;
}

export class ProfileDetailsDto implements IProfileDetailsDto {
    userName?: string | undefined;
    email?: string | undefined;
    isActive?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userRole?: string | undefined;

    constructor(data?: IProfileDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.isActive = _data["isActive"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userRole = _data["userRole"];
        }
    }

    static fromJS(data: any): ProfileDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userRole"] = this.userRole;
        return data;
    }
}

export interface IProfileDetailsDto {
    userName?: string | undefined;
    email?: string | undefined;
    isActive?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userRole?: string | undefined;
}

export class UpdateProfileDetailsInput implements IUpdateProfileDetailsInput {
    firstName!: string;
    lastName!: string;
    email!: string;

    constructor(data?: IUpdateProfileDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UpdateProfileDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        return data;
    }
}

export interface IUpdateProfileDetailsInput {
    firstName: string;
    lastName: string;
    email: string;
}

export class BaseTransportOfGet2FASetupCodeOutputAndBaseError implements IBaseTransportOfGet2FASetupCodeOutputAndBaseError {
    result?: Get2FASetupCodeOutput | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfGet2FASetupCodeOutputAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? Get2FASetupCodeOutput.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfGet2FASetupCodeOutputAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfGet2FASetupCodeOutputAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfGet2FASetupCodeOutputAndBaseError {
    result?: Get2FASetupCodeOutput | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfGet2FASetupCodeOutput extends BaseTransportOfGet2FASetupCodeOutputAndBaseError implements IResponseTransportOfGet2FASetupCodeOutput {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfGet2FASetupCodeOutput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfGet2FASetupCodeOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfGet2FASetupCodeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfGet2FASetupCodeOutput extends IBaseTransportOfGet2FASetupCodeOutputAndBaseError {
    status?: ResponseStatus;
}

export class Get2FASetupCodeOutput implements IGet2FASetupCodeOutput {
    is2FAEnabled?: boolean;
    isGoogleAuthenticatorEnabled?: boolean;
    qrCodeUrl?: string | undefined;
    manualSetupCode?: string | undefined;

    constructor(data?: IGet2FASetupCodeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.is2FAEnabled = _data["is2FAEnabled"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
            this.qrCodeUrl = _data["qrCodeUrl"];
            this.manualSetupCode = _data["manualSetupCode"];
        }
    }

    static fromJS(data: any): Get2FASetupCodeOutput {
        data = typeof data === 'object' ? data : {};
        let result = new Get2FASetupCodeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["is2FAEnabled"] = this.is2FAEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        data["qrCodeUrl"] = this.qrCodeUrl;
        data["manualSetupCode"] = this.manualSetupCode;
        return data;
    }
}

export interface IGet2FASetupCodeOutput {
    is2FAEnabled?: boolean;
    isGoogleAuthenticatorEnabled?: boolean;
    qrCodeUrl?: string | undefined;
    manualSetupCode?: string | undefined;
}

export class Verify2FASetupCodeInput implements IVerify2FASetupCodeInput {
    code?: string | undefined;

    constructor(data?: IVerify2FASetupCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): Verify2FASetupCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new Verify2FASetupCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IVerify2FASetupCodeInput {
    code?: string | undefined;
}

export class BaseTransportOfSafetyPlanDtoAndBaseError implements IBaseTransportOfSafetyPlanDtoAndBaseError {
    result?: SafetyPlanDto | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfSafetyPlanDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? SafetyPlanDto.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfSafetyPlanDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfSafetyPlanDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfSafetyPlanDtoAndBaseError {
    result?: SafetyPlanDto | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfSafetyPlanDto extends BaseTransportOfSafetyPlanDtoAndBaseError implements IResponseTransportOfSafetyPlanDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfSafetyPlanDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfSafetyPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfSafetyPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfSafetyPlanDto extends IBaseTransportOfSafetyPlanDtoAndBaseError {
    status?: ResponseStatus;
}

export class SafetyPlanDto implements ISafetyPlanDto {
    id?: number;
    updateTime?: Date | undefined;
    safetyPlanItems?: SafetyPlanItemDto[] | undefined;

    constructor(data?: ISafetyPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.updateTime = _data["updateTime"] ? new Date(_data["updateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["safetyPlanItems"])) {
                this.safetyPlanItems = [] as any;
                for (let item of _data["safetyPlanItems"])
                    this.safetyPlanItems!.push(SafetyPlanItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SafetyPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new SafetyPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.safetyPlanItems)) {
            data["safetyPlanItems"] = [];
            for (let item of this.safetyPlanItems)
                data["safetyPlanItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISafetyPlanDto {
    id?: number;
    updateTime?: Date | undefined;
    safetyPlanItems?: SafetyPlanItemDto[] | undefined;
}

export class SafetyPlanItemDto implements ISafetyPlanItemDto {
    id?: number;
    guid?: string;
    safetyPlanId?: number;
    safetyPlanItemType?: SafetyPlanItemType;
    ifStatement!: string;
    order?: number;
    isActive?: boolean;
    itemCards?: SafetyPlanItemCardDto[] | undefined;

    constructor(data?: ISafetyPlanItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.guid = _data["guid"];
            this.safetyPlanId = _data["safetyPlanId"];
            this.safetyPlanItemType = _data["safetyPlanItemType"];
            this.ifStatement = _data["ifStatement"];
            this.order = _data["order"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["itemCards"])) {
                this.itemCards = [] as any;
                for (let item of _data["itemCards"])
                    this.itemCards!.push(SafetyPlanItemCardDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SafetyPlanItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SafetyPlanItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["guid"] = this.guid;
        data["safetyPlanId"] = this.safetyPlanId;
        data["safetyPlanItemType"] = this.safetyPlanItemType;
        data["ifStatement"] = this.ifStatement;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.itemCards)) {
            data["itemCards"] = [];
            for (let item of this.itemCards)
                data["itemCards"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISafetyPlanItemDto {
    id?: number;
    guid?: string;
    safetyPlanId?: number;
    safetyPlanItemType?: SafetyPlanItemType;
    ifStatement: string;
    order?: number;
    isActive?: boolean;
    itemCards?: SafetyPlanItemCardDto[] | undefined;
}

export enum SafetyPlanItemType {
    Actions = 0,
    Thoughts = 1,
}

export class SafetyPlanItemCardDto implements ISafetyPlanItemCardDto {
    id?: number;
    guid?: string;
    safetyPlanItemId?: number;
    cardId?: number;
    card?: CardModel | undefined;
    order?: number;
    isActive?: boolean;

    constructor(data?: ISafetyPlanItemCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.guid = _data["guid"];
            this.safetyPlanItemId = _data["safetyPlanItemId"];
            this.cardId = _data["cardId"];
            this.card = _data["card"] ? CardModel.fromJS(_data["card"]) : <any>undefined;
            this.order = _data["order"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SafetyPlanItemCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new SafetyPlanItemCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["guid"] = this.guid;
        data["safetyPlanItemId"] = this.safetyPlanItemId;
        data["cardId"] = this.cardId;
        data["card"] = this.card ? this.card.toJSON() : <any>undefined;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISafetyPlanItemCardDto {
    id?: number;
    guid?: string;
    safetyPlanItemId?: number;
    cardId?: number;
    card?: CardModel | undefined;
    order?: number;
    isActive?: boolean;
}

export class ScienceBitesResponse implements IScienceBitesResponse {
    scienceBitesId?: number;
    quote?: string | undefined;
    authorName?: string | undefined;
    reference?: string | undefined;
    referenceLinks?: ScienceBitesLinks[] | undefined;
    dailyAction?: string | undefined;
    dailyActionLinks?: ScienceBitesLinks[] | undefined;
    isFavourite?: number;
    brainScienceBiteNextAlertDateTime?: Date;
    firstViewingDate?: Date;
    title?: string | undefined;
    readTimeMinutes?: number | undefined;
    categoryName?: string | undefined;
    categoryIcon?: string | undefined;
    preview?: string | undefined;
    bsbNotificationText?: string | undefined;

    constructor(data?: IScienceBitesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scienceBitesId = _data["scienceBitesId"];
            this.quote = _data["quote"];
            this.authorName = _data["authorName"];
            this.reference = _data["reference"];
            if (Array.isArray(_data["referenceLinks"])) {
                this.referenceLinks = [] as any;
                for (let item of _data["referenceLinks"])
                    this.referenceLinks!.push(ScienceBitesLinks.fromJS(item));
            }
            this.dailyAction = _data["dailyAction"];
            if (Array.isArray(_data["dailyActionLinks"])) {
                this.dailyActionLinks = [] as any;
                for (let item of _data["dailyActionLinks"])
                    this.dailyActionLinks!.push(ScienceBitesLinks.fromJS(item));
            }
            this.isFavourite = _data["isFavourite"];
            this.brainScienceBiteNextAlertDateTime = _data["brainScienceBiteNextAlertDateTime"] ? new Date(_data["brainScienceBiteNextAlertDateTime"].toString()) : <any>undefined;
            this.firstViewingDate = _data["firstViewingDate"] ? new Date(_data["firstViewingDate"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.readTimeMinutes = _data["readTimeMinutes"];
            this.categoryName = _data["categoryName"];
            this.categoryIcon = _data["categoryIcon"];
            this.preview = _data["preview"];
            this.bsbNotificationText = _data["bsbNotificationText"];
        }
    }

    static fromJS(data: any): ScienceBitesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScienceBitesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scienceBitesId"] = this.scienceBitesId;
        data["quote"] = this.quote;
        data["authorName"] = this.authorName;
        data["reference"] = this.reference;
        if (Array.isArray(this.referenceLinks)) {
            data["referenceLinks"] = [];
            for (let item of this.referenceLinks)
                data["referenceLinks"].push(item.toJSON());
        }
        data["dailyAction"] = this.dailyAction;
        if (Array.isArray(this.dailyActionLinks)) {
            data["dailyActionLinks"] = [];
            for (let item of this.dailyActionLinks)
                data["dailyActionLinks"].push(item.toJSON());
        }
        data["isFavourite"] = this.isFavourite;
        data["brainScienceBiteNextAlertDateTime"] = this.brainScienceBiteNextAlertDateTime ? this.brainScienceBiteNextAlertDateTime.toISOString() : <any>undefined;
        data["firstViewingDate"] = this.firstViewingDate ? this.firstViewingDate.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["readTimeMinutes"] = this.readTimeMinutes;
        data["categoryName"] = this.categoryName;
        data["categoryIcon"] = this.categoryIcon;
        data["preview"] = this.preview;
        data["bsbNotificationText"] = this.bsbNotificationText;
        return data;
    }
}

export interface IScienceBitesResponse {
    scienceBitesId?: number;
    quote?: string | undefined;
    authorName?: string | undefined;
    reference?: string | undefined;
    referenceLinks?: ScienceBitesLinks[] | undefined;
    dailyAction?: string | undefined;
    dailyActionLinks?: ScienceBitesLinks[] | undefined;
    isFavourite?: number;
    brainScienceBiteNextAlertDateTime?: Date;
    firstViewingDate?: Date;
    title?: string | undefined;
    readTimeMinutes?: number | undefined;
    categoryName?: string | undefined;
    categoryIcon?: string | undefined;
    preview?: string | undefined;
    bsbNotificationText?: string | undefined;
}

export class ScienceBitesLinks implements IScienceBitesLinks {
    urlLink?: string | undefined;

    constructor(data?: IScienceBitesLinks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.urlLink = _data["urlLink"];
        }
    }

    static fromJS(data: any): ScienceBitesLinks {
        data = typeof data === 'object' ? data : {};
        let result = new ScienceBitesLinks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["urlLink"] = this.urlLink;
        return data;
    }
}

export interface IScienceBitesLinks {
    urlLink?: string | undefined;
}

export class ScienceBitesSaveDbRequest implements IScienceBitesSaveDbRequest {
    scienceBitesFav?: ScienceBitesFav[] | undefined;

    constructor(data?: IScienceBitesSaveDbRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scienceBitesFav"])) {
                this.scienceBitesFav = [] as any;
                for (let item of _data["scienceBitesFav"])
                    this.scienceBitesFav!.push(ScienceBitesFav.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScienceBitesSaveDbRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ScienceBitesSaveDbRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scienceBitesFav)) {
            data["scienceBitesFav"] = [];
            for (let item of this.scienceBitesFav)
                data["scienceBitesFav"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScienceBitesSaveDbRequest {
    scienceBitesFav?: ScienceBitesFav[] | undefined;
}

export class ScienceBitesFav implements IScienceBitesFav {
    scienceBiteId?: number;
    isFavourite?: number;

    constructor(data?: IScienceBitesFav) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scienceBiteId = _data["scienceBiteId"];
            this.isFavourite = _data["isFavourite"];
        }
    }

    static fromJS(data: any): ScienceBitesFav {
        data = typeof data === 'object' ? data : {};
        let result = new ScienceBitesFav();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scienceBiteId"] = this.scienceBiteId;
        data["isFavourite"] = this.isFavourite;
        return data;
    }
}

export interface IScienceBitesFav {
    scienceBiteId?: number;
    isFavourite?: number;
}

export class ScoreResponse implements IScoreResponse {
    halos?: HalosAndZombies[] | undefined;
    zombies?: HalosAndZombies[] | undefined;
    latestHalos?: string[] | undefined;

    constructor(data?: IScoreResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["halos"])) {
                this.halos = [] as any;
                for (let item of _data["halos"])
                    this.halos!.push(HalosAndZombies.fromJS(item));
            }
            if (Array.isArray(_data["zombies"])) {
                this.zombies = [] as any;
                for (let item of _data["zombies"])
                    this.zombies!.push(HalosAndZombies.fromJS(item));
            }
            if (Array.isArray(_data["latestHalos"])) {
                this.latestHalos = [] as any;
                for (let item of _data["latestHalos"])
                    this.latestHalos!.push(item);
            }
        }
    }

    static fromJS(data: any): ScoreResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.halos)) {
            data["halos"] = [];
            for (let item of this.halos)
                data["halos"].push(item.toJSON());
        }
        if (Array.isArray(this.zombies)) {
            data["zombies"] = [];
            for (let item of this.zombies)
                data["zombies"].push(item.toJSON());
        }
        if (Array.isArray(this.latestHalos)) {
            data["latestHalos"] = [];
            for (let item of this.latestHalos)
                data["latestHalos"].push(item);
        }
        return data;
    }
}

export interface IScoreResponse {
    halos?: HalosAndZombies[] | undefined;
    zombies?: HalosAndZombies[] | undefined;
    latestHalos?: string[] | undefined;
}

export class HalosAndZombies implements IHalosAndZombies {
    itemTypeId?: number | undefined;
    itemTypeName?: string | undefined;
    itemId?: number | undefined;
    itemName?: string | undefined;
    scoreValue?: number;
    sortOrder?: number;
    tags?: TagDto[] | undefined;

    constructor(data?: IHalosAndZombies) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemTypeId = _data["itemTypeId"];
            this.itemTypeName = _data["itemTypeName"];
            this.itemId = _data["itemId"];
            this.itemName = _data["itemName"];
            this.scoreValue = _data["scoreValue"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HalosAndZombies {
        data = typeof data === 'object' ? data : {};
        let result = new HalosAndZombies();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemTypeId"] = this.itemTypeId;
        data["itemTypeName"] = this.itemTypeName;
        data["itemId"] = this.itemId;
        data["itemName"] = this.itemName;
        data["scoreValue"] = this.scoreValue;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHalosAndZombies {
    itemTypeId?: number | undefined;
    itemTypeName?: string | undefined;
    itemId?: number | undefined;
    itemName?: string | undefined;
    scoreValue?: number;
    sortOrder?: number;
    tags?: TagDto[] | undefined;
}

export class TopHalosResponse implements ITopHalosResponse {
    topHalos?: string[] | undefined;
    topHaloItems?: TopHaloItem[] | undefined;

    constructor(data?: ITopHalosResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["topHalos"])) {
                this.topHalos = [] as any;
                for (let item of _data["topHalos"])
                    this.topHalos!.push(item);
            }
            if (Array.isArray(_data["topHaloItems"])) {
                this.topHaloItems = [] as any;
                for (let item of _data["topHaloItems"])
                    this.topHaloItems!.push(TopHaloItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TopHalosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TopHalosResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.topHalos)) {
            data["topHalos"] = [];
            for (let item of this.topHalos)
                data["topHalos"].push(item);
        }
        if (Array.isArray(this.topHaloItems)) {
            data["topHaloItems"] = [];
            for (let item of this.topHaloItems)
                data["topHaloItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITopHalosResponse {
    topHalos?: string[] | undefined;
    topHaloItems?: TopHaloItem[] | undefined;
}

export class TopHaloItem implements ITopHaloItem {
    name?: string | undefined;
    categoryId?: number | undefined;

    constructor(data?: ITopHaloItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): TopHaloItem {
        data = typeof data === 'object' ? data : {};
        let result = new TopHaloItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        return data;
    }
}

export interface ITopHaloItem {
    name?: string | undefined;
    categoryId?: number | undefined;
}

export class LastScoreResponse implements ILastScoreResponse {
    totalScore?: number;
    scoreName?: string | undefined;
    imageId?: number;
    imageName?: string | undefined;
    nextAlertTime?: string | undefined;
    reminderTime?: string | undefined;
    nextAlertDateTime?: Date;
    insertLocalDate?: Date | undefined;

    constructor(data?: ILastScoreResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalScore = _data["totalScore"];
            this.scoreName = _data["scoreName"];
            this.imageId = _data["imageId"];
            this.imageName = _data["imageName"];
            this.nextAlertTime = _data["nextAlertTime"];
            this.reminderTime = _data["reminderTime"];
            this.nextAlertDateTime = _data["nextAlertDateTime"] ? new Date(_data["nextAlertDateTime"].toString()) : <any>undefined;
            this.insertLocalDate = _data["insertLocalDate"] ? new Date(_data["insertLocalDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LastScoreResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LastScoreResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalScore"] = this.totalScore;
        data["scoreName"] = this.scoreName;
        data["imageId"] = this.imageId;
        data["imageName"] = this.imageName;
        data["nextAlertTime"] = this.nextAlertTime;
        data["reminderTime"] = this.reminderTime;
        data["nextAlertDateTime"] = this.nextAlertDateTime ? this.nextAlertDateTime.toISOString() : <any>undefined;
        data["insertLocalDate"] = this.insertLocalDate ? this.insertLocalDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILastScoreResponse {
    totalScore?: number;
    scoreName?: string | undefined;
    imageId?: number;
    imageName?: string | undefined;
    nextAlertTime?: string | undefined;
    reminderTime?: string | undefined;
    nextAlertDateTime?: Date;
    insertLocalDate?: Date | undefined;
}

export class LastScoreWithCountResponse implements ILastScoreWithCountResponse {
    lastScore?: LastScoreResponse | undefined;
    scoresCountToday?: number;

    constructor(data?: ILastScoreWithCountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastScore = _data["lastScore"] ? LastScoreResponse.fromJS(_data["lastScore"]) : <any>undefined;
            this.scoresCountToday = _data["scoresCountToday"];
        }
    }

    static fromJS(data: any): LastScoreWithCountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LastScoreWithCountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastScore"] = this.lastScore ? this.lastScore.toJSON() : <any>undefined;
        data["scoresCountToday"] = this.scoresCountToday;
        return data;
    }
}

export interface ILastScoreWithCountResponse {
    lastScore?: LastScoreResponse | undefined;
    scoresCountToday?: number;
}

export class ScoreSave implements IScoreSave {
    halosAndZombies?: HalosAndZombies[] | undefined;
    localDateTime?: string | undefined;

    constructor(data?: IScoreSave) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["halosAndZombies"])) {
                this.halosAndZombies = [] as any;
                for (let item of _data["halosAndZombies"])
                    this.halosAndZombies!.push(HalosAndZombies.fromJS(item));
            }
            this.localDateTime = _data["localDateTime"];
        }
    }

    static fromJS(data: any): ScoreSave {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreSave();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.halosAndZombies)) {
            data["halosAndZombies"] = [];
            for (let item of this.halosAndZombies)
                data["halosAndZombies"].push(item.toJSON());
        }
        data["localDateTime"] = this.localDateTime;
        return data;
    }
}

export interface IScoreSave {
    halosAndZombies?: HalosAndZombies[] | undefined;
    localDateTime?: string | undefined;
}

export class ScoreChangeDay implements IScoreChangeDay {
    startDate?: string | undefined;
    totalScore?: number;

    constructor(data?: IScoreChangeDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"];
            this.totalScore = _data["totalScore"];
        }
    }

    static fromJS(data: any): ScoreChangeDay {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreChangeDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate;
        data["totalScore"] = this.totalScore;
        return data;
    }
}

export interface IScoreChangeDay {
    startDate?: string | undefined;
    totalScore?: number;
}

export class ScoreCalculationDbResponse implements IScoreCalculationDbResponse {
    haloScore?: number;
    zombieScore?: number;
    totalScore?: number;
    scoreName?: string | undefined;
    imageId?: number;
    imageName?: string | undefined;
    scoreMessage?: string | undefined;

    constructor(data?: IScoreCalculationDbResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haloScore = _data["haloScore"];
            this.zombieScore = _data["zombieScore"];
            this.totalScore = _data["totalScore"];
            this.scoreName = _data["scoreName"];
            this.imageId = _data["imageId"];
            this.imageName = _data["imageName"];
            this.scoreMessage = _data["scoreMessage"];
        }
    }

    static fromJS(data: any): ScoreCalculationDbResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreCalculationDbResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haloScore"] = this.haloScore;
        data["zombieScore"] = this.zombieScore;
        data["totalScore"] = this.totalScore;
        data["scoreName"] = this.scoreName;
        data["imageId"] = this.imageId;
        data["imageName"] = this.imageName;
        data["scoreMessage"] = this.scoreMessage;
        return data;
    }
}

export interface IScoreCalculationDbResponse {
    haloScore?: number;
    zombieScore?: number;
    totalScore?: number;
    scoreName?: string | undefined;
    imageId?: number;
    imageName?: string | undefined;
    scoreMessage?: string | undefined;
}

export class TotalHaloZombiesNumberResponse implements ITotalHaloZombiesNumberResponse {
    itemTypeName?: string | undefined;
    totalScore?: number;

    constructor(data?: ITotalHaloZombiesNumberResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemTypeName = _data["itemTypeName"];
            this.totalScore = _data["totalScore"];
        }
    }

    static fromJS(data: any): TotalHaloZombiesNumberResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TotalHaloZombiesNumberResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemTypeName"] = this.itemTypeName;
        data["totalScore"] = this.totalScore;
        return data;
    }
}

export interface ITotalHaloZombiesNumberResponse {
    itemTypeName?: string | undefined;
    totalScore?: number;
}

export class CategoryDto implements ICategoryDto {
    id?: number;
    name?: string | undefined;
    categoryType?: CategoryType;
    tags?: TagDto[] | undefined;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.categoryType = _data["categoryType"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["categoryType"] = this.categoryType;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategoryDto {
    id?: number;
    name?: string | undefined;
    categoryType?: CategoryType;
    tags?: TagDto[] | undefined;
}

export enum CategoryType {
    Body = 0,
    Experiences = 1,
    Feelings = 2,
    Novelty = 3,
    Relationships = 4,
    Thoughts = 5,
}

export class UserSettingDto implements IUserSettingDto {
    userGuid?: string;
    userName?: string | undefined;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    preferredName?: string | undefined;
    audioIsOn?: boolean;
    isMarginOfSafetyAlertOn?: boolean;
    isMarginOfSafetyPushOn?: boolean;
    isBrainScienceBiteAlertOn?: boolean;
    isBrainScienceBitePushOn?: boolean;
    marginOfSafetyStartTime?: string;
    marginOfSafetyAlertDateTime?: string | undefined;
    marginOfSafetyNextAlertDateTime?: string | undefined;
    marginOfSafetyRepeatPeriodMinutes?: number;
    brainScienceBiteStartTime?: string;
    brainScienceBiteNextAlertDateTime?: string | undefined;
    marginOfSafetySecondTime?: string;
    timezone?: string | undefined;
    isMarginOfSafetySecondAlertOn?: boolean;
    loadPreviousHalos?: boolean | undefined;
    loadPreviousZombies?: boolean | undefined;
    isDeviceSubscribedForWebPush?: boolean | undefined;
    isDeviceSubscribedForMobilePush?: boolean | undefined;
    isDeviceBrainScienceBitePushEnabled?: boolean | undefined;
    isDeviceScoreNotificationPushEnabled?: boolean | undefined;

    constructor(data?: IUserSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGuid = _data["userGuid"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.preferredName = _data["preferredName"];
            this.audioIsOn = _data["audioIsOn"];
            this.isMarginOfSafetyAlertOn = _data["isMarginOfSafetyAlertOn"];
            this.isMarginOfSafetyPushOn = _data["isMarginOfSafetyPushOn"];
            this.isBrainScienceBiteAlertOn = _data["isBrainScienceBiteAlertOn"];
            this.isBrainScienceBitePushOn = _data["isBrainScienceBitePushOn"];
            this.marginOfSafetyStartTime = _data["marginOfSafetyStartTime"];
            this.marginOfSafetyAlertDateTime = _data["marginOfSafetyAlertDateTime"];
            this.marginOfSafetyNextAlertDateTime = _data["marginOfSafetyNextAlertDateTime"];
            this.marginOfSafetyRepeatPeriodMinutes = _data["marginOfSafetyRepeatPeriodMinutes"];
            this.brainScienceBiteStartTime = _data["brainScienceBiteStartTime"];
            this.brainScienceBiteNextAlertDateTime = _data["brainScienceBiteNextAlertDateTime"];
            this.marginOfSafetySecondTime = _data["marginOfSafetySecondTime"];
            this.timezone = _data["timezone"];
            this.isMarginOfSafetySecondAlertOn = _data["isMarginOfSafetySecondAlertOn"];
            this.loadPreviousHalos = _data["loadPreviousHalos"];
            this.loadPreviousZombies = _data["loadPreviousZombies"];
            this.isDeviceSubscribedForWebPush = _data["isDeviceSubscribedForWebPush"];
            this.isDeviceSubscribedForMobilePush = _data["isDeviceSubscribedForMobilePush"];
            this.isDeviceBrainScienceBitePushEnabled = _data["isDeviceBrainScienceBitePushEnabled"];
            this.isDeviceScoreNotificationPushEnabled = _data["isDeviceScoreNotificationPushEnabled"];
        }
    }

    static fromJS(data: any): UserSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGuid"] = this.userGuid;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["preferredName"] = this.preferredName;
        data["audioIsOn"] = this.audioIsOn;
        data["isMarginOfSafetyAlertOn"] = this.isMarginOfSafetyAlertOn;
        data["isMarginOfSafetyPushOn"] = this.isMarginOfSafetyPushOn;
        data["isBrainScienceBiteAlertOn"] = this.isBrainScienceBiteAlertOn;
        data["isBrainScienceBitePushOn"] = this.isBrainScienceBitePushOn;
        data["marginOfSafetyStartTime"] = this.marginOfSafetyStartTime;
        data["marginOfSafetyAlertDateTime"] = this.marginOfSafetyAlertDateTime;
        data["marginOfSafetyNextAlertDateTime"] = this.marginOfSafetyNextAlertDateTime;
        data["marginOfSafetyRepeatPeriodMinutes"] = this.marginOfSafetyRepeatPeriodMinutes;
        data["brainScienceBiteStartTime"] = this.brainScienceBiteStartTime;
        data["brainScienceBiteNextAlertDateTime"] = this.brainScienceBiteNextAlertDateTime;
        data["marginOfSafetySecondTime"] = this.marginOfSafetySecondTime;
        data["timezone"] = this.timezone;
        data["isMarginOfSafetySecondAlertOn"] = this.isMarginOfSafetySecondAlertOn;
        data["loadPreviousHalos"] = this.loadPreviousHalos;
        data["loadPreviousZombies"] = this.loadPreviousZombies;
        data["isDeviceSubscribedForWebPush"] = this.isDeviceSubscribedForWebPush;
        data["isDeviceSubscribedForMobilePush"] = this.isDeviceSubscribedForMobilePush;
        data["isDeviceBrainScienceBitePushEnabled"] = this.isDeviceBrainScienceBitePushEnabled;
        data["isDeviceScoreNotificationPushEnabled"] = this.isDeviceScoreNotificationPushEnabled;
        return data;
    }
}

export interface IUserSettingDto {
    userGuid?: string;
    userName?: string | undefined;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    preferredName?: string | undefined;
    audioIsOn?: boolean;
    isMarginOfSafetyAlertOn?: boolean;
    isMarginOfSafetyPushOn?: boolean;
    isBrainScienceBiteAlertOn?: boolean;
    isBrainScienceBitePushOn?: boolean;
    marginOfSafetyStartTime?: string;
    marginOfSafetyAlertDateTime?: string | undefined;
    marginOfSafetyNextAlertDateTime?: string | undefined;
    marginOfSafetyRepeatPeriodMinutes?: number;
    brainScienceBiteStartTime?: string;
    brainScienceBiteNextAlertDateTime?: string | undefined;
    marginOfSafetySecondTime?: string;
    timezone?: string | undefined;
    isMarginOfSafetySecondAlertOn?: boolean;
    loadPreviousHalos?: boolean | undefined;
    loadPreviousZombies?: boolean | undefined;
    isDeviceSubscribedForWebPush?: boolean | undefined;
    isDeviceSubscribedForMobilePush?: boolean | undefined;
    isDeviceBrainScienceBitePushEnabled?: boolean | undefined;
    isDeviceScoreNotificationPushEnabled?: boolean | undefined;
}

export class BaseTransportOfUserSettingDtoAndBaseError implements IBaseTransportOfUserSettingDtoAndBaseError {
    result?: UserSettingDto | undefined;
    error?: BaseError | undefined;

    constructor(data?: IBaseTransportOfUserSettingDtoAndBaseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? UserSettingDto.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? BaseError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTransportOfUserSettingDtoAndBaseError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTransportOfUserSettingDtoAndBaseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseTransportOfUserSettingDtoAndBaseError {
    result?: UserSettingDto | undefined;
    error?: BaseError | undefined;
}

export class ResponseTransportOfUserSettingDto extends BaseTransportOfUserSettingDtoAndBaseError implements IResponseTransportOfUserSettingDto {
    status?: ResponseStatus;

    constructor(data?: IResponseTransportOfUserSettingDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseTransportOfUserSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTransportOfUserSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseTransportOfUserSettingDto extends IBaseTransportOfUserSettingDtoAndBaseError {
    status?: ResponseStatus;
}

export class UserSettingScorePromptRequest implements IUserSettingScorePromptRequest {
    userGuid?: string;
    scorePromptType?: ScorePromptType;
    showPrompt?: boolean;

    constructor(data?: IUserSettingScorePromptRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGuid = _data["userGuid"];
            this.scorePromptType = _data["scorePromptType"];
            this.showPrompt = _data["showPrompt"];
        }
    }

    static fromJS(data: any): UserSettingScorePromptRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingScorePromptRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGuid"] = this.userGuid;
        data["scorePromptType"] = this.scorePromptType;
        data["showPrompt"] = this.showPrompt;
        return data;
    }
}

export interface IUserSettingScorePromptRequest {
    userGuid?: string;
    scorePromptType?: ScorePromptType;
    showPrompt?: boolean;
}

export enum ScorePromptType {
    Halo = 0,
    Zombie = 1,
}

export class UserSettingsSaveDbResponse implements IUserSettingsSaveDbResponse {
    responseMessage?: string | undefined;

    constructor(data?: IUserSettingsSaveDbResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): UserSettingsSaveDbResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingsSaveDbResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IUserSettingsSaveDbResponse {
    responseMessage?: string | undefined;
}

export class UserSettingsSaveDbRequest implements IUserSettingsSaveDbRequest {
    userSettingsItems?: UserSettingsItems[] | undefined;
    localDateTime?: string | undefined;

    constructor(data?: IUserSettingsSaveDbRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userSettingsItems"])) {
                this.userSettingsItems = [] as any;
                for (let item of _data["userSettingsItems"])
                    this.userSettingsItems!.push(UserSettingsItems.fromJS(item));
            }
            this.localDateTime = _data["localDateTime"];
        }
    }

    static fromJS(data: any): UserSettingsSaveDbRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingsSaveDbRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userSettingsItems)) {
            data["userSettingsItems"] = [];
            for (let item of this.userSettingsItems)
                data["userSettingsItems"].push(item.toJSON());
        }
        data["localDateTime"] = this.localDateTime;
        return data;
    }
}

export interface IUserSettingsSaveDbRequest {
    userSettingsItems?: UserSettingsItems[] | undefined;
    localDateTime?: string | undefined;
}

export class UserSettingsItems implements IUserSettingsItems {
    audioIsOn?: boolean;
    isMarginOfSafetyAlertOn?: boolean;
    isMarginOfSafetyPushOn?: boolean;
    marginOfSafetyStartTime?: string | undefined;
    marginOfSafetySecondTime?: string | undefined;
    marginOfSafetyRepeatPeriodMinutes?: number;
    marginOfSafetyNextAlertDateTime?: string | undefined;
    isBrainScienceBiteAlertOn?: boolean;
    isBrainScienceBitePushOn?: boolean;
    brainScienceBiteStartTime?: string | undefined;
    brainScienceBiteNextAlertDateTime?: string | undefined;
    timezone?: string | undefined;
    isMarginOfSafetySecondAlertOn?: boolean;
    loadPreviousHalos?: boolean;
    loadPreviousZombies?: boolean;

    constructor(data?: IUserSettingsItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.audioIsOn = _data["audioIsOn"];
            this.isMarginOfSafetyAlertOn = _data["isMarginOfSafetyAlertOn"];
            this.isMarginOfSafetyPushOn = _data["isMarginOfSafetyPushOn"];
            this.marginOfSafetyStartTime = _data["marginOfSafetyStartTime"];
            this.marginOfSafetySecondTime = _data["marginOfSafetySecondTime"];
            this.marginOfSafetyRepeatPeriodMinutes = _data["marginOfSafetyRepeatPeriodMinutes"];
            this.marginOfSafetyNextAlertDateTime = _data["marginOfSafetyNextAlertDateTime"];
            this.isBrainScienceBiteAlertOn = _data["isBrainScienceBiteAlertOn"];
            this.isBrainScienceBitePushOn = _data["isBrainScienceBitePushOn"];
            this.brainScienceBiteStartTime = _data["brainScienceBiteStartTime"];
            this.brainScienceBiteNextAlertDateTime = _data["brainScienceBiteNextAlertDateTime"];
            this.timezone = _data["timezone"];
            this.isMarginOfSafetySecondAlertOn = _data["isMarginOfSafetySecondAlertOn"];
            this.loadPreviousHalos = _data["loadPreviousHalos"];
            this.loadPreviousZombies = _data["loadPreviousZombies"];
        }
    }

    static fromJS(data: any): UserSettingsItems {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingsItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["audioIsOn"] = this.audioIsOn;
        data["isMarginOfSafetyAlertOn"] = this.isMarginOfSafetyAlertOn;
        data["isMarginOfSafetyPushOn"] = this.isMarginOfSafetyPushOn;
        data["marginOfSafetyStartTime"] = this.marginOfSafetyStartTime;
        data["marginOfSafetySecondTime"] = this.marginOfSafetySecondTime;
        data["marginOfSafetyRepeatPeriodMinutes"] = this.marginOfSafetyRepeatPeriodMinutes;
        data["marginOfSafetyNextAlertDateTime"] = this.marginOfSafetyNextAlertDateTime;
        data["isBrainScienceBiteAlertOn"] = this.isBrainScienceBiteAlertOn;
        data["isBrainScienceBitePushOn"] = this.isBrainScienceBitePushOn;
        data["brainScienceBiteStartTime"] = this.brainScienceBiteStartTime;
        data["brainScienceBiteNextAlertDateTime"] = this.brainScienceBiteNextAlertDateTime;
        data["timezone"] = this.timezone;
        data["isMarginOfSafetySecondAlertOn"] = this.isMarginOfSafetySecondAlertOn;
        data["loadPreviousHalos"] = this.loadPreviousHalos;
        data["loadPreviousZombies"] = this.loadPreviousZombies;
        return data;
    }
}

export interface IUserSettingsItems {
    audioIsOn?: boolean;
    isMarginOfSafetyAlertOn?: boolean;
    isMarginOfSafetyPushOn?: boolean;
    marginOfSafetyStartTime?: string | undefined;
    marginOfSafetySecondTime?: string | undefined;
    marginOfSafetyRepeatPeriodMinutes?: number;
    marginOfSafetyNextAlertDateTime?: string | undefined;
    isBrainScienceBiteAlertOn?: boolean;
    isBrainScienceBitePushOn?: boolean;
    brainScienceBiteStartTime?: string | undefined;
    brainScienceBiteNextAlertDateTime?: string | undefined;
    timezone?: string | undefined;
    isMarginOfSafetySecondAlertOn?: boolean;
    loadPreviousHalos?: boolean;
    loadPreviousZombies?: boolean;
}

export class NotificationSettingDto implements INotificationSettingDto {
    isEnabled?: boolean;
    isPushEnabled?: boolean;
    notificationTime?: string | undefined;

    constructor(data?: INotificationSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.isPushEnabled = _data["isPushEnabled"];
            this.notificationTime = _data["notificationTime"];
        }
    }

    static fromJS(data: any): NotificationSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["isPushEnabled"] = this.isPushEnabled;
        data["notificationTime"] = this.notificationTime;
        return data;
    }
}

export interface INotificationSettingDto {
    isEnabled?: boolean;
    isPushEnabled?: boolean;
    notificationTime?: string | undefined;
}

export class NotificationSettingSaveRequest implements INotificationSettingSaveRequest {
    isEnabled?: boolean;
    isPushEnabled?: boolean;
    notificationTime?: string | undefined;

    constructor(data?: INotificationSettingSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.isPushEnabled = _data["isPushEnabled"];
            this.notificationTime = _data["notificationTime"];
        }
    }

    static fromJS(data: any): NotificationSettingSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSettingSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["isPushEnabled"] = this.isPushEnabled;
        data["notificationTime"] = this.notificationTime;
        return data;
    }
}

export interface INotificationSettingSaveRequest {
    isEnabled?: boolean;
    isPushEnabled?: boolean;
    notificationTime?: string | undefined;
}

export class CommunityNotificationSettingsDto implements ICommunityNotificationSettingsDto {
    isEnabled?: boolean;
    isPushEnabled?: boolean;

    constructor(data?: ICommunityNotificationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.isPushEnabled = _data["isPushEnabled"];
        }
    }

    static fromJS(data: any): CommunityNotificationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunityNotificationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["isPushEnabled"] = this.isPushEnabled;
        return data;
    }
}

export interface ICommunityNotificationSettingsDto {
    isEnabled?: boolean;
    isPushEnabled?: boolean;
}

export class AndroidSubscribe implements IAndroidSubscribe {
    endpoint?: string | undefined;
    auth?: string | undefined;
    p256dh?: string | undefined;

    constructor(data?: IAndroidSubscribe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endpoint = _data["endpoint"];
            this.auth = _data["auth"];
            this.p256dh = _data["p256dh"];
        }
    }

    static fromJS(data: any): AndroidSubscribe {
        data = typeof data === 'object' ? data : {};
        let result = new AndroidSubscribe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endpoint"] = this.endpoint;
        data["auth"] = this.auth;
        data["p256dh"] = this.p256dh;
        return data;
    }
}

export interface IAndroidSubscribe {
    endpoint?: string | undefined;
    auth?: string | undefined;
    p256dh?: string | undefined;
}

export class MobileSubscribe implements IMobileSubscribe {
    fcmToken?: string | undefined;

    constructor(data?: IMobileSubscribe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fcmToken = _data["fcmToken"];
        }
    }

    static fromJS(data: any): MobileSubscribe {
        data = typeof data === 'object' ? data : {};
        let result = new MobileSubscribe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fcmToken"] = this.fcmToken;
        return data;
    }
}

export interface IMobileSubscribe {
    fcmToken?: string | undefined;
}

export class ValidateAppleTransactionRequest implements IValidateAppleTransactionRequest {
    signedTransaction!: string;

    constructor(data?: IValidateAppleTransactionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signedTransaction = _data["signedTransaction"];
        }
    }

    static fromJS(data: any): ValidateAppleTransactionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateAppleTransactionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signedTransaction"] = this.signedTransaction;
        return data;
    }
}

export interface IValidateAppleTransactionRequest {
    signedTransaction: string;
}

export class ValidateGooglePurchaseRequest implements IValidateGooglePurchaseRequest {
    purchaseToken!: string;

    constructor(data?: IValidateGooglePurchaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseToken = _data["purchaseToken"];
        }
    }

    static fromJS(data: any): ValidateGooglePurchaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateGooglePurchaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseToken"] = this.purchaseToken;
        return data;
    }
}

export interface IValidateGooglePurchaseRequest {
    purchaseToken: string;
}

export class ProductSaveDbResponse implements IProductSaveDbResponse {
    responseMessage?: string | undefined;

    constructor(data?: IProductSaveDbResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): ProductSaveDbResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSaveDbResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IProductSaveDbResponse {
    responseMessage?: string | undefined;
}

export class ProductSaveDbRequest implements IProductSaveDbRequest {
    skuCode?: string | undefined;
    name?: string | undefined;
    period?: number;

    constructor(data?: IProductSaveDbRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skuCode = _data["skuCode"];
            this.name = _data["name"];
            this.period = _data["period"];
        }
    }

    static fromJS(data: any): ProductSaveDbRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSaveDbRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skuCode"] = this.skuCode;
        data["name"] = this.name;
        data["period"] = this.period;
        return data;
    }
}

export interface IProductSaveDbRequest {
    skuCode?: string | undefined;
    name?: string | undefined;
    period?: number;
}

export class LicenceDbRequest implements ILicenceDbRequest {
    email?: string | undefined;
    skuCode?: string | undefined;
    subscriptionRef?: string | undefined;

    constructor(data?: ILicenceDbRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.skuCode = _data["skuCode"];
            this.subscriptionRef = _data["subscriptionRef"];
        }
    }

    static fromJS(data: any): LicenceDbRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceDbRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["skuCode"] = this.skuCode;
        data["subscriptionRef"] = this.subscriptionRef;
        return data;
    }
}

export interface ILicenceDbRequest {
    email?: string | undefined;
    skuCode?: string | undefined;
    subscriptionRef?: string | undefined;
}

export class SubscriptionRenewDbResponse implements ISubscriptionRenewDbResponse {
    responseMessage?: string | undefined;

    constructor(data?: ISubscriptionRenewDbResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): SubscriptionRenewDbResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionRenewDbResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface ISubscriptionRenewDbResponse {
    responseMessage?: string | undefined;
}

export class SubscriptionRenewDbRequest implements ISubscriptionRenewDbRequest {
    subscriptionRef?: string | undefined;
    isActive?: number;

    constructor(data?: ISubscriptionRenewDbRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionRef = _data["subscriptionRef"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SubscriptionRenewDbRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionRenewDbRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionRef"] = this.subscriptionRef;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISubscriptionRenewDbRequest {
    subscriptionRef?: string | undefined;
    isActive?: number;
}

export class ThoughtForTodayDto implements IThoughtForTodayDto {
    morning?: string | undefined;
    afternoon?: string | undefined;
    evening?: string | undefined;

    constructor(data?: IThoughtForTodayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.morning = _data["morning"];
            this.afternoon = _data["afternoon"];
            this.evening = _data["evening"];
        }
    }

    static fromJS(data: any): ThoughtForTodayDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThoughtForTodayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["morning"] = this.morning;
        data["afternoon"] = this.afternoon;
        data["evening"] = this.evening;
        return data;
    }
}

export interface IThoughtForTodayDto {
    morning?: string | undefined;
    afternoon?: string | undefined;
    evening?: string | undefined;
}

export class TrackEventsRequest implements ITrackEventsRequest {
    interactions?: InteractionEventRequest[] | undefined;
    navigations?: NavigationEventRequest[] | undefined;

    constructor(data?: ITrackEventsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["interactions"])) {
                this.interactions = [] as any;
                for (let item of _data["interactions"])
                    this.interactions!.push(InteractionEventRequest.fromJS(item));
            }
            if (Array.isArray(_data["navigations"])) {
                this.navigations = [] as any;
                for (let item of _data["navigations"])
                    this.navigations!.push(NavigationEventRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrackEventsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TrackEventsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.interactions)) {
            data["interactions"] = [];
            for (let item of this.interactions)
                data["interactions"].push(item.toJSON());
        }
        if (Array.isArray(this.navigations)) {
            data["navigations"] = [];
            for (let item of this.navigations)
                data["navigations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITrackEventsRequest {
    interactions?: InteractionEventRequest[] | undefined;
    navigations?: NavigationEventRequest[] | undefined;
}

export class UserActivityEventRequest implements IUserActivityEventRequest {
    eventType?: string | undefined;
    platform?: string | undefined;

    constructor(data?: IUserActivityEventRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventType = _data["eventType"];
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): UserActivityEventRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityEventRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType;
        data["platform"] = this.platform;
        return data;
    }
}

export interface IUserActivityEventRequest {
    eventType?: string | undefined;
    platform?: string | undefined;
}

export class ResponseModelOfListOfString implements IResponseModelOfListOfString {
    resultStatus?: ResultStatus | undefined;
    responseData?: string[] | undefined;

    constructor(data?: IResponseModelOfListOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultStatus = _data["resultStatus"] ? ResultStatus.fromJS(_data["resultStatus"]) : <any>undefined;
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(item);
            }
        }
    }

    static fromJS(data: any): ResponseModelOfListOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelOfListOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultStatus"] = this.resultStatus ? this.resultStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item);
        }
        return data;
    }
}

export interface IResponseModelOfListOfString {
    resultStatus?: ResultStatus | undefined;
    responseData?: string[] | undefined;
}

export class MarkPromoFlagSeenRequest implements IMarkPromoFlagSeenRequest {
    flagKey?: string | undefined;

    constructor(data?: IMarkPromoFlagSeenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flagKey = _data["flagKey"];
        }
    }

    static fromJS(data: any): MarkPromoFlagSeenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkPromoFlagSeenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flagKey"] = this.flagKey;
        return data;
    }
}

export interface IMarkPromoFlagSeenRequest {
    flagKey?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

//export class CardSessions extends CardSessions {
//  sessionGuid: string;
//}